// @flow
/* eslint import/no-webpack-loader-syntax: 0 */
/* global chrome */

import React, { Component, useState, useEffect, useRef, useMemo, useCallback } from "react";
import WeekCalendar from 'react-week-calendar';
import {DayPilot, DayPilotCalendar} from "@daypilot/daypilot-lite-react";

import 'react-week-calendar/dist/style.css'


import { Document, Page } from 'react-pdf/dist/esm/entry.webpack';



import ReactPlayer from 'react-player'


import {
  PdfLoader,
  PdfHighlighter,
  Tip,
  Highlight,
  Popup,
  AreaHighlight
} from "react-pdf-highlighter";


import Dropzone from 'react-dropzone'


import './App.css';

import moment from 'moment';
import axios from 'axios'
import clsx from 'clsx';
import { GoogleLogin, GoogleOAuthProvider, useGoogleLogin } from '@react-oauth/google';

import { Graph } from "react-d3-graph";
import PropTypes, { any } from 'prop-types';

import {TokenAnnotator} from 'react-text-annotate'
import AsyncSelect from 'react-select/async';
import AsyncCreatableSelect from 'react-select/async-creatable';
import Badge from '@material-ui/core/Badge';
import SaveIcon from '@material-ui/icons/Save';
import { GridListTile, rgbToHex, TextField } from '@material-ui/core';
import { makeStyles, useTheme, withStyles, alpha } from '@material-ui/core/styles';
import SearchIcon from '@material-ui/icons/Search';
import InputBase from '@material-ui/core/InputBase';
import MenuIcon from '@material-ui/icons/Menu';
import EditIcon from '@material-ui/icons/Edit';
import DoneIcon from '@material-ui/icons/Done';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Button from '@material-ui/core/Button';
import Menu from '@material-ui/core/Menu';
import Avatar from '@material-ui/core/Avatar';
import MenuItem from '@material-ui/core/MenuItem';
import CircularProgress from '@material-ui/core/CircularProgress';
import Card from '@material-ui/core/Card';
import Grid from '@material-ui/core/Grid';
import CloseIcon from '@material-ui/icons/Close';
import RefreshIcon from '@material-ui/icons/Refresh';
import CardHeader from '@material-ui/core/CardHeader';
import CardActions from '@material-ui/core/CardActions';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import Collapse from '@material-ui/core/Collapse';
import IconButton from '@material-ui/core/IconButton';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import PushPinIcon from '@material-ui/icons/Beenhere';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import PictureAsPdfIcon from '@material-ui/icons/PictureAsPdf';
import ImageIcon from '@material-ui/icons/Image';
import PlayArrowIcon from "@material-ui/icons/PlayArrow";
import NotInterestedIcon from "@material-ui/icons/NotInterested";
import VideocamIcon from '@material-ui/icons/Videocam';
import DescriptionIcon from '@material-ui/icons/Description';

import TimelineIcon from '@material-ui/icons/Timeline';
import LinkOffIcon from '@material-ui/icons/LinkOff';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Drawer from '@material-ui/core/Drawer';
import List from '@material-ui/core/List';
import Divider from '@material-ui/core/Divider';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import InboxIcon from '@material-ui/icons/MoveToInbox';
import HomeIcon from '@material-ui/icons/Home';
import ViewListIcon from '@material-ui/icons/ViewList';
import AdbIcon from '@material-ui/icons/Adb';
import GridOnIcon from '@material-ui/icons/GridOn';
import BackspaceIcon from '@material-ui/icons/Backspace';
import SettingsIcon from '@material-ui/icons/Settings';
import AccountTreeIcon from '@material-ui/icons/AccountTree';
import EqualizerIcon from '@material-ui/icons/Equalizer';
import AddIcon from "@material-ui/icons/Add";
import HelpOutlineIcon from "@material-ui/icons/HelpOutline";
import TrendingUpIcon from "@material-ui/icons/TrendingUp";
import MoreHorizIcon from "@material-ui/icons/MoreHoriz";
import MailIcon from '@material-ui/icons/Mail';
import NotificationsIcon from '@material-ui/icons/Notifications';
import StyleIcon from '@material-ui/icons/Style';
import AddBoxIcon from '@material-ui/icons/AddBox';
import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import PendingIcon from '@material-ui/icons/Schedule';
import ErrorIcon from '@material-ui/icons/Error';
import KeyboardBackspaceIcon from '@material-ui/icons/KeyboardBackspace';
import CalendarTodayIcon from '@material-ui/icons/CalendarToday';
import SchoolIcon from '@material-ui/icons/School';
import RemoveIcon from '@material-ui/icons/Remove';
import { Google } from 'mdi-material-ui';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import Select from '@material-ui/core/Select';
import InputLabel from '@material-ui/core/InputLabel';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormLabel from '@material-ui/core/FormLabel';
import Checkbox from '@material-ui/core/Checkbox';
import GridList from '@material-ui/core/GridList';
import Box from '@material-ui/core/Box';
import {
  MuiPickersUtilsProvider,
  KeyboardTimePicker,
  KeyboardDatePicker,
  Calendar,
} from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';
import LinearProgress from '@material-ui/core/LinearProgress';
import AccountCircle from '@material-ui/icons/AccountCircle';
import MoreIcon from '@material-ui/icons/MoreVert';
import CardMedia from '@material-ui/core/CardMedia';
import NativeSelect from '@material-ui/core/NativeSelect';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import {
Chip,
Dialog,
DialogActions,
DialogContent,
DialogTitle,
ListItemButton,
Tooltip,
useMediaQuery,
Modal,
Paper,
Popover,
Table,
TableBody,
TableCell,
TableHead,
TableRow,
} from "@material-ui/core";


import { useDrag } from 'react-dnd'
import { isThisHour, set } from "date-fns";
import {ThemeProvider, createTheme } from '@material-ui/core/styles';


import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import Close from "@material-ui/icons/Close";

import {CanvasJS, CanvasJSChart} from 'canvasjs-react-charts'
import LinkIcon from '@material-ui/icons/Link';
import { use } from "react";
import { he } from "date-fns/locale";



//const SERVER_LINK = "http://localhost:8000"

//const SERVER_LINK = "http://192.168.1.2:5000"

//const SERVER_LINK = "https://10.0.0.189:443"

const SERVER_LINK = "https://dil-jarvis.com"

//const SERVER_LINK = "https://dil-node1.hopto.org




// convert image string to a Blob object
const dataURItoBlob = (dataURI) => {
  var byteString = atob(dataURI.split(',')[1]);
  var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0]
  var ab = new ArrayBuffer(byteString.length);
  var ia = new Uint8Array(ab);
  for (var i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
  }
  return new Blob([ab], { type: mimeString });
}

const getMimeType = (imageString) => {
  var chunks = imageString.split(',');
  var header = chunks[0];
  var type = header.match(/data:([a-z]+\/[a-z0-9-+.]+)/i)[1];
  return type;
}

const getNextId = () => String(Math.random()).slice(2);

const urltoFile = (url, filename, mimeType) => {
  return (fetch(url)
      .then(function(res){return res.arrayBuffer();})
      .then(function(buf){return new File([buf], filename,{type:mimeType});})
  );
}

const modOperation = (number, divisor) => {
  return number % divisor;
}

const zeros = (dimensions) => {
  var array = [];

  for (var i = 0; i < dimensions[0]; ++i) {
      array.push(dimensions.length == 1 ? 0 : zeros(dimensions.slice(1)));
  }

  return array;
}

const datesAreOnSameDay = (first, second) =>
    first.getFullYear() === second.getFullYear() &&
    first.getMonth() === second.getMonth() &&
    first.getDate() === second.getDate();

const datesIsBefore = (first, second) =>
    first.getFullYear() <= second.getFullYear() &&
    first.getMonth() <= second.getMonth() &&
    first.getDate() <= second.getDate();

const parseIdFromHash = () => document.location.hash.slice("#highlight-".length);
  
const resetHash = () => {document.location.hash = "";};

const secondsToMinutes = (seconds) => {
  if (typeof seconds !== "number" || Number.isNaN(seconds)) return null;
  return Math.floor(seconds / 60);
};

const HighlightPopup = ({ comment }) =>
  comment.text ? (
    <div className="Highlight__popup">
      {comment.emoji} {comment.text}
    </div>
  ) : null;


(function() {
    var days = ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'];

    var months = ['January','February','March','April','May','June','July','August','September','October','November','December'];

    Date.prototype.getMonthName = function() {
        return months[ this.getMonth() ];
    };
    Date.prototype.getDayName = function() {
        return days[ this.getDay() ];
    };
})();


function CustomHeaderCell(props) {
  var now = new Date();
  var day = now.getDayName();
  var headerDay = props.date.format("dddd")
  console.log(props.date.format("mm/YYYY"))
  console.log(day, headerDay)
  if (headerDay === day) {
    return <span style={{'color': 'blue'}}>{headerDay + '(' + props.date.format("D/M") + ')'}</span>
  }
  else {
    return <span>{headerDay + '(' + props.date.format("D/M") + ')'}</span>
  }
};


const useStyles = makeStyles((theme) => ({
  media: {
    height: 130,
  },
  media_map: {
    height: 190,
    width: 270
  },
  expand: {
    transform: 'rotate(0deg)',
    marginLeft: 'auto',
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.shortest,
    }),
  },
  expandOpen: {
    transform: 'rotate(180deg)',
    backgroundColor: 'lightGrey',
  },
  avatar: {
    backgroundColor: "#e6e9ff",
    color: "#3f51b5",
    fontWeight: 700,
  },
  root: {
    "display": 'flex',
    "flexWrap": 'wrap',
    "justifyContent": 'space-around',
  },
  root1: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.red,
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  title: {
    flexGrow: 0,
    width: '80px'
  },
  titleCard: {
    flexGrow: 0
  },
  text: {
    height: 89,
    overflow: 'scroll'
  },
  text_filling: {
    height: 299,
    overflow: 'scroll'
  },
  page: {
    flexDirection: 'row',
    backgroundColor: '#E4E4E4'
  },
  section: {
    margin: 10,
    padding: 10,
    flexGrow: 1
  },
  list: {
    width: 250,
  },
  fullList: {
    width: 'auto',
  },
  root_simple_instance_card: {
    minWidth: 275,
  },
  title_simple_instance_card: {
    fontSize: 14,
  },
  pos_simple_instance_card: {
    marginBottom: 12,
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
  search: {
    position: 'relative',
    borderRadius: theme.shape.borderRadius,
    backgroundColor: alpha(theme.palette.common.white, 0.15),
    marginRight: theme.spacing(2),
    marginLeft: 0,
    [theme.breakpoints.up('sm')]: {
      marginLeft: theme.spacing(3),
      width: 'auto',
    },
  },
  inputRoot: {
    color: 'inherit',
  },
  inputInput: {
    padding: theme.spacing(1, 1, 1, 0),
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(1em + ${theme.spacing(4)}px)`,
    transition: theme.transitions.create('width'),
    width: '100%',
    [theme.breakpoints.up('md')]: {
      width: '60ch',
    },
  },
  searchIcon: {
    padding: theme.spacing(0, 2),
    height: '100%',
    position: 'absolute',
    pointerEvents: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  sectionDesktop: {
    display: 'none',
    [theme.breakpoints.up('md')]: {
      display: 'flex',
    },
  },
  sectionMobile: {
    display: 'flex',
    [theme.breakpoints.up('md')]: {
      display: 'none',
    },
  },
  grow: {
    flexGrow: 1
  },
  gridList: {
    flexWrap: 'nowrap',
    // Promote the list into his own layer on Chrome. This cost memory but helps keeping high FPS.
    transform: 'translateZ(0)',
  },
}));

const useStylesTaskRow = makeStyles((theme) => ({
  root: {
    width: "100%",
    minWidth: 0,          // 🔑 allows shrinking inside grid
    overflow: "hidden",  
    position: "relative",        
    justifySelf: "stretch",
    boxSizing: "border-box",
    overflow: "hidden",
    position: "relative",
    borderRadius: theme.shape.borderRadius * 2,
    border: `1px solid ${theme.palette.divider}`,
    padding: theme.spacing(2),
    margin: theme.spacing(1, 0),
    cursor: "pointer",
    userSelect: "none",
    transition: theme.transitions.create(
      ["transform", "box-shadow", "border-color", "background-color"],
      { duration: 160 }
    ),
    "&:hover": {
      transform: "translateY(-2px)",
      boxShadow: theme.shadows[4],
      borderColor: theme.palette.text.primary,
      backgroundColor: theme.palette.action.hover,
    },
    "&:focus": {
      outline: "none",
    },
    "&:focus-visible": {
      boxShadow: `0 0 0 3px ${theme.palette.primary.main}33`,
      borderColor: theme.palette.primary.main,
    },
  },
  expanded: {
    backgroundColor: theme.palette.action.hover,
    borderColor: theme.palette.text.primary,
    transform: "scale(1.01)",
    boxShadow: theme.shadows[6],
  },

  // top header area (responsive)
  header: {
    display: "grid",
    gridTemplateColumns: "minmax(0, 1fr) 50px", // ✅ left can shrink, right fits duration
    alignItems: "start",
    columnGap: theme.spacing(1),
  },

  header_paused: {
    display: "grid",
    gridTemplateColumns: "minmax(0, 1fr) 100px", // ✅ left can shrink, right fits duration
    alignItems: "start",
    columnGap: theme.spacing(1),
    marginTop: theme.spacing(2.5),
  },

  goalChip: {
    fontWeight: 800,
    letterSpacing: 0.8,
    textTransform: "uppercase", 
    minWidth: 0,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },

  duration: {
    position: "absolute",
    top: theme.spacing(2),
    right: theme.spacing(2),
    fontWeight: 800,
    color: theme.palette.text.secondary,
    whiteSpace: "nowrap",
    pointerEvents: "none",
  },

  durationPaused: {
    position: "absolute",
    top: theme.spacing(4.5),
    right: theme.spacing(2),
    fontWeight: 800,
    color: theme.palette.text.secondary,
    whiteSpace: "nowrap",
    pointerEvents: "none",
    color: theme.palette.warning.main,
  },

  title: {
    marginTop: theme.spacing(1),
    fontWeight: 900,
    lineHeight: 1.15,
    letterSpacing: -0.2,
    [theme.breakpoints.down("xs")]: {
      fontSize: "1.25rem",
    },

  },

  expandBtn: {
    transition: theme.transitions.create("transform", { duration: 160 }),
  },
  expandBtnOpen: {
    transform: "rotate(180deg)",
  },

  details: {
    marginTop: theme.spacing(2),
    paddingTop: theme.spacing(2),
    borderTop: `1px solid ${theme.palette.divider}`,
    display: "grid",
    gap: theme.spacing(2),
  },

  actionsRow: {
    display: "flex",
    gap: theme.spacing(1),
    justifyContent: "flex-end",
    flexWrap: "wrap",
  },

  primaryBtn: {
    borderRadius: 999,
    fontWeight: 900,
    letterSpacing: 0.6,
    paddingLeft: theme.spacing(2.5),
    paddingRight: theme.spacing(2.5),
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    textTransform: "none",
    backgroundImage: "linear-gradient(135deg, #6a5af9, #00c6ff)",
    boxShadow: "0 8px 22px rgba(0, 198, 255, 0.25)",
    "&:hover": {
      backgroundImage: "linear-gradient(135deg, #5a4af4, #00b4e6)",
      boxShadow: "0 10px 30px rgba(0, 198, 255, 0.35)",
      transform: "translateY(-1px)",
    },
    "&:active": {
      transform: "scale(0.98)",
    },
  },

  resumeBtn: {
    borderRadius: 999,
    fontWeight: 900,
    letterSpacing: 0.6,
    paddingLeft: theme.spacing(2.5),
    paddingRight: theme.spacing(2.5),
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    textTransform: "none",
    backgroundImage: "linear-gradient(135deg, #22c55e, #16a34a)",
    boxShadow: "0 6px 20px rgba(34, 197, 94, 0.35)",
    "&:hover": {
      backgroundImage: "linear-gradient(135deg, #16a34a, #15803d)",
      boxShadow: "0 10px 30px rgba(34, 197, 94, 0.35)",
      transform: "translateY(-1px)",
    },
    "&:active": {
      transform: "scale(0.98)",
    },
  },


  ghostBtn: {
    borderRadius: 999,
    fontWeight: 800,
    textTransform: "none",
  },
}));


function useOutsideAlerter(ref, clickedOutside) {
  useEffect(() => {
    /**
     * Alert if clicked on outside of element
     */
    function handleClickOutside(event) {
      if (ref.current && !ref.current.contains(event.target)) {
        clickedOutside()
      }
    }
    // Bind the event listener
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [ref]);
}


function CircularProgressWithLabel(props) {
  return (
    <Box position="relative" display="inline-flex">
      <CircularProgress variant="determinate" {...props} />
      <Box
        top={0}
        left={0}
        bottom={0}
        right={0}
        position="absolute"
        display="flex"
        alignItems="center"
        justifyContent="center"
      >
        <Typography variant="caption" component="div" color="textSecondary">{`${Math.round(
          props.value,
        )}%`}</Typography>
      </Box>
    </Box>
  );
}


CircularProgressWithLabel.propTypes = {
  /**
   * The value of the progress indicator for the determinate variant.
   * Value between 0 and 100.
   */
  value: PropTypes.number.isRequired,
};


const BorderLinearProgress = withStyles((theme) => ({
  root: {
    height: '10px',
    width: '218px',
    borderRadius: 5,
  },
  colorPrimary: {
    backgroundColor: theme.palette.grey[theme.palette.type === 'light' ? 200 : 700],
  },
  bar: {
    borderRadius: 5,
    backgroundColor: 'green',
  },
}))(LinearProgress);


function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}


//************** */
//*****PDF****** */
//****Images**** */
//************** */

function validURL(str) {
  var pattern = new RegExp('^(https?:\\/\\/)?'+ // protocol
    '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|'+ // domain name
    '((\\d{1,3}\\.){3}\\d{1,3}))'+ // OR ip (v4) address
    '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*'+ // port and path
    '(\\?[;&a-z\\d%_.~+=-]*)?'+ // query string
    '(\\#[-a-z\\d_]*)?$','i'); // fragment locator
  return !!pattern.test(str);
}

function PDFHighlightPopUp(props) {
  return (
    <div className="Tip__compact"
          onClick={props.onConfirm} >
      Add highlight
    </div>
  )
}

function HighlightDragableCard({ isDragging, text }) {
  const [{ opacity }, dragRef] = useDrag(
    () => ({
      item: { text },
      collect: (monitor) => ({
        opacity: monitor.isDragging() ? 0.5 : 1
      })
    }),
    []
  )
  return (
    <div ref={dragRef} style={{ opacity }}>
      {text}
    </div>
  )
}

function ImagePatch(props) {
  const [currentlySelected, setCurrentlySelected] = useState(false)

  useEffect(() => {
    setCurrentlySelected(false)
  }, [props.reinitializeSpan])
  

  return <span className={'imagePatch'} 
                onMouseEnter={() => {if (props.paintKeyPressed) {if (!currentlySelected) {setCurrentlySelected(true); props.onPatchSelection()}} else if (props.eraseKeyPressed) {if (currentlySelected) {setCurrentlySelected(false); props.onPatchRemoval()}} }}
                style={{
                      'box-sizing': 'border-box',
                      '-moz-box-sizing': 'border-box',
                      '-webkit-box-sizing': 'border-box',
                      'border-style': 'solid',
                      'border-width': '1px',
                      borderLeftColor: 'rgba(255, 0, 0, ' + (1-props.patch[0]) + ')',
                      borderTopColor: 'rgba(255, 0, 0, ' + (1-props.patch[1]) + ')',
                      borderRightColor: 'rgba(255, 0, 0, ' + (1-props.patch[2]) + ')',
                      borderBottomColor: 'rgba(255, 0, 0, ' + (1-props.patch[3]) + ')',
                      backgroundColor: currentlySelected ? 'rgba(255, 0, 0, 0.8)' : 'rgba(0, 0, 0, 0.0)'
                      }}/>

}

function ImageAnnotator(props) {
  const [zoomScale, setZoomScale] = useState(1)

  const [patches, setPatches] = useState([])
  const [columns, setColumns] = useState(5)
  const [rows, setRows] = useState(5)
  const [originalWidth, setOriginalWidth] = useState(5)
  const [originalHeight, setOriginalHeight] = useState(5)
  const [width, setWidth] = useState(5)
  const [height, setHeight] = useState(5)

  const [layerNum, setLayerNum] = useState(1)

  // an annotation is an instance with associated patches
  const [annotations, setAnnotations] = React.useState([]) 

  const [addingAnnotation, setAddingAnnotation] = useState(false)
  const [paintKeyPressed, setPaintKeyPressed] = useState(false)
  const [eraseKeyPressed, setEraseKeyPressed] = useState(false)
  const [currentlySelectedPatches, setCurrentlySelectedPatches] = useState([])
  const [reinitializeSpans, setReinitializeSpans] = useState(false)
  const [currentAnnotationImage, setCurrentAnnotationImage] = useState('')
  const [currentAnnotationImageFile, setCurrentAnnotationImageFile] = useState()
  const [currentAnnotationTypeInputValue, setCurrentAnnotationTypeInputValue] = useState('')
  const [currentAnnotationType, setCurrentAnnotationType] = useState()
  const [currentAnnotationText, setCurrentAnnotationText] = useState('')
  const [uploadingResourceToServer, setUploadingResourceToServer] = useState(false)
  const [uploadingProgress, setUploadingProgress] = useState(0)
  const [uploadStatusResponse, setUploadStatusResponse] = useState('')

  const [savingAnnotations, setSavingAnnotations] = useState(false)

  const [dimensions, setDimensions] = useState({ 
    height: window.innerHeight,
    width: window.innerWidth
  })

  const handleResize = () => {
    setDimensions({
      height: window.innerHeight,
      width: window.innerWidth
    }) 
  }

  const handlePressKey = ({ key }) => {
    if (key === 'p') {
      setPaintKeyPressed(true);
    }
    else if (key === 'e') {
      setEraseKeyPressed(true)
    }
  }
  // If released key is our target key then set to false
  const handleReleaseKey = ({ key }) => {
    if (key === 'p') {
      setPaintKeyPressed(false);
    }
    else if (key === 'e') {
      setEraseKeyPressed(false)
    }
    //compute the new clusters
  };


  useEffect(() => {
    loadPatchClusters()
    window.addEventListener('resize', handleResize)
    window.addEventListener("keydown", handlePressKey);
    window.addEventListener("keyup", handleReleaseKey);
    // Remove event listeners on cleanup
    return () => {
      window.removeEventListener('resize', handleResize)
      window.removeEventListener("keydown", handlePressKey);
      window.removeEventListener("keyup", handleReleaseKey);
    };
  }, [])

  const fetchTypes = async (input) => {
    return fetch(SERVER_LINK + '/get_types', {
                method: 'GET',
                  headers: {
                    Accept:'application/json',
                    'Content-Type': 'application/json',
                    'SimpTokAuth': props.tokenPass,
                    'InputSearchText': input
                  }
                }).then((response) => response.json())
                  .then((data) => data.map((type) => {return {label: type.name, value:type.id}}) )
                  .catch((error) => console.log(error))
  }

  const addType = (new_type_name) => {
    fetch(SERVER_LINK + '/add_type', {
      method: 'POST',
      headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
      },
      body: JSON.stringify({
          idtoken: props.tokenPass,
          type_name: new_type_name
      })
    }).then((response) => response.json())
      .catch((error) => console.log(error))
  }

  const loadPatchClusters = () => {
    urltoFile(props.urlImage, 'image_to_process.jpg', 'image/jpg')
    .then((file) => {
      const data = new FormData();
      data.append('file', file);
      fetch(SERVER_LINK + '/get_image_attention_grid', {
        method: 'POST',
        headers: {
          'SimpTokAuth': props.tokenPass,
          'IntendedImageWidth': (56*16)-1,
        },
        body: data
      }).then((response) => response.json())
        .then((json) => {console.log(json); setPatches(json.patches); setColumns(parseInt(json.width/16)); setRows(parseInt(json.height/16)); setWidth(parseInt(json.width)); setHeight(parseInt(json.height)); setOriginalWidth(parseInt(json.original_width)); setOriginalHeight(parseInt(json.original_height))})
        .catch((error) => {console.log(error)})
    })
  }

  const handleLayerNumChange = (event) => {
    setLayerNum(event.target.value)
  }

  const closeAddAnnotation = () => {
    setAddingAnnotation(false)
    setReinitializeSpans((value) => !value)
    setCurrentlySelectedPatches([])
  }

  const startAnnotation = () => {
    setAddingAnnotation(true);
    var top_left_y = Math.floor(Math.min(...currentlySelectedPatches)/columns) + 1
    var top_left_x = columns
    for (var i = 0; i < currentlySelectedPatches.length; i++) {
      const x_loc_to_left = (currentlySelectedPatches[i]%columns)
      if (top_left_x > x_loc_to_left) {
        top_left_x = x_loc_to_left
      }
    }
    top_left_x += 1
    console.log(top_left_y)
    console.log(top_left_x)

    var bottom_right_y = Math.floor(Math.max(...currentlySelectedPatches)/columns) + 1
    var bottom_right_x = 0
    for (var i = 0; i < currentlySelectedPatches.length; i++) {
      const x_loc = (currentlySelectedPatches[i]%columns)
      if (bottom_right_x < x_loc) {
        bottom_right_x = x_loc
      }
    }
    bottom_right_x += 1
    console.log(bottom_right_y)
    console.log(bottom_right_x)

    var patch_size_original = 16*(originalWidth/width)
    var top_left_y_pixel = (top_left_y-1)*patch_size_original
    var top_left_x_pixel = (top_left_x-1)*patch_size_original
    var bottom_right_y_pixel = (bottom_right_y)*patch_size_original
    var bottom_right_x_pixel = (bottom_right_x)*patch_size_original



    var img = new Image();

    img.onload = function() {
      var canvas = document.createElement("canvas"); 
      canvas.width = bottom_right_x_pixel - top_left_x_pixel
      canvas.height = bottom_right_y_pixel - top_left_y_pixel
      canvas.getContext('2d').drawImage(img, top_left_x_pixel, top_left_y_pixel, canvas.width, canvas.height, 0, 0, canvas.width, canvas.height);
      var base64ImageData = canvas.toDataURL();
      setCurrentAnnotationImage(base64ImageData)
      canvas.remove();
    }
    img.src = props.urlImage
  }

  const addAnnotation = () => {
    setReinitializeSpans((value) => !value)

  }



  const addInstanceToContext = () => {
    setUploadingResourceToServer(true)
    fetch(SERVER_LINK + '/add_instance', {
      method: 'POST',
      headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
      },
      body: JSON.stringify({
          idtoken: props.tokenPass,
          typeid: currentAnnotationType.id,
          instance_text: encodeURI(currentAnnotationText)
      })
    }).then((response) => response.json())
      .then((data) => {if (Array.isArray(data)) { setAnnotations((oldValues) => [...oldValues, {instanceId: data[0][0], patches: currentlySelectedPatches}]); setImageInServer(data[0][0]); } else { console.log(data) }})
      .catch((error) => console.log(error))
  }

  const setImageInServer = (instance_id) => {
    urltoFile(currentAnnotationImage, instance_id + '.jpg', 'image/jpg')
    .then((file) => {
      const data = new FormData();
      data.append('file', file);
      fetch(SERVER_LINK + '/get_image_upload_link', {
        method: 'POST',
        headers: {
          'SimpTokAuth': props.tokenPass,
          'InstID': instance_id,
          'ImageFileType': 'jpg'
        },
        body: data
      }).then((response) => response.json())
        .then((json) => {uploadImageToCloud(json, file, instance_id)})
        .catch((error) => {console.log(error)})
    })
  }

  const uploadImageToCloud = (upload_link, image, instanceid) => {
    const putCloudConfig = {
      onUploadProgress: progressEvent => setUploadingProgress((progressEvent.loaded/image.size)*100),
      headers: {
        'Content-Type': 'image/jpg'
      }
    }
    axios.put(upload_link, image, putCloudConfig)
    .then((response) => {response.status==200 ? setSuccessfullImageUploadOnServer(instanceid) : alert('something went wrong with the upload')})
    .catch((error) => {console.log('error ... ' + error)})
  }

  const setSuccessfullImageUploadOnServer = (instanceid) => {
    fetch(SERVER_LINK + '/set_instance_image', {
      method: 'POST',
      headers: {
        'SimpTokAuth': props.tokenPass,
        'InstID': instanceid,
        'ImageFileType': 'jpg'
      },
      body: JSON.stringify({'empty': 'object'})
    }).then((response) => response.json())
      .then((data) => {closeAddAnnotation()})
      .catch((error) => {console.log(error)})
      .finally(() => {setUploadingResourceToServer(false)})
  }



  const imageWidth = parseInt(dimensions.width*0.6)
  const imageHeight = (height/width)*imageWidth


  const miniImageWidth = parseInt((width/originalWidth)*parseInt(dimensions.width*0.2))
  const miniImageHeight = (height/width)*miniImageWidth

  return (<div style={{ display: "flex", height: "100vh" }}>
      <div
          style={{
            height: "100vh",
            width: "60vw",
            position: "relative"
          }}
        >
          {/** 
          <Button onClick={() => {setZoomScale((oldScale) => {var newScale = oldScale + 0.1;  return newScale}) }}>Zoom in</Button>
          <Button onClick={() => {setZoomScale((oldScale) => {var newScale = oldScale - 0.1; return newScale}) }}>Zoom out</Button>
          <Button onClick={() => {setZoomScale((oldScale) => {var newScale = 1;  return newScale}) }}>Reset Zoom</Button>
          <Button onClick={() => {setLayerNum((oldLayer) => {var newLayer = oldLayer + 1;  if (newLayer>12) {return oldLayer} else {return newLayer}}) }}>Layer Up</Button>
          <Button onClick={() => {setLayerNum((oldLayer) => {var newLayer = oldLayer - 1; if (newLayer<0) {return oldLayer} else {return newLayer}}) }}>Layer Down</Button>
          <Button onClick={startAnnotation}>Annotate</Button>
          {layerNum} {paintKeyPressed ? <div style={{backgroundColor:'yellow', width:'10px', display:'inline'}}> P </div> : <div style={{width:'10px', display:'inline'}}></div>}
          {eraseKeyPressed ? <div style={{backgroundColor:'red', width:'10px', display:'inline'}}> E </div> : <div style={{width:'10px', display:'inline'}}></div>}
          {/** 
          <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={layerNum}
                onChange={handleLayerNumChange}
              >
                <MenuItem value={0}>0</MenuItem>
                <MenuItem value={1}>1</MenuItem>
                <MenuItem value={2}>2</MenuItem>
                <MenuItem value={3}>3</MenuItem>
                <MenuItem value={4}>4</MenuItem>
                <MenuItem value={5}>5</MenuItem>
                <MenuItem value={6}>6</MenuItem>
                <MenuItem value={7}>7</MenuItem>
                <MenuItem value={8}>8</MenuItem>
                <MenuItem value={9}>9</MenuItem>
                <MenuItem value={10}>10</MenuItem>
                <MenuItem value={11}>11</MenuItem>
                <MenuItem value={12}>12</MenuItem>
          </Select>
          <Button onClick={loadPatchClusters}>Load Patches</Button>
          */}
          
          <div style={{'position': 'relative'}}>
            <div style={{'position': 'absolute', 'width': parseInt(dimensions.width*0.6), 'height': parseInt((height/width)*parseInt(dimensions.width*0.6))}}>
              <img src={props.urlImage} width={imageWidth} height={imageHeight}/>
            </div>
            {/** 
            {patches.length == 0 ? <p>Loading...</p> :
                  <div style={{'position': 'absolute'}}>
                      <div style={{'display':'grid', 'grid-template-columns': 'repeat(' + columns + ', 1fr)', 'width': parseInt(dimensions.width*0.6), 'height': parseInt((height/width)*parseInt(dimensions.width*0.6))}}>
                            {patches[layerNum].map((patch, idx) => 
                              <ImagePatch paintKeyPressed={paintKeyPressed}
                                          eraseKeyPressed={eraseKeyPressed}
                                          reinitializeSpan={reinitializeSpans}
                                          patch={patch}
                                          selfIndex={idx}
                                          onPatchSelection={() => {setCurrentlySelectedPatches((array) => [...array, idx])}}
                                          onPatchRemoval={() => {setCurrentlySelectedPatches((array) => {for (var i=0;i<array.length;i++) {
                                                                                                            if (array[i] == idx) {
                                                                                                              array.splice(i, 1);
                                                                                                            }
                                                                                                        }
                                                                                                        return array})}}/>)}
                      </div>
                  </div>}
                  */}
          </div>  

        </div>
        {/** 
            <div style={{'position': 'relative'}}>
          <List style={{overflow:'scroll'}}>
            <Button onClick={() => {console.log(annotations)}}>Save</Button>
            {savingAnnotations ? 
              <ListItem style={{'backgroundColor': 'orange'}}>
                <p>Saving...</p>
              </ListItem> :
              <div></div>}
            {annotations.length == 0 ? <div></div> :
            annotations.map((annotation, annotation_index) => 
              <ListItem style={{'width':'20vw'}}>
                <div>
                  <Card style={{'width':'100%', draggable: 'true'}}>
                    <CardActionArea>
                      {annotation.instanceId}
                    </CardActionArea>
                  </Card>
                </div>
              </ListItem>
            )}
          </List>
          </div>
           {addingAnnotation ?
            <div className="infoi"> 
              <div className="centeredBox"> 
                <Button style={{'float': 'right'}}
                        onClick={closeAddAnnotation}>
                  <CloseIcon/>
                </Button>
                <div style={{'width':'85%'}}>
                  <AsyncCreatableSelect cacheOptions
                                        defaultOptions
                                        inputValue={currentAnnotationTypeInputValue}
                                        onInputChange={(new_input) => {setCurrentAnnotationTypeInputValue(new_input.toUpperCase())}}
                                        loadOptions={fetchTypes}
                                        onCreateOption={addType}
                                        placeholder={"Select Type"}
                                        onChange={(selectedOption) => {setCurrentAnnotationType({id:selectedOption.value,name:selectedOption.label})}} />
                </div>
                {currentAnnotationImage == '' ? <CircularProgress /> :
                <div style={{'grid-template-columns': 'repeat(1, 1fr)'}}>
                  <div>
                    <img src={currentAnnotationImage} height={'200px'} maxWidth={'250px'}/>
                    <TextField
                        value={currentAnnotationText}
                        onChange={(event) => setCurrentAnnotationText(event.target.value)}
                        variant="outlined"
                        rows={8}
                        multiline={true}
                      />
                  </div>
                  <div>
                    <Button onClick={addInstanceToContext}>Add Instance</Button>
                  </div>
                </div>}
              </div>
            </div> : <div></div>}
          */}
          </div>
          

  );
}

function FullscreenImageViewer({
  src,
  alt = "",
  isOpen,
  onClose,
  initialZoom = 1,
  minZoom = 1,
  maxZoom = 6,
  background = "rgba(0,0,0,0.65)",
  blurPx = 18,
}) {
  const containerRef = useRef(null);
  const imgRef = useRef(null);

  const [zoom, setZoom] = useState(initialZoom);
  const [tx, setTx] = useState(0); // translate X (px)
  const [ty, setTy] = useState(0); // translate Y (px)

  const [isDragging, setIsDragging] = useState(false);
  const dragStart = useRef({ x: 0, y: 0, tx: 0, ty: 0 });

  const [lastTouchDist, setLastTouchDist] = useState(null);
  const [lastTouchCenter, setLastTouchCenter] = useState(null);

  const clamp = (v, lo, hi) => Math.max(lo, Math.min(hi, v));

  // Lock scroll behind modal
  useEffect(() => {
    if (!isOpen) return;
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = prev;
    };
  }, [isOpen]);

  // ESC to close + reset on open
  useEffect(() => {
    if (!isOpen) return;

    setZoom(initialZoom);
    setTx(0);
    setTy(0);

    const onKeyDown = (e) => {
      if (e.key === "Escape") onClose?.();
      if (e.key === "+" || e.key === "=") zoomBy(1.15);
      if (e.key === "-" || e.key === "_") zoomBy(1 / 1.15);
      if (e.key === "0") resetView();
    };

    window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen]);

  const resetView = () => {
    setZoom(1);
    setTx(0);
    setTy(0);
  };

  const zoomBy = (factor, originClient = null) => {
    setZoom((z) => {
      const nextZoom = clamp(z * factor, minZoom, maxZoom);

      // Keep zoom centered around cursor/touch if we know origin point
      if (originClient && containerRef.current) {
        const rect = containerRef.current.getBoundingClientRect();
        const ox = originClient.x - (rect.left + rect.width / 2);
        const oy = originClient.y - (rect.top + rect.height / 2);

        // adjust translate so the point under cursor stays stable
        const scaleRatio = nextZoom / z;
        setTx((prev) => (prev - ox) * scaleRatio + ox);
        setTy((prev) => (prev - oy) * scaleRatio + oy);
      }

      return nextZoom;
    });
  };

  // Wheel/trackpad zoom
  const onWheel = (e) => {
    e.preventDefault();
    const delta = -e.deltaY;
    const factor = delta > 0 ? 1.12 : 1 / 1.12;
    zoomBy(factor, { x: e.clientX, y: e.clientY });
  };

  // Mouse drag to pan
  const onMouseDown = (e) => {
    // only left click
    if (e.button !== 0) return;
    e.preventDefault();
    setIsDragging(true);
    dragStart.current = { x: e.clientX, y: e.clientY, tx, ty };
  };

  const onMouseMove = (e) => {
    if (!isDragging) return;
    e.preventDefault();
    const dx = e.clientX - dragStart.current.x;
    const dy = e.clientY - dragStart.current.y;
    setTx(dragStart.current.tx + dx);
    setTy(dragStart.current.ty + dy);
  };

  const endDrag = () => setIsDragging(false);

  // Touch: drag + pinch zoom
  const getTouchInfo = (touches) => {
    if (touches.length === 1) {
      return { type: "pan", x: touches[0].clientX, y: touches[0].clientY };
    }
    if (touches.length >= 2) {
      const a = touches[0];
      const b = touches[1];
      const dx = b.clientX - a.clientX;
      const dy = b.clientY - a.clientY;
      const dist = Math.hypot(dx, dy);
      const center = { x: (a.clientX + b.clientX) / 2, y: (a.clientY + b.clientY) / 2 };
      return { type: "pinch", dist, center };
    }
    return { type: "none" };
  };

  const onTouchStart = (e) => {
    if (!isOpen) return;
    if (!e.touches?.length) return;
    e.preventDefault();

    const info = getTouchInfo(e.touches);
    if (info.type === "pan") {
      setIsDragging(true);
      dragStart.current = { x: info.x, y: info.y, tx, ty };
    } else if (info.type === "pinch") {
      setIsDragging(false);
      setLastTouchDist(info.dist);
      setLastTouchCenter(info.center);
    }
  };

  const onTouchMove = (e) => {
    if (!e.touches?.length) return;
    e.preventDefault();

    const info = getTouchInfo(e.touches);

    if (info.type === "pan" && isDragging) {
      const dx = info.x - dragStart.current.x;
      const dy = info.y - dragStart.current.y;
      setTx(dragStart.current.tx + dx);
      setTy(dragStart.current.ty + dy);
    } else if (info.type === "pinch") {
      if (lastTouchDist && lastTouchCenter) {
        const factor = info.dist / lastTouchDist;
        zoomBy(factor, info.center);

        // Also pan slightly by moving center
        const cdx = info.center.x - lastTouchCenter.x;
        const cdy = info.center.y - lastTouchCenter.y;
        setTx((p) => p + cdx);
        setTy((p) => p + cdy);
      }
      setLastTouchDist(info.dist);
      setLastTouchCenter(info.center);
    }
  };

  const onTouchEnd = (e) => {
    e.preventDefault();
    setIsDragging(false);
    if (!e.touches?.length) {
      setLastTouchDist(null);
      setLastTouchCenter(null);
    }
  };

  // Double click toggles zoom
  const onDoubleClick = (e) => {
    e.preventDefault();
    setZoom((z) => {
      const next = z <= 1.01 ? 2 : 1;
      if (next === 1) {
        setTx(0);
        setTy(0);
      } else {
        // zoom around cursor
        const rect = containerRef.current?.getBoundingClientRect();
        if (rect) {
          const ox = e.clientX - (rect.left + rect.width / 2);
          const oy = e.clientY - (rect.top + rect.height / 2);
          const scaleRatio = next / z;
          setTx((prev) => (prev - ox) * scaleRatio + ox);
          setTy((prev) => (prev - oy) * scaleRatio + oy);
        }
      }
      return clamp(next, minZoom, maxZoom);
    });
  };

  const transform = useMemo(
    () => `translate(${tx}px, ${ty}px) scale(${zoom})`,
    [tx, ty, zoom]
  );

  if (!isOpen) return null;

  return (
    <div
      ref={containerRef}
      style={{
        position: "fixed",
        inset: 0,
        zIndex: 9999,
        background,
        display: "grid",
        placeItems: "center",
        overflow: "hidden",
        touchAction: "none", // important for custom pinch/drag
      }}
      onWheel={onWheel}
      onMouseMove={onMouseMove}
      onMouseUp={endDrag}
      onMouseLeave={endDrag}
      onTouchStart={onTouchStart}
      onTouchMove={onTouchMove}
      onTouchEnd={onTouchEnd}
      onTouchCancel={onTouchEnd}
    >
      {/* Blurred backdrop layer */}
      <div
        aria-hidden
        style={{
          position: "absolute",
          inset: 0,
          backgroundImage: `url(${src})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          filter: `blur(${blurPx}px)`,
          transform: "scale(1.08)", // avoids edge clipping from blur
          opacity: 0.6,
        }}
      />

      {/* Clickable backdrop to close */}
      <button
        type="button"
        aria-label="Close image viewer"
        onClick={onClose}
        style={{
          position: "absolute",
          inset: 0,
          background: "transparent",
          border: "none",
          padding: 0,
          cursor: "zoom-out",
        }}
      />

      {/* Image wrapper (stops click-to-close) */}
      <div
        style={{
          position: "relative",
          zIndex: 1,
          maxWidth: "100vw",
          maxHeight: "100vh",
          padding: 16,
          display: "grid",
          placeItems: "center",
          userSelect: "none",
        }}
        onMouseDown={(e) => e.stopPropagation()}
        onClick={(e) => e.stopPropagation()}
      >
        <img
          ref={imgRef}
          src={src}
          alt={alt}
          draggable={false}
          onMouseDown={onMouseDown}
          onDoubleClick={onDoubleClick}
          style={{
            maxWidth: "calc(100vw - 32px)",
            maxHeight: "calc(100vh - 32px)",
            transform,
            transformOrigin: "center center",
            cursor: isDragging ? "grabbing" : zoom > 1 ? "grab" : "zoom-in",
            transition: isDragging ? "none" : "transform 80ms linear",
            boxShadow: "0 16px 50px rgba(0,0,0,0.35)",
            borderRadius: 12,
            background: "rgba(0,0,0,0.2)",
          }}
        />

        {/* Controls */}
        <div
          style={{
            position: "fixed",
            right: 16,
            bottom: 16,
            zIndex: 2,
            display: "flex",
            gap: 8,
          }}
        >
          <ControlButton onClick={() => zoomBy(1 / 1.2)} label="Zoom out" text="−" />
          <ControlButton onClick={() => zoomBy(1.2)} label="Zoom in" text="+" />
          <ControlButton onClick={resetView} label="Reset view" text="Reset" />
          <ControlButton onClick={onClose} label="Close" text="✕" />
        </div>

        {/* Hint */}
        <div
          style={{
            position: "fixed",
            left: 16,
            bottom: 16,
            zIndex: 2,
            padding: "8px 10px",
            borderRadius: 10,
            background: "rgba(0,0,0,0.35)",
            color: "white",
            fontSize: 12,
            lineHeight: 1.3,
            backdropFilter: "blur(8px)",
            maxWidth: 360,
          }}
        >
          <div><b>Tips:</b> wheel/pinch to zoom, drag to pan, double-click to toggle zoom, ESC to close.</div>
        </div>
      </div>
    </div>
  );
}

function ControlButton({ onClick, label, text }) {
  return (
    <button
      type="button"
      aria-label={label}
      onClick={(e) => {
        e.stopPropagation();
        onClick?.();
      }}
      style={{
        width: text === "Reset" ? 70 : 44,
        height: 44,
        borderRadius: 12,
        border: "1px solid rgba(255,255,255,0.18)",
        background: "rgba(0,0,0,0.35)",
        color: "white",
        fontSize: text === "Reset" ? 13 : 20,
        cursor: "pointer",
        backdropFilter: "blur(10px)",
      }}
    >
      {text}
    </button>
  );
}

/*
function SmallPdfViewer(props){
  const canvasRef = useRef();
  pdfjsLib.GlobalWorkerOptions.workerSrc = pdfjsWorker;

  const [pdfRef, setPdfRef] = useState();
  const [currentPage, setCurrentPage] = useState(1);

  const renderPage = useCallback((pageNum, pdf=pdfRef) => {
    pdf && pdf.getPage(pageNum).then(function(page) {
      const viewport = page.getViewport({scale: 1.5});
      const canvas = canvasRef.current;
      canvas.height = viewport.height;
      canvas.width = viewport.width;
      const renderContext = {
        canvasContext: canvas.getContext('2d'),
        viewport: viewport
      };
      page.render(renderContext);
    });   
  }, [pdfRef]);

  useEffect(() => {
    renderPage(currentPage, pdfRef);
  }, [pdfRef, currentPage, renderPage]);

  useEffect(() => {
    const loadingTask = pdfjsLib.getDocument(url);
    loadingTask.promise.then(loadedPdf => {
      setPdfRef(loadedPdf);
    }, function (reason) {
      console.error(reason);
    });
  }, [url]);

  const nextPage = () => pdfRef && currentPage < pdfRef.numPages && setCurrentPage(currentPage + 1);

  const prevPage = () => currentPage > 1 && setCurrentPage(currentPage - 1);

  return <canvas ref={canvasRef}></canvas>;
}
*/

function PDFViewerFunctional(props) {
  const [zoomScalePDF, setZoomScalePDF] = useState(1)
  const [highlights, setHighlights] = React.useState([])

  const [scrollToHighlightFunc, setScrollToHighlightFunc] = useState(() => (highlight) => console.log(highlight))

  const [addingHighlightType, setAddingHighlightType] = useState(false)
  const [currentHighlightIndex, setCurrentHighlightIndex] = useState(0)
  const [currentHighlightText, setCurrentHighlightText] = useState('')
  const [highlightTypeInputValue, setHighlightTypeInputValue] = useState('')
  const [selectedHighlightType, setSelectedHighlightType] = useState()

  //for image upload
  const [uploadingResourceToServer, setUploadingResourceToServer] = useState(false)
  const [uploadingProgress, setUploadingProgress] = useState(0.0)

  const [savingHighlights, setSavingHighlights] = useState(false)
  const [selectedTag, setSelectedTag] = useState('NOT_SET')
  const [currentInstanceID, setCurrentInstanceID] = useState('NOT_SET')

  const [previousDocumentTitle, setPreviousDocumentTitle] = useState('')


  useEffect(() => {
    loadHighlights()
    setPreviousDocumentTitle(document.title)
    document.title = "DIL PDF Reader (" + props.instancename + ")";
  }, [])


  const addHighlight = (newHighlight) => {
    console.log("Adding highlight", newHighlight);
    setHighlights(oldHighlights => {
        newHighlight.content.type = {id:'',name:''}
        const newHighlights = [{ ...newHighlight, id: getNextId() }, ...oldHighlights]
        setSavingHighlights(true)
        saveHighlights(newHighlights);
        console.log(newHighlights)
        return newHighlights;
    })
  }

  const updateHighlight = (highlightId, position, content) => {
    console.log("Updating highlight", highlightId, position, content);

    setHighlights(oldHighlights => {
      const newHighlights = oldHighlights.map(h => {const { id,
                                            position: originalPosition,
                                            content: originalContent,
                                            ...rest } = h;
                                            return id === highlightId ? {
                                                        id,
                                                        position: { ...originalPosition, ...position },
                                                        content: { ...originalContent, ...content },
                                                        ...rest
                                                      }
                                        : h})
      setSavingHighlights(true)
      saveHighlights(newHighlights);
      return newHighlights;
    });
  }

  const removeHighlight = (highlighId) => {
    console.log("Removing highlight ", highlighId);
    setHighlights(oldHighlights => {
      var newHighlights = []
      for (var i = 0; i < oldHighlights.length; i++) {
        if (oldHighlights[i].id != highlighId) {
          newHighlights.push(oldHighlights[i])
        }
      } 
      setSavingHighlights(true)
      saveHighlights(newHighlights);
      return newHighlights;})
  }

  const loadHighlights = () => {
    fetch(SERVER_LINK + '/load_pdf_tags', {
        method: 'GET',
          headers: {
            Accept:'application/json',
            'Content-Type': 'application/json',
            'SimpTokAuth': props.tokenPass,
            'InstID': props.instanceid
          }
        }).then((response) => response.json())
          .then((data) => { if (data==='NO_ANNOTATIONS') { console.log('no annotations'); } else { setHighlights(JSON.parse(data)) } console.log(data)})
          .catch((error) => console.log(error))
  }

  const saveHighlights = (highlightsToSave) => {
    fetch(SERVER_LINK + '/save_pdf_tags', {
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            idtoken: props.tokenPass,
            instanceid: props.instanceid,
            annotations: JSON.stringify(highlightsToSave)
        })
      }).then((response) => response.json())
        .then((data) => {if (data=='SUCCESS') {setSavingHighlights(false)} else {alert('Could not save highlights, please refresh')}} )
        .catch((error) => console.log(error))
  }

  const fetchTypes = async (input) => {
    return fetch(SERVER_LINK + '/get_types', {
                method: 'GET',
                  headers: {
                    Accept:'application/json',
                    'Content-Type': 'application/json',
                    'SimpTokAuth': props.tokenPass,
                    'InputSearchText': input
                  }
                }).then((response) => response.json())
                  .then((data) => data.map((type) => {return {label: type.name, value:type.id}}) )
                  .catch((error) => console.log(error))
  }

  const addType = (new_type_name) => {
    fetch(SERVER_LINK + '/add_type', {
      method: 'POST',
      headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
      },
      body: JSON.stringify({
          idtoken: props.tokenPass,
          type_name: new_type_name
      })
    }).then((response) => response.json())
      .catch((error) => console.log(error))
  }
  
  const startSettingTypeForHighlight = (hightlight_index) => {
    setCurrentHighlightIndex(hightlight_index); 
    if (highlights[hightlight_index].content.text != undefined) {
      setCurrentHighlightText(highlights[hightlight_index].content.text)
    } else {
      setCurrentHighlightText('Image from PDF of ' + props.instancename)
    }
    setAddingHighlightType(true)
  }

  const selectTypeForCurrentSelectedHighlight = (selectedOption) => {
    setSelectedHighlightType({id:selectedOption.value,name:selectedOption.label})
  }

  const handleSetTypeForHighlight = (instanceid) => {
    highlights[currentHighlightIndex].content.type = selectedHighlightType
    highlights[currentHighlightIndex].content.instanceid = instanceid
    if (highlights[currentHighlightIndex].content.image) {
      console.log('setting image for instance ... ' + instanceid)
      startUploadingImageInCloud(highlights[currentHighlightIndex].content.image, instanceid)

    }
    else {
      finishSettingHighlightType()
    }
  }

  const finishSettingHighlightType = () => {
    setSavingHighlights(true)
    saveHighlights(highlights);
    setAddingHighlightType(false)
  }

  //Linking Images
  const startUploadingImageInCloud = (image_string, instanceid) => {
    urltoFile(image_string, instanceid.toString() + '.png', 'image/png')
        .then((file) => {
          const data = new FormData();
          data.append('file', file);
          fetch(SERVER_LINK + '/get_image_upload_link', {
            method: 'POST',
            headers: {
              'SimpTokAuth': props.tokenPass,
              'InstID': instanceid,
              'ImageFileType': 'png'
            },
            body: data
          }).then((response) => response.json())
            .then((json) => {uploadImageToCloud(json, instanceid, file)})
            .catch((error) => {console.log(error)})
        })
  }

  const uploadImageToCloud = (imageToUploadURL, instanceid, imagefile) => {
    setUploadingResourceToServer(true)
    const putCloudConfig = {
      onUploadProgress: progressEvent => setUploadingProgress((progressEvent.loaded/imagefile.size)*100),
      headers: {
        'Content-Type': 'image/png'
      }
    }
    axios.put(imageToUploadURL, imagefile, putCloudConfig)
    .then((response) => {response.status==200 ? setSuccessfullImageUploadOnServer(instanceid) : alert('something went wrong with the upload')})
    .catch((error) => {console.log('error ... ' + error)})
    .finally(() => {setUploadingResourceToServer(false)})
  }

  const setSuccessfullImageUploadOnServer = (instanceid) => {
    fetch(SERVER_LINK + '/set_instance_image', {
      method: 'POST',
      headers: {
        'SimpTokAuth': props.tokenPass,
        'InstID': instanceid,
        'ImageFileType': 'png'
      },
      body: JSON.stringify({'empty': 'object'})
    }).then((response) => response.json())
      .then((data) => {finishSettingHighlightType()})
      .catch((error) => {console.log(error)})
  }

  const getHighlightById = (id) => {
    return highlights.find(highlight => highlight.id === id);
  }

  const copyToClipboard = (text) => {
    navigator.clipboard.writeText(text);
  }

  const parseIdFromHash = () => {document.location.hash.slice("#highlight-".length)};

  const scrollChange = () => {
    console.log('scroll change');
    document.location.hash = ''
  };

  const closePDFReader = () => {
    document.title = previousDocumentTitle
    props.closePdf()
  }

  
  return (<div>
    <div className="App" style={{ display: "flex", height: "100vh" }}>
      <div
          style={{
            height: "100vh",
            width: "110vw",
            position: "relative"
          }}
        >
          <Button onClick={() => {setZoomScalePDF((oldScale) => {var newScale = oldScale + 0.1; window.PdfViewer.viewer.currentScaleValue = newScale; return newScale}) }}>Zoom in</Button>
          <Button onClick={() => {setZoomScalePDF((oldScale) => {var newScale = oldScale - 0.1; window.PdfViewer.viewer.currentScaleValue = newScale; return newScale}) }}>Zoom out</Button>
          <Button onClick={() => {setZoomScalePDF((oldScale) => {var newScale = 1; window.PdfViewer.viewer.currentScaleValue = newScale; return newScale}) }}>Reset Zoom</Button>
          <Button onClick={() => {window.open(props.urlPdf, "PRINT");}}>Print</Button>
          <Button style={{'float': 'right'}} onClick={closePDFReader}> <CloseIcon/> </Button>
            <PdfLoader url={props.urlPdf}>
              {pdfDocument => (
                <PdfHighlighter
                  pdfDocument={pdfDocument}
                  enableAreaSelection={event => event.altKey}
                  onScrollChange={scrollChange}

                  // pdfScaleValue="page-width"
                  scrollRef={scrollTo => {
                    console.log(scrollTo)
                    setScrollToHighlightFunc(() => scrollTo)
                  }}

                  highlights={highlights}

                  onSelectionFinished={(
                    position,
                    content,
                    hideTipAndSelection,
                    transformSelection
                  ) => (
                    <PDFHighlightPopUp
                      onConfirm={() => {
                        addHighlight({ content, position });
                        hideTipAndSelection();
                      }}
                    />
                  )}

                  // When the user scrolls in top of the 
                  highlightTransform={(
                    highlight,
                    index,
                    setTip,
                    hideTip,
                    viewportToScaled,
                    screenshot,
                    isScrolledTo
                  ) => {
                    const isTextHighlight = !Boolean(
                      highlight.content && highlight.content.image
                    );

                    const component = isTextHighlight ? (
                      <Highlight
                        isScrolledTo={isScrolledTo}
                        position={highlight.position}
                        comment={highlight.comment}
                      />
                    ) : (
                      <AreaHighlight
                        highlight={highlight}
                        onChange={boundingRect => {
                          updateHighlight(
                            highlight.id,
                            { boundingRect: viewportToScaled(boundingRect) },
                            { image: screenshot(boundingRect) }
                          );
                        }}
                      />
                    );

                    return (
                      <Popup
                        popupContent={<HighlightPopup {...highlight} />}
                        onMouseOver={()=>{}}
                        onMouseOut={hideTip}
                        key={index}
                        children={component}
                      />
                    );}}
                  
                />
              )}
            </PdfLoader>
      </div>
          <List style={{overflow:'scroll'}}>
            {savingHighlights ? 
              <ListItem style={{'backgroundColor': 'orange'}}>
                <p>Saving...</p>
              </ListItem> :
              <div></div>}
            {highlights.length == 0 ? <div></div> :
            highlights.map((highlight, hightlight_index) => 
              <ListItem>
                <div>
                  <Card style={{'width':'100%', draggable: 'true'}}>
                    <div style={{'width':'50%', 'float':'left'}}>
                      {highlight.content.instanceid === undefined ?
                        <Button onClick={() => {startSettingTypeForHighlight(hightlight_index)}}>Set Type</Button> :
                        <div>
                          <h4 className={'type_mini'}>{highlight.content.type.name}</h4>
                          <Button onClick={() => {if (props.sendToMap) {props.sendToMap(highlight.content.instanceid)} else {alert('sendToMap only available if you open the pdf from a map')}}}>Send to Map</Button>
                        </div>}
                    </div>
                    <Button onClick={() => {removeHighlight(highlight.id)}} style={{'float': 'right', 'width':'50%'}}>Remove</Button>
                    <CardActionArea onClick={() => {scrollToHighlightFunc(highlight); copyToClipboard(highlight.content.text)}}>
                    {highlight.content.text ? (
                          <div style={{ marginTop: "0.5rem" , width:'200px', height: 'auto'}} >
                            <Typography variant='body2' style={{'padding':'5px'}}>{highlight.content.text}</Typography> 
                          </div>
                          ) : null}
                    {highlight.content.image ? (
                            <div
                              style={{ marginTop: "0.5rem" , width:'200px', height: 'auto'}}
                            >
                              <img src={highlight.content.image} alt={"Screenshot"} style={{width:'190px', 'padding':'5px'}}/>
                            </div>
                          ) : null}
                    </CardActionArea>
                  </Card>
                </div>
              </ListItem>
            )}
          </List>
          </div>
          {addingHighlightType ?
            <div className="infoi"> 
              <div className="centeredBox"> 
                <Button style={{'float': 'right'}}
                        onClick={() => {setCurrentHighlightIndex(-1); setAddingHighlightType(false);}}>
                  <CloseIcon/>
                </Button>
                <h4>Setting type for tag '{currentHighlightText}'</h4>
                {uploadingResourceToServer ? <CircularProgressWithLabel value={uploadingProgress} /> : null}
                <p>Current type is: #{highlights[currentHighlightIndex].content.type.id} - {highlights[currentHighlightIndex].content.type.name} </p>
                <h6>Select type of tag: </h6>
                <AsyncCreatableSelect cacheOptions
                                      defaultOptions
                                      inputValue={highlightTypeInputValue}
                                      onInputChange={(new_input) => {setHighlightTypeInputValue(new_input.toUpperCase())}}
                                      loadOptions={fetchTypes}
                                      placeholder={"Select type of content"}
                                      onChange={selectTypeForCurrentSelectedHighlight}
                                      onCreateOption={addType}
                                      style={{'margin-bottom': '10px', 'z-index': '10'}}/>
                {selectedHighlightType === undefined ? 
                  <div></div> :
                  <ListOfInstances tokenPass={props.tokenPass} 
                                   currentText={currentHighlightText} 
                                   typeid={selectedHighlightType.id} 
                                   typename={selectedHighlightType.name}
                                   removeText={() => {}}
                                   addNewLink={handleSetTypeForHighlight}
                                   url={''} />
                }

              
              </div>
            </div> : <div></div>}
          

      </div>
  );
}

function MiniPDFViewerFunctional(props) {
  const [numPages, setNumPages] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);

  function onDocumentLoadSuccess({ numPages }) {
    setNumPages(numPages);
  }


  return (<div style={{height: '300px', width: '300px'}}>
            <Document file={props.pdfPath} onLoadSuccess={onDocumentLoadSuccess} onLoadError={console.error}>
              <Page pageNumber={pageNumber} />
            </Document>
            <p>
              Page {pageNumber} of {numPages}
            </p>
          </div>

  );
}


  

/*
class WeekCalender extends Component {

  constructor(props) {
    super(props);
    this.props = props
    this.state = {
      startDate: props.beginningWeek,
      viewType: "Week",
      headerDateFormat: "dddd",
      cellHeight: 30
    };
  }

  componentDidMount() {

    // load event data


    this.setState({
      events: [
        {
          id: 1,
          text: "Event 1",
          start: "2022-03-07T10:30:00",
          end: "2022-03-07T13:00:00"
        },
        {
          id: 2,
          text: "Event 2",
          start: "2022-03-08T09:30:00",
          end: "2022-03-08T11:30:00",
          backColor: "#6aa84f"
        },
        {
          id: 3,
          text: "Event 3",
          start: "2022-03-08T12:00:00",
          end: "2022-03-08T15:00:00",
          backColor: "#f1c232"
        },
        {
          id: 4,
          text: "Event 4",
          start: "2022-03-06T11:30:00",
          end: "2022-03-06T14:30:00",
          backColor: "#cc4125"
        },
      ]
    });
  }

  render() {
    var {...config} = this.state;
    return (
      <div>
        <DayPilotCalendar
          {...config}
          ref={component => {
            this.calendar = component && component.control;
          }}
          onTimeRangeSelected={args => {
            DayPilot.Modal.prompt("New event name", "Event").then(modal => {
              this.scheduler.clearSelection();
              if (!modal.result) {
                return;
              }
              this.scheduler.events.add({
                id: DayPilot.guid(),
                text: modal.result,
                start: args.start,
                end: args.end,
                resource: args.resource
              });
            });
          }}
        />
      </div>
    );
  }
}
*/

class DynamicChart extends Component {
	constructor() {
		super();
		this.updateChart = this.updateChart.bind(this);
    this.jump = this.jump.bind(this);
    //construct 100 points
    this.dps = [{x: 1, y: 0}, {x: 2, y: 0}, {x: 3, y: 0}, {x: 4, y: 0}, {x: 5, y: 1},{x: 6, y: 1}, {x: 7, y: 1}, {x: 8, y: 2}, {x: 9, y: 2}, {x: 10, y: 3},{x: 11, y: 3}, {x: 12, y: 3}, {x: 13, y: 4}, {x: 14, y: 4}, {x: 15, y: 5},{x: 16, y: 5}, {x: 17, y: 5}, {x: 18, y: 6}, {x: 19, y: 6}, {x: 20, y: 7},{x: 21, y: 7}, {x: 22, y: 7}, {x: 23, y: 8}, {x: 24, y: 8}, {x: 25, y: 9},{x: 26, y: 9}, {x: 27, y: 9}, {x: 28, y: 10}, {x: 29, y: 10}, {x: 30, y: 11},{x: 31, y: 11}, {x: 32, y: 11}, {x: 33, y: 12}, {x: 34, y: 12}, {x: 35, y: 13},{x: 36, y: 13}, {x: 37, y: 13}, {x: 38, y: 14}, {x: 39, y: 14}, {x: 40, y: 15},{x: 41, y: 15}, {x: 42, y: 15}, {x: 43, y: 16}, {x: 44, y: 16}, {x: 45, y: 17},{x: 46, y: 17}, {x: 47, y: 17}, {x: 48, y: 18}, {x: 49, y: 18}, {x: 50, y: 19},{x: 51, y: 19}, {x: 52, y: 19}, {x: 53, y: 20}, {x: 54, y: 20}, {x: 55, y: 21},{x: 56, y: 21}, {x: 57, y: 21}, {x: 58, y: 22}, {x: 59, y: 22}, {x: 60, y: 23},{x: 61, y: 23}, {x: 62, y: 23}, {x: 63, y: 24}, {x: 64, y: 24}, {x: 65, y: 25},{x: 66, y: 25}, {x: 67, y: 25}, {x: 68, y: 26}, {x: 69, y: 26}, {x: 70, y: 27},{x: 71, y: 27}, {x: 72, y: 27}, {x: 73, y: 28}, {x: 74, y: 28}, {x: 75, y: 29},{x: 76, y: 29}, {x: 77, y: 29}, {x: 78, y: 30}, {x: 79, y: 30}, {x: 80, y: 31},{x: 81, y: 31}, {x: 82, y: 31}, {x: 83, y: 32}, {x: 84, y: 32}, {x: 85, y: 33},{x: 86, y: 33}, {x: 87, y: 33}, {x: 88, y: 34}, {x: 89, y: 34}, {x: 90, y: 35},{x: 91, y: 35}, {x: 92, y: 35}, {x: 93, y: 36}, {x: 94, y: 36}, {x: 95, y: 37},{x: 96, y: 37}, {x: 97, y: 37}, {x: 98, y: 38}, {x: 99, y: 38}, {x: 100, y: 39}]
    this.xVal = this.dps.length + 1;
    this.yVal = 21;
    this.yVelocity = 10;
    this.yAcceleration = -0.5;
	}
	componentDidMount() {
		const myInterval = setInterval(this.updateChart, 1000);
    this.interval_js = myInterval;
	}
  componentWillUnmount() {
    clearInterval(this.interval_js);
  }
  jump() {
    console.log("jump");
    this.yVelocity = 10;
  }
	updateChart() {
		this.xVal = this.xVal + 1;
		this.yVal += this.yVelocity;
		this.dps.push({x: this.xVal,y: this.yVal});
    this.yVelocity += this.yAcceleration;
		if (this.dps.length >  20 ) {
			this.dps.shift();
		}
		this.chart.render();
	}
	render() {
		const options = {
			title :{
				text: "Dynamic Line Chart"
			},
      height : 200,
      width: 300,
			data: [{
				type: "line",
				dataPoints : this.dps
			}]
		}
		return (
		<div>
			<CanvasJSChart options = {options}
				             onRef={ref => this.chart = ref} />
      <Button onClick={this.jump}>Jump</Button>
			{/*You can get reference to the chart instance as shown above using onRef. This allows you to access all chart properties and methods*/}
		</div>
		);
	}
}




//************** */
//***Content**** */
//************** */
//************** */


function PropTagBox(props) {
  const classes = useStyles();

  const [expanded, setExpanded] = React.useState(false);

  const [typeName, setTypeName] = useState('')

  const [inheritedTypes, setInheritedTypes] = useState([])

  const [propTypeInputValue, setPropTypeInputValue] = useState('')
  const [selectedPropTypeID, setSelectedPropTypeID] = useState('')
  const [selectedPropTypeName, setSelectedPropTypeName] = useState('')

  const [possiblePaths, setPossiblePaths] = useState([])
  const [possiblePathsIDs, setPossiblePathsIDs] = useState([])
  const [selectedPath, setSelectedPath] = useState('NULL')

  //const cardBackground = (selectedPath == 'NULL' ? 'grey' : 'green')

  useEffect(() => {
    fetch(SERVER_LINK + '/get_all_parents_and_type', {
      method: 'GET',
        headers: {
          Accept:'application/json',
          'Content-Type': 'application/json',
          'SimpTokAuth': props.tokenPass,
          'InstTypeId': props.assType.id
        }
      }).then((response) => response.json())
        .then((data) => { if (Array.isArray(data)) {setInheritedTypes(data)} else {console.log(data)}})
        .catch((error) => console.log(error))
  }, [props.assType.id])

  const handleSelection = (selectedOption) => {
    setSelectedPropTypeID(selectedOption.value)
    setSelectedPropTypeName(selectedOption.label)
  }

  const handleInputChange = (new_input) => {
    setPropTypeInputValue(new_input.toUpperCase())
  }

  const fetchTypes = async (input) => {
    return fetch(SERVER_LINK + '/get_types', {
                method: 'GET',
                  headers: {
                    Accept:'application/json',
                    'Content-Type': 'application/json',
                    'SimpTokAuth': props.tokenPass,
                    'InputSearchText': input
                  }
                }).then((response) => response.json())
                  .then((data) => data.map((type) => {return {label: type.name, value:type.id}}) )
                  .catch((error) => console.log(error))
  }

  const handleExpandClick = () => {
    // compute all the possible fit's with depth 5
    if (possiblePaths.length == 0) {
      recursiveTypeSearch(props.selectedType.name, props.selectedType.id, props.selectedType.id, 5)
    }

    setExpanded(!expanded);
  };

  const recursiveTypeSearch = (currentPath, currentPathID, currentTypeID, maxDepth) => {
    if (selectedPath == 'NULL') {
      fetch(SERVER_LINK + '/get_properties', {
        method: 'GET',
          headers: {
            Accept:'application/json',
            'Content-Type': 'application/json',
            'SimpTokAuth': props.tokenPass,
            'InstTypeID': currentTypeID
          }
        }).then((response) => response.json())
          .then((data) => {matchType(currentPath, currentPathID, data, maxDepth)})
          .catch((error) => console.log(error))
    }
      
    }


  const matchType = (currentPath, currentPathID, properties, maxDepth) => {
    for (var prop_index = 0; prop_index < properties.length; prop_index++) {
      var newPath = currentPath + ':' + properties[prop_index].propname + '-' + properties[prop_index].required_typename
      var newPathID = currentPathID + ':' + properties[prop_index].propid + '-' + properties[prop_index].required_typeid
      console.log(newPath)
      var pathIsValid = false
      console.log(inheritedTypes)
      for (var i = 0; i < inheritedTypes.length; i++) {
        if (inheritedTypes[i].id == properties[prop_index].required_typeid) {
          pathIsValid = true;
          break;
        }
      }
      if (pathIsValid) {
        setPossiblePaths((oldArray) => [...oldArray, newPath])
        setPossiblePathsIDs((oldArray) => [...oldArray, newPathID])
      }

      if (maxDepth > 0) {
        recursiveTypeSearch(newPath, newPathID, properties[prop_index].required_typeid, maxDepth-1)
      }

    }


  }



  return (<Card style={{'margin': '15px'}}>
                <CardContent style={{'margin': '5px', display: 'flex', justifyContent: 'space-between', padding: '10px'}}>
                  <Typography style={{'width': '50%', 'margin-left':'5px'}}>{props.tag.text}</Typography>
                  <div>
                    {props.assType.name == '' ? 
                      <Button style={{'float': 'right'}} onClick={props.setType}>Set Type</Button> :
                      <div style={{'float': 'right', 'display': 'flex'}} >
                        <h4 className={'type_mini'}>{props.assType.name}</h4>
                        {selectedPath == 'NULL' ? <div></div> :
                          <CheckCircleIcon/>}
                        <IconButton aria-label="edit instance">
                          <EditIcon onClick={props.setType}/>
                        </IconButton>
                        <IconButton
                          className={clsx(classes.expand, {
                            [classes.expandOpen]: expanded,
                          })}
                          onClick={handleExpandClick}
                          aria-expanded={expanded}
                          aria-label="show more"
                        >
                          <ExpandMoreIcon />
                        </IconButton>
                      </div>
                    }
                  </div>
              </CardContent>
            <Collapse in={expanded} timeout="auto" unmountOnExit>
                <CardContent>
                  <Typography paragraph>Possible paths for type: </Typography>
                  <Grid>
                    {possiblePaths.map((path, idx) => 
                        {if (selectedPath == path) {
                          return <Card style={{'backgroundColor': 'lightgreen'}}>
                                    <CardActionArea onClick={() => {setSelectedPath('NULL');}} >
                                      <p>{path}</p>
                                    </CardActionArea>
                                  </Card>
                        } else {
                          return <Card>
                                  <CardActionArea onClick={() => {setSelectedPath(path); props.setPropPath(possiblePathsIDs[idx], props.tag)}} >
                                    <p>{path}</p>
                                  </CardActionArea>
                                </Card>
                        }}
                    )}
                  </Grid>
                </CardContent>
            </Collapse>
          </Card>)
}


function SearchPrototype(props) {
  const classes = useStyles();
  const [fetchingProperties, setFetchingProperties] = React.useState(true)
  const [properties, setProperties] = React.useState([])
  const [prototype, setPrototype] = React.useState([
                                                        { 
                                                          "propid": "20", 
                                                          "values": ['66', '64', '65']
                                                        }, 
                                                        {
                                                          "propid":"18", 
                                                          "values":[]
                                                        } 
                                                      ])
  const [values, setValues] = React.useState([])

  React.useEffect(() => {
    fetchProperties()
  }, [1])

  const initializePrototype = (prop_data) => {
    if (Array.isArray(prop_data)) {
      setProperties(prop_data); 
      setFetchingProperties(false);
      var newPrototype = []
      for (var i = 0; i < prop_data.length; i++) {
        newPrototype.push({"propid": prop_data[i].propid.toString(), "values": []})
      }
      setPrototype(newPrototype)
    } 
    else {
      console.log(prop_data)
    }
  }

  const updtPrttype = (propsid, instsid) => {
    var newPrototype = []
    for (var i = 0; i < prototype.length; i++) {
      if (prototype[i].propid==propsid) {
        const newValues = prototype[i].values.concat(instsid.toString())
        newPrototype.push({"propid": prototype[i].propid, "values": newValues})
      }
      else {
        newPrototype.push(prototype[i])
      }
    }
    setPrototype(newPrototype)
  }

  const fetchProperties = () => {
    fetch(SERVER_LINK + '/get_properties', {
        method: 'GET',
          headers: {
            Accept:'application/json',
            'Content-Type': 'application/json',
            'SimpTokAuth': props.tokenPass,
            'InstTypeID': props.typeid
          }
        }).then((response) => response.json())
          .then((data) => {initializePrototype(data)})
          .catch((error) => console.log(error))
  }

  const query = () => {
    console.log('querying instances');
    props.startQuery()
      fetch(SERVER_LINK + '/query_instances', {
        method: 'GET',
          headers: {
            Accept:'application/json',
            'Content-Type': 'application/json',
            'SimpTokAuth': props.tokenPass,
            'InstTypeID': props.typeid,
            // 'InputSearchText': encodeURI(JSON.stringify(prototype))
          }
        }).then((response) => response.json())
          .then((data) => {if (Array.isArray(data)) {props.setQueryResult(data); props.closeAdvSearch()} else { console.log(data) }})
          .catch((error) => console.log(error))
    }


  return (
    fetchingProperties ? 
        <p> Loading...</p> : 
        <div>
              <Grid container
                    direction="column"
                    justify="flex-start"
                    alignItems="stretch"
                    style={{'flex-wrap': 'initial'}}>
                    {properties.map((property) => <InstancePropertyForSearch  tokenPass={props.tokenPass} 
                                                                              propid={property.propid} 
                                                                              propname={property.propname} 
                                                                              prop_req_typeid={property.required_typeid} 
                                                                              prop_req_type={property.required_typename}
                                                                              updatePrototype={updtPrttype}
                                                                              />)}
                  </Grid>
                  <Button onClick={query}>Query</Button>
      </div>
  )

}


function SearchBox(props) {
  const classes = useStyles();
  const [opened, setOpened] = React.useState(false)


  return (<div style={{width: '100%'}}>
            <Card>
              <CardActionArea onClick={() => setOpened(!opened)}>
                <CardContent>
                  <Typography variant="h4" >Advanced Search</Typography>
                </CardContent>
              </CardActionArea>
            
              <Collapse in={opened} timeout="auto" unmountOnExit>
                <SearchPrototype tokenPass={props.tokenPass} 
                                  typeid={props.typeid}
                                  startQuery={props.startQuery}
                                  setQueryResult={props.setQueryResult}
                                  closeAdvSearch={() => setOpened(false)}
                        />
              </Collapse>
            </Card>
          </div>)

}


function AddProperty(props) {
  const classes = useStyles();
  const [addingProperty, setAddingProperty] = React.useState(false);
  const [refreshing, setRefreshing] = React.useState(false);
  const [newPropName, setNewPropName] = React.useState('');
  const [reqPropTypeName, setReqPropTypeName] = React.useState('');
  const [reqPropTypeID, setReqPropTypeID] = React.useState('');


  const addProperty = () => {
    fetch(SERVER_LINK + '/add_property', {
      method: 'POST',
      headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
      },
      body: JSON.stringify({
          idtoken: props.tokenPass,
          parent_type: props.parentType,
          prop_name: newPropName,
          req_type_id: reqPropTypeID
      })
    }).then((response) => response.json())
      .then(() => {setAddingProperty(false); props.refresh()} )
      .catch((error) => console.log(error))
  }

  const handleSelectChange = (selectedOption) => {
    setReqPropTypeID(selectedOption.value)
  }

  const handleInputChange = (new_input) => {
    setReqPropTypeName(new_input.toUpperCase())
  }

  const handleTextInputChange = (event) => {
    setNewPropName(event.target.value)
  }

  const fetchTypes = async (input) => {
    return fetch(SERVER_LINK + '/get_types', {
                method: 'GET',
                  headers: {
                    Accept:'application/json',
                    'Content-Type': 'application/json',
                    'SimpTokAuth': props.tokenPass,
                    'InputSearchText': input
                  }
                }).then((response) => response.json())
                  .then((data) => data.map((type) => {return {label: type.name, value:type.id}}) )
                  .catch((error) => console.log(error))
  }

  const addType = (new_type_name) => {
    fetch(SERVER_LINK + '/add_type', {
      method: 'POST',
      headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
      },
      body: JSON.stringify({
          idtoken: props.tokenPass,
          type_name: reqPropTypeName
      })
    }).then((response) => response.json())
      .catch((error) => console.log(error))
      .finally(() => {setRefreshing(true);})
  }

  return (<div className="prop_wrapper">
            {addingProperty ?
                  <div style={{'overflow': 'auto'}}>
                    <p >Prop Name:</p>
                    <TextField variant="outlined"
                               fullWidth={true}
                               onChange={handleTextInputChange}
                               value={newPropName} />
                    <p>Required Type:</p>
                    {refreshing? <p>Loading ... {setRefreshing(false)}</p> :
                    <AsyncCreatableSelect cacheOptions
                                          defaultOptions
                                          inputValue={reqPropTypeName}
                                          onInputChange={handleInputChange}
                                          loadOptions={fetchTypes}
                                          onCreateOption={addType}
                                          placeholder={"Select Type"}
                                          onChange={handleSelectChange} 
                                          />}

                    <Button onClick={() => {setAddingProperty(false)}}> Cancel </Button>
                    <Button onClick={() => {addProperty()}}> Add </Button>
                  </div> :
                  <Button onClick={() => {setAddingProperty(true)}}> Add New Property </Button>
            }
          </div>)
}


function InstanceProperty(props) {
  const classes = useStyles();
  const [expanded, setExpanded] = React.useState(false);
  const [fetchingLink, setFetchingLink] = React.useState(true);

  const [linkData, setLinkData] = React.useState([]);

  const [refreshingInstChoices, setRefreshingInstChoices] = React.useState(true)
  const [currentSearchText, setCurrentSearchText] = React.useState('')
  const [refreshOptions, setRefreshOptions] =  React.useState(true)

  const fetchCurrentLink = () => {
    fetch(SERVER_LINK + '/get_link', {
        method: 'GET',
          headers: {
            Accept:'application/json',
            'Content-Type': 'application/json',
            'SimpTokAuth': props.tokenPass,
            'InstID': props.instid,
            'PropID': props.propid
          }
        }).then((response) => response.json())
          .then((data) => {if (Array.isArray(data)) {setLinkData(data); setFetchingLink(false);} else { setLinkData([]); setFetchingLink(false);}; console.log(data); })
          .catch((error) => console.log(error))
  };

  const removeLink = () => {
    fetch(SERVER_LINK + '/delete_link', {
      method: 'POST',
      headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
      },
      body: JSON.stringify({
          idtoken: props.tokenPass,
          instid: props.instid,
          propid: props.propid
      })
    }).then((response) => response.json())
      .then((data) => {if (data=='SUCCESS') {setFetchingLink(true); fetchCurrentLink();} else {console.log(data)}})
      .catch((error) => console.log(error))
  };

  const addLink = (choosenPropId) => {
    fetch(SERVER_LINK + '/add_link', {
      method: 'POST',
      headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        idtoken: props.tokenPass,
        instid: props.instid,
        propid: props.propid,
        instvalueid: choosenPropId
      })
    }).then((response) => response.json())
      .then((data) => {if (data=='SUCCESS') {setFetchingLink(true); fetchCurrentLink(); setCurrentSearchText('')} else {console.log(data)}})
      .catch((error) => console.log(error))
  };


  const handleSearchTextChange = (event) => {
    setCurrentSearchText(event.target.value)
    setRefreshOptions(true)
  }

  const keyPress = (e) => {
    if(e.keyCode == 13){
      setRefreshOptions(false)
    }
 }

 const handleExpandClick = () => {
  if (!expanded) {
    setFetchingLink(true);
    fetchCurrentLink()
  }
  else {
    setFetchingLink(false);
    setLinkData([]);
  }
  setExpanded(!expanded);
  
};


  return (<div className="prop_wrapper">
            <div className="prop_top">
                <div class="alignleft">
                    <h4 class="prop_title">{props.propname}</h4>
                    <IconButton onClick={() => {props.removeProp(props.propid)}}>
                      <DeleteForeverIcon/>
                    </IconButton>
                </div>
                <div class="alignright">
                  <h6 class="type_mini">{props.prop_req_type}</h6>
                  <IconButton className={clsx(classes.expand, { [classes.expandOpen]: expanded })}
                              onClick={handleExpandClick}>
                      <ExpandMoreIcon />
                  </IconButton>
                </div>
            </div>
            {expanded?
            <div className="prop_bottom">
                {fetchingLink ? 
                    <p>Loading values... </p> :
                      <div>
                          <Grid container
                              direction="column"
                              justify="flex-start"
                              alignItems="stretch">
                            {linkData.map((instance) => 
                                <div className="card">
                                  <InstanceCard tokenPass={props.tokenPass}
                                          text={instance.instancetext} 
                                          typename={instance.typename} 
                                          instanceid={instance.instanceid} 
                                          typeid={instance.typeid}
                                          handleDelete={removeLink}
                                          pdfPath={instance.instancepdf}
                                          imagePath={instance.instanceimage}
                                          someURL={instance.someURL}
                                          updateParent={() => {}}
                                          sendToMap={(instid) => {}}
                                          />
                                </div>)}
                          </Grid>
                          <div className="instanceSearcher">
                            <TextField variant="standard" 
                                        value={currentSearchText}
                                        onChange={handleSearchTextChange}
                                        fullWidth={true} 
                                        placeholder="Type new value for this property"
                                        onKeyDown={keyPress}/>
                                        {currentSearchText=='' ? <div></div> : 
                                                    <div>
                                                       <ListOfInstances tokenPass={props.tokenPass} 
                                                                        currentText={currentSearchText} 
                                                                        typeid={props.prop_req_typeid} 
                                                                        typename={props.prop_req_type}
                                                                        removeText={() => {setCurrentSearchText('')}}
                                                                        addNewLink={addLink} />
                                                      </div>}
                          </div>
                      </div>
                    }
              </div>
              :<div></div>}

          </div>)
}


function InstancePropertyForSearch(props) {
  const classes = useStyles();

  const [instances, setInstances] = React.useState([])

  const [currentSearchText, setCurrentSearchText] = React.useState('')
  const [refreshOptions, setRefreshOptions] =  React.useState(true)


  const handleSearchTextChange = (event) => {
    setCurrentSearchText(event.target.value)
    setRefreshOptions(true)
  }

  const keyPress = (e) => {
    if(e.keyCode == 13){
      setRefreshOptions(false)
    }
  }


  const addNewInstance = (instance) => {
    const newInstances = instances.concat(instance)
    setInstances(newInstances)
    setCurrentSearchText('')
    setRefreshOptions(true)
    props.updatePrototype(props.propid, instance.instanceid)
  }


  return (<div className="prop_search_wrapper" style={{'display': 'inline-table'}}>
                <div class="alignleft" style={{'width': '20%', 'display': 'block'}}>
                    <h4 class="prop_title" style={{'margin-left': '0px'}}>{props.propname}</h4>{"\n"}
                    <h6 class="type_mini">{props.prop_req_type}</h6>
                </div>
                <div className="alignright" style={{'width': '75%', 'display': 'block'}}>
                  <div style={{'width': '100%'}}>
                  <Grid container
                        direction="column"
                        justify="flex-start"
                        alignItems="stretch"
                        style={{'flex-wrap': 'initial'}}>
                        {instances.map((instance) => 
                                <div className="cardmini" style={{'padding': '3px'}}>
                                  <Card>
                                      <CardContent style={{'display': 'flex', 'padding': '3px'}}>
                                        <Avatar aria-label="recipe">
                                                  {instance.typename.charAt(0)}
                                        </Avatar>
                                      <Typography variant="body2" style={{'margin': 'auto', 'margin-left': '10px'}}>
                                        {instance.instancetext.length > 200 ? instance.instancetext.substring(0,200).join(' ') : instance.instancetext.join(' ') }
                                      </Typography>
                                      </CardContent>
                                  </Card>
                                </div>)}
                                <div className="instanceSearcher">
                      <TextField variant="standard" 
                                  value={currentSearchText}
                                  onChange={handleSearchTextChange}
                                  fullWidth={true} 
                                  placeholder="Type new value for this property"
                                  onKeyDown={keyPress}/>
                      {currentSearchText=='' ? <div></div> : 
                            (refreshOptions? <div> <Button onClick={() => {setRefreshOptions(false)}}> Search </Button></div> : 
                            <div>
                                <ListOfKnownInstancesForSearch tokenPass={props.tokenPass} 
                                                                currentText={currentSearchText} 
                                                                typeid={props.prop_req_typeid} 
                                                                typename={props.prop_req_type}
                                                                removeText={() => {setCurrentSearchText('')}}
                                                                addNewValue={addNewInstance}
                                                            />
                            </div>)}
                  </div>  
                        </Grid>
                  </div>
                  
                </div>
          </div>)
}


//Instance Card
function InstanceCard(props) {
  const classes = useStyles();

  const [expanded, setExpanded] = React.useState(false);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [fetchingProperties, setFetchingProperties] = React.useState(false);
  const [properties, setProperties] = React.useState([{}]);

  const [editingText, setEditingText] = React.useState(false);
  const [currentEditedText, setCurrentEditedText] = React.useState(props.text);

  const [addingHighlight, setAddingHighlight] = React.useState(false)
  const [highlightCurrentTypeName, setHighlightCurrentTypeName] = React.useState('')

  const [currentFullTokenizedText, setCurrentFullTokenizedText] = React.useState(props.text);
  const [currentlyHighlightedTokens, setCurrentlyHighlightedTokens] = React.useState([]);
  const [temporaryHighlights, setTemporaryHighlights] = React.useState([]);
  const [highlights, setHighlights] = React.useState([]);
  const [currentHighlightTypeName, setCurrentHighlightTypeName] = React.useState('');
  const [currentHighlightTypeID, setCurrentHighlightTypeID] = React.useState('');
  const [currentHighlightTagColor, setCurrentHighlightTagColor] = React.useState('#ffcc80')

  const [currentURLPath, setCurrentURLPath] = useState(props.someURL);
  const [embedType, setEmbedType] = useState('');
  const [embedLink, setEmbedLink] = useState('');
  const [widthEmbed, setWidthEmbed] = useState(340)


  const [currentPdfPath, setCurrentPdfPath] = React.useState(props.pdfPath);


  const [currentImagePath, setCurrentImagePath] = React.useState(props.imagePath);

  const [currentSelectedImage, setCurrentSelectedImage] = useState(null)
  const [currentSelectedImageFile, setCurrentSelectedImageFile] = useState(null)
  const [currentSelectedImageName, setCurrentSelectedImageName] = useState('')
  const [currentSelectedImageUploadURL, setCurrentSelectedImageUploadURL] = useState('')

  const [deletingInstance, setDeletingInstance] = React.useState(false);
  const [linkingResource, setLinkingResource] = React.useState(false);
  const [resourceType, setResourceType] = useState('');
  const [uploadingResourceToServer, setUploadingResourceToServer] = useState(false)
  const [uploadingProgress, setUploadingProgress] = useState(0);
  const [clickedHighlight, setClickedHighlight] = React.useState(false);
  const [visualizingPDF, setVisualizingPDF] = React.useState(false);
  const [visualizingImage, setVisualizingImage] = useState(false)

  const [currentURLToLink, setCurrentURLToLink] = useState('')
  const [URLToLinkMeta, setURLToLinkMeta] = useState({})

  const [currentURLMeta, setCurrentURLMeta] = useState({})
  const [currentOpacity, setCurrentOpacity] = useState('1.0')



  useEffect(() => {
    let url_div_element = document.getElementById("cardid" + props.instanceid.toString())
    if ((url_div_element != null) && (currentURLPath != '')) {
      url_div_element.addEventListener('click', handleURLClick);
    }
  }, [])

  useEffect(() => {
    if (currentURLPath != null) {
      //checkURL(currentURLPath)
    }
  }, [currentURLPath])

  const handleExpandClick = () => {
    if (!expanded) {
      setFetchingProperties(true);
      fetchProperties()
    }
    setExpanded(!expanded);
    
  };

  const handleEdit = () => {
    setEditingText(true)
  }

  const handleMainInstTextChange = (event) => {
    setCurrentEditedText(event.target.value)
  }

  const handleSave = () => {
    fetch(SERVER_LINK + '/set_instance_text', {
      method: 'POST',
      headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
      },
      body: JSON.stringify({
          idtoken: props.tokenPass,
          instanceid: props.instanceid,
          instance_text: currentEditedText,
          typename: props.typename,
          url: currentURLPath || '',
      })
    }).then((response) => response.json())
      .then((data) => {if (data) {setCurrentFullTokenizedText(currentEditedText); setEditingText(false); props.updateParent()} else {alert('Not connected, please refreshh - Note that all writing will be lost')}})
      .catch((error) => console.log(error))
  }

  const fetchProperties = () => {
    fetch(SERVER_LINK + '/get_properties', {
        method: 'GET',
          headers: {
            Accept:'application/json',
            'Content-Type': 'application/json',
            'SimpTokAuth': props.tokenPass,
            'InstTypeID': props.typeid
          }
        }).then((response) => response.json())
          .then((data) => {if (Array.isArray(data)) {setProperties(data); setFetchingProperties(false);} else {console.log(data)}})
          .catch((error) => console.log(error))
  }

  const removeProperty = (property_id) => {
    fetch(SERVER_LINK + '/delete_property', {
      method: 'POST',
      headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
      },
      body: JSON.stringify({
          idtoken: props.tokenPass,
          propid: property_id
      })
    }).then((response) => response.json())
      .then((data) => {if (data=='SUCCESS') {setFetchingProperties(true); fetchProperties();} else {console.log(data)}})
      .catch((error) => console.log(error))
  };

  const handleTaggingEvent = (new_highlights) => {
    if (new_highlights.length < highlights.length) {
      console.log('clicked highlight ');
      // get the clicked instance
      var selectedHighlight;
      if (new_highlights.length == 0) {
        selectedHighlight = highlights[0]
      }
      else {
        for (var i = 0; i < highlights.length; i++) {
          var currentHighlightedBelongs = false
          for (var j = 0; j < new_highlights.length; j++) {
            if (highlights[i].start == new_highlights[j].start && highlights[i].end == new_highlights[j].end && highlights[i].instanceid == new_highlights[j].instanceid) {
              currentHighlightedBelongs = true
              break;
            }
          }
          if (!currentHighlightedBelongs) {
            selectedHighlight = highlights[i]
            break;
          }
        }
      }
      setCurrentlyHighlightedTokens(selectedHighlight.tokens)
      setClickedHighlight(true)
      setTemporaryHighlights(new_highlights)
    }
    else {
      console.log('adding and copying highlight');
      //get object highligh
      var nhighlight = new_highlights[new_highlights.length-1]
      var highlighttokens = [];
      for (var i=nhighlight.start; i<nhighlight.end; i++) {
        highlighttokens.push(currentFullTokenizedText[i])
      }
      var text = highlighttokens.join(" ");
      navigator.clipboard.writeText(text).then(function() {
        console.log('Async: Copying to clipboard was successful!');
      }, function(err) {
        console.error('Async: Could not copy text: ', err);
      });
      setCurrentlyHighlightedTokens(highlighttokens)
      setAddingHighlight(true)
      setTemporaryHighlights(new_highlights)
    }
  };

  const openWebLink = () => {

    for (var i = 0; i < currentlyHighlightedTokens.length; i++) {
      if (validURL(currentlyHighlightedTokens[i])) {
        window.open(currentlyHighlightedTokens[i])
      }
    }
    setCurrentlyHighlightedTokens([])
    setClickedHighlight(false)
    setTemporaryHighlights([])
  }

  const deleteHighlight = () => {
    setHighlights(temporaryHighlights)
    saveHighlights(temporaryHighlights)
    setCurrentlyHighlightedTokens([])
    setClickedHighlight(false)
    setTemporaryHighlights([])
  }

  const fetchTypes = async (input) => {
    return fetch(SERVER_LINK + '/get_types', {
                method: 'GET',
                  headers: {
                    Accept:'application/json',
                    'Content-Type': 'application/json',
                    'SimpTokAuth': props.tokenPass,
                    'InputSearchText': input
                  }
                }).then((response) => response.json())
                  .then((data) => data.map((type) => {return {label: type.name, value:type.id}}))
                  .catch((error) => console.log(error))
  }

  const addHighlight = (associated_instance_id) => {
    var l = temporaryHighlights.length;
    temporaryHighlights[l-1].tokens = currentlyHighlightedTokens
    temporaryHighlights[l-1].tag = currentHighlightTypeName
    temporaryHighlights[l-1].typeid = currentHighlightTypeID
    temporaryHighlights[l-1].instanceid = associated_instance_id
    temporaryHighlights[l-1].color = currentHighlightTagColor
    setHighlights(temporaryHighlights)
    saveHighlights(temporaryHighlights)
    setCurrentlyHighlightedTokens([])
    setAddingHighlight(false)
    setTemporaryHighlights([])
    setCurrentHighlightTypeID('');
  }

  const fetchHighlights = () => {
    fetch(SERVER_LINK + '/load_annotations', {
      method: 'GET',
        headers: {
          Accept:'application/json',
          'Content-Type': 'application/json',
          'SimpTokAuth': props.tokenPass,
          'InstID': props.instanceid
        }
      }).then((response) => response.json())
        .then((data) => {data==='NO_ANNOTATIONS'? console.log('no annotations') : setHighlights(JSON.parse(data)) })
        .catch((error) => console.log(error))
  }

  const saveHighlights = (new_highlights) => {
    fetch(SERVER_LINK + '/save_annotations', {
      method: 'POST',
      headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
      },
      body: JSON.stringify({
          idtoken: props.tokenPass,
          instanceid: props.instanceid,
          annotations: JSON.stringify(new_highlights)
      })
    }).then((response) => response.json())
      .then((data) => {if (data=='SUCCESS') {alert('Annotation saved successfully! ')}} )
      .catch((error) => console.log(error))
  }

  const handleHighlightTypeChange = (selectedOption) => {
    setCurrentHighlightTypeID(selectedOption.value)
    setCurrentHighlightTypeName(selectedOption.label)

  }
  
  const addType = (new_type_name) => {
    fetch(SERVER_LINK + '/add_type', {
      method: 'POST',
      headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
      },
      body: JSON.stringify({
          idtoken: props.tokenPass,
          type_name: new_type_name
      })
    }).then((response) => response.json())
      .catch((error) => console.log(error))
  }

  const onMenuClickEvent = (event) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null);
  };

  const openPDF = () => {
    setVisualizingPDF(true)
  }

  const openImageAnnotation = () => {
    console.log(currentImagePath)
    setVisualizingImage(true)
  }

  //Linking PDFs
  const startUploadingPDFInCloud = (files) => {
    setUploadingResourceToServer(true)
    fetch(SERVER_LINK + '/get_pdf_upload_link', {
      method: 'POST',
      headers: {
        'SimpTokAuth': props.tokenPass,
        'InstID': props.instanceid
      },
      body: {}
    }).then((response) => response.json())
      .then((data) => {uploadPDFToCloud(data, files[0])})
      .catch((error) => {console.log(error)})
  }

  const uploadPDFToCloud = (signedURL, pdfFile) => {
    const putCloudConfig = {
      onUploadProgress: progressEvent => setUploadingProgress((progressEvent.loaded/pdfFile.size)*100),
      headers: {
        'Content-Type': 'application/pdf'
      }
    }
    axios.put(signedURL, pdfFile, putCloudConfig)
    .then((response) => {response.status==200 ? setSuccessfullPDFUploadOnServer() : alert('something went wrong with the upload')})
    .catch((error) => {console.log('error ... ' + error)})
    .finally(() => {setUploadingResourceToServer(false)})
  }

  const setSuccessfullPDFUploadOnServer = () => {
    fetch(SERVER_LINK + '/set_instance_pdf', {
      method: 'POST',
      headers: {
        'SimpTokAuth': props.tokenPass,
        'InstID': props.instanceid
      },
      body: JSON.stringify({'empty': 'object'})
    }).then((response) => response.json())
      .then((data) => {setCurrentPdfPath(data); setLinkingResource(false);})
      .catch((error) => {console.log(error)})
  }

  //Linking Images
  const startUploadingImageInCloud = (files) => {
    const imageFile = files[0]

    const data = new FormData();
    data.append('file', imageFile);
    console.log(imageFile.type)
    const dot_split_array = imageFile.name.split('.')
    if (imageFile.name.match(/\.(jpg|jpeg|png|gif)$/)) {
      setCurrentSelectedImage(URL.createObjectURL(imageFile))
      setCurrentSelectedImageName(imageFile.name)
      setCurrentSelectedImageFile(imageFile)
      
    
      fetch(SERVER_LINK + '/get_image_upload_link', {
        method: 'POST',
        headers: {
          'SimpTokAuth': props.tokenPass,
          'InstID': props.instanceid,
          'ImageFileType': dot_split_array[dot_split_array.length -1]
        },
        body: data
      }).then((response) => response.json())
        .then((json) => {setCurrentSelectedImageUploadURL(json)})
        .catch((error) => {console.log(error)})
    }
  }
  const uploadImageToCloud = () => {
    setUploadingResourceToServer(true)
    const putCloudConfig = {
      onUploadProgress: progressEvent => setUploadingProgress((progressEvent.loaded/currentSelectedImageFile.size)*100),
      headers: {
        'Content-Type': 'image/jpeg'
      }
    }
    axios.put(currentSelectedImageUploadURL, currentSelectedImageFile, putCloudConfig)
    .then((response) => {response.status==200 ? setSuccessfullImageUploadOnServer() : alert('something went wrong with the upload')})
    .catch((error) => {console.log('error ... ' + error)})
    .finally(() => {setUploadingResourceToServer(false)})
  }
  const setSuccessfullImageUploadOnServer = () => {
    const dot_arrays = currentSelectedImageName.split('.')
    fetch(SERVER_LINK + '/set_instance_image', {
      method: 'POST',
      headers: {
        'SimpTokAuth': props.tokenPass,
        'InstID': props.instanceid,
        'ImageFileType': dot_arrays[dot_arrays.length - 1]
      },
      body: JSON.stringify({'empty': 'object'})
    }).then((response) => response.json())
      .then((data) => {setCurrentImagePath(data); closeLinkingResourceBox(); props.updateParent();})
      .catch((error) => {console.log(error)})
  }



  //Linking URLS
  const checkURL = (url) => {
    //first check if url is a file type, which we can use directly
    console.log(url)
    let split_url = url.split('/')
    console.log(split_url)
    let url_domain = split_url[2]
    // if (url_domain == "www.youtube.com" || url_domain == "youtube.com") {
    //   setEmbedType("youtube")
    // }
    // else 
    if (url_domain == "www.instagram.com") {
      setEmbedLink("https://www.instagram.com/p/" + split_url[4] + "/embed")
      setEmbedType("instagram")
    }
    else if (url_domain == "youtube.com") {
      setEmbedLink(url)
      setEmbedType("player")
    }
    else if (ReactPlayer.canPlay(url)) {
      setEmbedLink(url)
      setEmbedType("player")
    }
    else if (currentImagePath != '') {
      //padd
    }
    else {
      fetch(SERVER_LINK + '/check_url', {
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            idtoken: props.tokenPass,
            url: url
        })
      }).then((response) => response.json())
        .then((data) => {setCurrentURLMeta(data); console.log(data)} )
        .catch((error) => console.log(error))
    }
  }

  const linkURLToInstance = () => {
    fetch(SERVER_LINK + '/set_instance_url', {
      method: 'POST',
      headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
      },
      body: JSON.stringify({
          idtoken: props.tokenPass,
          instanceid: props.instanceid,
          new_url: currentURLToLink
      })
    }).then((response) => response.json())
      .then((data) => {if (data == 'SUCCESS') {closeLinkingResourceBox(); props.updateParent()}} )
      .catch((error) => console.log(error))
  }

  const closeLinkingResourceBox = () => {
    setLinkingResource(false);
    setResourceType('')
    setCurrentSelectedImage(null)
    setCurrentSelectedImageFile(null)
    setCurrentSelectedImageName('')
    setCurrentSelectedImageUploadURL('')
  }

  const handleURLClick = () => {
    if ((currentURLPath == null) || (currentURLPath == '')) {
      //pdf url
      if ((currentPdfPath != null) && (currentPdfPath != '')) {
        openPDF()
      }
    }
    else {
      //some url
      const newWindow = window.open(props.someURL, '_blank', 'noopener,noreferrer')
      if (newWindow) newWindow.opener = null
    }
  }

  const handleGoogleClick = () => {
    const link = "https://www.google.com/search?q=" + currentFullTokenizedText.split(" ").join('+')
    const newWindow = window.open(link, '_blank', 'noopener,noreferrer')
    if (newWindow) newWindow.opener = null
  }

  const handleGoogleScholarClick = () => {
    const link = "https://scholar.google.com/scholar?q=" + currentFullTokenizedText.split(" ").join('+')
    const newWindow = window.open(link, '_blank', 'noopener,noreferrer')
    if (newWindow) newWindow.opener = null
  }



  const handleDelete = () => {
    fetch(SERVER_LINK + '/delete_instance', {
      method: 'POST',
      headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
      },
      body: JSON.stringify({
          idtoken: props.tokenPass,
          instanceid: props.instanceid
      })
    }).then((response) => response.json())
      .then((data) => {if (data == 'SUCCESS') {props.handleDelete()}} )
      .catch((error) => console.log(error))
  }




  return (<div style ={{'width': '340px'}}>
          <Card>
            <CardHeader avatar={

                          <Avatar aria-label="recipe" className={classes.avatar}>
                            {props.typename.charAt(0)}
                          </Avatar>
                        }
                        action={
                          <IconButton aria-label="settings" aria-controls="instance-options" aria-haspopup="true" onClick={onMenuClickEvent}>
                            <MoreVertIcon />
                          </IconButton>
                        }
                        title={<span style={{fontWeight: 'bold'}}>{props.typename}</span>}
                        subheader={"#" + props.instanceid} />
            <Menu id="instance-options"
                  anchorEl={anchorEl}
                  keepMounted
                  open={Boolean(anchorEl)}
                  onClose={handleClose}>
                <MenuItem onClick={() => {handleClose(); }}>List Topics</MenuItem>
                <MenuItem onClick={() => {handleClose(); setLinkingResource(true)}}>Link Resource</MenuItem>
                <MenuItem onClick={() => {handleClose(); handleGoogleScholarClick()}}>Search in Scholar</MenuItem>
                <MenuItem onClick={() => {handleClose(); setDeletingInstance(true)}}>Delete Instance</MenuItem>
            </Menu>
            



            
              {((currentImagePath == '') && (currentURLPath == '' || currentURLPath == null)) ?
              <div> </div> :
               <div className="url_card_big"
                        style={{width:widthEmbed}}
                        id={"cardid" + props.instanceid.toString()}>
                      
                    <CardMedia  image={currentImagePath}
                                onClick={handleURLClick}
                                title={"image of #" + props.instanceid}
                                style={{'backgroundColor':'lightgray','backgroundSize':'contain', height:190}} />
              </div>}

            <CardContent className={((currentImagePath == '') && (currentURLPath == '' || currentURLPath == null)) ? classes.text_filling : classes.text}>
                        {editingText? <TextField  type="text" 
                                      variant="outlined" 
                                      label="Text" 
                                      multiline={true} 
                                      fullWidth={true} 
                                      onChange={handleMainInstTextChange}
                                      value={currentEditedText} /> :
                                      <div>
                                        <Typography style={{'white-space': 'pre-line'}}>
                                            {currentFullTokenizedText}
                                          </Typography>
                                      </div>}
                      </CardContent>
            <CardActions disableSpacing>

            {editingText? 
              <IconButton onClick={handleSave}
                          aria-label="save">
                <SaveIcon />
              </IconButton> 
              :
              <div>
               {expanded ? <div></div> :
                            <div>
                              <IconButton aria-label="edit instance">
                                <EditIcon onClick={handleEdit}/>
                              </IconButton>
                              <IconButton aria-label="google text">
                                <Google onClick={handleGoogleClick}/>
                              </IconButton>
                            </div>
                            }
              </div>}

              {currentPdfPath == '' ?<div></div> :
              <IconButton onClick={openPDF}>
                <PictureAsPdfIcon />
               </IconButton> }

               {currentImagePath == '' ?<div></div> :
              <IconButton onClick={openImageAnnotation}>
                <ImageIcon />
               </IconButton> }

              {currentURLPath == '' ?<div></div> :
              <IconButton onClick={handleURLClick}>
                <LinkIcon />
                </IconButton> }


              {editingText? <div> </div> :
              <IconButton
                  className={clsx(classes.expand, {
                    [classes.expandOpen]: expanded,
                  })}
                  onClick={handleExpandClick}
                  aria-expanded={expanded}
                  aria-label="show more"
              >
                <ExpandMoreIcon />
              </IconButton>}


            </CardActions>
            <Collapse in={expanded} timeout="auto" unmountOnExit>
              {fetchingProperties ? <p>Loading</p>: 
              <CardContent>
                  <Grid container
                        direction="column"
                        justify="flex-start"
                        alignItems="stretch">
                      {properties.map((property) => 
                                      <InstanceProperty  tokenPass={props.tokenPass} 
                                                         instid={props.instanceid} 
                                                         propid={property.propid} 
                                                         propname={property.propname} 
                                                         prop_req_typeid={property.required_typeid} 
                                                         prop_req_type={property.required_typename} 
                                                         removeProp={removeProperty}/>)}

                      <AddProperty tokenPass={props.tokenPass} parentType={props.typeid} refresh={fetchProperties}/>
                  </Grid>
                </CardContent>}
            </Collapse>
          </Card>
          {addingHighlight? <div className="infoi"> 
                              <div className="centeredBox"> 
                                <Button style={{'float': 'right'}}
                                        onClick={() => {setCurrentHighlightTypeID(''); setAddingHighlight(false);}}>
                                  <CloseIcon/>
                                </Button>
                                <h4>Adding new Highlight</h4>
                                <p>Set instance type for the fragment '{currentlyHighlightedTokens.join(' ')}': </p>
                                <AsyncCreatableSelect cacheOptions
                                             defaultOptions
                                             inputValue={highlightCurrentTypeName}
                                             onInputChange={(new_input) => {setHighlightCurrentTypeName(new_input.toUpperCase())}}
                                             onCreateOption={addType}
                                             createOptionPosition={"first"}
                                             loadOptions={fetchTypes}
                                             placeholder={"Type new parents name"}
                                             onChange={handleHighlightTypeChange} />
                                {currentHighlightTypeID==='' ?
                                           <p>Please select type first... </p> :
                                           <ListOfKnownInstancesSmall tokenPass={props.tokenPass} 
                                                                      currentText={currentlyHighlightedTokens.join(' ')} 
                                                                      typeid={currentHighlightTypeID} 
                                                                      typename={currentHighlightTypeName}
                                                                      addNewLink={addHighlight}
                                                                 />}
                              </div>
                            </div>: <div></div>}
          {clickedHighlight? <div className="infoi"> 
                              <div className="centeredBox"> 
                                <Button style={{'float': 'right'}}
                                        onClick={() => {setClickedHighlight(false);}}>
                                  <CloseIcon/>
                                </Button>
                                <h4>Highlight Options</h4>
                                <p>What to do with '{currentlyHighlightedTokens.join(' ')}'? </p>
                                <Grid container
                                      direction="column"
                                      justify="flex-start"
                                      alignItems="stretch">
                                   <Button onClick={openWebLink}>Open Link</Button>
                                   <Button onClick={deleteHighlight}>Delete Highlight</Button>
                                </Grid>

                              </div>
                            </div>: <div></div>}
          {deletingInstance? <div className="infoi"> 
                              <div className="centeredBox"> 
                                <Button style={{'float': 'right'}}
                                        onClick={() => {setDeletingInstance(false)}}>
                                  <CloseIcon/>
                                </Button>
                                <h4>Deleting instance permenantly, are you sure?</h4>
                                <p>{currentlyHighlightedTokens.join(' ')} </p>
                                <Grid container
                                      direction="column"
                                      justify="flex-start"
                                      alignItems="stretch">
                                   <Button onClick={() => {setDeletingInstance(false); handleDelete()}}>Yes</Button>
                                   <Button onClick={() => {setDeletingInstance(false)}}>No</Button>
                                </Grid>

                              </div>
                            </div>: <div></div>}
          {linkingResource? <div className="infoi"> 
                              <div className="centeredBox"> 
                                <Button style={{'float': 'right'}}
                                        onClick={closeLinkingResourceBox}>
                                  <CloseIcon/>
                                </Button>
                                {uploadingResourceToServer? 
                                <CircularProgressWithLabel value={uploadingProgress} />
                                :
                                (resourceType == 'PDF' ? 
                                <div>
                                  <Dropzone onDrop={acceptedFiles => startUploadingPDFInCloud(acceptedFiles)}>
                                    {({getRootProps, getInputProps}) => (
                                      <section>
                                        <div {...getRootProps()}>
                                          <input {...getInputProps()} />
                                          <p>Drag 'n' drop a pdf file here, or click to select files</p>
                                        </div>
                                      </section>
                                    )}
                                  </Dropzone>
                                </div> : 
                                (resourceType == 'IMAGE' ? 
                                    <div>
                                      <Dropzone onDrop={acceptedFiles => startUploadingImageInCloud(acceptedFiles)}>
                                      {({getRootProps, getInputProps}) => (
                                        <section>
                                          <div {...getRootProps()}>
                                            <input {...getInputProps()} />
                                            <p>Drag 'n' drop some files here, or click to select files</p>
                                          </div>
                                        </section>
                                      )}
                                    </Dropzone>
                                    {currentSelectedImage == null ? <p>No image</p> :
                                    <div>
                                      {currentSelectedImageUploadURL == '' ? <CircularProgress/> : 
                                      <div>
                                        <Button onClick={uploadImageToCloud}>Upload</Button>
                                      </div>}
                                      <img src={currentSelectedImage} width={'500px'} height={'auto'}/>
                                    </div>
                                    }
                                    
                                    </div> :
                                (resourceType == 'VIDEO' ?
                                  <div>
                                    <Dropzone onDrop={acceptedFiles => startUploadingImageInCloud(acceptedFiles)}>
                                    {({getRootProps, getInputProps}) => (
                                      <section>
                                        <div {...getRootProps()}>
                                          <input {...getInputProps()} />
                                          <p>Drag 'n' drop some files here, or click to select files</p>
                                        </div>
                                      </section>
                                    )}
                                  </Dropzone>
                                  </div> :
                                (resourceType == 'STREAM' ?
                                  <div>
                                    <p>Please select the source</p>
                                  </div> :
                                (resourceType == 'URL' ?
                                  <div>
                                    <p>Please enter the url</p>
                                    <TextField  type="text" 
                                                variant="outlined" 
                                                label="Enter URL..." 
                                                multiline={false} 
                                                fullWidth={true} 
                                                onChange={(event) => {setCurrentURLToLink(event.target.value)}}
                                                value={currentURLToLink} />
                                    <Button onClick={linkURLToInstance}>Link</Button>
                                      <p>{URLToLinkMeta.title}</p>
                                  </div> :
                                  <div>
                                    <h4>Which kind of resource would you like to link?</h4>
                                    <Grid container
                                          direction="column"
                                          justify="flex-start"
                                          alignItems="stretch">
                                      <Button onClick={() => {setResourceType('URL')}}>URL</Button>
                                      <Button onClick={() => {setResourceType('IMAGE')}}>Image</Button>
                                      <Button onClick={() => {setResourceType('VIDEO')}}>Video</Button>
                                      <Button onClick={() => {setResourceType('PDF')}}>PDF</Button>
                                      <Button onClick={() => {setResourceType('STREAM')}}>Live Stream</Button>
                                    </Grid>
                                  </div>))))
                                )}

                              </div>
                            </div>: <div></div>}
          {visualizingPDF? <div className="infoi"> 
                                <div style={{'margin': 'auto', 'width': '100%', 'height': '100%', 'background-color': 'grey'}}>
                                  <PDFViewerFunctional urlPdf={currentPdfPath} 
                                                       tokenPass={props.tokenPass} 
                                                       instanceid={props.instanceid}
                                                       instancename={props.text}
                                                       sendToMap={props.sendToMap}
                                                       closePdf={() => {setVisualizingPDF(false); }} />
                                </div>
                            </div>: <div></div>}
          {visualizingImage? <div className="infoi"> 
                                <Button style={{'float': 'right'}}
                                        onClick={() => {setVisualizingImage(false)}}>
                                  <CloseIcon/>
                                </Button>
                                <div style={{'margin': 'auto', 'width': '80%', 'height': '100%', 'background-color': 'grey'}}>
                                  <ImageAnnotator urlImage={currentImagePath} tokenPass={props.tokenPass} instanceid={props.instanceid}/>
                                </div>
                            </div>: <div></div>}
          </div>)
}

//Instance Card
function ModernInstanceCard(props) {
  const classes = useStyles();

  const [expanded, setExpanded] = React.useState(false);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [fetchingProperties, setFetchingProperties] = React.useState(false);
  const [properties, setProperties] = React.useState([{}]);

  const [editingText, setEditingText] = React.useState(false);
  const [currentEditedText, setCurrentEditedText] = React.useState(props.text);

  const [addingHighlight, setAddingHighlight] = React.useState(false)
  const [highlightCurrentTypeName, setHighlightCurrentTypeName] = React.useState('')

  const [currentFullTokenizedText, setCurrentFullTokenizedText] = React.useState(props.text);
  const [currentlyHighlightedTokens, setCurrentlyHighlightedTokens] = React.useState([]);
  const [temporaryHighlights, setTemporaryHighlights] = React.useState([]);
  const [highlights, setHighlights] = React.useState([]);
  const [currentHighlightTypeName, setCurrentHighlightTypeName] = React.useState('');
  const [currentHighlightTypeID, setCurrentHighlightTypeID] = React.useState('');
  const [currentHighlightTagColor, setCurrentHighlightTagColor] = React.useState('#ffcc80')

  const [currentURLPath, setCurrentURLPath] = useState(props.someURL);
  const [embedType, setEmbedType] = useState('');
  const [embedLink, setEmbedLink] = useState('');
  const [widthEmbed, setWidthEmbed] = useState(240)


  const [currentPdfPath, setCurrentPdfPath] = React.useState(props.pdfPath);


  const [currentImagePath, setCurrentImagePath] = React.useState(props.imagePath);

  const [currentSelectedImage, setCurrentSelectedImage] = useState(null)
  const [currentSelectedImageFile, setCurrentSelectedImageFile] = useState(null)
  const [currentSelectedImageName, setCurrentSelectedImageName] = useState('')
  const [currentSelectedImageUploadURL, setCurrentSelectedImageUploadURL] = useState('')

  const [deletingInstance, setDeletingInstance] = React.useState(false);
  const [linkingResource, setLinkingResource] = React.useState(false);
  const [resourceType, setResourceType] = useState('');
  const [uploadingResourceToServer, setUploadingResourceToServer] = useState(false)
  const [uploadingProgress, setUploadingProgress] = useState(0);
  const [clickedHighlight, setClickedHighlight] = React.useState(false);
  const [visualizingPDF, setVisualizingPDF] = React.useState(false);
  const [visualizingImage, setVisualizingImage] = useState(false)

  const [currentURLToLink, setCurrentURLToLink] = useState('')
  const [URLToLinkMeta, setURLToLinkMeta] = useState({})

  const [currentURLMeta, setCurrentURLMeta] = useState({})
  const [currentOpacity, setCurrentOpacity] = useState('1.0')

  // State for the custom context menu position
  const [menuPosition, setMenuPosition] = useState(null);
  const [isHovered, setIsHovered] = useState(false);

  const handleRightClick = (event) => {
    event.preventDefault(); // Stop the browser menu
    setMenuPosition({
      mouseX: event.clientX - 2,
      mouseY: event.clientY - 4,
    });
  };

  const handleClose = () => setMenuPosition(null);



  useEffect(() => {
    let url_div_element = document.getElementById("cardid" + props.instanceid.toString())
    if ((url_div_element != null) && (currentURLPath != '')) {
      url_div_element.addEventListener('click', handleURLClick);
    }
  }, [])

  useEffect(() => {
    if (currentURLPath != null) {
      //checkURL(currentURLPath)
    }
  }, [currentURLPath])

  const handleExpandClick = () => {
    if (!expanded) {
      setFetchingProperties(true);
      fetchProperties()
    }
    setExpanded(!expanded);
    
  };

  const handleEdit = () => {
    setEditingText(true)
  }

  const handleMainInstTextChange = (event) => {
    setCurrentEditedText(event.target.value)
  }

  const handleSave = () => {
    fetch(SERVER_LINK + '/set_instance_text', {
      method: 'POST',
      headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
      },
      body: JSON.stringify({
          idtoken: props.tokenPass,
          instanceid: props.instanceid,
          instance_text: currentEditedText
      })
    }).then((response) => response.json())
      .then((data) => {if (data) {setCurrentFullTokenizedText(currentEditedText); setEditingText(false); props.updateParent()} else {alert('Not connected, please refreshh - Note that all writing will be lost')}})
      .catch((error) => console.log(error))
  }

  const fetchProperties = () => {
    fetch(SERVER_LINK + '/get_properties', {
        method: 'GET',
          headers: {
            Accept:'application/json',
            'Content-Type': 'application/json',
            'SimpTokAuth': props.tokenPass,
            'InstTypeID': props.typeid
          }
        }).then((response) => response.json())
          .then((data) => {if (Array.isArray(data)) {setProperties(data); setFetchingProperties(false);} else {console.log(data)}})
          .catch((error) => console.log(error))
  }

  const removeProperty = (property_id) => {
    fetch(SERVER_LINK + '/delete_property', {
      method: 'POST',
      headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
      },
      body: JSON.stringify({
          idtoken: props.tokenPass,
          propid: property_id
      })
    }).then((response) => response.json())
      .then((data) => {if (data=='SUCCESS') {setFetchingProperties(true); fetchProperties();} else {console.log(data)}})
      .catch((error) => console.log(error))
  };

  const handleTaggingEvent = (new_highlights) => {
    if (new_highlights.length < highlights.length) {
      console.log('clicked highlight ');
      // get the clicked instance
      var selectedHighlight;
      if (new_highlights.length == 0) {
        selectedHighlight = highlights[0]
      }
      else {
        for (var i = 0; i < highlights.length; i++) {
          var currentHighlightedBelongs = false
          for (var j = 0; j < new_highlights.length; j++) {
            if (highlights[i].start == new_highlights[j].start && highlights[i].end == new_highlights[j].end && highlights[i].instanceid == new_highlights[j].instanceid) {
              currentHighlightedBelongs = true
              break;
            }
          }
          if (!currentHighlightedBelongs) {
            selectedHighlight = highlights[i]
            break;
          }
        }
      }
      setCurrentlyHighlightedTokens(selectedHighlight.tokens)
      setClickedHighlight(true)
      setTemporaryHighlights(new_highlights)
    }
    else {
      console.log('adding and copying highlight');
      //get object highligh
      var nhighlight = new_highlights[new_highlights.length-1]
      var highlighttokens = [];
      for (var i=nhighlight.start; i<nhighlight.end; i++) {
        highlighttokens.push(currentFullTokenizedText[i])
      }
      var text = highlighttokens.join(" ");
      navigator.clipboard.writeText(text).then(function() {
        console.log('Async: Copying to clipboard was successful!');
      }, function(err) {
        console.error('Async: Could not copy text: ', err);
      });
      setCurrentlyHighlightedTokens(highlighttokens)
      setAddingHighlight(true)
      setTemporaryHighlights(new_highlights)
    }
  };

  const openWebLink = () => {

    for (var i = 0; i < currentlyHighlightedTokens.length; i++) {
      if (validURL(currentlyHighlightedTokens[i])) {
        window.open(currentlyHighlightedTokens[i])
      }
    }
    setCurrentlyHighlightedTokens([])
    setClickedHighlight(false)
    setTemporaryHighlights([])
  }

  const deleteHighlight = () => {
    setHighlights(temporaryHighlights)
    saveHighlights(temporaryHighlights)
    setCurrentlyHighlightedTokens([])
    setClickedHighlight(false)
    setTemporaryHighlights([])
  }

  const fetchTypes = async (input) => {
    return fetch(SERVER_LINK + '/get_types', {
                method: 'GET',
                  headers: {
                    Accept:'application/json',
                    'Content-Type': 'application/json',
                    'SimpTokAuth': props.tokenPass,
                    'InputSearchText': input
                  }
                }).then((response) => response.json())
                  .then((data) => data.map((type) => {return {label: type.name, value:type.id}}))
                  .catch((error) => console.log(error))
  }

  const addHighlight = (associated_instance_id) => {
    var l = temporaryHighlights.length;
    temporaryHighlights[l-1].tokens = currentlyHighlightedTokens
    temporaryHighlights[l-1].tag = currentHighlightTypeName
    temporaryHighlights[l-1].typeid = currentHighlightTypeID
    temporaryHighlights[l-1].instanceid = associated_instance_id
    temporaryHighlights[l-1].color = currentHighlightTagColor
    setHighlights(temporaryHighlights)
    saveHighlights(temporaryHighlights)
    setCurrentlyHighlightedTokens([])
    setAddingHighlight(false)
    setTemporaryHighlights([])
    setCurrentHighlightTypeID('');
  }

  const fetchHighlights = () => {
    fetch(SERVER_LINK + '/load_annotations', {
      method: 'GET',
        headers: {
          Accept:'application/json',
          'Content-Type': 'application/json',
          'SimpTokAuth': props.tokenPass,
          'InstID': props.instanceid
        }
      }).then((response) => response.json())
        .then((data) => {data==='NO_ANNOTATIONS'? console.log('no annotations') : setHighlights(JSON.parse(data)) })
        .catch((error) => console.log(error))
  }

  const saveHighlights = (new_highlights) => {
    fetch(SERVER_LINK + '/save_annotations', {
      method: 'POST',
      headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
      },
      body: JSON.stringify({
          idtoken: props.tokenPass,
          instanceid: props.instanceid,
          annotations: JSON.stringify(new_highlights)
      })
    }).then((response) => response.json())
      .then((data) => {if (data=='SUCCESS') {alert('Annotation saved successfully! ')}} )
      .catch((error) => console.log(error))
  }

  const handleHighlightTypeChange = (selectedOption) => {
    setCurrentHighlightTypeID(selectedOption.value)
    setCurrentHighlightTypeName(selectedOption.label)

  }
  
  const addType = (new_type_name) => {
    fetch(SERVER_LINK + '/add_type', {
      method: 'POST',
      headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
      },
      body: JSON.stringify({
          idtoken: props.tokenPass,
          type_name: new_type_name
      })
    }).then((response) => response.json())
      .catch((error) => console.log(error))
  }

  const openPDF = () => {
    setVisualizingPDF(true)
  }

  const openImageAnnotation = () => {
    console.log(currentImagePath)
    setVisualizingImage(true)
  }

  //Linking PDFs
  const startUploadingPDFInCloud = (files) => {
    setUploadingResourceToServer(true)
    fetch(SERVER_LINK + '/get_pdf_upload_link', {
      method: 'POST',
      headers: {
        'SimpTokAuth': props.tokenPass,
        'InstID': props.instanceid
      },
      body: {}
    }).then((response) => response.json())
      .then((data) => {uploadPDFToCloud(data, files[0])})
      .catch((error) => {console.log(error)})
  }

  const uploadPDFToCloud = (signedURL, pdfFile) => {
    const putCloudConfig = {
      onUploadProgress: progressEvent => setUploadingProgress((progressEvent.loaded/pdfFile.size)*100),
      headers: {
        'Content-Type': 'application/pdf'
      }
    }
    axios.put(signedURL, pdfFile, putCloudConfig)
    .then((response) => {response.status==200 ? setSuccessfullPDFUploadOnServer() : alert('something went wrong with the upload')})
    .catch((error) => {console.log('error ... ' + error)})
    .finally(() => {setUploadingResourceToServer(false)})
  }

  const setSuccessfullPDFUploadOnServer = () => {
    fetch(SERVER_LINK + '/set_instance_pdf', {
      method: 'POST',
      headers: {
        'SimpTokAuth': props.tokenPass,
        'InstID': props.instanceid
      },
      body: JSON.stringify({'empty': 'object'})
    }).then((response) => response.json())
      .then((data) => {setCurrentPdfPath(data); setLinkingResource(false);})
      .catch((error) => {console.log(error)})
  }

  //Linking Images
  const startUploadingImageInCloud = (files) => {
    const imageFile = files[0]

    const data = new FormData();
    data.append('file', imageFile);
    console.log(imageFile.type)
    const dot_split_array = imageFile.name.split('.')
    if (imageFile.name.match(/\.(jpg|jpeg|png|gif)$/)) {
      setCurrentSelectedImage(URL.createObjectURL(imageFile))
      setCurrentSelectedImageName(imageFile.name)
      setCurrentSelectedImageFile(imageFile)
      
    
      fetch(SERVER_LINK + '/get_image_upload_link', {
        method: 'POST',
        headers: {
          'SimpTokAuth': props.tokenPass,
          'InstID': props.instanceid,
          'ImageFileType': dot_split_array[dot_split_array.length -1]
        },
        body: data
      }).then((response) => response.json())
        .then((json) => {setCurrentSelectedImageUploadURL(json)})
        .catch((error) => {console.log(error)})
    }
  }
  const uploadImageToCloud = () => {
    setUploadingResourceToServer(true)
    const putCloudConfig = {
      onUploadProgress: progressEvent => setUploadingProgress((progressEvent.loaded/currentSelectedImageFile.size)*100),
      headers: {
        'Content-Type': 'image/jpeg'
      }
    }
    axios.put(currentSelectedImageUploadURL, currentSelectedImageFile, putCloudConfig)
    .then((response) => {response.status==200 ? setSuccessfullImageUploadOnServer() : alert('something went wrong with the upload')})
    .catch((error) => {console.log('error ... ' + error)})
    .finally(() => {setUploadingResourceToServer(false)})
  }
  const setSuccessfullImageUploadOnServer = () => {
    const dot_arrays = currentSelectedImageName.split('.')
    fetch(SERVER_LINK + '/set_instance_image', {
      method: 'POST',
      headers: {
        'SimpTokAuth': props.tokenPass,
        'InstID': props.instanceid,
        'ImageFileType': dot_arrays[dot_arrays.length - 1]
      },
      body: JSON.stringify({'empty': 'object'})
    }).then((response) => response.json())
      .then((data) => {setCurrentImagePath(data); closeLinkingResourceBox(); props.updateParent();})
      .catch((error) => {console.log(error)})
  }



  //Linking URLS
  const checkURL = (url) => {
    //first check if url is a file type, which we can use directly
    console.log(url)
    let split_url = url.split('/')
    console.log(split_url)
    let url_domain = split_url[2]
    // if (url_domain == "www.youtube.com" || url_domain == "youtube.com") {
    //   setEmbedType("youtube")
    // }
    // else 
    if (url_domain == "www.instagram.com") {
      setEmbedLink("https://www.instagram.com/p/" + split_url[4] + "/embed")
      setEmbedType("instagram")
    }
    else if (url_domain == "youtube.com") {
      setEmbedLink(url)
      setEmbedType("player")
    }
    else if (ReactPlayer.canPlay(url)) {
      setEmbedLink(url)
      setEmbedType("player")
    }
    else if (currentImagePath != '') {
      //padd
    }
    else {
      fetch(SERVER_LINK + '/check_url', {
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            idtoken: props.tokenPass,
            url: url
        })
      }).then((response) => response.json())
        .then((data) => {setCurrentURLMeta(data); console.log(data)} )
        .catch((error) => console.log(error))
    }
  }

  const linkURLToInstance = () => {
    fetch(SERVER_LINK + '/set_instance_url', {
      method: 'POST',
      headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
      },
      body: JSON.stringify({
          idtoken: props.tokenPass,
          instanceid: props.instanceid,
          new_url: currentURLToLink
      })
    }).then((response) => response.json())
      .then((data) => {if (data == 'SUCCESS') {closeLinkingResourceBox(); props.updateParent()}} )
      .catch((error) => console.log(error))
  }

  const closeLinkingResourceBox = () => {
    setLinkingResource(false);
    setResourceType('')
    setCurrentSelectedImage(null)
    setCurrentSelectedImageFile(null)
    setCurrentSelectedImageName('')
    setCurrentSelectedImageUploadURL('')
  }

  const handleURLClick = () => {
    if ((currentPdfPath != null) && (currentPdfPath != '')) {
      openPDF()
    }
    else {
      if ((currentURLPath == null) || (currentURLPath == '')) {
        if ((currentImagePath == null) || (currentImagePath == '')) {
          alert('No URL or file linked to this instance!')
        }
        else {
          openImageAnnotation()
        }
      }
      else {
        //some url
        const newWindow = window.open(props.someURL, '_blank', 'noopener,noreferrer')
        if (newWindow) newWindow.opener = null
      }
    }
  }

  const handleGoogleClick = () => {
    const link = "https://www.google.com/search?q=" + currentFullTokenizedText.split(" ").join('+').slice(0, -1)
    const newWindow = window.open(link, '_blank', 'noopener,noreferrer')
    if (newWindow) newWindow.opener = null
  }

  const handleGoogleScholarClick = () => {
    const link = "https://scholar.google.com/scholar?q=" + currentFullTokenizedText.split(" ").join('+').slice(0, -1)
    const newWindow = window.open(link, '_blank', 'noopener,noreferrer')
    if (newWindow) newWindow.opener = null
  }



  const handleDelete = () => {
    fetch(SERVER_LINK + '/delete_instance', {
      method: 'POST',
      headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
      },
      body: JSON.stringify({
          idtoken: props.tokenPass,
          instanceid: props.instanceid
      })
    }).then((response) => response.json())
      .then((data) => {if (data == 'SUCCESS') {props.updateParent()} else {alert("Failed to delete instance")}} )
      .catch((error) => console.log(error))
  }




  return (
  <div style={{ width: 240 }}>
    <Card
        elevation={0}
        onClick={handleURLClick}
        onContextMenu={handleRightClick}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        style={{
          height: 235,
          width: 240,
          borderRadius: 16,
          overflow: "hidden",
          display: "flex",
          flexDirection: "column",
          cursor: "pointer",
          border: isHovered ? "1px solid #3f51b5" : "1px solid #e0e0e0",
          backgroundColor: "#fff",
          transform: isHovered ? "translateY(-5px)" : "translateY(0)",
          boxShadow: isHovered ? "0 10px 20px rgba(0,0,0,0.1)" : "0 2px 4px rgba(0,0,0,0.05)",
          transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
          zIndex: isHovered ? 1 : 0,
        }}
      >
        {/* Media Container */}
        <div style={{ padding: 12, paddingBottom: 0 }}>
          <CardMedia
            image={currentImagePath}
            title={currentFullTokenizedText}
            style={{
              height: 120,
              borderRadius: 10,
              backgroundColor: "#f9f9f9",
              backgroundSize: "contain",
              transition: "transform 0.3s ease",
              transform: isHovered ? "scale(1.02)" : "scale(1)",
            }}
          />
        </div>

        {/* Header */}
        <CardHeader
          style={{ padding: "12px 16px" }}
          avatar={
            <Avatar style={{ backgroundColor: "#3f51b5", fontSize: '0.8rem' }}>
              {props.typename.charAt(0)}
            </Avatar>
          }
          title={
            <Typography variant="body2" style={{ fontWeight: 700, color: '#222' }}>
              {props.typename}
            </Typography>
          }
          subheader={
            <Typography variant="caption" color="textSecondary" style={{ lineHeight: 1.2 }}>
              {currentFullTokenizedText.slice(0, 45)}
              {currentFullTokenizedText.length > 45 ? "..." : ""}
            </Typography>
          }
        />
      </Card>

      {/* Context Menu Component */}
      <Menu
        keepMounted
        open={menuPosition !== null}
        onClose={handleClose}
        anchorReference="anchorPosition"
        anchorPosition={
          menuPosition !== null
            ? { top: menuPosition.mouseY, left: menuPosition.mouseX }
            : undefined
        }
      >
        <MenuItem onClick={() => { window.open(`https://google.com/search?q=${currentFullTokenizedText}`); handleClose(); }}>
          <ListItemIcon style={{ minWidth: 35 }}>
            <SearchIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText primary="Search" />
        </MenuItem>
        
        <MenuItem onClick={() => { handleDelete(); handleClose(); }} style={{ color: '#f44336' }}>
          <ListItemIcon style={{ minWidth: 35 }}>
            <RemoveIcon fontSize="small" style={{ color: '#f44336' }} />
          </ListItemIcon>
          <ListItemText primary="Delete" />
        </MenuItem>
      </Menu>

    {/* PDF Viewer */}
    {visualizingPDF && (
      <div className="infoi">
        <div
          style={{
            margin: "auto",
            width: "100%",
            height: "100%",
            backgroundColor: "#eee",
            borderRadius: 8,
          }}
        >
          <PDFViewerFunctional
            urlPdf={currentPdfPath}
            tokenPass={props.tokenPass}
            instanceid={props.instanceid}
            instancename={props.text}
            sendToMap={props.sendToMap}
            closePdf={() => setVisualizingPDF(false)}
          />
        </div>
      </div>
    )}

    <FullscreenImageViewer
      isOpen={visualizingImage}
      onClose={() => setVisualizingImage(false)}
      src={currentImagePath}
      alt="Demo"
    />
  </div>
);
}


//************** */
//*****Tasks**** */
//************** */
//************** */

/** 
function SimpleInstanceCard(props) {
  const classes = useStyles();

  
  return (
    <Card style={{backgroundColor: props.color, height: props.size.height-5}}>
      <CardContent>
        <Typography className={classes.title_simple_instance_card} color="textSecondary" gutterBottom>
          {props.typename}
        </Typography>
        {props.tsize == 'headline' ? 
          <Typography variant={'h1'} style={{'white-space': 'pre-line', 'font-size': '300px'}}>
          {props.text}
        </Typography> :
        <Typography variant={props.tsize} style={{'white-space': 'pre-line'}}>
          {props.text}
        </Typography>}
        {props.imageurl == '' ? <div></div> : 
                <CardMedia  className={classes.media_map}
                            image={props.imageurl}
                            style={{'backgroundColor':'white','backgroundSize':'contain'}} />}
      </CardContent>
    </Card>
  );
}
  */

function SimpleInstanceCard(props) {
  const classes = useStyles();
  const height = Math.max(0, (props.size.height ?? 0) - 5);
  const hasImage = !(props.imageurl == '');

  const width = ((props.tsize === "headline") ? 2498 : ((props.tsize === "h1") ? 898 : ((props.tsize === "h3") ? 598 : 298)))

  // Make headline huge but still bounded (so nodes don’t explode)
  const isHeadline = props.tsize === "headline";

  return (
    <Card
      elevation={0}
      style={{
        backgroundColor: props.color || "#fff",
        height: (props.size.height/10)-5,
        width: width,
        borderRadius: 14,
        overflow: "hidden",
        border: "1px solid rgba(0,0,0,0.10)",
        boxShadow: "0 1px 0 rgba(0,0,0,0.04)",
        display: "flex",
        flexDirection: "column",
      }}
    >
      {/* Header strip */}
      <div
        style={{
          padding: "10px 12px 8px 12px",
          borderBottom: "1px solid rgba(0,0,0,0.08)",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: 10,
          minHeight: 36,
          boxSizing: "border-box",
        }}
      >
        <Typography
          variant="caption"
          style={{
            fontWeight: 900,
            letterSpacing: 0.8,
            textTransform: "uppercase",
            opacity: 0.8,
            minWidth: 0,
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
          }}
          title={props.typename}
        >
          {props.typename}
        </Typography>

        {/* Optional tiny badge (keeps visual balance) */}
        <div
          style={{
            width: 8,
            height: 8,
            borderRadius: 999,
            background: "rgba(0,0,0,0.25)",
            flex: "0 0 auto",
          }}
        />
      </div>

      {/* Body */}
      <div
        style={{
          display: "grid",
          gridTemplateRows: hasImage ? "1fr 190px" : "1fr",
        }}
      >
        {/* Text area */}
        <div
          style={{
            padding: "12px",
            minHeight: 0,
            overflow: "hidden", // ✅ critical: node never grows with text
            boxSizing: "border-box",
            display: "flex",
            alignItems: "flex-start",
            justifyContent: "center",
            textAlign: "center",
          }}
        >
          <Typography
            variant={isHeadline ? "h1" : props.tsize || "body1"}
            style={{
              width: "100%",
              fontWeight: 800,
              lineHeight: 1.25,
              letterSpacing: -0.2,
              fontSize: isHeadline ? "160px" : undefined,
              // ✅ Efficient multiline clamp: prevents layout blowups
              overflow: "hidden",
              display: "-webkit-box",
              WebkitBoxOrient: "vertical",
              whiteSpace: "pre-line",
            }}
            title={typeof props.text === "string" ? props.text : ""}
          >
            {props.text}
          </Typography>
        </div>

        {/* Image thumbnail (optional, fixed height so layout is stable) */}
        {hasImage ? (
          <div
            style={{
              borderTop: "1px solid rgba(0,0,0,0.08)",
              background: "rgba(255,255,255,0.65)",
              boxSizing: "border-box",
              overflow: "hidden",
            }}
          >
            <CardMedia
              image={props.imageurl}
              style={{
                height:190,
                backgroundColor: "#fff",
                backgroundSize: "contain",
              }}
            />
          </div>
        ) : null}
      </div>
    </Card>
  );
}


function ClickableInstanceCard(props) {
  const classes = useStyles();
  
  return (
    <Card>
      <CardActionArea onClick={() => props.handleClick(props.instanceid)}>
        <CardContent>
        <Typography className={classes.title_simple_instance_card} color="textSecondary" gutterBottom>
          {props.typename}
        </Typography>
        <Typography variant={props.tsize} component="p" style={{'white-space': 'pre-line'}}>
          {props.text}
        </Typography>
        {props.imageurl == '' ? <div></div> : 
                <CardMedia  className={classes.media}
                            image={props.imageurl}
                            style={{'backgroundColor':'lightgray','backgroundSize':'contain'}} />}
        </CardContent>
      </CardActionArea>
    </Card>
  );
}


function SimpleTaskCard(props) {
  const classes = useStyles();

  useEffect(() => {
    console.log(props.task)
  }, [])
  
  return (

    <Card style={{'margin' :'5px'}}>
      <CardActionArea onClick={props.clickCallback}>
        {/** 
        <CardHeader>
          <Typography className={classes.title_simple_instance_card} color="textSecondary" gutterBottom>
            {props.task.taskPrototype.taskMood}
          </Typography>
        </CardHeader>
        */}
        <CardContent>
          
          <Typography component="p" style={{'white-space': 'pre-line'}}>
            {props.task.taskPrototype.name.join(' ')}
          </Typography>
        </CardContent>
      </CardActionArea>
    </Card>
  );
}


function StateTaskCard({ task, onClick }) {
  const classes = useStyles();

  return (
    <Card
      style={{
        mb: 1,
        borderRadius: 2,
        transition: '0.2s',
        '&:hover': {
          boxShadow: 6,
          transform: 'translateY(-1px)',
        },
      }}
    >
      <CardActionArea onClick={onClick}>
        <CardContent style={{ pb: 1 }}>
          
          {/* HEADER ROW */}
          <Typography variant="subtitle1" fontWeight={600}>
            {task.name}
          </Typography>

          {/* DESCRIPTION */}
          {task.description && (
            <Typography
              variant="body2"
              color="text.secondary"
              style={{
                mt: 1,
                whiteSpace: 'pre-line',
              }}
            >
              {task.description}
            </Typography>
          )}

        </CardContent>
      </CardActionArea>
    </Card>
  );
}

function PlannerTaskCard(props) {
  const classes = useStyles();
  const cardColor = (props.task.status == 'DONE' ? 'green' : 'red')
  const [border, setBorder] = useState('')

  useEffect(() => {
    console.log(props.selected)
    if (props.selected.includes(props.task.id)) {
      setBorder('steelblue 5px solid')
    }
    else {
      setBorder('')
    }
  }, [props.selected]) 


  
  return (
    <Card style={{backgroundColor: cardColor, margin: '10px', border: border}}>
      <CardActionArea onClick={() => {props.cardClicked()}}>
         <CardContent>
        <Typography variant='body2' component="p" style={{'white-space': 'pre-line'}}>
          {props.task.text}
        </Typography>
        <div style={{margin:'5px', backgroundColor: 'white'}}>
          <Typography variant='subtitle2' style={{float: 'left', width: '150px'}}>
            {new Date(props.task.start).toUTCString()}
          </Typography>
          <Typography variant='subtitle2' style={{'float':'right', width: '150px'}}>
            {props.task.end}
          </Typography>
        </div>
      </CardContent>
      </CardActionArea>
    </Card>
  );
}


function AddTaskCard(props) {
  const classes = useStyles();
  const [taskBackground, setTaskBackground] = useState('#a6a6a6')
  const [newTaskNameEntry, setNewTaskNameEntry] = useState('')
  
  const [fetchingPrototypeTasks, setFetchingPrototypeTasks] = useState(false);
  const [prototypeTasks, setPrototypeTasks] = useState([]);
  const [selectedPrototypeID, setselectedPrototypeID] = useState('');
  
  const [dimensions, setDimensions] = useState({ 
    height: window.innerHeight,
    width: window.innerWidth
  })
  
  const cardHeightPixel = (props.cardHeight-160) + 'px'

  const cardStyle = {
        'border-top' : 'solid',
        'background' : taskBackground
      }
  
  useEffect(() => {
    window.addEventListener('resize', handleResize)
  }, [])

  
  const handleResize = () => {
    setDimensions({
      height: window.innerHeight,
      width: window.innerWidth
    }) 
  }
  
  const getPrototypeTasks = () => {
    setFetchingPrototypeTasks(true);
    fetch(SERVER_LINK + '/query_task_prototypes', {
      method: 'GET',
        headers: {
          Accept:'application/json',
          'Content-Type': 'application/json',
          'SimpTokAuth': props.tokenPass,
          'InputSearchText': newTaskNameEntry
        }
      }).then((response) => response.json())
        .then((data) => {Array.isArray(data) ? setPrototypeTasks(data) : console.log(data)})
        .catch((error) => console.log(error))
        .finally(() => {setFetchingPrototypeTasks(false)})
  }

  const setTaskMood = (taskId, taskMood) => {
    fetch(SERVER_LINK + '/set_task_mood', {
      method: 'POST',
      headers: {
        Accept:'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        'idtoken': props.tokenPass,
        'task_id': taskId,
        'new_moodid': taskMood
      })
    }).then((response) => response.json())
      .then((data) => {console.log(data); props.taskAddedCallback();})
      .catch((error) => console.log(error))
  }

  const addNewTask = () => {
    if (props.parentid == '-1') {
      fetch(SERVER_LINK + '/add_task', {
        method: 'POST',
          headers: {
            Accept:'application/json',
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            'idtoken': props.tokenPass,
            'taskname': newTaskNameEntry
          })
        }).then((response) => response.json())
          .then((data) => {if ((data!='NO_AUTH') && (data!='ERROR')) { if (props.mood != -1) {setTaskMood(data, props.mood)} else {props.taskAddedCallback();}}})
          .catch((error) => console.log(error))
      }
      else {
        fetch(SERVER_LINK + '/add_task_instance_with_parent', {
          method: 'POST',
          headers: {
            Accept:'application/json',
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            'idtoken': props.tokenPass,
            'taskname': newTaskNameEntry,
            'parentid': props.parentid
          })
        }).then((response) => response.json())
          .then((data) => {if ((data!='NO_AUTH') && (data!='ERROR')) {if (props.mood != -1) {setTaskMood(data, props.mood)} else {props.taskAddedCallback();}}})
          .catch((error) => console.log(error))
      }
  }
  
  
  return (<div  style={cardStyle} >
            <div>
                <TextField id="standard-basic"
                            value={newTaskNameEntry}
                            onChange={(e) => {setNewTaskNameEntry(e.target.value)}}
                            style={{'width':'100%'}}
                            multiline={true}
                            rows={3}
                            variant="outlined" />
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                  <Button onClick={props.cancelAddTask}> Cancel </Button>
                  <Button onClick={addNewTask}> Add </Button>
                </div>
            </div>
          </div>)
  
}

/*
function ListOfTasks(props) {
  const [fetchingTasks, setFetchingTasks] = useState(false);
  const [prototypeTasks, setPrototypeTasks] = useState([]);

}
*/

function ExpandedTaskCard(props) {
  const classes = useStyles();

  const [taskBackground, setTaskBackground] = useState('#a6a6a6')
  const [backButtonBackground, setBackButtonBackground] = useState('#a6a6a6')
  const [binBackground, setBinBackground] = useState('#a6a6a6')
  const [editingTaskName, setEditingTaskName] = useState(false)
  const [newTaskNameEntry, setNewTaskNameEntry] = useState('')
  const [thisTaskName, setThisTaskName] = useState('');

  const [fetchingChildTasks, setFetchingChildTasks] = useState(false);
  const [childTasks, setChildTasks] = useState([]);
  const [selectedChildTaskID, setSelectedChildTaskID] = useState('');
  const [fetchingSelectedChildTask, setFetchingSelectedChildTask] = useState(false);
  const [selectedChildTask, setSelectedChildTask] = useState(null);

  const [addingChildTask, setAddingChildTask] = useState(false);

  const [taskIsSplit, setTaskIsSplit] = useState(props.task.isSplit)

  const [schedulingTask, setSchedulingTask] = useState(false);

  const [settingTaskSplit, setSettingTaskSplit] = useState(false);
  const [taskSplitMode, setTaskSplitMode] = useState(false);

  const [settingTaskMood, setSettingTaskMood] = useState(false);
  const [moodList, setMoodList] = useState([])

  
  

  const [currentElapsedTime, setCurrentEllapsedTime] = useState('')

  const [dimensions, setDimensions] = useState({ 
    height: window.innerHeight,
    width: window.innerWidth
  })

  const [enteredTaskAt, setEnteredTaskAt] = useState(new Date().getTime())
  const cardHeight = dimensions.height - 241 - (props.depthIndex*50)
  const cardStyle = (props.depthIndex > 0 ?
    {
      'border-top' : 'solid',
      'border-radius' : '5px',
      'background' : taskBackground,
      'height' : cardHeight.toString() + 'px'
    } :
    {
      'border-style' : 'solid',
      'border-radius' : '5px',
      'background' : taskBackground,
      'height' : (dimensions.height - 211).toString() + 'px'
    })

  const [anchorEl, setAnchorEl] = useState(null);
  const menuId = 'task-options-menu';
  const isMenuOpen = Boolean(anchorEl);
  

  useEffect(() => {
    getChildTasks()
    console.log('focused time ... ' + props.task.focusTime)
    setThisTaskName(props.task.name)
    window.addEventListener('resize', handleResize)
  }, [])

  useEffect(() => {
    // Create interval get the interval ID so it can be cleared later.
    const intervalId = setInterval(updateTimeElapsed, 1000);

    // Create function to clean up the interval when the component unmounts.
    return () => {
        if (intervalId) {
          const timed_date = new Date().getTime()
          console.log('seting new focus time ... ' + Math.round((timed_date-enteredTaskAt)/1000))
          setNewTimeInServer(Math.round((timed_date-enteredTaskAt)/1000))
          clearInterval(intervalId);
        }
    }
  }, []);

  useEffect(() => {
    if (selectedChildTask != null) {
      if (selectedChildTask.prototype != null) {
        props.fetchLinksForTask(selectedChildTask.prototype.id)
      }
    }
  }, [selectedChildTask]) 

  const handleResize = () => {
    setDimensions({
      height: window.innerHeight,
      width: window.innerWidth
    }) 
  }

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const setNewTimeInServer = (new_focus_time) => {
    fetch(SERVER_LINK + '/set_task_instance_focus_time', {
      method: 'POST',
      headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
      },
      body: JSON.stringify({
          idtoken: props.tokenPass,
          taskid: props.task.taskId,
          new_time: new_focus_time + parseInt(props.task.focusTime)
      })
    }).then((response) => response.json())
      .then((data) => {if (data=='SUCCESS') {console.log('task ' + props.task.taskId.toString() + ' paused');} else {alert('Server Error / No internet')}} )
      .catch((error) => console.log(error))
  }

  const updateTimeElapsed = () => {
    const t1 = new Date();
    console.log(t1.getTime())
    console.log(enteredTaskAt)
    let elapsedSeconds = Math.round((t1.getTime() - enteredTaskAt)/1000) + parseInt(props.task.focusTime)
    var hoursElapsed = Math.floor(elapsedSeconds / 3600);
    hoursElapsed = (hoursElapsed < 10) ? '0'+hoursElapsed.toString() : hoursElapsed.toString()
    var minutesElapsed = Math.floor(elapsedSeconds / 60) % 60;
    minutesElapsed = (minutesElapsed < 10) ? '0'+minutesElapsed.toString() : minutesElapsed.toString()
    var secondsElapsed = elapsedSeconds % 60;
    secondsElapsed = (secondsElapsed < 10) ? '0'+secondsElapsed.toString() : secondsElapsed.toString()

    let timeString = `${hoursElapsed}:${minutesElapsed}:${secondsElapsed}`;
    setCurrentEllapsedTime(timeString)
    
  }

  const getChildTasks = () => {
    setFetchingChildTasks(true);
    fetch(SERVER_LINK + '/get_task_instances_with_parent', {
      method: 'GET',
        headers: {
          Accept:'application/json',
          'Content-Type': 'application/json',
          'SimpTokAuth': props.tokenPass,
          'TaskParentID': props.task.taskId
        }
      }).then((response) => response.json())
        .then((data) => {Array.isArray(data) ? setChildTasks(data) : console.log(data)})
        .catch((error) => console.log(error))
        .finally(() => {setFetchingChildTasks(false)})
  }

  const fetchInfoForChildTask = (selected_task_id) => {
    setFetchingSelectedChildTask(true)
    fetch(SERVER_LINK + '/get_task_info', {
      method: 'GET',
        headers: {
          Accept:'application/json',
          'Content-Type': 'application/json',
          'SimpTokAuth': props.tokenPass,
          'TaskID': selected_task_id
        }
      }).then((response) => response.json())
        .then((data) => {if (Array.isArray(data)) { setSelectedChildTask(data[0]);} else { console.log(data)}})
        .catch((error) => console.log(error))
        .finally(() => {setFetchingSelectedChildTask(false)})
  }

  const setNewTaskNameInServer = () => {
    fetch(SERVER_LINK + '/set_task_instance_text', {
      method: 'POST',
      headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
      },
      body: JSON.stringify({
          idtoken: props.tokenPass,
          taskid: props.task.taskId,
          new_text: newTaskNameEntry
      })
    }).then((response) => response.json())
      .then((data) => {if (data=='SUCCESS') {setThisTaskName(newTaskNameEntry)} else {alert('Status couldnt be set')}} )
      .catch((error) => console.log(error))
      .finally(() => props.updateParent())
  }

  const setTaskDone = () => {
    fetch(SERVER_LINK + '/set_task_instance_done', {
      method: 'POST',
      headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
      },
      body: JSON.stringify({
          idtoken: props.tokenPass,
          taskid: props.task.taskId
      })
    }).then((response) => response.json())
      .then((data) => {if (data=='SUCCESS') {console.log('task ' + props.task.taskId.toString() + ' is done'); props.updateParent(); props.goBackFunction();} else {if (data=='INCOMPLETE_TASK') {alert('Please complete all subtasks first')} else {alert('Server Error / No internet')}}} )
      .catch((error) => console.log(error))
  }
  
  const handleAddNewChildTask = () => {
    if (addingChildTask) {
      setAddingChildTask(false)
    }
    else {
      setAddingChildTask(true)
    }
  }

  const setTaskSplit = () => {
    fetch(SERVER_LINK + '/set_task_split', {
      method: 'POST',
      headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
      },
      body: JSON.stringify({
          idtoken: props.tokenPass,
          taskid: props.task.taskId
      })
    }).then((response) => response.json())
      .then((data) => {if (data=='SUCCESS') {console.log('task ' + props.task.taskId.toString() + ' split'); props.updateParent(); setTaskIsSplit(true)} else {alert('Server Error / No internet')}} )
      .catch((error) => console.log(error))
  }

  const setTaskStartDate = () => {

  }

  const draggingOverBackButton = (ev) => {
    console.log('dragging over back button'); 
    let event = ev;
    event.stopPropagation();
    event.preventDefault();
    setBackButtonBackground('#408000')
  }

  const dragExitBackButton = (ev) => {
    console.log('exiting back button'); 
    setBackButtonBackground('#a6a6a6')
  }

  const droppedOnBackButton = (ev) => {
    console.log(ev.target)
    ev.stopPropagation();
    ev.preventDefault();
    let new_child_task_instance_id = ev.dataTransfer.getData("task_instance_id")
    fetch(SERVER_LINK + '/set_task_instance_new_parent', {
      method: 'POST',
      headers: {
        Accept:'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
          idtoken: props.tokenPass,
          taskid: new_child_task_instance_id,
          parentid: props.parentid
      })
    }).then((response) => response.json())
      .then((data) => {if (data=='SUCCESS') {props.updateParent()} else {alert('Task couldnt be moved')}} )
      .catch((error) => console.log(error))
  }

  const draggingOverBin = (ev) => {
    console.log('dragging over bin'); 
    let event = ev;
    event.stopPropagation();
    event.preventDefault();
    setBinBackground('#F71300')
  }

  const dragExitBin = (ev) => {
    console.log('exiting bin'); 
    setBinBackground('#a6a6a6')
  }

  const droppedOnBin = (ev) => {
    let event = ev;
    let task_instance_id = ev.dataTransfer.getData("task_instance_id")
    fetch(SERVER_LINK + '/delete_task_instance', {
      method: 'POST',
        headers: {
          Accept:'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            idtoken: props.tokenPass,
            taskid: task_instance_id
        })
      }).then((response) => response.json())
        .then((data) => {if (data=='SUCCESS') {console.log('task ' + task_instance_id.toString() + ' deleted')} else {alert('Task couldnt be deleted')}} )
        .catch((error) => console.log(error))
        .finally(() => {setBinBackground('#a6a6a6'); getChildTasks();})


    setBinBackground('#a6a6a6')
  }

  const fixMissingPrototype = () => {
    fetch(SERVER_LINK + '/add_task_prototype', {
      method: 'POST',
        headers: { 
          Accept:'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          'idtoken': props.tokenPass,
          'taskname': props.task.name,
        })
      }).then((response) => response.json())
        .then((data) => {
          if ((data != 'NO_AUTH') && (data != 'ERROR')) {
            fetch(SERVER_LINK + '/set_task_instance_prototype', {
              method: 'POST',
                headers: {
                  Accept:'application/json',
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    idtoken: props.tokenPass,
                    taskinstid: props.task.taskId,
                    protid: data
                })
              }).then((response) => response.json())
                .then((data) => {if (data=='SUCCESS') {props.goBackFunction()}})
                .catch((error) => console.log(error))
            }
        })
        .catch((error) => console.log(error))
  }

  const getMoodsFromServer = () => {
    fetch(SERVER_LINK + '/get_moods', {
      method: 'GET',
        headers: {
          Accept:'application/json',
          'Content-Type': 'application/json',
          'SimpTokAuth': props.tokenPass
        }
      }).then((response) => response.json())
        .then((data) => {console.log(data); setMoodList(data);})
        .catch((error) => console.log(error))
        .finally(() => setSettingTaskMood(true))
  };

  const setTaskMood = (moodId) => {
    fetch(SERVER_LINK + '/set_task_mood', {
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            idtoken: props.tokenPass,
            task_prototype_id: props.task.prototype.id,
            new_moodid: moodId
        })
      }).then((response) => response.json())
        .then((data) => {if (data=='SUCCESS') {alert('Mood set succesfully'); setSettingTaskMood(false); props.updateParent()} else {alert('Status couldnt be set')}} )
        .catch((error) => console.log(error))
        .finally(() => {setSettingTaskMood(false)})
  };


  const renderMenu = (
    <Menu
      anchorEl={anchorEl}
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      id={menuId}
      keepMounted
      transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      open={isMenuOpen}
      onClose={handleMenuClose}
    >
      <MenuItem onClick={() => { handleMenuClose()}}>Edit Text</MenuItem>
      <MenuItem onClick={() => { handleMenuClose()}}>Set Mood</MenuItem>
      <MenuItem onClick={handleMenuClose}>My account</MenuItem>
    </Menu>
  );

  return <div>
            <div  style={cardStyle} >
            {selectedChildTaskID == '' ?
            <div>
              <div>
                <div style={{display: 'flex', 'justify-content': 'space-between'}}>
                    <div onClick={() => {props.goBackFunction()}}
                          onDragOver={draggingOverBackButton}
                          onDragLeave={dragExitBackButton} 
                          onDrop={droppedOnBackButton}
                          style={{'background' : backButtonBackground}}>
                      <p>Back</p>
                    </div>
                    {props.task.prototype == null ?
                      <div style={{'background' : '#F7A800'}} 
                            onClick={fixMissingPrototype}>
                        <p>No Prototype (Click to fix)</p>
                      </div>
                      :
                      <div></div>}
                      
                    {taskIsSplit ?
                    <div>
                      <BorderLinearProgress variant="determinate" value={props.task.progress*100} style={{marginTop:'10px', marginRight:'10px'}} />
                      <h5 style={{'fontSize' : '18px', 'fontWeight': 'bolder', 'text-align': 'right', 'margin':'5px'}}>{currentElapsedTime}</h5>
                    </div>
                      : <p>Time to completion</p> }
                  </div>
                  <div style={{display: 'flex', 'justify-content': 'space-between'}}>
                    {editingTaskName ?
                      <TextField 
                        id="standard-basic"
                        value={newTaskNameEntry}
                        onChange={(e) => {setNewTaskNameEntry(e.target.value)}}
                        onKeyPress={(e) => {if (e.key === 'Enter') {setNewTaskNameInServer()}}}
                        style={{'width':'80%'}}
                        variant="outlined"
                        multiline={true} 
                      /> :
                      <Typography variant="body2" component="p" style={{'width':'80%', 'height': '96px', 'overflow': 'scroll'}}>
                        {thisTaskName}
                      </Typography>
                    }


                    
                    <Button onClick={() => {setEditingTaskName((old) => {if (old) {setNewTaskNameInServer(); return false} else {setNewTaskNameEntry(thisTaskName); return true}})}}>{editingTaskName ? 'Save' : 'Edit'}</Button>
                    <Button onClick={getMoodsFromServer}>Set Mood</Button>
                  </div>
                  <div style={{'height': '36px'}}>
                    {props.task.isSplit ?
                      <div>
                        {addingChildTask ?
                          <div><Button onClick={() => {setAddingChildTask(false)}}>Back</Button></div> :
                          <div style={{'display': 'flex', 'justify-content': 'space-between'}}>
                            <Button onClick={handleAddNewChildTask}> Add Task </Button>
                            <Button onClick={setTaskDone}> Done </Button>
                            <div onDragOver={draggingOverBin}
                                  onDragLeave={dragExitBin}
                                  onDrop={droppedOnBin}
                                  style={{'background' : binBackground}}>
                              <DeleteForeverIcon />
                            </div>
                          </div>}
                      </div>
                      : 
                        <div style={{'display': 'flex', 'justify-content': 'space-between'}}>
                          <Button onClick={setTaskSplit}> Help </Button>
                          <Button onClick={() => {setSchedulingTask(true)}}> Schedule </Button>
                          <Button onClick={setTaskDone}> Done </Button>
                        </div> }
                  </div>
                </div>
                {props.task.isSplit ?
                  (fetchingChildTasks ? 
                      <div><p>Loading children...</p></div> :
                      (addingChildTask ?
                        <AddTaskCard tokenPass={props.tokenPass}
                                      cardHeight={cardHeight}
                                      parentid={props.task.taskId}
                                      taskAddedCallback={() => {setAddingChildTask(false); getChildTasks()}}
                                      mood={props.currentMood} /> :
                        <div style={{'overflow': 'scroll', 'height': (cardHeight - 120).toString() + 'px'}}>
                            <Grid container
                                  direction="column"
                                  justify="flex-start"
                                  alignItems="stretch">
                                            {childTasks.map((childTask) => 
                                                          <DraggableTaskCard task={childTask}
                                                                          tokenPass={props.tokenPass}
                                                                          setSelectedTaskID={(selected_task_id) => {setSelectedChildTaskID(selected_task_id); fetchInfoForChildTask(selected_task_id);}}
                                                                          setTaskInProgress={props.setTaskInProgress}
                                                                          setTaskDone={props.setTaskDone}
                                                                          setPostponingTask={() => {}}
                                                                          updateParent={getChildTasks} />)}
                                                                          
                            </Grid>
                        </div> )) :
                        ((cardHeight<500) ?
                              <div class='circle' style={{'height': (cardHeight-200).toString() + 'px', 'width': (cardHeight-200).toString() + 'px', 'margin': 'auto', alignContent: 'center', overflow: 'scroll'}}>
                                <h5 style={{'fontSize' : ((cardHeight-200)*0.2) + 'px', 'text-align': 'center'}}>{currentElapsedTime}</h5>
                              </div> :
                              <div class='circle' style={{'height':  '300px', 'width': '300px', 'margin': 'auto'}}>
                                <h5 style={{'fontSize' : '60px', 'text-align': 'center'}}>{currentElapsedTime}</h5>
                              </div> )
                  }
            </div> :

              (fetchingSelectedChildTask ? <div><p>Loading child...</p></div> :
                  <div style={{'left': 5}}>
                  <div style={{display: 'flex', 'justify-content': 'space-between', 'height' : '50px', 'overflow': 'scroll'}}>
                    <Typography variant='caption' style={{'margin': 'auto', 'width' : '50%'}}>
                      {thisTaskName}
                    </Typography>
                    <div>
                    <BorderLinearProgress variant="determinate" value={props.task.progress*100} style={{margin:'10px'}} />
                    <h5 style={{'fontSize' : '18px', 'fontWeight': 'bolder', 'text-align': 'right', 'margin':'5px'}}>{currentElapsedTime}</h5>
                    </div>
                  </div>

                  <ExpandedTaskCard task={selectedChildTask}
                                    parentid={props.task.taskId}
                                    tokenPass={props.tokenPass}
                                    goBackFunction={() => {setSelectedChildTaskID(''); props.fetchLinksForTask(props.task.prototype.id); getChildTasks();}}
                                    fetchLinksForTask={props.fetchLinksForTask}
                                    depthIndex={props.depthIndex+1}
                                    updateParent={props.updateParent}
                                    currentMood={props.currentMood}/>
                  
                  </div>) }
            </div>
          {schedulingTask ? <div className="infoi"> 
                              <div className="centeredBox"> 
                                <Button style={{'float': 'right'}}
                                        onClick={() => {setSchedulingTask(false)}}>
                                  <CloseIcon/>
                                </Button>
                                <h4>Scheduling task ...</h4>
                              </div>
                            </div>: <div></div>}
          {settingTaskSplit ? <div className="infoi">
                                <div className="centeredBox">     
                                    <Button style={{'float': 'right'}}
                                            onClick={() => {setSettingTaskSplit(false)}}>
                                      <CloseIcon/>
                                    </Button>
                                    {taskSplitMode == 'undefined' ?
                                      <div>
                                        <h4>Choose a strategy ...</h4>
                                        <div style={{'display': 'flex', 'justify-content': 'space-between'}}>
                                          <Button onClick={setTaskSplit}>Blank</Button>
                                          <Button onClick={() => {setTaskSplitMode('divideAndConquer')}}>Divide and Conquer</Button>
                                          <Button onClick={() => {}}></Button> 
                                        </div>
                                      </div> :
                                       (taskSplitMode == 'divideAndConquer' ? 
                                          <div>
                                            <h4>Divide and Conquer</h4>
                                            <div style={{'display': 'flex', 'justify-content': 'space-between'}}>
                                            </div>
                                          </div> : <div></div>)}
                                </div>
                              </div> : <div></div>}


          {settingTaskMood ? <div className="infoi">
                                <div className="centeredBox">
                                <Button style={{'float': 'right'}}
                                        onClick={() => {setSettingTaskMood(false)}}>
                                  <CloseIcon/>
                                </Button>
                                <p>Select mood</p>
                                <List>
                                  {moodList.map((mood) => 
                                  <ListItem button onClick={() => {setTaskMood(mood.id)}}> {mood.name} </ListItem>)}
                                </List>
                              </div>
                              </div> :
                              <div>
                            </div>}
          </div>
}


function DraggableTaskCard(props) {
  const classes = useStyles();


  const [taskBackground, setTaskBackground] = useState('#a6a6a6')
  
  const cardStyle = {
    'margin' : '5px',
    'padding-right' : '5px',
    'padding-left' : '10px',
    'padding-top' : '2px',
    'padding-bottom' : '5px',
    'border-style' : 'solid',
    'background' : taskBackground,
    'border-radius' : '10px',
    'width': '314px'
  }
  
  const onDragStart = (ev) => {
    ev.dataTransfer.setData("task_instance_id", props.task.taskId);
    ev.dataTransfer.setData("task_instance_name", props.task.name);
  }

  const mouseOver = () => {
    setTaskBackground('#d9d9d9')
  }

  const mouseLeaves = () => {
    setTaskBackground('#a6a6a6')
  }

  const draggingOver = (ev) => {
    console.log('dragging over ' + props.task.taskId); 
    let event = ev;
    event.stopPropagation();
    event.preventDefault();
    setTaskBackground('#408000')
  }

  const dragExit = (ev) => {
    console.log('exiting' + props.task.id); 
    setTaskBackground('#a6a6a6')
  }

  const droppedOn = (ev) => {
    console.log('dropped on ' + props.task.taskId);
    let event = ev;
    event.stopPropagation();
    event.preventDefault();
    let new_child_task_instance_id = ev.dataTransfer.getData("task_instance_id")
    if (new_child_task_instance_id != props.task.taskId) {
      if (props.task.isSplit == 1) {
        fetch(SERVER_LINK + '/set_task_instance_new_parent', {
            method: 'POST',
            headers: {
              Accept:'application/json',
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                idtoken: props.tokenPass,
                taskid: new_child_task_instance_id,
                parentid: props.task.taskId
            })
          }).then((response) => response.json())
            .then((data) => {if (data=='SUCCESS') {props.updateParent()} else {alert('Task couldnt be moved')}} )
            .catch((error) => console.log(error))
      } else {
        alert('Task is not split')
      }
    }
    setTaskBackground('#a6a6a6')
  }

  return (
    <div>
          <div style={cardStyle}
              draggable 
              onMouseOver={mouseOver}
              onMouseLeave={mouseLeaves}
              onClick={() => {props.setSelectedTaskID(props.task.taskId)}}
              onDrop={droppedOn} 
              onDragOver={draggingOver}
              onDragLeave={dragExit}
              onDragStart={onDragStart}
          >
      
            <div style={{width:'100%'}}>
                <div style={{display: 'flex'}}>
                    <div>
                      <img src={props.task.prototype == null ? 'https://static.thenounproject.com/png/398413-200.png' : (props.task.prototype.taskMood == null ? 'https://static.thenounproject.com/png/398413-200.png' : props.task.prototype.taskMood.symbolPath)} style={{'width': '20px', 'height': '20px', 'margin-top': '5px', 'margin-right': '5px'}}/>
                    </div>
                    <Typography className={classes.titleCard} color="textSecondary" gutterBottom>
                      {props.task.prototype == null ? 'any mood' : (props.task.prototype.taskMood == null ? 'any mood' : props.task.prototype.taskMood.name)}
                    </Typography>
                    {props.task.isSplit != 1 ? 
                    <div></div> : 
                    <BorderLinearProgress variant="determinate" value={props.task.progress*100} style={{margin:'10px'}} />}
                </div>
                <Typography variant="body2" component="p">
                  <Box sx={{ fontWeight: 'bold' }}>
                    {props.task.name}
                  </Box>
                </Typography>
            </div>
          </div> 
          
    </div>
  );
}


function PredictedTypeBox(props) {
  const classes = useStyles();

  const [expanded, setExpanded] = React.useState(false);

  const handleExpandClick = () => {
    // compute all the possible fit's with depth 5
    setExpanded(!expanded);
  };

  return <Card style={{'margin': '15px'}}>
            <CardContent style={{'margin': '5px', display: 'flex', justifyContent: 'space-between', padding: '10px'}}>
                  <Typography style={{'width': '50%', 'margin-left':'5px'}}>{props.name}</Typography>
                  <div>
                    <div style={{'float': 'right', 'display': 'flex'}} >
                      <h4 className={'type_mini'}>{props.probs}</h4>
                      <IconButton
                          className={clsx(classes.expand, {
                            [classes.expandOpen]: expanded,
                          })}
                          onClick={handleExpandClick}
                          aria-expanded={expanded}
                          aria-label="show more">
                        <ExpandMoreIcon />
                      </IconButton>
                    </div>
                  </div>
              </CardContent>
              <Collapse in={expanded} timeout="auto" unmountOnExit>
              
                <CardContent>
                  <Grid>
                    {props.prop_path_string.map((path) => {
                      if (path.segment_tokens.length > 0) {
                        return <Card style={{'margin': '15px'}}>
                                  <CardContent style={{'margin': '5px', display: 'flex', justifyContent: 'space-between', padding: '10px'}}>
                                    <p>{path.propname}</p>
                                    <div style={{'float': 'right', 'display': 'flex'}} >
                                      <p>{path.segment_tokens.join(' ')}</p>
                                    </div>
                                  </CardContent>
                               </Card>
                      } 
                      else {
                        return <div></div>
                      }
                    })}
                  </Grid>
                </CardContent>
            </Collapse>
          </Card>
}


function TaskCard(props) {
  const classes = useStyles();

  const [loadingTask, setLoadingTask] = useState(true)

  const [taskText, setTaskText] = useState('') 
  const [taskStatus, setTaskStatus] = useState('')
  const [taskGoal, setTaskGoal] = useState('')
  const [taskStart, setTaskStart] = useState('')
  const [taskEnd, setTaskEnd] = useState('')

  const [anchorEl, setAnchorEl] = useState(null);

  const [editingTask, setEditingTask] = useState(false)
  const [newTaskText, setNewTaskText] = useState('')


  const [settingGoal, setSettingGoal] = useState(false)
  const [goalText, setGoalText] = useState('')


  useEffect(() => {
    getTaskInfo()
  }, [props.id])

  const getTaskInfo = () => {
    fetch(SERVER_LINK + '/get_task_info', {
      method: 'GET',
        headers: {
          Accept:'application/json',
          'Content-Type': 'application/json',
          'SimpTokAuth': props.tokenPass,
          'TaskID': props.id
        }
      }).then((response) => response.json())
        .then((data) => {Array.isArray(data) ? setTaskData(data[0]): console.log(data)})
        .catch((error) => console.log(error))
        .finally(setLoadingTask(false))
  }

  const setTaskData = (task_data) => {
    setTaskText(task_data.text)
    setTaskStatus(task_data.status)
    setTaskGoal(task_data.goal)
    setTaskStart(task_data.start)
    setTaskEnd(task_data.end)
  }

  const setTaskGoalServer = (goalid) => {
    fetch(SERVER_LINK + '/set_task_goal', {
      method: 'POST',
      headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
      },
      body: JSON.stringify({
          idtoken: props.tokenPass,
          taskid: props.id,
          new_goalid: goalid,
      })
    }).then((response) => response.json())
      .then((data) => {if (data=='SUCCESS') {setGoalText(''); setSettingGoal(false); props.updateTasks() } else {alert('Not connected, please refreshh')}})
      .catch((error) => console.log(error))
      .finally(() => getTaskInfo())
  }

  const handleSave = () => {
    fetch(SERVER_LINK + '/set_task_text', {
      method: 'POST',
      headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
      },
      body: JSON.stringify({
          idtoken: props.tokenPass,
          taskid: props.id,
          new_text: newTaskText
      })
    }).then((response) => response.json())
      .then((data) => {if (data=='SUCCESS') {setTaskText(newTaskText); setEditingTask(false); props.updateTasks() } else {alert('Not connected, please refreshh')}})
      .catch((error) => console.log(error))
  }

  

  const onMenuClickEvent = (event) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null);
  };
  
  return (<div>
          {loadingTask? <p>Loading ... </p> :
           <div>
             <div>
                <Typography variant={'body'} align={'center'} style={{'backgroundColor':'lightgreen'}}>{taskGoal}</Typography>
                <IconButton aria-label="settings" aria-controls="instance-options" aria-haspopup="true" onClick={onMenuClickEvent} style={{'float':'right'}}>
                    <MoreVertIcon />
                  </IconButton>
              </div>
          {editingTask ? <TextField  type="text" 
                                        variant="outlined" 
                                        label="Text" 
                                        multiline={true} 
                                        fullWidth={true} 
                                        onChange={(event) => {setNewTaskText(event.target.value)}}
                                        value={newTaskText} />
                            :
                            <Typography variant={'h3'}>{taskText}</Typography>}
                  
                  <Menu id="instance-options"
                        anchorEl={anchorEl}
                        keepMounted
                        open={Boolean(anchorEl)}
                        onClose={handleClose}>
                      <MenuItem onClick={() => {handleClose(); setSettingGoal(true)}}>Set Goal</MenuItem>
                      <MenuItem onClick={() => {handleClose(); props.setPostponingTask(true)}}>Postpone Task</MenuItem>
                      <MenuItem onClick={() => {handleClose(); props.deleteTask()}}>Delete Task</MenuItem>
                  </Menu>
                
              
              {editingTask ? 
              <IconButton onClick={handleSave}
                          aria-label="save">
                <SaveIcon />
              </IconButton> 
              :
              <IconButton aria-label="edit instance">
                  <EditIcon onClick={() => {setEditingTask(true); setNewTaskText(taskText)}}/>
               </IconButton>}
            {settingGoal ? <div className="infoi"> 
            <div className="centeredBox"> 
              <Button style={{'float': 'right'}}
                      onClick={() => {setSettingGoal(false)}}>
                <CloseIcon/>
              </Button>
              <h4>Set Goal</h4>
              <p>Current: {taskGoal}</p>
              <TextField id="time" 
                         type="text" 
                        variant="outlined" 
                        label="Text" 
                        multiline={true} 
                        rows={4} 
                        fullWidth={true} 
                        onChange={(newText) => {setGoalText(newText.target.value)}}
                        value={goalText}/>
              
              <ListOfGoals tokenPass={props.tokenPass} 
                           currentText={goalText} 
                           addNewLink={setTaskGoalServer} />
              

        </div>
      </div>: <div></div>}</div>}
      </div>)
}


function SimpleGoalCard({ goal, onSelection, selected }) {
  const progressPct = Math.round((goal.progress ?? 0) * 100);

  const border = selected ? "rgba(33,150,243,0.65)" : "rgba(255,255,255,0.14)";
  const bg = selected ? "rgba(33,150,243,0.14)" : "rgba(255,255,255,0.10)";

  return (
    <ListItem
      button
      onClick={() => onSelection?.()}
      selected={selected}
      // v4 fix: make the item align to top so multi-line text isn't vertically clipped
      style={{ padding: 0, marginBottom: 10, alignItems: "flex-start" }}
    >
      <div
        style={{
          width: "100%",
          borderRadius: 14,
          border: `1px solid ${border}`,
          background: bg,
          padding: "10px 12px",
          boxShadow: selected
            ? "0 10px 18px rgba(0,0,0,0.18)"
            : "0 4px 12px rgba(0,0,0,0.12)",
          overflow: "visible",
        }}
      >
        <div style={{ display: "flex", gap: 10, alignItems: "flex-start" }}>
          {/* Left: title + progress */}
          <div style={{ flex: 1, minWidth: 0 }}>
            <Typography
              variant="subtitle2"
              style={{
                fontWeight: 800,
                lineHeight: 1.25,
                whiteSpace: "normal",     // allow wrapping
                overflowWrap: "anywhere", // prevent overflow on long tokens
                wordBreak: "break-word",
                margin: 0,
              }}
            >
              {goal.name}
            </Typography>

            <div style={{ marginTop: 10 }}>
              <BorderLinearProgress
                variant="determinate"
                value={progressPct}
                style={{ height: 6, borderRadius: 999 }}
              />
            </div>
          </div>

          {/* Right: percent pill */}
          <div
            style={{
              flexShrink: 0,
              padding: "6px 10px",
              borderRadius: 999,
              fontSize: 12,
              fontWeight: 800,
              lineHeight: 1,
              color: "rgba(255,255,255,0.92)",
              background: selected ? "rgba(33,150,243,0.55)" : "rgba(0,0,0,0.25)",
              marginTop: 2,
            }}
          >
            {progressPct}%
          </div>
        </div>

        {goal.subtitle ? (
          <Typography
            variant="caption"
            style={{
              display: "block",
              marginTop: 10,
              opacity: 0.85,
              whiteSpace: "normal",
              overflowWrap: "anywhere",
              wordBreak: "break-word",
              color: "rgba(255,255,255,0.85)",
            }}
          >
            {goal.subtitle}
          </Typography>
        ) : null}
      </div>
    </ListItem>
  );
}


function SimpleMapCard(props) {
  const classes = useStyles();
  
  return (
    <ListItem button onClick={() => {props.onSelection()}}>
        <div style={{position: 'relative', padding: '5px 0px'}}>
            <Typography variant='button' style={{padding: '5px 0px', textAlign:'center'}}>{props.map.name}</Typography>
        </div>
    </ListItem>
  );
}


function GoalPlannerCard(props) {
  const classes = useStyles();

  const [goalText, setGoalText] = useState('') 

  const [editingGoalName, setEditingGoalName] = useState(false)
  const [newGoalName, setNewGoalName] = useState('')


  useEffect(() => {
    setGoalText(props.name)
  }, [props.id, props.name])

  
  const handleChangeGoalName = () => {
    fetch(SERVER_LINK + '/set_goal_name', {
      method: 'POST',
      headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
      },
      body: JSON.stringify({
          idtoken: props.tokenPass,
          goalid: props.id,
          new_name: newGoalName
      })
    }).then((response) => response.json())
      .then((data) => {if (data=='SUCCESS') {setGoalText(newGoalName); setEditingGoalName(false); props.updateGoals() } else {alert('Not connected, please refreshh')}})
      .catch((error) => console.log(error))
  }

  const handleDeleteGoal = () => {
    fetch(SERVER_LINK + '/delete_goal', {
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            idtoken: props.tokenPass,
            goalid: props.id
        })
      }).then((response) => response.json())
        .then((data) => {if (data=='SUCCESS') {setGoalText(''); props.updateGoals()} else {alert('Goal couldnt be deleted')}} )
        .catch((error) => console.log(error))
  };

  

  
  return (<div style={{'display': 'inline'}}>
            {editingGoalName ? 
                <div>
                  <TextField  type="text" 
                              variant="outlined" 
                              label="Text" 
                              onChange={(event) => {setNewGoalName(event.target.value)}}
                              value={newGoalName} /> 
                  <Button onClick={handleChangeGoalName}> Set Name </Button>
                  <Button onClick={() => {setEditingGoalName(false)}}> Back </Button>
                </div> 
                :
                <div>
                  <p style={{'float': 'left'}}>{goalText}</p>
                  <Button style={{'float': 'right'}} onClick={handleDeleteGoal}>Delete</Button>
                  <Button style={{'float': 'right'}} onClick={() => {setEditingGoalName(true); setNewGoalName(goalText)}}>Edit Name</Button>
                  <Button style={{'float': 'right'}} onClick={props.addTaskHandler}>Add Task</Button>
                </div>}
                
          </div>)
                
              
}


function MapCard(props) {
  const classes = useStyles();

  const [mapText, setMapText] = useState('') 


  const [editingMapName, setEditingMapName] = useState(false)
  const [newMapName, setNewMapName] = useState('')



  useEffect(() => {
    setMapText(props.name)
  }, [props.id, props.name])

  
  const handleChangeMapName = () => {
    fetch(SERVER_LINK + '/set_map_name', {
      method: 'POST',
      headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
      },
      body: JSON.stringify({
          idtoken: props.tokenPass,
          mapid: props.id,
          new_name: newMapName
      })
    }).then((response) => response.json())
      .then((data) => {if (data=='SUCCESS') {setMapText(newMapName); setEditingMapName(false); props.updateMaps() } else {alert('Not connected, please refreshh')}})
      .catch((error) => console.log(error))
  }

  const handleDeleteMap = () => {
    fetch(SERVER_LINK + '/delete_map', {
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            idtoken: props.tokenPass,
            mapid: props.id
        })
      }).then((response) => response.json())
        .then((data) => {if (data=='SUCCESS') {setMapText(''); props.updateMaps()} else {alert('Map couldnt be deleted')}} )
        .catch((error) => console.log(error))
  };
  
  return (<div style={{display: 'inline'}}>
            {editingMapName ? 
                <div>
                  <TextField  type="text" 
                              variant="outlined" 
                              label="Text" 
                              onChange={(event) => {setNewMapName(event.target.value)}}
                              value={newMapName} /> 
                  <Button onClick={handleChangeMapName}> Set Name </Button>
                  <Button onClick={() => {setEditingMapName(false)}}> Back </Button>
                </div> 
                :
                <div>
                  <p style={{float: 'left'}}>{mapText}</p>
                  <Button style={{float: 'right'}} onClick={handleDeleteMap}>Delete</Button>
                  <Button style={{float: 'right'}} onClick={() => {setEditingMapName(true); setNewMapName(mapText)}}>Edit Name</Button>
                </div>}
                
          </div>)
                
              
}


class ListOfKnownInstancesForSearch extends React.Component {
  constructor(props) {
    super(props);
    this.props = props
    this.state = {fetchingInstances: true,
                  rankedInstances: []}

    this.fetchInstances = this.fetchInstances.bind(this)
  }

  componentDidMount() {
    this.fetchInstances()
  }

  fetchInstances() {
    console.log('fetching');
    fetch(SERVER_LINK + '/get_quick_instances', {
      method: 'GET',
        headers: {
          Accept:'application/json',
          'Content-Type': 'application/json',
          'SimpTokAuth': this.props.tokenPass,
          'InstTypeID': this.props.typeid,
          'InputSearchText': encodeURI(this.props.currentText)
        }
      }).then((response) => response.json())
        .then((data) => {Array.isArray(data)? this.setState({fetchingInstances: false, rankedInstances: data}) : console.log(data)})
        .catch((error) => console.log(error))
  }


  
  render() {
    return (
      <div>
      <div className="screen">
            {this.state.fetchingInstances ?
                  <p>Loading instances... </p> :
                  <div>
                      {this.props.currentText=='' ? <div></div> :
                        <Grid container
                              direction="column"
                              justify="flex-start"
                              alignItems="stretch">
                            {this.state.rankedInstances.map((instance) => 
                                <div className="cardmini">
                                  <Card>
                                      <CardActionArea onClick={() => {this.props.addNewValue(instance)}}>
                                        <CardContent style={{'display': 'flex', 'padding': '5px'}}>
                                          <Avatar aria-label="recipe">
                                                    {instance.typename.charAt(0)}
                                          </Avatar>
                                          <Typography variant="body2" style={{'margin': 'auto', 'margin-left': '10px'}}>
                                            {instance.instancetext.join(' ')}
                                          </Typography>
                                        </CardContent>
                                      </CardActionArea>
                                  </Card>
                                </div>)}
                            <div className="padd"><Button onClick={this.addInstance} variant="contained">Create Prototype</Button></div>
                        </Grid>}
                  </div>
            }
      </div>
       
      </div>)
  }
}


function ListOfKnownInstancesSmall(props) {
  const [fetchingInstances, setFetchingInstances] = useState(true)
  const [rankedInstances, setRankedInstances] = useState([])

  useEffect(() => {
    fetchInstances()
  }, [props.currentText, props.typeid])

  const fetchInstances = () => {
    console.log('fetching');
    fetch(SERVER_LINK + '/get_quick_instances', {
      method: 'GET',
        headers: {
          Accept:'application/json',
          'Content-Type': 'application/json',
          'SimpTokAuth': props.tokenPass,
          'InstTypeID': props.typeid,
          'InputSearchText': encodeURI(props.currentText)
        }
      }).then((response) => response.json())
        .then((data) => {Array.isArray(data)? setRankedInstances(data) : console.log(data)})
        .catch((error) => console.log(error))
        .finally(() => setFetchingInstances(false))
  }

  const addInstance = () => {
    fetch(SERVER_LINK + '/add_instance', {
      method: 'POST',
      headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
      },
      body: JSON.stringify({
          idtoken: props.tokenPass,
          typeid: props.typeid,
          instance_text: encodeURI(props.currentText)
      })
    }).then((response) => response.json())
      .then((data) => {Array.isArray(data) ? props.addNewLink(data[0][0]) : console.log(data)})
      .catch((error) => console.log(error))
  }



  
  return (
      <div>
      <div className="screen">
            {fetchingInstances ?
                  <p>Loading instances... </p> :
                  <div>
                      {props.currentText=='' ? <div></div> :
                        <Grid container
                              direction="column"
                              justify="flex-start"
                              alignItems="stretch">
                            {rankedInstances.map((instance) => 
                                <div className="cardmini">
                                  <Card>
                                      <CardActionArea onClick={() => {props.addNewLink(instance.instanceid)}}>
                                        <CardContent style={{'display': 'flex', 'padding': '5px'}}>
                                        <Avatar aria-label="recipe">
                                                  {instance.typename.charAt(0)}
                                        </Avatar>
                                      <Typography variant="body2" style={{'margin': 'auto', 'margin-left': '10px'}}>
                                        {instance.instancetext.join(' ')}
                                      </Typography>
                                      </CardContent>
                                      </CardActionArea>
                                  </Card>
                                </div>)}
                            <div className="padd"><Button onClick={addInstance} variant="contained">Create New Instance</Button></div>
                        </Grid>}
                  </div>
            }
      </div>
       
      </div>)
}


class ListOfKnownInstances extends React.Component {
  constructor(props) {
    super(props);
    this.props = props
    this.state = {fetchingInstances: true,
                  rankedInstances: [],
                  searchQuery: ''}

    this.fetchInstances = this.fetchInstances.bind(this)
    this.queryInstances = this.queryInstances.bind(this)
  }

  componentDidMount() {
    this.fetchInstances()
  }

  queryInstances(prototype) {
    console.log('querying...');
    fetch(SERVER_LINK + '/query_instances', {
      method: 'GET',
        headers: {
          Accept:'application/json',
          'Content-Type': 'application/json',
          'SimpTokAuth': this.props.tokenPass,
          'InstTypeID': this.props.typeid,
          'InputSearchText': encodeURI(JSON.stringify(prototype))
        }
      }).then((response) => response.json())
        .then((data) => console.log(data))
        .catch((error) => console.log(error))
  }

  fetchInstances() {
    console.log('fetching...');
    fetch(SERVER_LINK + '/get_ranked_instances', {
      method: 'GET',
        headers: {
          Accept:'application/json',
          'Content-Type': 'application/json',
          'SimpTokAuth': this.props.tokenPass,
          'InstTypeID': this.props.typeid,
          'InputSearchText': encodeURI(this.props.currentText)
        }
      }).then((response) => response.json())
        .then((data) => {Array.isArray(data) ? this.setState({fetchingInstances: false, rankedInstances: data}) : alert('error fetching data, please reload page')})
        .catch((error) => console.log(error))
  }

  addInstance = () => {
    fetch(SERVER_LINK + '/add_instance', {
      method: 'POST',
      headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
      },
      body: JSON.stringify({
          idtoken: this.props.tokenPass,
          typeid: this.props.typeid,
          instance_text: this.props.currentText
      })
    }).then((response) => response.json())
      .then((data) => {Array.isArray(data) ? this.setState({fetchingInstances: true}, () => {this.props.removeText(); this.fetchInstances();}) : alert('failed to add, please reload the page')})
      .catch((error) => console.log(error))
  }

  deleteInstance = (instance_id) => {
    fetch(SERVER_LINK + '/delete_instance', {
      method: 'POST',
      headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
      },
      body: JSON.stringify({
          idtoken: this.props.tokenPass,
          instanceid: instance_id
      })
    }).then((response) => response.json())
      .then(() => this.setState({fetchingInstances: true}, () => {this.fetchInstances()} ))
      .catch((error) => console.log(error))
      .finally(this.fetchInstances())
  }

  render() {
    return (
      <div>
        <SearchBox tokenPass={this.props.tokenPass}
                       typeid={this.props.typeid}
                       executeQuery={this.queryInstances}
                       startQuery={() => {this.setState({fetchingInstances:true})}}
                       setQueryResult={(results) => {this.setState({rankedInstances: results, fetchingInstances:false})}}/>
          <div className="screen">
            {this.state.fetchingInstances ?
                  <p>Loading instances... </p> :
                  <div>
                      {this.props.currentText=='' ? <div></div> :
                        <Button onClick={this.addInstance}>Create new instance from text </Button>}
                        <Grid container
                              direction="column"
                              justify="flex-start"
                              alignItems="stretch">
                            {this.state.rankedInstances.map((instance) => 
                                <div className="card">
                                  <InstanceCard text={instance.instancetext} 
                                                typeid={instance.typeid}
                                                typename={instance.typename} 
                                                instanceid={instance.instanceid} 
                                                handleDelete={() => {this.deleteInstance(instance.instanceid)}}
                                                handleChangeName={() => {}}
                                                pdfPath={instance.instancepdf}
                                                tokenPass={this.props.tokenPass}
                                                imagePath={instance.instanceimage}
                                                someURL={instance.someURL}
                                                sendToMap={(instid) => {}} />
                                </div>)}
                        </Grid>
                  
                  </div>
            }
          </div>
       </div>)}
}


class StructureScreen extends React.Component {
  constructor(props) {
    super(props);
    this.props = props
    this.state = {
      fetchingStructure: false,
      typeid: '',
      instanceid: '',
      structure: [],
      typename: "",
      anchorEl: null,
      refreshing: false,
      refreshingType: false,
      textMode: 'EDIT', 
      overlay_set_type_parent: false,
      fetchingParent: true,
      parentOfCurrentTypeId: '',
      parentOfCurrentTypeName: '',
      currentlySetParentName: '',
      overlay_set_type_name: false,
      newTypeName: ''
    }
    this.fetchTypes = this.fetchTypes.bind(this)
    this.fetchTypeParent = this.fetchTypeParent.bind(this)
  }

  async fetchTypes(input) {
    this.setState({refreshing:false})
    return fetch(SERVER_LINK + '/get_types', {
                method: 'GET',
                  headers: {
                    Accept:'application/json',
                    'Content-Type': 'application/json',
                    'SimpTokAuth': this.props.tokenPass,
                    'InputSearchText': input
                  }
                }).then((response) => response.json())
                  .then((data) => data.map((type) => {return {label: type.name, value:type.id}}))
                  .catch((error) => console.log(error))
  }

  addType = (new_type_name) => {
    fetch(SERVER_LINK + '/add_type', {
      method: 'POST',
      headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
      },
      body: JSON.stringify({
          idtoken: this.props.tokenPass,
          type_name: new_type_name
      })
    }).then((response) => response.json())
      .then((data) => {if (data == 'SUCCESS') {this.setState({refreshing: true, typeid: ''})} })
      .catch((error) => console.log(error))
  }

  deleteSelectedType = () => {
    fetch(SERVER_LINK + '/delete_type', {
      method: 'POST',
      headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
      },
      body: JSON.stringify({
          idtoken: this.props.tokenPass,
          typeid: this.state.typeid
      })
    }).then((response) => response.json())
      .catch((error) => console.log(error))
      .finally(() => {this.setState({refreshing: true, typeid: ''}); this.handleClose()})
  }

  async fetchTypeParent() {
    return fetch(SERVER_LINK + '/get_type_parent', {
                method: 'GET',
                  headers: {
                    Accept:'application/json',
                    'Content-Type': 'application/json',
                    'SimpTokAuth': this.props.tokenPass,
                    'InstTypeId': this.state.typeid
                  }
                }).then((response) => response.json())
                  .then((data) => {Array.isArray(data) && data.length==1 ? this.setState({currentlySetParentName: data[0].parent_name, fetchingParent:false}) : this.setState({currentlySetParentName: '', fetchingParent:false})})
                  .catch((error) => console.log(error))
  }

  setTypeParent = () => {
    fetch(SERVER_LINK + '/set_type_parent', {
      method: 'POST',
      headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
      },
      body: JSON.stringify({
          idtoken: this.props.tokenPass,
          typeid: this.state.typeid,
          newparentid: this.state.parentOfCurrentTypeId.toString()
      })
    }).then((response) => response.json())
      .then((data) => {if (data == 'SUCCESS') {this.setState({fetchingParent: true, currentlySetParentName: ''}, () => this.fetchTypeParent())} })
      .catch((error) => console.log(error))
  }

  setTypeName = () => {
    fetch(SERVER_LINK + '/set_type_name', {
      method: 'POST',
      headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
      },
      body: JSON.stringify({
          idtoken: this.props.tokenPass,
          typeid: this.state.typeid,
          new_type_name: this.state.newTypeName
      })
    }).then((response) => response.json())
      .then((data) => {if (data == 'SUCCESS') {this.setState({refreshing: true, typeid: ''})} })
      .catch((error) => console.log(error))
  }

  handleChange = (selectedOption) => {
    console.log(selectedOption);
    this.setState({
      typeid: selectedOption.value,
      selected_typename: selectedOption.label,
      refreshingType: true
    });
  }

  handleInputChange = (new_input) => {
    this.setState({
      typename: new_input.toUpperCase()
    })
  }

  handleSetParentChange = (selectedOption) => {
    console.log(selectedOption);
    this.setState({
      parentOfCurrentTypeId: selectedOption.value,
      parentOfCurrentTypeName: selectedOption.label
    });
  }

  handleSetParentInputChange = (new_input) => {
    this.setState({
      parentOfCurrentTypeName: new_input.toUpperCase()
    })
  }

  handleNewNameInputChange = (new_input) => {
    this.setState({
      newTypeName: new_input.target.value.toUpperCase()
    })
  }

  handleClick = (event) => {
    this.setState({anchorEl: event.currentTarget});
  };

  handleClose = () => {
    this.setState((state) => {return {anchorEl: null}});
  };

  render() {
    return (
    <div className="container" style={{'overflow-x': 'hidden'}}>
      <div className="screen navi">
        {this.state.refreshing ? this.setState({refreshing:false}) : 
            <div>
              <div className="outter">

                  <div className="inner" style={{width: `${(this.props.screenWidth*0.6) - 150}px`}}  >
                      <AsyncCreatableSelect cacheOptions
                                    defaultOptions
                                    inputValue={this.state.typename}
                                    onInputChange={this.handleInputChange}
                                    onCreateOption={this.addType}
                                    createOptionPosition={"first"}
                                    loadOptions={this.fetchTypes}
                                    placeholder={"What is this?"}
                                    onChange={this.handleChange} />
                  </div>
                  <div className="inner" style={{float: 'right', 'padding-right': '40px'}}>
                      <Button aria-controls="simple-menu" aria-haspopup="true" onClick={this.handleClick}>
                        <MenuIcon />
                      </Button>
                      <Menu
                          id="simple-menu"
                          anchorEl={this.state.anchorEl}
                          keepMounted
                          open={Boolean(this.state.anchorEl)}
                          onClose={this.handleClose}>
                                <MenuItem onClick={() => {this.setState({overlay_set_type_parent: true, anchorEl: null}, () => this.fetchTypeParent()); }}>Parent Info</MenuItem>
                                <MenuItem onClick={() => {this.setState({overlay_set_type_name: true, anchorEl: null})}}>Change Name</MenuItem>
                                <MenuItem onClick={this.deleteSelectedType}>Delete</MenuItem>
                        </Menu>
                  </div>
              </div>
              {this.state.typeid == '' ?
                  <p>Please select the note's type</p> :
                      (this.state.refreshingType ? this.setState({refreshingType:false}) : 
                          <div>
                            <ListOfKnownInstances tokenPass={this.props.tokenPass} 
                                                  currentText={this.props.currentText} 
                                                  typeid={this.state.typeid} 
                                                  typename={this.state.selected_typename}
                                                  removeText={this.props.removeText}/>
                          </div>)}
            </div>
        }
      </div>
            {this.state.overlay_set_type_parent ? 
                        <div className="infoi">
                            <div className="centeredBox">
                                  <Button style={{'float': 'right'}}onClick={() => this.setState({overlay_set_type_parent: false, currentlySetParentName: '', fetchingParent:true})}><CloseIcon/></Button>
                                      {this.state.typeid==='' ? <p>Type not selected</p> : 
                                                  <div>
                                                      <p>Current parent: </p>
                                                          {this.state.fetchingParent ? 
                                                                  <p>Fetching... </p> : 
                                                                  (this.state.currentlySetParentName === '' ? 
                                                                          <p>Not defined</p> : 
                                                                          <div>
                                                                              <h6 class="type_mini">{this.state.currentlySetParentName}</h6>
                                                                          </div>)}
                                                      <p>Set new parent: </p>
                                                      <AsyncSelect cacheOptions
                                                                   defaultOptions
                                                                   inputValue={this.state.parentOfCurrentTypeName}
                                                                   onInputChange={this.handleSetParentInputChange}
                                                                   loadOptions={this.fetchTypes}
                                                                   placeholder={"Type new parents name"}
                                                                   onChange={this.handleSetParentChange} />
                                                      <Button onClick={() => this.setTypeParent()}>Set</Button>
                                                  </div>}
                                                  
                                              </div>
                                           </div> : <div></div>}
            {this.state.overlay_set_type_name ? <div className="infoi">
                                                <div className="centeredBox">
                                                <Button style={{'float': 'right'}} onClick={() => this.setState({overlay_set_type_name: false, newTypeName: ''})}><CloseIcon/></Button>
                                                {this.state.typeid==='' ? <p>Type not selected</p> : 
                                                  <div>
                                                      <p>Set new type name: </p>
                                                      <TextField id="newname" 
                                                                  type="text" 
                                                                  variant="outlined" 
                                                                  label="New type name" 
                                                                  fullWidth={true} 
                                                                  onChange={this.handleNewNameInputChange}
                                                                  value={this.state.newTypeName} />
                                                      <Button onClick={this.setTypeName}>Set</Button>
                                                  </div>}
                                                  
                                              </div>
                                           </div> : <div></div>}
      </div>
      
    )
  }
}



//List of small instances
function ListOfInstances(props) {
  const [fetchingInstances, setFetchingInstances] = useState(true);
  const [rankedInstances, setRankedInstances] = useState([]);

  useEffect(() => {
      console.log('fetching with text: ' + props.currentText + ' and typeid: ' + props.typeid);
      setFetchingInstances(true)
      fetch(SERVER_LINK + '/get_quick_instances', {
        method: 'POST',
          headers: {
            Accept:'application/json',
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            idtoken: props.tokenPass,
            search_text: props.currentText,
            inst_type_id: props.typeid
          })
        }).then((response) => response.json())
          .then((data) => {Array.isArray(data) ? setRankedInstances(data) : console.log(data)})
          .catch((error) => console.log(error))
          .finally(() => setFetchingInstances(false))
    }, [props.currentText, props.typeid])

  const addInstance = () => {
    fetch(SERVER_LINK + '/add_instance', {
      method: 'POST',
      headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
      },
      body: JSON.stringify({
          idtoken: props.tokenPass,
          typeid: props.typeid,
          typename: props.typename,
          instance_text: props.currentText,
          url: props.url
      })
    }).then((response) => response.json())
      .then((data) => {!isNaN(data) ? props.addNewLink(data) : console.log(data)})
      .catch((error) => console.log(error))
      .finally(() => setFetchingInstances(true))
  }



  
  return (
      <div>
      <div className="screen">
            {fetchingInstances ?
                  <p>Loading instances... </p> :
                  <div>
                      {props.currentText=='' ? <div></div> :
                        <Grid container
                              direction="column"
                              justify="flex-start"
                              alignItems="stretch">
                            <div className="padd"><Button onClick={addInstance} variant="contained">Create New Instance</Button></div>
                            {rankedInstances.map((instance) => 
                                <div className="cardmini">
                                  <Card style={{'backgroundColor' : 'rgb(' + (200*(1-instance.similarity)) + ',' + (instance.similarity > 0.9 ? 200*(instance.similarity) : 0) + ',0,0.5)'}}>
                                      <CardActionArea onClick={() => {props.addNewLink(instance.instanceid); setFetchingInstances(true)}}>
                                        <CardContent style={{'display': 'flex', 'padding': '5px'}}>
                                        <Avatar aria-label="recipe">
                                                  {instance.typename.charAt(0)}
                                        </Avatar>
                                        <Typography variant="body2" style={{'margin': 'auto', 'margin-left': '10px'}}>
                                          {instance.instancetext}
                                        </Typography>
                                      </CardContent>
                                      </CardActionArea>
                                  </Card>
                                </div>)}
                            
                        </Grid>}
                  </div>
            }
      </div>
       
      </div>)
}


function ListOfGoals(props) {
  const [fetchingGoals, setFetchingGoal] = useState(true);
  const [rankedGoals, setRankedGoals] = useState([]);

  useEffect(() => {
      console.log('fetching');
      fetch(SERVER_LINK + '/get_sorted_goals', {
        method: 'GET',
          headers: {
            Accept:'application/json',
            'Content-Type': 'application/json',
            'SimpTokAuth': props.tokenPass,
            'InstTypeID': props.typeid,
            'InputSearchText': encodeURI(props.currentText)
          }
        }).then((response) => response.json())
          .then((data) => {Array.isArray(data) ? setRankedGoals(data) : console.log(data)})
          .catch((error) => console.log(error))
          .finally(() => setFetchingGoal(false))
    }, [props.currentText])

  const addGoal = () => {
    fetch(SERVER_LINK + '/add_goal', {
      method: 'POST',
      headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
      },
      body: JSON.stringify({
          idtoken: props.tokenPass,
          goal_text: props.currentText
      })
    }).then((response) => response.json())
      .then((data) => {Array.isArray(data) ? props.addNewLink(data[0][0]) : console.log(data)})
      .catch((error) => console.log(error))
  }



  
  return (
      <div>
      <div className="screen">
            {fetchingGoals ?
                  <p>Loading goals... </p> :
                  <div>
                      {props.currentText=='' ? <div></div> :
                        <Grid container
                              direction="column"
                              justify="flex-start"
                              alignItems="stretch">
                            {rankedGoals.map((goal) => 
                                <div className="cardmini">
                                  <Card>
                                      <CardActionArea onClick={() => {props.addNewLink(goal.id)}}>
                                        <CardContent style={{'display': 'flex', 'padding': '5px'}}>
                                          <Typography variant="body2" style={{'margin': 'auto', 'margin-left': '10px'}}>
                                            {goal.name}
                                          </Typography>
                                        </CardContent>
                                      </CardActionArea>
                                  </Card>
                                </div>)}
                            <div className="padd">
                              <Button onClick={addGoal} variant="contained">Create New Goal</Button>
                              </div>
                        </Grid>}
                  </div>
            }
      </div>
       
      </div>)
}


function SearchBar(props) {
  const classes = useStyles();

  const [fetchingSearchTokens, setFetchingSearchTokens] = useState(false)
  const [currentSearchTokens, setCurrentSearchTokens] = useState([])
  const [predictedSearchHighlights, setPredictedSearchHighlights] = useState([])
  const [predictedTypeProbs, setPredictedTypeProbs] = useState([])
  const [predictedTypeLoc, setPredictedTypeLoc] = useState([])

  const [currentSearchHighlights, setCurrentSearchHighlights] = useState([])
  const [currentTypeHighlight, setCurrentTypeHighlight] = useState('')
  const [selectedTypeIndex, setSelectedTypeIndex] = useState('')
  const [mainTypeNameInputValue, setMainTypeNameInputValue] = useState('')
  const [currentType, setCurrentType] = useState('NULL')
  const [currentTypeLocation, setCurrentTypeLocation] = useState({start:'', end:''})
  
  const [currentPropTags, setCurrentPropTags] = useState([])
  const [addingPropTagType, setAddingPropTagType] = useState(false)
  const [propTagIndex, setPropTagIndex] = useState(0)
  const [propTagTypeNameInputValue, setPropTagTypeNameInputValue] = useState('')
  const [propTagSelectedType, setPropTagSelectedType] = useState({id:'', name:''})

  const [loadingResults, setLoadingResults] = useState(false)
  const [results, setResults] = useState([])
  const [currentResults, setCurrentResults] = useState([])

  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const reinitializeSearch = () => {
    setCurrentSearchTokens([])
    setCurrentSearchHighlights([])
    setCurrentTypeHighlight('')
    setMainTypeNameInputValue('')
    setCurrentType('NULL')
    setCurrentPropTags([])
    setCurrentResults([])
  }

  const loadSimpleInstances = () => {
    setLoadingResults(true)
    fetch(SERVER_LINK + '/get_instances_for_text', {
      method: 'POST',
        headers: {
          Accept:'application/json',
          'Content-Type': 'application/json',
          'SimpTokAuth': props.tokenPass,
        },
        body: JSON.stringify({
          text: props.searchingText
        })
      }).then((response) => response.json())
        .then((data) => {console.log(data); setResults(data);})
        .catch((error) => console.log(error))
        .finally(() => setLoadingResults(false))
  }

  const handleTaggingEvent = (new_highlights) => {
    console.log(currentSearchHighlights)
    if (new_highlights.length < currentSearchHighlights.length) {
      // removing tag

      var selectedHighlight;
      if (new_highlights.length == 0) {
        selectedHighlight = currentSearchHighlights[0]
      }
      else {
        for (var i = 0; i < currentSearchHighlights.length; i++) {
          var currentHighlightedBelongs = false
          for (var j = 0; j < new_highlights.length; j++) {
            if (currentSearchHighlights[i].start == new_highlights[j].start && currentSearchHighlights[i].end == new_highlights[j].end && currentSearchHighlights[i].instanceid == new_highlights[j].instanceid) {
              currentHighlightedBelongs = true
              break;
            }
          }
          if (!currentHighlightedBelongs) {
            selectedHighlight = currentSearchHighlights[i]
            break;
          }
        }
      }
      if ((currentType != 'NULL') && (selectedHighlight.tag == 'TYPE')) {
        // do not remove type tag
        console.log('cannot delete type while it is selected')
      }
      else {
        // remove tag from props
        var newPropTags = []
        var newPropLeafs = []
        for (var i = 0; i < currentPropTags.length; i++) {
          if (!((selectedHighlight.start == currentPropTags[i].textStart) && (selectedHighlight.end == currentPropTags[i].textEnd))) {
            newPropTags.push(currentPropTags[i])
          }
        }
        setCurrentPropTags(newPropTags)
        setCurrentSearchHighlights(new_highlights)
      }
    }
    else {
      //adding tag

      var nhighlight = new_highlights[new_highlights.length-1]
      var highlighttokens = [];
      for (var i=nhighlight.start; i<nhighlight.end; i++) {
        highlighttokens.push(currentSearchTokens[i])
      }
      if (currentType != 'NULL') {
        setCurrentPropTags(oldArray => [...oldArray, {text:highlighttokens.join(' ').trim(), textStart:nhighlight.start, textEnd:nhighlight.end, type:{name:'', id:''}, path: 'NULL'}]);
      }
      if (new_highlights.length == 1) {
        setCurrentTypeHighlight(highlighttokens.join(' '))
      }
      setCurrentSearchHighlights(new_highlights)
    }
  };

  const handleTypeChange = (event) => {
    setCurrentTypeHighlight(event.target.value)
  };

  const selectMainType = (selectedOption) => {
    setCurrentType({id: selectedOption.value, name: selectedOption.label})
    for (var highlights_index = 0; highlights_index < currentSearchHighlights.length; highlights_index++) {
      var highlightValue = ''
      var highlight = currentSearchHighlights[highlights_index]
      for (var i = highlight.start; i < highlight.end; i++) {
        highlightValue += currentSearchTokens[i] + ' '
      }
      highlightValue = highlightValue.trim()
      console.log(currentTypeHighlight)

      if (highlightValue != currentTypeHighlight.trim()) {
        console.log('adding props')
        currentPropTags.push({text:highlightValue, textStart:highlight.start, textEnd:highlight.end, type:{name:'', id:''}});
      }
      else {
        setCurrentTypeLocation({start:highlight.start,end:highlight.end})
        currentSearchHighlights[highlights_index].tag = 'TYPE'
        currentSearchHighlights[highlights_index].color = '#85ff8f'
        setSelectedTypeIndex(highlights_index)
      }
    }
  }

  const removeSelectedType = () => {
    setCurrentType('NULL')
    setCurrentPropTags([])
    setCurrentResults([])
    delete currentSearchHighlights[selectedTypeIndex].tag
    delete currentSearchHighlights[selectedTypeIndex].color
  }

  const fetchTypes = async (input) => {
    return fetch(SERVER_LINK + '/get_types', {
                method: 'GET',
                  headers: {
                    Accept:'application/json',
                    'Content-Type': 'application/json',
                    'SimpTokAuth': props.tokenPass,
                    'InputSearchText': input
                  }
                }).then((response) => response.json())
                  .then((data) => data.map((type) => {return {label: type.name, value:type.id}}) )
                  .catch((error) => console.log(error))
  }

  const startSettingPropTagType = (index) => {
    setPropTagIndex(index)
    setAddingPropTagType(true)
  }

  const selectPropTagType = (selectedOption) => {
    setPropTagSelectedType({id: selectedOption.value, name: selectedOption.label})
  }

  const hanldeSetOfTypeForPropTag = () => {
    fetch(SERVER_LINK + '/get_all_parents_and_type', {
      method: 'GET',
        headers: {
          Accept:'application/json',
          'Content-Type': 'application/json',
          'SimpTokAuth': props.tokenPass,
          'InstTypeID': propTagSelectedType
        }
      }).then((response) => response.json())
        .then((data) => {console.log(data)})
        .catch((error) => console.log(error))
    currentPropTags[propTagIndex].type = propTagSelectedType
    for (var highlights_index = 0; highlights_index < currentSearchHighlights.length; highlights_index++) {
      if ((currentSearchHighlights[highlights_index].start == currentPropTags[propTagIndex].textStart) && (currentSearchHighlights[highlights_index].end == currentPropTags[propTagIndex].textEnd)) {
        currentSearchHighlights[highlights_index].tag = propTagSelectedType.name
        currentSearchHighlights[highlights_index].typeid = propTagSelectedType.id
      }
    }
    setPropTagTypeNameInputValue('')
    setAddingPropTagType(false)
  }

  const setPropLeaf = (propLeaf, propTag) => {
    for (var i = 0; i < currentPropTags.length; i++) {
      if ((currentPropTags[i].textStart == propTag.textStart) && (currentPropTags[i].textEnd == propTag.textEnd)) {
          currentPropTags[i].path = propLeaf
          break;
      }
    }
  }

  return <div>
              <div style={{'position': 'fixed',
                    'background-color': 'rgba(107, 107, 107, 0.408)',
                    'z-index': '10',
                    'width': '100%',
                    'height': '100%'}}>
                  <div className={'searchBox'}>
                  <Button onClick={props.hideSearchBox} style={{'float': 'right'}}><CloseIcon/></Button>
                  <br/>
                  {/**
                  <AppBar position="static">
                    <Tabs value={value} onChange={handleChange} aria-label="simple tabs example">
                      <Tab label="Simple Task Search" />
                      <Tab label="Simple Object Search" />
                      <Tab label="Complex Search" />

                    </Tabs>
                  </AppBar>
                   */}
                  <TabPanel value={value} index={0}>
                    <div>
                        <Button onClick={() => {loadSimpleInstances()}}>Search</Button>
                        {loadingResults ? <CircularProgress /> :
                        <Grid spacing={2}>
                        {results.map((instance) => 
                            <Grid item key={instance.id} style={{margin:10}}>
                              <InstanceCard tokenPass={props.tokenPass}
                                                text={instance.text} 
                                                typename={instance.typeName} 
                                                instanceid={instance.id} 
                                                typeid={instance.typeId}
                                                updateParent={() => {}}
                                                handleDelete={loadSimpleInstances}
                                                pdfPath={instance.pdfURL}
                                                imagePath={instance.imageURL}
                                                someURL={instance.someURL} />
                                                </Grid>)}
                        </Grid>}
                    </div>
                  </TabPanel>
                  {/** 
                  <TabPanel value={value} index={1}>
                  <div style={{marginTop: '20px'}} >
                    <Button onClick={query}>Search Tokens</Button>
                    {fetchingSearchTokens ? 
                      <CircularProgress /> :
                      <div>
                        <Typography variant='h3'>Auto:</Typography>
                        <TokenAnnotator style={{display: 'inline-block', 'white-space': 'pre-line', 'maxWidth': '80%'}} 
                                      tokens={currentSearchTokens} 
                                      value={predictedSearchHighlights} 
                                      onChange={()=>{}} />
                        <Typography>Predicted type probs:</Typography>
                        {predictedTypeLoc}
                        <Grid>
                          {predictedTypeProbs.map((type) => 
                              <PredictedTypeBox id={type.id}
                                                name={type.name}
                                                probs={type.probs}
                                                prop_path_string={type.prop_segments} />)}
                        </Grid>
                        <Typography variant='h3'>Manual:</Typography>
                        <TokenAnnotator style={{display: 'inline-block', 'white-space': 'pre-line', 'maxWidth': '80%'}} 
                                      tokens={currentSearchTokens} 
                                      value={currentSearchHighlights} 
                                      onChange={handleTaggingEvent} />
                        
                        <br/>
                        <div style={{marginTop: '50px'}} >
                            <Typography variant='h6'>Type: </Typography>
                            {currentType == 'NULL' ?
                            <div>
                              <p>Choose highlight</p>
                              <NativeSelect
                                value={currentTypeHighlight}
                                onChange={handleTypeChange}
                                name="Type"
                                inputProps={{ 'aria-label': 'age' }}
                                style={{'width' : '100%'}}
                              >
                                {currentSearchHighlights.map((highlight) => {
                                  var highlightValue = ''
                                  for (var i = highlight.start; i < highlight.end; i++) {
                                    highlightValue += currentSearchTokens[i] + ' '
                                  }
                                  return <option value={highlightValue}>{highlightValue}</option>
                                })}
                              </NativeSelect>
                              <p>Choose hightlight's type:</p>
                              <AsyncSelect cacheOptions
                                          defaultOptions
                                          inputValue={mainTypeNameInputValue}
                                          onInputChange={(new_input) => {setMainTypeNameInputValue(new_input.toUpperCase())}}
                                          loadOptions={fetchTypes}
                                          placeholder={"Type tag's type"}
                                          onChange={selectMainType} />
                            </div> :
                            <div>
                              <h4 className="type_large" style={{'float':'left', 'width':'50%'}}>{currentType.name}</h4>
                              <Button onClick={removeSelectedType} style={{'float':'right', 'width':'20%'}}><BackspaceIcon/></Button>
                            </div>}
                        </div>
                        <br/>
                        <br/>
                        <div style={{marginTop: '10px'}} >
                            <Typography style={{width: '50px', 'float':'left'}} variant='h6'>Props: </Typography>
                        </div>
                        <br/>
                        <div style={{marginTop: '30px'}}>
                            {currentType == 'NULL' ? 
                              <Typography variant='body'>Select Type First</Typography> :
                              <Grid >
                                {currentPropTags.map((tag, index) => 
                                                          <PropTagBox tag={tag} 
                                                                      assType={tag.type}
                                                                      selectedType={currentType}
                                                                      setType={() => {startSettingPropTagType(index);}}
                                                                      setPropPath={setPropLeaf}
                                                                      tokenPass={props.tokenPass} />)}
                              </Grid>
                            }
                        </div> 
                        <div style={{marginTop: '40px'}}>
                          <Button style={{width: '100%'}} onClick={saveCurrentAnnotation}>Save and search</Button>
                        </div>
                      </div>
                    }
                  </div>
                  </TabPanel>
                  */}
                  </div>
              </div>
              {addingPropTagType ? 
                <div className="infoi"> 
                  <div className="centeredBox"> 
                    <Button style={{'float': 'right'}}
                            onClick={() => {setPropTagTypeNameInputValue(''); setAddingPropTagType(false);}}>
                      <CloseIcon/>
                    </Button>
                    <h4>Setting type for tag '{currentPropTags[propTagIndex].text}'</h4>
                    <p>Current type is: #{currentPropTags[propTagIndex].type.id} - {currentPropTags[propTagIndex].type.name} </p>
                    <h6>Select type of tag: </h6>
                    <AsyncSelect cacheOptions
                                defaultOptions
                                inputValue={propTagTypeNameInputValue}
                                onInputChange={(new_input) => {setPropTagTypeNameInputValue(new_input.toUpperCase())}}
                                loadOptions={fetchTypes}
                                placeholder={"Type tag's type"}
                                onChange={selectPropTagType} />
                    <Button onClick={hanldeSetOfTypeForPropTag}>Set</Button>
                  
              </div>
            </div>: <div></div>}
        </div>
}


function NotificationsBox(props) {
  const classes = useStyles();

  const [fetchingNotifications, setFetchingNotification] = useState(false)
  const [currentNotifications, setCurrentNotifications] = useState([])




  return <div>
              <div style={{'position': 'fixed',
                    'background-color': 'rgba(107, 107, 107, 0.408)',
                    'z-index': '10',
                    'width': '100%',
                    'height': '100%'}}>
                  <div className={'notificationsBox'} ref={props.refWrapper}>
                    <p>Some notifications</p>
                  </div>
              </div>
        </div>
}


function MoodChooser(props) {
  const [moodIndex, setMoodIndex] = useState(-1);

  const [loadingMoods, setLoadingMoods] = useState(true);
  const [moodList, setMoodList] = useState([{id: -1, name: 'Recent', symbol: 'null'}]);

  const [addingMood, setAddingMood] = useState(false);
  const [moodNameInputValue, setMoodNameInputValue] = useState('');
  const [searchingSymbols, setSearchingSymbols] = useState(false)
  const [symbolsResults, setSymbolsResults] = useState([])
  const [selectedSymbolLink, setSelectedSymbolLink] = useState('');
  
  const [currentMoodObject, setCurrentMoodObject] = useState(null)

  const topScrollMenuRef = React.useRef();

  useEffect(() => {
    if(topScrollMenuRef.current) {
      const scrollContainer = topScrollMenuRef.current

      console.log('setting scroll listners')


      const onWheel = e => {
        if (e.deltaY == 0) return;
        e.preventDefault();
        scrollContainer.scrollTo({
          left: scrollContainer.scrollLeft + e.deltaY,
          behavior: "smooth"
        });
      };

      scrollContainer.addEventListener("wheel", onWheel);
    }
  }, [topScrollMenuRef.current])

  useEffect(() => {
    getMoodsFromServer()
  }, [loadingMoods])

  useEffect(() => {
    setCurrentMoodObject(moodList.find(element => element.id == props.selectedMood))
  }, [props.selectedMood])

  const getMoodsFromServer = () => {
    fetch(SERVER_LINK + '/get_moods', {
      method: 'GET',
        headers: {
          Accept:'application/json',
          'Content-Type': 'application/json',
          'SimpTokAuth': props.tokenPass
        }
      }).then((response) => response.json())
        .then((data) => {console.log(data); setMoodList(data);})
        .catch((error) => console.log(error))
        .finally(() => setLoadingMoods(false))
  };

  const addNewMood = () => {
    setAddingMood(true);
    fetch(SERVER_LINK + '/add_mood', {
      method: 'POST',
      headers: {
        Accept:'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        idtoken: props.tokenPass,
        mood_name: moodNameInputValue,
        mood_symbol: selectedSymbolLink
      })
    }).then((response) => response.json())
      .then((data) => {console.log(data); setLoadingMoods(true);})
  };

  const searchForSymbols = () => {
    if (moodNameInputValue == '') return;
    setSearchingSymbols(true);
    fetch(SERVER_LINK + '/search_symbols', {
      method: 'POST',
      headers: {
        Accept:'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        idtoken: props.tokenPass,
        search_string: moodNameInputValue
      })
    }).then((response) => response.json())
      .then((data) => {console.log(data); setSymbolsResults(data);})
      .finally(() => {setSearchingSymbols(false);})
  }

  return (
    loadingMoods ? 
      <div><p></p></div> :
      <div>
      <div class="scrollmenu" style={{'height': '100px', 'borderRadius': '10px'}} ref={topScrollMenuRef}>
        {moodList.map((mood) => {
          if (props.selectedMood == mood.id) {
            return <Button style={{display: 'inline-block',
                          'background': 'lightblue',
                          'text-align': 'center',
                          'padding': '14px',
                          'text-decoration': 'none'}}
                  onClick={() => {props.setSelectedMood(mood.id);}}> 
                  <div style={{'width': '100px'}}>
                   <img src={mood.symbolPath} style={{'width': '40px', 'height': '40px'}}/>
                  <br/>
                  <Typography variant="caption" sx={{ 'color': 'black', 'font-weigth': '1000' }} >{mood.name} </Typography>
                  </div>
                  </Button>
          } else {
              return <Button style={{display: 'inline-block',
                              'text-align': 'center',
                              'padding': '14px',
                              'text-decoration': 'none'}}
                      onClick={() => {props.setSelectedMood(mood.id);}}>
                        <div style={{'width': '100px'}}>
                        <img src={mood.symbolPath} style={{'width': '40px', 'height': '40px'}}/>
                        <br/>
                        <Typography variant="caption" color="black">{mood.name} </Typography>
                        </div>
                  </Button>
          }
        })}
        <Button style={{display: 'inline-block',
                            color: 'gray',
                            'text-align': 'center',
                            'padding': '14px',
                            'text-decoration': 'none'}}
                    onClick={() => {setAddingMood(true)}}> 
                    <div style={{'width': '100px'}}>
                        <img src={'https://static.thenounproject.com/png/4871880-200.png'} style={{'width': '40px', 'height': '40px'}}/>
                        <br/>
                        <Typography variant="caption" color="black">{'ADD MOOD'} </Typography>
                        </div>
         </Button>
         </div>
        {!addingMood ? <div></div>: 
          <div className="infoi"> 
                    <div className="centeredBox"> 
                                <div>
                                <TextField id="addnewmood" 
                                            type="text" 
                                            variant="outlined" 
                                            label="New Mood" 
                                            onChange={(event) => {setMoodNameInputValue(event.target.value)}}
                                            value={moodNameInputValue} /> 

                                <Button onClick={searchForSymbols}>Search</Button> 
                                
                                <Button onClick={() => {
                                  if (moodNameInputValue != '') {
                                    addNewMood(moodNameInputValue);
                                    setMoodNameInputValue('');
                                    setAddingMood(false);
                                  }
                                }}>Add</Button>
                                <Button onClick={() => {setAddingMood(false); setMoodNameInputValue('')}}>Cancel</Button>
                                </div>
                                <br/>
                                <div>
                                {!searchingSymbols ?

                                    <div class={'grid-container-central'} >
                                      {symbolsResults.map((symbol_path, idx) => {
                                        if (selectedSymbolLink == symbol_path) {
                                          return <div class={'grid-item-central-selected'}>
                                                  <Button onClick={() => {setSelectedSymbolLink('')}}>
                                                  <img src={symbol_path} style={{'width': '40px', 'height': '40px'}}/>
                                                  </Button>
                                                </div>
                                        }
                                        else {
                                          return <div class={'grid-item-central'}>
                                                  <Button onClick={() => {setSelectedSymbolLink(symbol_path)}}>
                                                    <img src={symbol_path} style={{'width': '40px', 'height': '40px'}}/>
                                                  </Button>
                                                </div>
                                        }
                                      })}
                                  </div>
                                  :
                                  <p>Searching...</p>}
                                </div>
                              </div>

          </div>}
        {!props.editingSelectedMood ? <div></div>: 
          <div className="infoi"> 
                    <div className="centeredBox"> 
                                <div>
                                <TextField id="addnewmood" 
                                            type="text" 
                                            variant="outlined" 
                                            label={currentMoodObject.text}
                                            onChange={(event) => {setMoodNameInputValue(event.target.value)}}
                                            value={moodNameInputValue} /> 

                                <Button onClick={searchForSymbols}>Search</Button> 
                                
                                <Button onClick={() => {props.setEditing(false); setMoodNameInputValue('')}}>Cancel</Button>
                                </div>
                                <br/>
                                <div>
                                {!searchingSymbols ?

                                    <div class={'grid-container-central'} >
                                      {symbolsResults.map((symbol_path, idx) => {
                                        if (selectedSymbolLink == symbol_path) {
                                          return <div class={'grid-item-central-selected'}>
                                                  <Button onClick={() => {setSelectedSymbolLink('')}}>
                                                  <img src={symbol_path} style={{'width': '40px', 'height': '40px'}}/>
                                                  </Button>
                                                </div>
                                        }
                                        else {
                                          return <div class={'grid-item-central'}>
                                                  <Button onClick={() => {setSelectedSymbolLink(symbol_path)}}>
                                                    <img src={symbol_path} style={{'width': '40px', 'height': '40px'}}/>
                                                  </Button>
                                                </div>
                                        }
                                      })}
                                  </div>
                                  :
                                  <p>Searching...</p>}
                                </div>
                              </div>

          </div>}
      </div>
  );

}


function TopicVisualizer(props) {
  //List of topics include 'pinned' content which is set by user

  const [loadingTopics, setLoadingTopics] = useState(true);
  const [topicList, setTopicList] = useState([{name:'topic1'}, {name:'topic2'}, {name:'topic3'}]);

  /**
   * The selected topic has an instance id > 0
   * -1 means the content displaying is directly linked to the task (pinned)
   * -2 means the content is a mix of topics (mix)
   */
  const [selectedTopicId, setSelectedTopicId] = useState(-2) //array index

  const [loadingContent, setLoadingContent] = useState(false)
  const [reccomendedContent, setReccomendedContent] = useState([])
  
  const [currentPage, setCurrentPage] = useState(0)

  const [pinningInstance, setPinningInstance] = useState(false)

  const [addingTopic, setAddingTopic] = useState(false);
  const [removingTopic, setRemovingTopic] = useState(false);
  const [newTopicInstID, setNewTopicInstID] = useState('')

  const [reloadVar, setReloadVar] = useState(false)


  useEffect(() => {

  }, [loadingTopics])

  useEffect(() => {
    setReccomendedContent([])
    if (selectedTopicId==-1) {
      if (props.currentPinTypeSelected == "TASK") {
        console.log('fetching task ' + props.currentPinID + ' pinned content')
        fetchPinnedContentForTask((data) => {setReccomendedContent(data); setLoadingContent(false)})
      }
      else if (props.currentPinTypeSelected == "MOOD") {
        console.log('fetching mood ' + props.currentPinID + ' pinned content')
        fetchPinnedContentForMood((data) => {setReccomendedContent(data); setLoadingContent(false)})
      }
    }
    else if (selectedTopicId==-2) {
      if (props.currentPinTypeSelected == "TASK") {
        getTopicsForTask() 
      }
      else if (props.currentPinTypeSelected == "MOOD") {
        getTopicsForMood()
      }
    }
    else if (selectedTopicId>=0) {
      fetchMixedContent([topicList[selectedTopicId]], 'SINGLE_TOPIC')


    }
  }, [props.currentPinTypeSelected, props.currentPinID, selectedTopicId, reloadVar])


  const getTopicsForTask = () => {
    setLoadingTopics(true)
    fetch(SERVER_LINK + '/get_task_topics', {
      method: 'GET',
        headers: {
          Accept:'application/json',
          'Content-Type': 'application/json',
          'SimpTokAuth': props.tokenPass,
          'TaskID': props.currentPinID
        }
      }).then((response) => response.json())
        .then((data) => {if (Array.isArray(data)) {setTopicList(data); fetchMixedContent(data, 'TASK'); setLoadingTopics(false)} else {console.log('error getting topics for task  -  ' + data)}})
        .catch((error) => console.log(error))
        .finally(() => {})
  };


  const addTopicToTask = (new_topic_instid) => {
    fetch(SERVER_LINK + '/link_topic_to_task', {
      method: 'POST',
      headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
      },
      body: JSON.stringify({
          idtoken: props.tokenPass,
          taskid: props.currentPinID,
          topicinstid: new_topic_instid
      })
    }).then((response) => response.json())
      .then((data) => {if ('SUCCESS') {setAddingTopic(false); getTopicsForTask()} 
                        else {console.log('error adding topic to task - ' + data)}})
      .catch((error) => console.log(error))
      .finally(() => {setAddingTopic(false)})
  }

  const removeTopic = (instid) => {
    if (props.currentPinTypeSelected == "TASK") {
      fetch(SERVER_LINK + '/remove_topic_from_task', {
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            idtoken: props.tokenPass,
            taskid: props.currentPinID,
            topicinstid: instid
        })
      }).then((response) => response.json())
        .then((data) => {if ('SUCCESS') {setRemovingTopic(false); getTopicsForTask() }
                          else {console.log('error removing topic from task - ' + data)}})
        .catch((error) => console.log(error))
        .finally(() => {setRemovingTopic(false)})
    }
    else if (props.currentPinTypeSelected == "MOOD") {
      fetch(SERVER_LINK + '/remove_mood_topic', {
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            idtoken: props.tokenPass,
            mood_id: props.currentPinID,
            topic_instid: instid
        })
      }).then((response) => response.json())
        .then((data) => {if ('SUCCESS') {setRemovingTopic(false); getTopicsForMood()}
                          else {console.log('error removing topic from mood - ' + data)}})
        .catch((error) => console.log(error))
        .finally(() => {setRemovingTopic(false)})
    }
  }

  const getTopicsForMood = () => {
    setLoadingTopics(true)
    fetch(SERVER_LINK + '/get_mood_topics', {
      method: 'GET',
        headers: {
          Accept:'application/json',
          'Content-Type': 'application/json',
          'SimpTokAuth': props.tokenPass,
          'MoodID': props.currentPinID
        }
      }).then((response) => response.json())
        .then((data) => {if (Array.isArray(data)) {setTopicList(data); fetchMixedContent(data, 'MOOD'); setLoadingTopics(false)} else {console.log('error getting topics for mood  -  ' + data)}})
        .catch((error) => console.log(error))
        .finally(() => {})
  };

  const addTopicToMood = (new_topic_instid) => {
    fetch(SERVER_LINK + '/add_mood_topic', {
      method: 'POST',
      headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
      },
      body: JSON.stringify({
          idtoken: props.tokenPass,
          mood_id: props.currentPinID,
          topic_instid: new_topic_instid
      })
    }).then((response) => response.json())
      .then((data) => {if ('SUCCESS') {setAddingTopic(false); getTopicsForMood()} 
                       else {console.log('error adding topic to mood - ' + data)}})
      .catch((error) => console.log(error))
  }

  const fetchPinnedContentForTask = (successCallback) => {
    setLoadingContent(true)
    fetch(SERVER_LINK + '/get_task_content', {
      method: 'GET',
        headers: {
          Accept:'application/json',
          'Content-Type': 'application/json',
          'SimpTokAuth': props.tokenPass,
          'TaskID': props.currentPinID
        }
      }).then((response) => response.json())
        .then((data) => {if (Array.isArray(data)) {successCallback(data);} else {console.log(data)}} )
        .catch((error) => console.log(error))
  }

  const fetchPinnedContentForMood = (successCallback) => {
    setLoadingContent(true)
    console.log('fetching mood ' + props.currentPinID + ' pinned content')
    fetch(SERVER_LINK + '/get_mood_content', {
      method: 'GET',
        headers: {
          Accept:'application/json',
          'Content-Type': 'application/json',
          'SimpTokAuth': props.tokenPass,
          'MoodID': props.currentPinID
        }
      }).then((response) => response.json())
        .then((data) => {if (Array.isArray(data)) {successCallback(data);} else {console.log(data)}} )
        .catch((error) => console.log(error))
  }

  const appendContent = (new_data) => {
    setReccomendedContent((old_content) => {
      const new_content = old_content.concat(new_data)
      return new_content
    })
  }

  const fetchMixedContent = (topicss, mode) => {
    setLoadingContent(true)
    if (mode == 'SINGLE_TOPIC') {
      setReccomendedContent([])
      fetch(SERVER_LINK + '/get_content_for_topics', {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            idtoken: props.tokenPass,
            list_topics_instid: [topicss.map((topic) => topic.instid)],
            page_number: currentPage,
            page_size: 1000
        })
        }).then((response) => response.json())
          .then((more_data) => {if (Array.isArray(more_data)) {setReccomendedContent(more_data); console.log(more_data)} else {console.log(more_data)}} )
          .catch((error) => console.log(error))
          .finally(setLoadingContent(false))
    }
    else if (mode == 'MOOD') {
      setReccomendedContent([])
      fetchPinnedContentForMood((data) => {
        appendContent(data); 
        fetch(SERVER_LINK + '/get_content_for_topics', {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
              idtoken: props.tokenPass,
              list_topics_instid: [topicss.map((topic) => topic.instid)],
              page_number: currentPage,
              page_size: 1000
          })
          }).then((response) => response.json())
            .then((more_data) => {if (Array.isArray(more_data)) {appendContent(more_data); console.log(more_data); setLoadingContent(false)} else {console.log(more_data)}} )
            .catch((error) => console.log(error))
      })
    }
    else if (mode == 'TASK') {
      setReccomendedContent([])
      fetchPinnedContentForTask((data) => {
        appendContent(data); 
        fetch(SERVER_LINK + '/get_content_for_topics', {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
              idtoken: props.tokenPass,
              list_topics_instid: [topicss.map((topic) => topic.instid)],
              page_number: currentPage,
              page_size: 1000
          })
          }).then((response) => response.json())
            .then((more_data) => {if (Array.isArray(more_data)) {appendContent(more_data); setLoadingContent(false)} else {console.log(more_data)}} )
            .catch((error) => console.log(error))
      })
    }
  }

  const loadMoreContent = () => {
    setCurrentPage(currentPage+1)
    setLoadingContent(true)
    fetch(SERVER_LINK + '/get_content_for_topics', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
          idtoken: props.tokenPass,
          list_topics_instid: [topicList.map((topic) => topic.instid)],
          page_number: currentPage,
          page_size: 1000
      })
      }).then((response) => response.json())
        .then((data) => {if (Array.isArray(data)) {setReccomendedContent((old_data) => {return old_data.concat(data)}); console.log(data); setLoadingContent(false)} else {console.log(data)}} )
        .catch((error) => console.log(error))
  }

  const selectTopicOption = (new_topic) => {
    if (new_topic == selectedTopicId) {
      return
    }
    setSelectedTopicId(new_topic)
    setLoadingContent(true)
    if (new_topic==-1) {
      if (props.parent == "TASK") {
        console.log('fetching task ' +  + ' pinned content')
      }
      else if (props.parent == "MOOD") {
      }
    }
    else if (new_topic==-2) {
      if (props.parent == "TASK") {

      }
      else if (props.parent == "MOOD") {
      }
    }
    else if (new_topic>=0) {

    }
  };

  const removeLinkFromCurrentSelectedTask = (instanceid) => {
    fetch(SERVER_LINK + '/remove_content_from_task', {
      method: 'POST',
        headers: {
          Accept:'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          'idtoken': props.tokenPass,
          'taskid': '',
          'instid': instanceid
        })
      }).then((response) => response.json())
        .then((data) => {if (data=='SUCCESS') {}})
        .catch((error) => console.log(error))
  }

  

  

  return (
    <div>
      <div>
          <div style={{'backgroundColor': 'lightgray','height': '47px', 'marginRight': '20px', 'marginTop': '15px', 'borderRadius': '5px'}}>
              <Button onClick={() => {selectTopicOption(-2)}} style={{margin: '5px', 'borderRadius': '5px', display: 'inline-block', 'backgroundColor': (selectedTopicId == -2) ? 'lightblue' : ''}}>
                Mix
              </Button>
              {removingTopic ? 
              <div style={{display: 'inline-block', background:'#e1e3e2d9', 'height': '36px', marginBottom:'5px', 'width': (props.currentScreenWidth-750) + 'px', 'white-space': 'nowrap', 'overflow-x': 'scroll', 'vertical-align': 'bottom', 'borderRadius': '5px'}}>
                {topicList.map((topic, idx) => {
                  return <Button onClick={() => {removeTopic(topic.instid)}} style={{display: 'inline-block', 'backgroundColor': 'red'}}>
                            {topic.name + '(R)'}
                          </Button>
                })}
              </div> :
              <div style={{display: 'inline-block', background:'#e1e3e2d9', 'height': '36px', marginBottom:'5px', 'width': (props.currentScreenWidth-750) + 'px', 'white-space': 'nowrap', 'overflow-x': 'scroll', 'vertical-align': 'bottom', 'borderRadius': '5px'}}>
                <Button onClick={() => {selectTopicOption(-1)}} style={{display: 'inline-block', 'backgroundColor': (selectedTopicId == -1)? 'orange':'', 'padding-top':'10px', 'paddingBottom':'0px'}}>
                  <PushPinIcon fontSize="small" />
                </Button>
                {topicList.map((topic, idx) => {
                  return <Button onClick={() => {selectTopicOption(idx)}} style={{display: 'inline-block', 'backgroundColor': (selectedTopicId == idx)? 'lightcoral':''}}>
                            {topic.name}
                          </Button>
                })}
              </div> }

            <Button onClick={() => {setAddingTopic(true)}} style={{margin: '5px', 'borderRadius': '5px', display: 'inline-block', 'float': 'right'}}>
                <AddBoxIcon />
              </Button>
              {removingTopic ? 
              <Button onClick={() => {setRemovingTopic(false)}} style={{margin: '5px', 'borderRadius': '5px', display: 'inline-block', 'float': 'right'}}>
                <DoneIcon />
              </Button> :
              
              <Button onClick={() => {setRemovingTopic(true)}} style={{margin: '5px', 'borderRadius': '5px', display: 'inline-block', 'float': 'right'}}>
                <EditIcon />
              </Button>}
          </div>
        <div>
          <div className="cardmini">
              {/*<Button onClick={loadMoreContent} > Load More</Button>*/}
              {loadingContent ? 
                <div><CircularProgress /> <p>Loading Reccomendations...</p> </div> :
                <div style={{'margin-top':'30px'}}>
                  <Grid container spacing={1} columns={2}>
                    {reccomendedContent.map((instance, index) => {
                      return <Grid item key={index}>
                                <div style={{'width':'340px', 'height': '470px', 'display': 'flex', overflow: 'scroll'}}>
                                  <InstanceCard tokenPass={props.tokenPass}
                                                text={instance.text} 
                                                typename={instance.typeName} 
                                                instanceid={instance.id} 
                                                typeid={instance.typeId}
                                                updateParent={() => {setReloadVar((old_var) => {return !old_var})}}
                                                pdfPath={instance.pdfURL}
                                                imagePath={instance.imageURL}
                                                someURL={instance.someURL} />
                                  </div>
                              </Grid>
                    })}
                    <Grid item key={-2}>
                              <div style={{'width':'290px', 'height': '290px', 'position': 'relative'}}>
                                  <Button onClick={()=>{setPinningInstance(true)}} style={{height: '180px', width: '290px'}}>
                                      <AddBoxIcon />
                                  </Button>
                              </div>
                      </Grid>
                    
                  </Grid>
                </div>}
          </div>
        </div>
      </div>
      {pinningInstance ? 
        (props.currentPinTypeSelected == "MOOD" ?
          <AddingContentWindow tokenPass={props.tokenPass} 
                                moodid={props.currentPinID}
                                closeAddBox={() => {setPinningInstance(false); fetchPinnedContentForMood((data) => {setReccomendedContent(data); setLoadingContent(false)})}} />
          : (props.currentPinTypeSelected == "TASK" ?
            <AddingContentWindow tokenPass={props.tokenPass}
                                taskid={props.currentPinID}
                                closeAddBox={() => {setPinningInstance(false); fetchPinnedContentForTask((data) => {setReccomendedContent(data); setLoadingContent(false)})}} /> : <div>error</div>) )

      :  <div></div>}
      {addingTopic ? 
        (props.currentPinTypeSelected == "MOOD" ?
          <AddingTopicWindow tokenPass={props.tokenPass}
                             addTopic={(topic) => {addTopicToMood(topic)}} 
                             closeWindow={() => {setAddingTopic(false)}}/>
          : (props.currentPinTypeSelected == "TASK" ?
            <AddingTopicWindow tokenPass={props.tokenPass}
                               addTopic={(topic) => {addTopicToTask(topic)}}
                               closeWindow={() => {setAddingTopic(false)}} /> : <div>error</div>) )
      :  <div></div>}
    </div>
  );

}


function NewsFeedHome(props) {

  

  return (
    <div>
      <div>
        <div>
          <div className="cardmini">
              {/*<Button onClick={loadMoreContent} > Load More</Button>*/}
                <div style={{marginTop:'0px'}}>
                  <Grid container spacing={0} columns={2}>
                    {props.content.map((instance, index) => {
                      if (!(((instance.pdfURL == '') || (instance.pdfURL == null)) && ((instance.imageURL == '') || (instance.imageURL == null)) && ((instance.someURL == '') || (instance.someURL == null)))) {
                        return <Grid item key={index}>
                                <div style={{'width':'240px', 'height': '250px', 'display': 'flex', overflow: 'scroll', padding: '5px'}}>
                                  <ModernInstanceCard tokenPass={props.tokenPass}
                                                text={instance.text} 
                                                typename={instance.typeName} 
                                                instanceid={instance.id} 
                                                typeid={instance.typeId}
                                                updateParent={() => {props.updateParent()}}
                                                pdfPath={instance.pdfURL}
                                                imagePath={instance.imageURL}
                                                someURL={instance.someURL} />
                                  </div>
                              </Grid>
                      }
                    })}
                    
                  </Grid>
                  {props.content.length == 0 ? <p>No content yet. Use the mobile app, chrome extension or add content directly by clicking on the top right corner button. </p> : null}
                </div>
          </div>
        </div>
      </div>
    </div>
  );

}

function EmbeddingsFeedHome(props) {

  const [reloadVar, setReloadVar] = useState(false);

  const [loadingContent, setLoadingContent] = useState(false)
  const [recentContent, setRecentContent] = useState([])


  useEffect(() => {
    fetchRecentContent()
  }, [reloadVar])


  const fetchRecentContent = () => {
    setLoadingContent(true)
    fetch(SERVER_LINK + '/get_instances_for_text', {
      method: 'POST',
        headers: {
          Accept:'application/json',
          'Content-Type': 'application/json',
          'SimpTokAuth': props.tokenPass
        },
        body: JSON.stringify({text: props.embeddingText})
      }).then((response) => response.json())
        .then((data) => {if (Array.isArray(data)) {setRecentContent(data); setLoadingContent(false)} else {console.log(data)}} )
        .catch((error) => console.log(error))
  }

  

  return (
    <div>
      <div>
        <div>
          <div className="cardmini">
              {/*<Button onClick={loadMoreContent} > Load More</Button>*/}
              {loadingContent ? 
                <div><CircularProgress /> <p>Loading content...</p> </div> :
                <div style={{'margin-top':'0px'}}>
                  <Grid container spacing={1} columns={2}>
                    {recentContent.map((instance, index) => {
                      if (!(((instance.pdfURL == '') || (instance.pdfURL == null)) && ((instance.imageURL == '') || (instance.imageURL == null)) && ((instance.someURL == '') || (instance.someURL == null)))) {
                        return <Grid item key={index}>
                                <div style={{'width':'240px', 'height': '250px', 'display': 'flex', overflow: 'scroll', padding: '5px'}}>
                                  <ModernInstanceCard tokenPass={props.tokenPass}
                                                text={instance.text} 
                                                typename={instance.typeName} 
                                                instanceid={instance.id} 
                                                typeid={instance.typeId}
                                                updateParent={fetchRecentContent}
                                                pdfPath={instance.pdfURL}
                                                imagePath={instance.imageURL}
                                                someURL={instance.someURL} />
                                  </div>
                              </Grid>
                      }
                      
                    })}
                    
                  </Grid>
                </div>}
          </div>
        </div>
      </div>
     
    </div>
  );

}


/*
function ListOfTreeTasks(props) {
  const classes = useStyles();
  const [fetchingTasks, setFetchingTasks] = useState(true);
  const [tasks, setTasks] = useState([]);
  const [addingTask, setAddingTask] = useState(false);
  const [taskText, setTextTask] = useState('');
  const [startTask, setStartTask] = useState(new Date());
  const [endTask, setEndTask] = useState(new Date());
  const [selectedTaskID, setSelectedTaskID] = useState('');
  const [deletingTask, setDeletingTask] = useState(false)
  const [postponingTask, setPostponingTask] = useState(false)
  const [postponedTaskId, setPostponedTaskId] = useState('')
  const [postponedTaskEndDate, setPostponedTaskEndDate] = useState(new Date())
  const [daysPostponed, setDaysPostponed] = useState(0)
  const [hoursPostponed, setHoursPostponed] = useState(0)
  const [dimensions, setDimensions] = useState({ 
    height: window.innerHeight,
    width: window.innerWidth
  })

  useEffect(() => {
    getTasks()
    window.addEventListener('resize', handleResize)
  }, [])

  const handleResize = () => {
    setDimensions({
      height: window.innerHeight,
      width: window.innerWidth
    }) 
  }

  const getTasks = () => {
    fetch(SERVER_LINK + '/get_tasks', {
      method: 'GET',
        headers: {
          Accept:'application/json',
          'Content-Type': 'application/json',
          'SimpTokAuth': props.tokenPass,
        }
      }).then((response) => response.json())
        .then((data) => {Array.isArray(data) ? setTasks(data) : console.log(data)})
        .catch((error) => console.log(error))
        .finally(() => {setFetchingTasks(false)})
  }
  

  const addTask = () => {
    fetch(SERVER_LINK + '/add_task', {
      method: 'POST',
      headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
      },
      body: JSON.stringify({
          idtoken: props.tokenPass,
          task_text: taskText,
          start: startTask.toISOString().slice(0, 19).replace('T', ' '),
          end: endTask.toISOString().slice(0, 19).replace('T', ' '),
      })
    }).then((response) => response.json())
      .then((data) => {if (data=='SUCCESS') {setTextTask(''); setAddingTask(false)} else {alert('TASK NOT ADDED: ' + data)}})
      .catch((error) => console.log(error))
      .finally(() => getTasks())
  }

  const delete_task = () => {
    fetch(SERVER_LINK + '/delete_task', {
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            idtoken: props.tokenPass,
            taskid: selectedTaskID
        })
      }).then((response) => response.json())
        .then((data) => {if (data=='SUCCESS') {setSelectedTaskID('')} else {alert('Task couldnt be deleted')}} )
        .catch((error) => console.log(error))
        .finally(() => getTasks())
  };

  const setTaskDone = (taskId) => {
    fetch(SERVER_LINK + '/set_task_status', {
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            idtoken: props.tokenPass,
            taskid: taskId,
            new_status: 'DONE'
        })
      }).then((response) => response.json())
        .then((data) => {if (data=='SUCCESS') {} else {alert('Status couldnt be set')}} )
        .catch((error) => console.log(error))
        .finally(() => getTasks())
  };

  const setTaskInProgress = (taskId) => {
    fetch(SERVER_LINK + '/set_task_status', {
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            idtoken: props.tokenPass,
            taskid: taskId,
            new_status: 'INPROGRESS'
        })
      }).then((response) => response.json())
        .then((data) => {if (data=='SUCCESS') {} else {alert('Status couldnt be set')}} )
        .catch((error) => console.log(error))
        .finally(() => getTasks())
  };

  const startPostponingTask = (taskid, taskdeadline) => {
    setPostponedTaskId(taskid)
    setPostponedTaskEndDate(taskdeadline)
    setPostponingTask(true)
  }

  const setTaskDeadline = () => {
    var new_deadline = new Date(postponedTaskEndDate);
    new_deadline.setDate(new_deadline.getDate()+parseInt(daysPostponed)); 
    new_deadline.setHours(new_deadline.getHours()+parseInt(hoursPostponed)); 

    fetch(SERVER_LINK + '/set_task_deadline', {
      method: 'POST',
      headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
      },
      body: JSON.stringify({
          idtoken: props.tokenPass,
          taskid: postponedTaskId,
          new_deadline: new_deadline.toISOString().slice(0, 19).replace('T', ' '),
      })
    }).then((response) => response.json())
      .then((data) => {if (data=='SUCCESS') { getTasks() } else {alert('Not connected, please refreshh')}})
      .catch((error) => console.log(error))
      .finally(() => setPostponingTask(false))
  }



  
  return (
      <div>
      <div className="screen">
            {fetchingTasks ?
                  <p>Loading tasks... </p> :
                  <div>
                    <div style={{'width': '50%', 'height': dimensions.height - 84, 'position': 'absolute', 'overflow': 'scroll'}}>
                        <Grid container
                              direction="column"
                              justify="flex-start"
                              alignItems="stretch"
                              >
                                <div className="cardmini">
                                <Card>
                                        <CardActionArea onClick={() => {if (addingTask) {setAddingTask(false)} else {setAddingTask(true)}}}>
                                          <CardContent style={{'display': 'flex', 'padding': '5px'}}>
                                        <Typography variant="h5" style={{'margin': 'auto', 'marginLeft': '10px'}}>
                                          {'Add task'}
                                        </Typography>
                                        </CardContent>
                                        </CardActionArea>
                                            {addingTask ? 
                                            <div>
                                            <TextField id="newname" 
                                                        type="text" 
                                                        variant="outlined" 
                                                        label="New task" 
                                                        fullWidth={true} 
                                                        onChange={(event) => {setTextTask(event.target.value)}}
                                                        value={taskText} /> 
                                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                                <Grid container justify="space-around">
                                                  <KeyboardDatePicker
                                                    disableToolbar
                                                    variant="inline"
                                                    format="dd/MM/yyyy"
                                                    margin="normal"
                                                    id="start-date-picker"
                                                    label="Start Date"
                                                    value={startTask}
                                                    onChange={(date) => {setStartTask(date)}}
                                                    KeyboardButtonProps={{
                                                      'aria-label': 'change date',
                                                    }}
                                                  />
                                                  <KeyboardTimePicker
                                                    margin="normal"
                                                    id="start-time-picker"
                                                    label="Start Time"
                                                    value={startTask}
                                                    onChange={(date) => {setStartTask(date)}}
                                                    KeyboardButtonProps={{
                                                      'aria-label': 'change time',
                                                    }}
                                                  />
                                                  <KeyboardDatePicker
                                                    disableToolbar
                                                    variant="inline"
                                                    format="dd/MM/yyyy"
                                                    margin="normal"
                                                    id="end-date-picker"
                                                    label="End Date"
                                                    value={endTask}
                                                    onChange={(date) => {setEndTask(date)}}
                                                    KeyboardButtonProps={{
                                                      'aria-label': 'change date',
                                                    }}
                                                  />
                                                  <KeyboardTimePicker
                                                    margin="normal"
                                                    id="end-time-picker"
                                                    label="End Time"
                                                    value={endTask}
                                                    onChange={(date) => {setEndTask(date)}}
                                                    KeyboardButtonProps={{
                                                      'aria-label': 'change time',
                                                    }}
                                                  />
                                                </Grid>
                                            </MuiPickersUtilsProvider>
                                            <Button onClick={() => {addTask()}}>Add</Button>
                                            </div>:
                                            <div></div>}
                                </Card>
                              </div>
                              {tasks.map((task) => 
                                  <DraggableTaskCard task={task}
                                                  tokenPass={props.tokenPass}
                                                  setSelectedTaskID={setSelectedTaskID}
                                                  setTaskInProgress={setTaskInProgress}
                                                  setTaskDone={setTaskDone}
                                                  setPostponingTask={() => startPostponingTask(task.id, task.end)} />) }
                          </Grid>
                    </div>
                    <div style={{'width': '45%', 'position': 'absolute', 'left': '53%'}}>
                      {selectedTaskID == '' ?
                      <div></div> : 
                      <div className="cardmini">
                          <TaskCard tokenPass={props.tokenPass}
                                    id={selectedTaskID}
                                    updateTasks={getTasks}
                                    deleteTask={delete_task}
                                    setPostponingTask={setPostponingTask}/>


                      </div>}
                    </div>
                  </div>
                  
            }
      </div>

      {deletingTask ? <div className="infoi"> 
            <div className="centeredBox"> 
              <Button style={{'float': 'right'}}
                      onClick={() => {setDeletingTask(false)}}>
                <CloseIcon/>
              </Button>
              <h4>Deleting selected task permenantly, are you sure?</h4>
              <Grid container
                    direction="column"
                    justify="flex-start"
                    alignItems="stretch">
                <Button onClick={() => {delete_task(); setDeletingTask(false);}}>Yes</Button>
                <Button onClick={() => {setDeletingTask(false)}}>No</Button>
              </Grid>

        </div>
      </div>: <div></div>}
      {postponingTask ? <div className="infoi"> 
            <div className="centeredBox"> 
              <Button style={{'float': 'right'}}
                      onClick={() => {setPostponingTask(false)}}>
                <CloseIcon/>
              </Button>
              <Typography variant="h4"> Postpone Task </Typography>
              <p>By : </p>
              <TextField  type="text" 
                            variant="outlined" 
                            label="Text" 
                            onChange={(event) => {setDaysPostponed(event.target.value)}}
                            value={daysPostponed} />
              <Typography variant="h6" style={{float:'right'}}> Days </Typography>
              <p>and : </p>
              <TextField  type="text" 
                            variant="outlined" 
                            label="Text" 
                            onChange={(event) => {setHoursPostponed(event.target.value)}}
                            value={hoursPostponed} />
              <Typography variant="h6" style={{float:'right'}}> Hours </Typography>
              <br></br>
              <br></br>
              <Button onClick={() => setTaskDeadline()} style={{float:'right'}}>Save</Button>

              
              

        </div>
      </div>: <div></div>}
    </div>)
}*/


class TextListScreen extends React.Component {
    constructor(props) {
        super(props);
        this.props = props;
        this.state = { width: window.innerWidth, 
                       height: window.innerHeight-64,
                       currentText: ''};
        this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
        this.handleTextChange = this.handleTextChange.bind(this);
        this.removeText = this.removeText.bind(this);
    }

    componentDidMount() {
      this.updateWindowDimensions();
      window.addEventListener('resize', this.updateWindowDimensions);
    }
    
    componentWillUnmount() {
      window.removeEventListener('resize', this.updateWindowDimensions);
    }
    
    updateWindowDimensions() {
      this.setState({ width: window.innerWidth, height: window.innerHeight-64 });
    }

    handleTextChange(event) {
      this.setState({ currentText : event.target.value})
    }

    removeText() {
      this.setState({ currentText : ''})
    }

    render() {
        return (<div className="wrapper" style={{height:this.state.height}}>
                        <div className="left" style={{height:this.state.height}}>
                          <div className="screen">
                            <div>
                              <TextField id="time" 
                                          type="text" 
                                          variant="outlined" 
                                          label="Text" 
                                          multiline={true} 
                                          rows={((this.state.height/2)/10) - 5} 
                                          fullWidth={true} 
                                          onChange={this.handleTextChange}
                                          value={this.state.currentText}
                                          />
                            </div>
                          </div>
                        </div>
                        <div className="right" style={{height:this.state.height}}>
                          <StructureScreen tokenPass={this.props.tokenPass} 
                                           screenWidth={this.state.width} 
                                           currentText={this.state.currentText}
                                           removeText={this.removeText}/>
                        </div>
                      </div>)
    }
}

function TypeScreen(props) {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState({});
  const [addingLink, setAddingLink] = useState(false);
  const [firstNodeSelected, setFirstNodeSelected] = useState(false)
  const [firstNode, setFirstNode] = useState({});
  const [secondNodeSelected, setSecondNodeSelected] = useState(false)
  const [secondNode, setSecondNode] = useState({});

  const [addingNode, setAddingNode] = useState(false)
  const [addingNodeEvent, setAddingNodeEvent] = useState({})
  const [newTypeName, setNewTypeName] = useState('')

  const [nodeOpened, setNodeOpened] = useState(false)
  const [openedNode, setOpenedNode] = useState({})


  const [dimensions, setDimensions] = useState({ 
    height: window.innerHeight,
    width: window.innerWidth
  })

  useEffect(() => {
    window.addEventListener('resize', handleResize)
    fetch(SERVER_LINK + '/get_type_graph', {
      method: 'GET',
        headers: {
          Accept:'application/json',
          'Content-Type': 'application/json',
          'SimpTokAuth': props.tokenPass
        }
      }).then((response) => response.json())
        .then((data) => setData(data))
        .catch((error) => console.log(error))
        .finally(() => setLoading(false))
  }, [])

  const handleResize = () => {
    setDimensions({
      height: window.innerHeight,
      width: window.innerWidth
    }) 
  }

  const myConfig = {
    nodeHighlightBehavior: true,
    directed: true,
    height: dimensions.height - 67,
    width: dimensions.width - 150,
    border: 'solid',
    backColor: 'gray',
    color: 'gray',
    node: {
      color: "lightgreen",
      highlightStrokeColor: "blue",
    },
    link: {
      highlightColor: "lightblue",
    },
  };

  const onClickNode = (nodeId, node) => {
    if (addingLink) {
      if (!firstNodeSelected) {
        setFirstNode(node)
        setFirstNodeSelected(true)
      }
      else {
        if (!secondNodeSelected) {
          setSecondNode(node)
          setSecondNodeSelected(true)
        }
      }
    }
    else {
      setNodeOpened(true)
      setOpenedNode(node)
    }
  };

  const onClickGraph = function(event) {
    setAddingNode(true)
    setAddingNodeEvent(event)
  };

  const closeAddNodeBox = () => {
    setAddingNode(false); 
    setNewTypeName(''); 
  }

  const closeNodeInfoBox = () => {
    setNodeOpened(false)
    setOpenedNode({})
  }

  const resetAddLink = () => {
    setAddingLink(false); 
    setFirstNodeSelected(false); 
    setSecondNodeSelected(false); 
  }

  const addLink = () => {
    fetch(SERVER_LINK + '/set_type_parent', {
      method: 'POST',
      headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
      },
      body: JSON.stringify({
          idtoken: props.tokenPass,
          typeid: firstNode.db_id.toString(),
          newparentid: secondNode.db_id.toString()
      })
    }).then((response) => response.json())
      .then((data) => {if (data == 'SUCCESS') {
                            setAddingLink(false); 
                            setFirstNodeSelected(false); 
                            setSecondNodeSelected(false); 
                            setData((state, props) => {
                              var new_links = state.links;
                              new_links.push({source: firstNode.id, target: secondNode.id});
                              return {
                                nodes : state.nodes,
                                links : new_links
                              }
                            })
                          }})
      .catch((error) => console.log(error))
  };



  return (<div>{loading ? 
            <p>Loading....</p> :
            <div>
              <div style={{height: dimensions.height - 64}} className='side-bar-graph-type'>
                <Button onClick={() => {setAddingLink(true)}}>Add Link</Button>
                {addingLink ? 
                  <div>
                    <Button onClick={resetAddLink}>Reset</Button>
                    {firstNodeSelected ? 
                      <div>
                        <p> Source: {firstNode.id} </p> 
                        {secondNodeSelected ? 
                          <div>
                            <p> Target: {secondNode.id} </p>
                            <Button onClick={addLink}>Add</Button> 
                          </div>
                          : 
                          <p> Select target node</p> }
                      </div>
                      :
                      <p> Select source node </p>}
                  </div>
                  :
                  <div></div>}
              </div>
              <Graph
                id="graph-id"
                data={data}
                config={myConfig}
                onClickNode={onClickNode}
                onClickGraph={onClickGraph}
              />
            {addingNode? <div className="infoi"> 
                              <div className="centeredBox"> 
                                <Button style={{'float': 'right'}}
                                        onClick={closeAddNodeBox}>
                                  <CloseIcon/>
                                </Button>
                                <h4>Adding new Node</h4>
                                <TextField id="time" 
                                          type="text" 
                                          variant="outlined" 
                                          label="Type Name" 
                                          multiline={true} 
                                          rows={4} 
                                          fullWidth={true} 
                                          onChange={(newText) => {setNewTypeName(newText.target.value)}}
                                          value={newTypeName}
                                          />
                                <p></p>
                              </div>
                            </div>: <div></div>}
            {nodeOpened ? 
              <div style={{backgroundColor:'white', height: dimensions.height-64, width: '45vw', float: 'right', zIndex: '5', position: 'absolute', top: '64px', right: '0px', 'overflow': 'scroll'}}>
                  <Button style={{'float': 'right'}}
                          onClick={closeNodeInfoBox}>
                    <CloseIcon/>
                  </Button>
                  <ListOfKnownInstances tokenPass={props.tokenPass} 
                                        currentText={''} 
                                        typeid={openedNode.db_id} 
                                        typename={openedNode.id}
                                        removeText={() => {}}/>


              </div> :
              <div></div>
              }
              </div>}
          </div>)
}


/*
function MapScreen(props) {
  const classes = useStyles();
  const [graphData, setGraphData] = useState({nodes:[], links:[]})

  const [maps, setMaps] = useState([])
  const [fetchingMapList, setFetchingMapList] = useState(true)
  const [currentMap, setCurrentMap] = useState({})
  const [fetchingMap, setFetchingMap] = useState(false)
  const [addingMap, setAddingMap] = useState(false)
  const [editingMapName, setEditingMapName] = useState(false)
  const [newMapName, setNewMapName] = useState('')

  const [addingNode, setAddingNode] = useState(false)
  const [addingNodeEvent, setAddingNodeEvent] = useState()
  const [currentPotentialNodeTypeInput, setCurrentPotentialNodeTypeInput] = useState('')
  const [currentPotentialNodeTypeID, setCurrentPotentialNodeTypeID] = useState('')
  const [newNodeCurrentText, setNewNodeCurrentText] = useState('')
  const [nodeOpened, setNodeOpened] = useState(false)
  const [openedNode, setOpenedNode] = useState({})
  const [openedNodeTextSize, setOpenedNodeTextSize] = useState('')

  const [addingLink, setAddingLink] = useState(false);
  const [firstNodeSelected, setFirstNodeSelected] = useState(false)
  const [firstNode, setFirstNode] = useState({});
  const [secondNodeSelected, setSecondNodeSelected] = useState(false)
  const [secondNode, setSecondNode] = useState({});


  const [dimensions, setDimensions] = useState({ 
    height: window.innerHeight,
    width: window.innerWidth
  })

  useEffect(() => {
    window.addEventListener('resize', handleResize)
    fetchMapList()
  }, [])

  const fetchMapList = () => {
    fetch(SERVER_LINK + '/get_map_list', {
      method: 'GET',
        headers: {
          Accept:'application/json',
          'Content-Type': 'application/json',
          'SimpTokAuth': props.tokenPass
        }
      }).then((response) => response.json())
        .then((data) => {Array.isArray(data) ? setMaps(data) : alert('error fetching data, please reload page')})
        .catch((error) => console.log(error))
        .finally(() => setFetchingMapList(false))
  }

  const addMap = () => {
    fetch(SERVER_LINK + '/add_map', {
      method: 'POST',
        headers: {
          Accept:'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          'idtoken': props.tokenPass,
          'map_name': newMapName,
        })
      }).then((response) => response.json())
        .then((data) => {if (Array.isArray(data)) {fetchMapList()}})
        .catch((error) => console.log(error))
        .finally(() => {setAddingMap(false)})
  }

  const fetchTypes = async (input) => {
    return fetch(SERVER_LINK + '/get_types', {
                method: 'GET',
                  headers: {
                    Accept:'application/json',
                    'Content-Type': 'application/json',
                    'SimpTokAuth': props.tokenPass,
                    'InputSearchText': input
                  }
                }).then((response) => response.json())
                  .then((data) => data.map((type) => {return {label: type.name, value:type.id}}) )
                  .catch((error) => console.log(error))
  }

  const handleTypeChange = (selectedOption) => {
    setCurrentPotentialNodeTypeID(selectedOption.value)
  }

  const onClickGraph = function(event) {
    setAddingNode(true)
    setAddingNodeEvent(event)
  };


  const addNode = (instanceid) => {
    var screen_x = addingNodeEvent.nativeEvent.layerX;
    var screen_y = addingNodeEvent.nativeEvent.layerY;
    var trans_x = 0
    var trans_y = 0
    var trans_scale = 1
    if (addingNodeEvent.target.childNodes[1].transform.baseVal.length > 0) {
      trans_x = addingNodeEvent.target.childNodes[1].transform.baseVal[0].matrix.e;
      trans_y = addingNodeEvent.target.childNodes[1].transform.baseVal[0].matrix.f;
      trans_scale = addingNodeEvent.target.childNodes[1].transform.baseVal[1].matrix.a;
    }
    var canvas_x = (screen_x - trans_x)/trans_scale;
    var canvas_y = (screen_y - trans_y)/trans_scale;
    console.log(canvas_x)
    console.log(canvas_y)

    fetch(SERVER_LINK + '/add_node', {
      method: 'POST',
        headers: {
          Accept:'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          'idtoken': props.tokenPass,
          'mapid': currentMap.mapid,
          'instid': instanceid,
          'x': canvas_x,
          'y': canvas_y
        })
      }).then((response) => response.json())
        .then((data) => {if (data=='SUCCESS') {openMap(currentMap.mapid)}})
        .catch((error) => console.log(error))
        .finally(closeAddNodeBox)
  }

  const deleteNode = () => {
    fetch(SERVER_LINK + '/delete_node', {
      method: 'POST',
        headers: {
          Accept:'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          'idtoken': props.tokenPass,
          'mapid': currentMap.mapid,
          'instid': openedNode.id,
        })
      }).then((response) => response.json())
        .then((data) => {if (data=='SUCCESS') {openMap(currentMap.mapid); closeNodeInfoBox()}})
        .catch((error) => console.log(error))
  }

  const nodeMoved = (instanceId, newX, newY) => {
    console.log(graphData['nodes'].find(x => x.id === instanceId).x)
    const selectedNode = graphData['nodes'].find(x => x.id === instanceId)
    const deltaX = (selectedNode.x-newX)
    const deltaY = (selectedNode.y-newY)
    console.log('moved by ' + (deltaX) + ' ... ' + (deltaY))
    fetch(SERVER_LINK + '/set_node_position', {
      method: 'POST',
        headers: {
          Accept:'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          'idtoken': props.tokenPass,
          'mapid': currentMap.mapid,
          'instid': instanceId,
          'x': newX,
          'y': newY
        })
      }).then((response) => response.json())
        .then((data) => {if (data=='SUCCESS') {
                          selectedNode.x = newX
                          selectedNode.y = newY
                        } else {
                          alert('ERROR UPDATING POSITION')
                        }})
        .catch((error) => console.log(error))
  }

  const resetAddLink = () => {
    setAddingLink(false); 
    setFirstNodeSelected(false); 
    setSecondNodeSelected(false); 
  }

  const addLink = () => {
    fetch(SERVER_LINK + '/set_node_parent', {
      method: 'POST',
      headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
      },
      body: JSON.stringify({
          idtoken: props.tokenPass,
          mapid: currentMap.mapid,
          instid: secondNode.id.toString(),
          newparentid: firstNode.id.toString()
      })
    }).then((response) => response.json())
      .then((data) => {if (data == 'SUCCESS') {
                            setAddingLink(false); 
                            setFirstNodeSelected(false); 
                            setSecondNodeSelected(false); 
                            setGraphData((state, props) => {
                              var new_links = state.links;
                              new_links.push({source: firstNode.id, target: secondNode.id});
                              return {
                                nodes : state.nodes,
                                links : new_links
                              }
                            })
                          }})
      .catch((error) => console.log(error))
  };


  const closeAddNodeBox = () => {
    setAddingNode(false); 
    setCurrentPotentialNodeTypeID(''); 
    setCurrentPotentialNodeTypeInput('');
    setNewNodeCurrentText('')
  }

  const closeNodeInfoBox = () => {
    setNodeOpened(false)
    setOpenedNodeTextSize('')
    setOpenedNode({})
  }

  const onClickNode = function(nodeId, node) {
    if (addingLink) {
      if (!firstNodeSelected) {
        setFirstNode(node)
        setFirstNodeSelected(true)
      }
      else {
        if (!secondNodeSelected) {
          setSecondNode(node)
          setSecondNodeSelected(true)
        }
      }
    }
    else {
      setOpenedNode(node)
      setOpenedNodeTextSize(node.textsize)
      setNodeOpened(true)
    }
  };

  const openMap = (map) => {
    fetch(SERVER_LINK + '/get_map', {
      method: 'GET',
        headers: {
          Accept:'application/json',
          'Content-Type': 'application/json',
          'SimpTokAuth': props.tokenPass,
          'ConceptMapID': map.mapid
        }
      }).then((response) => response.json())
        .then((data) => {setGraphData(data); console.log(data)})
        .catch((error) => console.log(error))
        .finally(() => {setFetchingMap(false); setCurrentMap(map); })
  }

  const handleOpenedNodeTextSizeChange = (event) => {
    fetch(SERVER_LINK + '/set_node_text_size', {
      method: 'POST',
        headers: {
          Accept:'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          'idtoken': props.tokenPass,
          'mapid': currentMap.mapid,
          'instid': openedNode.id,
          'tsize': event.target.value
        })
      }).then((response) => response.json())
        .then((data) => {if (data=='SUCCESS') {setOpenedNodeTextSize(event.target.value); openMap(currentMap)}})
        .catch((error) => console.log(error))
  }

  const handleChangeMapName = () => {
    fetch(SERVER_LINK + '/set_map_name', {
      method: 'POST',
      headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
      },
      body: JSON.stringify({
          idtoken: props.tokenPass,
          mapid: currentMap.mapid,
          new_name: newMapName
      })
    }).then((response) => response.json())
      .then((data) => {if (data=='SUCCESS') {setCurrentMap({...currentMap, mapname: newMapName}); setEditingMapName(false); fetchMapList() } else {alert('Not connected, please refreshh')}})
      .catch((error) => console.log(error))
  };

  const handleDeleteMap = () => {
    fetch(SERVER_LINK + '/delete_map', {
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            idtoken: props.tokenPass,
            mapid: props.id
        })
      }).then((response) => response.json())
        .then((data) => {if (data=='SUCCESS') {setCurrentMap({}); props.updateMaps()} else {alert('Map couldnt be deleted')}} )
        .catch((error) => console.log(error))
  };




  const handleResize = () => {
    setDimensions({
      height: window.innerHeight,
      width: window.innerWidth
    }) 
  }
  

  
  // the graph configuration, just override the ones you need
  const myConfig1 = {
    nodeHighlightBehavior: true,
    height: dimensions.height - 137,
    width: dimensions.width - 150 ,
    node: {
      color: "lightgreen",
      highlightStrokeColor: "blue",
      size: {width:2750, height:3500},
      labelProperty: () => {return ''},
      viewGenerator: (node) => {
        return <SimpleInstanceCard tokenPass={props.tokenPass}
                                   text={node.text} 
                                   typename={node.typename} 
                                   instanceid={node.id} 
                                   typeid={node.typeid}
                                   tsize={node.textsize}/>
      }
    },
    link: {
      highlightColor: "lightblue",
      directed: true
    },
    d3: {
      disableLinkForce: true,
      gravity: -400,
      linkLength: 180,
    },
  };
  

  
  return (<div style={{'overflow': 'hidden'}}>
            <div style={{height: window.innerHeight-64, 'overflow-y':'scroll'}} className='side-bar-graph-type'>
              {fetchingMapList ? 
                <p> Loading... </p> :
                <div>
                  {!addingMap ? 
                  <Button onClick={() => {setAddingMap(true)}}> Add Map </Button> : 
                    <div>
                      <TextField id="newname" 
                                  type="text" 
                                  variant="outlined" 
                                  label="New map name" 
                                  fullWidth={true} 
                                  onChange={(event) => {setNewMapName(event.target.value)}}
                                  value={newMapName} /> 
                        <Button onClick={addMap}> Add </Button>
                        <Button onClick={() => setAddingMap(false)}> Back </Button>
                    </div>}
                  <List>
                    {maps.map((instance) => {
                      return (<ListItem button onClick={() => {setFetchingMap(true); openMap(instance)}}>
                                {instance.mapname}
                              </ListItem>)
                    })}
                  </List>
                </div>
              }
            </div>
            <div style={{ backgroundColor: "#E3F6AC", overflow: 'overlay'}}>
              <div style={{ backgroundColor: "#FFF", width: '100%', height:'57px', padding: '5px', borderBottom: '3px solid'}}>
                {currentMap == {} ? <p>Select map</p> :
                <div style={{display: 'inline'}}>
                    {editingMapName ? 
                        <div>
                          <TextField  type="text" 
                                      variant="outlined" 
                                      label="Text" 
                                      onChange={(event) => {setNewMapName(event.target.value)}}
                                      value={newMapName} /> 
                          <Button onClick={handleChangeMapName}> Set Name </Button>
                          <Button onClick={() => {setEditingMapName(false)}}> Back </Button>
                        </div> 
                        :
                        <div>
                          <p style={{float: 'left'}}>{currentMap.mapname}</p>
                          <Button style={{float: 'right'}} onClick={handleDeleteMap}>Delete</Button>
                          <Button style={{float: 'right'}} onClick={() => {setEditingMapName(true); setNewMapName(currentMap.mapname)}}>Edit Name</Button>
                        </div>}
                        {addingLink ? 
                          <div>
                            <Button onClick={resetAddLink}>Reset</Button>
                            {firstNodeSelected ? 
                              <div>
                                <p> Source: {firstNode.id} </p> 
                                {secondNodeSelected ? 
                                  <div>
                                    <p> Target: {secondNode.id} </p>
                                    <Button onClick={addLink}>Add</Button> 
                                  </div>
                                  : 
                                  <p> Select target node</p> }
                              </div>
                              :
                              <p> Select source node </p>}
                          </div>
                          :
                          <Button style={{float: 'right'}} onClick={() => {setAddingLink(true)}}>Add Link</Button>}
                  </div>}
              </div>
              {fetchingMap ? <p>Loading... </p> : 
                <Graph
                  id="graph-id" // id is mandatory
                  data={graphData}
                  config={myConfig1}
                  onClickGraph={onClickGraph}
                  onNodePositionChange={nodeMoved}
                  onClickNode={onClickNode}
                /> }
            </div>
            {addingNode? <div className="infoi"> 
                              <div className="centeredBox"> 
                                <Button style={{'float': 'right'}}
                                        onClick={closeAddNodeBox}>
                                  <CloseIcon/>
                                </Button>
                                <h4>Adding new Node</h4>
                                <AsyncCreatableSelect cacheOptions
                                                      defaultOptions
                                                      inputValue={currentPotentialNodeTypeInput}
                                                      onInputChange={(new_input) => {setCurrentPotentialNodeTypeInput(new_input.toUpperCase())}}
                                                      loadOptions={fetchTypes}
                                                      placeholder={"What do you want to add?"}
                                                      onChange={handleTypeChange} 
                                                      style={{'margin-bottom': '10px', 'z-index': '10'}}/>
                                <TextField id="time" 
                                          type="text" 
                                          variant="outlined" 
                                          label="Text" 
                                          multiline={true} 
                                          rows={4} 
                                          fullWidth={true} 
                                          onChange={(newText) => {setNewNodeCurrentText(newText.target.value)}}
                                          value={newNodeCurrentText}
                                          />
                                <p></p>
                                {currentPotentialNodeTypeID == '' ? <p> Select type </p> :
                                        <ListOfInstances tokenPass={props.tokenPass} 
                                                                      currentText={newNodeCurrentText} 
                                                                      typeid={currentPotentialNodeTypeID} 
                                                                      typename={currentPotentialNodeTypeInput}
                                                                      addNewLink={addNode}
                                                                 />}
                              </div>
                            </div>: <div></div>}
            {nodeOpened ? 
                <div style={{backgroundColor:'white', height: window.innerHeight-134, width: '45vw', float: 'right', zIndex: '5', position: 'absolute', top: '134px', right: '10px', 'overflow': 'scroll'}}>
                    <Button style={{'float': 'right'}}
                            onClick={closeNodeInfoBox}>
                      <CloseIcon/>
                    </Button>
                    <InputLabel>Text Size</InputLabel>
                    <Select
                      value={openedNodeTextSize}
                      onChange={handleOpenedNodeTextSizeChange}
                    >
                      <MenuItem value={'h1'}>Big Title</MenuItem>
                      <MenuItem value={'h3'}>Small Title</MenuItem>
                      <MenuItem value={'body2'}>Normal Text</MenuItem>
                    </Select>
                    <Button onClick={deleteNode}>
                      Delete from map
                    </Button>
                    <InstanceMapDescription text={openedNode.text} 
                                            typeid={openedNode.typeid}
                                            typename={openedNode.typename} 
                                            instanceid={openedNode.id} 
                                            handleDelete={() => {}}
                                            handleChangeName={() => {openMap(currentMap)}}
                                            pdfPath={''}
                                            tokenPass={props.tokenPass}/>


                </div> :
                <div></div>
            }
          </div>);
}
*/

/*
props:
  -tokenPass
  -mapid (if is coming from map)
  -closeBox()
*/



function TopicsBox(props) {
  const [topics, setTopics] = useState([])
  const [fetchingTopics, setFetchingTopics] = useState(true)
  const [newTopicID, setNewTopicID] = useState('')




}






function TextBoxParserAndUploader(props) {
  const [text, setText] = useState('');

  const handleTextChange = (e) => {
    setText(e.target.value);
  }

  const handleTextSubmit = (e) => {
    e.preventDefault();
    console.log('submitting text: ' + text);
  }
}


function ImageParserAndUploader(props) {
}


function VideoParserAndUploader(props) {
}


function b64EncodeUnicode(str) {
  // first we use encodeURIComponent to get percent-encoded Unicode,
  // then we convert the percent encodings into raw bytes which
  // can be fed into btoa.
  return btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g,
      function toSolidBytes(match, p1) {
          return String.fromCharCode('0x' + p1);
  }));
}


function PDFParserAndUploader(props) {
  const classes = useStyles();

  const [response, setResponse] = useState(null);
  const [loadingResponse, setLoadingResponse] = useState(false);

  const [pdfFile, setPdfFile] = useState(null);
  const [uploadingPdf, setUploadingPdf] = useState(false);
  const [uploadingProgress, setUploadingProgress] = useState(0.0);

  const [textList, setTextList] = useState([]);
  const [currentIndexText, setCurrentIndexText] = useState(0);
  const [currentText, setCurrentText] = useState('');
  const [images, setImages] = useState([]);
  const [currentIndexImage, setCurrentIndexImage] = useState(0);

  const [contentTypeSelected, setContentTypeSelected] = useState(null);
  const [contentTypeText, setContentTypeText] = useState('');



  const handleDrop = (e) => {
    e.preventDefault();
    const file = e.dataTransfer.files[0];
    setPdfFile(file);
    uploadFile(file);
  };

  //should return text and image for the pdf
  const uploadFile = async (file) => {
    const formData = new FormData();
    formData.append('file', file);
    setLoadingResponse(true)
    fetch(SERVER_LINK + '/check_pdf', {
      method: 'POST',
      headers: {
        'SimpTokAuth': props.tokenPass
      },
      body: formData
    }).then((response) => response.json())
      .then((data) => {setResponse(data); console.log(data); setTextList(data['result_text']); setCurrentText(data['result_text'][0]); setImages(data['result_image']); setLoadingResponse(false);})
      .catch((error) => {console.log(error)})
  };


  //Saving PDFs in cloud
  const startUploadingPDFInCloud = (instance_id) => {
    setUploadingPdf(true)
    fetch(SERVER_LINK + '/get_pdf_upload_link', {
      method: 'POST',
      headers: {
        'SimpTokAuth': props.tokenPass,
        'InstID': instance_id
      },
      body: {}
    }).then((response) => response.json())
      .then((data) => {uploadPDFToCloud(data, instance_id)})
      .catch((error) => {console.log(error)})
  }
  
  const uploadPDFToCloud = (signedURL, instance_id) => {
    const putCloudConfig = {
      onUploadProgress: progressEvent => setUploadingProgress((progressEvent.loaded/pdfFile.size)*100),
      headers: {
        'Content-Type': 'application/pdf'
      }
    }
    axios.put(signedURL, pdfFile, putCloudConfig)
    .then((response) => {response.status==200 ? setSuccessfullPDFUploadOnServer(instance_id) : alert('something went wrong with the upload')})
    .catch((error) => {console.log('error ... ' + error)})
  }

  const setSuccessfullPDFUploadOnServer = (instance_id) => {
    fetch(SERVER_LINK + '/set_instance_pdf', {
      method: 'POST',
      headers: {
        'SimpTokAuth': props.tokenPass,
        'InstID': instance_id
      },
      body: JSON.stringify({'empty': 'object'})
    }).then((response) => response.json())
      .then((data) => {if (images && (images.length > 0)) { startUploadImageFromBase64URL(instance_id, images[currentIndexImage])} else {props.dropInstance(instance_id)}})
      .catch((error) => {console.log(error)})
  }

  //Linking images
  const startUploadImageFromBase64URL = (instance_id, contentURLBase64) => {
    console.log(contentURLBase64)
    const fileType = getMimeType(contentURLBase64);
    const imageFile = new File([dataURItoBlob(contentURLBase64)], 'image.'+fileType.split("/")[1], { type: fileType });
    const data = new FormData();
    data.append('file', imageFile);
    if (imageFile.name.match(/\.(jpg|jpeg|png|gif)$/)) {
      fetch(SERVER_LINK + '/get_image_upload_link', {
        method: 'POST',
        headers: {
          'SimpTokAuth': props.tokenPass,
          'InstID': instance_id,
          'ImageFileType': fileType.split("/")[1]
        },
        body: data
      }).then((response) => response.json())
        .then((json) => {uploadImageToCloud(json, imageFile, fileType, instance_id)})
        .catch((error) => {console.log(error)})
    }
  }

  const uploadImageToCloud = (upload_url, image_file, file_type, instance_id) => {
    const putCloudConfig = {
      onUploadProgress: progressEvent => setUploadingProgress((progressEvent.loaded/image_file.size)*100),
      headers: {
        'Content-Type': file_type
      }
    }
    axios.put(upload_url, image_file, putCloudConfig)
    .then((response) => {response.status==200 ? setSuccessfullImageUploadOnServer(file_type, instance_id) : alert('something went wrong with the upload')})
    .catch((error) => {console.log('error ... ' + error)})
  }

  const setSuccessfullImageUploadOnServer = (file_type, instanceid) => {
    fetch(SERVER_LINK + '/set_instance_image', {
      method: 'POST',
      headers: {
        'SimpTokAuth': props.tokenPass,
        'InstID': instanceid,
        'ImageFileType': file_type.split("/")[1]
      },
      body: JSON.stringify({'empty': 'object'})
    }).then((response) => response.json())
      .then((data) => {props.dropInstance(instanceid)})
      .catch((error) => {console.log(error)})
  }



  const fetchTypes = async (input) => {
    return fetch(SERVER_LINK + '/get_types', {
                method: 'GET',
                  headers: {
                    Accept:'application/json',
                    'Content-Type': 'application/json',
                    'SimpTokAuth': props.tokenPass,
                    'InputSearchText': input
                  }
                }).then((response) => response.json())
                  .then((data) => data.map((type) => {return {label: type.name, value:type.id}}) )
                  .catch((error) => console.log(error))
  }

  const addType = (new_type_name) => {
    fetch(SERVER_LINK + '/add_type', {
      method: 'POST',
      headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
      },
      body: JSON.stringify({
          idtoken: props.tokenPass,
          type_name: new_type_name
      })
    }).then((response) => response.json())
      .then((data) => {setContentTypeSelected({id: data, name: new_type_name}); setContentTypeText("");})
      .catch((error) => console.log(error))
  }

  

  return (
    <div>
      {response ? <div></div> :
        <div
          style={{
            border: '2px dashed #ccc',
            padding: '20px',
            textAlign: 'center',
          }}
          onDragOver={(e) => e.preventDefault()}
          onDrop={handleDrop}
        >
          <h3>Drag and Drop a PDF File Here</h3>
        </div>}
      {loadingResponse ? 
        <div>
          <CircularProgress />
        </div> :
        (response ?
            (uploadingPdf ?
                <CircularProgressWithLabel value={uploadingProgress} /> :
                  <div>
                    <AsyncCreatableSelect cacheOptions
                                    defaultOptions
                                    value={
                                      contentTypeSelected
                                        ? { value: contentTypeSelected.id, label: contentTypeSelected.name }
                                        : null
                                    }
                                    inputValue={contentTypeText}
                                    onInputChange={(newInput, meta) => {
                                          // prevents weird clearing loops when react-select changes input internally
                                          if (meta.action === "input-change") {
                                            setContentTypeText(newInput.toUpperCase());
                                          }
                                        }}
                                    loadOptions={fetchTypes}
                                    placeholder={"Select type of content"}
                                    onCreateOption={addType}
                                    onChange={(selectedOption) => {
                                        setContentTypeSelected({ id: selectedOption.value, name: selectedOption.label });
                                        setContentTypeText(""); // usually you want the input cleared after selection
                                      }}
                                    styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }), marginBottom: '10px' }}
                                    menuPortalTarget={document.body}/>
                      <div className="container-pdfparsing">

                        <div className="text-pdfparsing">
                          <TextField  type="text"
                                      variant="outlined"
                                      label="Text"
                                      multiline={true}
                                      rows={8}
                                      fullWidth={true}
                                      onChange={(newText) => {setCurrentText(newText.target.value)}}
                                      value={currentText} 
                                      />
                        {textList && (textList.length >= 1) ?
                                <div>
                                  <Button onClick={() => { setCurrentIndexText((old_index) => {
                                                                    const new_index = (old_index-1)%textList.length;
                                                                    setCurrentText(textList[new_index])
                                                                    return new_index})}
                                                    } style={{'color': 'blue'}}> Back </Button>
                                  <Button onClick={() => { setCurrentIndexText((old_index) => {
                                                                    const new_index = (old_index+1)%textList.length;
                                                                    setCurrentText(textList[new_index])
                                                                    return new_index})}
                                                    } style={{'color': 'blue'}}> Next </Button>
                                  <p>{currentIndexText + "/" + textList.length}</p>
                                </div> : <div></div>}
                        </div>

                        <div className="image-pdfparsing">
                          {images? 
                          <div>
                            <CardMedia  className={classes.media_map}
                                        image={images[currentIndexImage]}
                                        style={{'backgroundColor':'white','backgroundSize':'contain'}} />
                          {images.length > 1 ?
                                <div>
                                  <Button onClick={() => { setCurrentIndexImage((old_index) => {
                                                                    const new_index = (old_index-1)%images.length;
                                                                    return new_index})}
                                                    } style={{'color': 'blue'}}> Back </Button>
                                  <Button onClick={() => { setCurrentIndexImage((old_index) => {
                                                                    const new_index = (old_index+1)%images.length;
                                                                    return new_index})}
                                                    } style={{'color': 'blue'}}> Next </Button>
                                  <p>{currentIndexImage + "/" + images.length}</p>
                                </div> : <div></div>} </div> :
                          <div></div>}
                        </div>
                      </div>

                      {contentTypeSelected != null ?
                            <ListOfInstances  tokenPass={props.tokenPass} 
                                              currentText={currentText} 
                                              typeid={contentTypeSelected.id} 
                                              typename={contentTypeSelected.name}
                                              url={''}
                                              addNewLink={(instance_id)=>{startUploadingPDFInCloud(instance_id)}} /> :
                                              <p>Select type of instance</p> }
                  </div>) :
                <div></div>
          )}
    </div>
  );
}


const useStylesAddingContent = makeStyles((theme) => ({
  gridRoot: {
    width: "100%",
  },
  card: {
    width: 110,
    height: 120,
    borderRadius: 12,
    overflow: "hidden",
    border: `1px solid ${theme.palette.divider}`,
    transition: "transform 160ms ease, box-shadow 160ms ease, border-color 160ms ease",
    "&:hover": {
      transform: "translateY(-2px)",
      boxShadow: theme.shadows[4],
      borderColor: theme.palette.text.primary,
    },
  },
  action: {
    height: 86, // top area
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  img: {
    width: 56,
    height: 56,
    objectFit: "contain",
    display: "block",
  },
  label: {
    height: 34, // bottom bar
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: theme.spacing(0, 1),
    backgroundColor: theme.palette.action.hover,
    borderTop: `1px solid ${theme.palette.divider}`,
  },
  labelText: {
    fontWeight: 700,
    fontSize: 12,
    lineHeight: 1.1,
    textAlign: "center",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    width: "100%",
  },
}));

//Adding Content Box
function AddingContentWindow(props) {
  const classes = useStylesAddingContent();
  const [contentEncodingSelected, setContentEncodingSelected] = useState(false);
  const [contentEncoding, setContentEncoding] = useState('');
  const [currentAddingState, setCurrentAddingState] = useState('inserting');
  const allAddingStates = ['inserting', 'classifying', 'uploading', 'adding'];
  const allContentEncodingTypes = ['text', 'image', 'video', 'pdf', 'url', 'recent'];
  const allContentEncodingTypesImages = [ 'https://static.thenounproject.com/png/192568-200.png', 
                                          'https://static.thenounproject.com/png/3882414-200.png', 
                                          'https://static.thenounproject.com/png/3136011-200.png', 
                                          'https://static.thenounproject.com/png/1242090-200.png',
                                          'https://static.thenounproject.com/png/1092854-200.png',
                                          'https://static.thenounproject.com/png/7184932-200.png' ];


  const [contentInstanceID, setContentInstanceID] = useState(null);

  const [loadingContentDescription, setLoadingContentDescription] = useState(true);

  const [uploadingResourceToServer, setUploadingResourceToServer] = useState(false);
  const [uploadingProgress, setUploadingProgress] = useState(0.0)
  
  const [contentText, setContentText] = useState('');
  const [contentImage, setContentImage] = useState('');
  const [contentURL, setContentURL] = useState('');
  const [contentURLPreviewProperties, setContentURLPreviewProperties] = useState({});

  const [contentTypeText, setContentTypeText] = useState('');
  const [contentTypeSelected, setContentTypeSelected] = useState(null);

  const [dropMode, setDropMode] = useState('');


  useEffect(() => {
    if ((props.contentData !== undefined) && (props.contentData.url != '')) {
      setContentEncoding('url')
      setCurrentAddingState('classifying')
      setContentText(props.contentData.title)
      setContentURL(props.contentData.url)
      setContentImage(props.contentData.image)
      setLoadingContentDescription(false)
    }
    else {
      setContentEncoding('')
      setCurrentAddingState('inserting')
      setContentText('')
      setContentURL('')
      setContentImage('')
      setLoadingContentDescription(false)
    }
  }, [])

  const fetchTypes = async (input) => {
    return fetch(SERVER_LINK + '/get_types', {
                method: 'GET',
                  headers: {
                    Accept:'application/json',
                    'Content-Type': 'application/json',
                    'SimpTokAuth': props.tokenPass,
                    'InputSearchText': input
                  }
                }).then((response) => response.json())
                  .then((data) => data.map((type) => {return {label: type.name, value:type.id}}) )
                  .catch((error) => console.log(error))
  }

  const addType = (new_type_name) => {
    fetch(SERVER_LINK + '/add_type', {
      method: 'POST',
      headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
      },
      body: JSON.stringify({
          idtoken: props.tokenPass,
          type_name: new_type_name
      })
    }).then((response) => response.json())
      .then((data) => {setContentTypeSelected({id: data, name: new_type_name}); setContentTypeText("");})
      .catch((error) => console.log(error))
  }
  
  const renderTextBox = () => {
    switch (currentAddingState) {
      case 'inserting':
          return (
            <div>
              <TextField  type="text"
                          variant="outlined"
                          label="Text"
                          multiline={true}
                          rows={8}
                          fullWidth={true}
                          onChange={(newText) => {setContentText(newText.target.value)}}
                          value={contentText}
                          />
              <Button onClick={() => {setCurrentAddingState('classifying')}} style={{ 'float': 'right' }}> Next </Button>
            </div>)
      case 'classifying':
          return (
            <div>
              <Typography variant="body2">{contentText}</Typography>
              <br/>
              <AsyncCreatableSelect cacheOptions
                                    defaultOptions
                                    value={
                                      contentTypeSelected
                                        ? { value: contentTypeSelected.id, label: contentTypeSelected.name }
                                        : null
                                    }
                                    inputValue={contentTypeText}
                                    onInputChange={(newInput, meta) => {
                                          // prevents weird clearing loops when react-select changes input internally
                                          if (meta.action === "input-change") {
                                            setContentTypeText(newInput.toUpperCase());
                                          }
                                        }}
                                    loadOptions={fetchTypes}
                                    placeholder={"Type category of text"}
                                    onCreateOption={addType}
                                    onChange={(selectedOption) => {
                                        setContentTypeSelected({ id: selectedOption.value, name: selectedOption.label });
                                        setContentTypeText(""); // usually you want the input cleared after selection
                                      }}
                                    styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }), marginBottom: '10px' }}
                                    menuPortalTarget={document.body}/>
              <div>
                  {contentTypeSelected != null ?
                    <ListOfInstances  tokenPass={props.tokenPass} 
                                      currentText={contentText} 
                                      typeid={contentTypeSelected.id} 
                                      typename={contentTypeSelected.name}
                                      url={''}
                                      addNewLink={(instance_id)=>{dropInstance(instance_id)}} /> :
                                      <p>Select type of instance</p> }
              </div>
            </div>)
      case 'uploading':
          return (
            <div>
            <CircularProgress />
            </div>)
      case 'adding':
        return renderAddingState()
      default:
        return (
          <div>
          <p>ERROR</p>
          </div>)
  }}

  const renderImageUploadBox = () => {
    return (<div>

    </div>
    )
  }

  const renderVideoUploadBox = () => {
    return (<div>

    </div>
    )
  }

  const renderURLBox = () => {
    switch (currentAddingState) {
      case 'inserting':
        return (<div>
                  <TextField  type="text"
                              variant="outlined"
                              label="URL"
                              multiline={true}
                              rows={3}
                              fullWidth={true}
                              onChange={(newText) => {setContentURL(newText.target.value)}}
                              value={contentURL}
                              />
                    <Button onClick={loadURLPreview} style={{'float': 'right'}}>Next</Button>
                </div>)
      case 'classifying':
        return (<div>
                  <AsyncCreatableSelect cacheOptions
                                    defaultOptions
                                    value={
                                      contentTypeSelected
                                        ? { value: contentTypeSelected.id, label: contentTypeSelected.name }
                                        : null
                                    }
                                    inputValue={contentTypeText}
                                    onInputChange={(newInput, meta) => {
                                          // prevents weird clearing loops when react-select changes input internally
                                          if (meta.action === "input-change") {
                                            setContentTypeText(newInput.toUpperCase());
                                          }
                                        }}
                                    loadOptions={fetchTypes}
                                    placeholder={"Type category of content"}
                                    onCreateOption={addType}
                                    onChange={(selectedOption) => {
                                        setContentTypeSelected({ id: selectedOption.value, name: selectedOption.label });
                                        setContentTypeText(""); // usually you want the input cleared after selection
                                      }}
                                    styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }), marginBottom: '10px'}}
                                    menuPortalTarget={document.body}/>
                  {loadingContentDescription ? <CircularProgress /> :
                    <div>
                      <div style={{'display': 'flex', 'align-items': 'center', 'justify-content': 'center', 'margin-top': '10px'}}>
                      <TextField  type="text"
                              variant="outlined"
                              label="Title"
                              multiline={true}
                              rows={3}
                              fullWidth={true}
                              onChange={(newText) => {setContentText(newText.target.value)}}
                              value={contentText}
                              />
                        <img src={contentImage} style={{'height': '100px'}}/>
                      </div>
                      {contentTypeSelected != null ?
                      <ListOfInstances  tokenPass={props.tokenPass} 
                                        currentText={contentText} 
                                        typeid={contentTypeSelected.id} 
                                        typename={contentTypeSelected.name}
                                        url={contentURL}
                                        addNewLink={(instance_id)=>{setCurrentAddingState('uploading'); setInstanceURL(instance_id)}} /> :
                                        <p>Select type of instance</p> }
                    </div>
                  }
                                  
                </div>)
      case 'uploading':
        return (<div>
                  <CircularProgress />
                </div>)
      case 'adding':
        return renderAddingState()
      default:
        return (<div>
                  <p>Error</p>
                  </div>
        )
    }
  }

  const renderRecentBox = () => {
    return <ListOfInstances  tokenPass={props.tokenPass} 
                              currentText={'NOTEXT'} 
                              typeid={'-1'} 
                              typename={'NOTYPE'}
                              url={''}
                              addNewLink={(instance_id)=>{dropInstance(instance_id)}} /> 
  }

  const closeAndResetBox = () => {
    setContentInstanceID(null)
    setContentEncoding('')
    setCurrentAddingState('inserting')
    setContentText('')
    setContentURL('')
    setContentImage('')
    setLoadingContentDescription(false)
    props.closeAddBox()
  }

  const loadURLPreview = () => {
    setLoadingContentDescription(true)
    setCurrentAddingState('classifying');
    fetch(SERVER_LINK + '/check_url', {
      method: 'POST',
        headers: {
          Accept:'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          'idtoken': props.tokenPass,
          'url': contentURL
        })
      }).then((response) => response.json())
        .then((data) => { setContentText(data.result_text); setContentImage(data.result_image); setLoadingContentDescription(false)})
        .catch((error) => console.log(error))
  }

  const setInstanceURL = (instance_id) => {
    fetch(SERVER_LINK + '/set_instance_url', {
      method: 'POST',
        headers: {
          Accept:'application/json',
          'Content-Type': 'application/json',
        }, 
        body: JSON.stringify({
          'idtoken': props.tokenPass,
          'instanceid': instance_id,
          'new_url': contentURL
        })
      }).then((response) => response.json())
        .then((data) => {if (data == 'SUCCESS') {if (contentImage && contentImage != '') { if (contentImage.split(':')[0] == 'data') {startUploadImageFromBase64URL(instance_id, contentImage)} else {alert("Image URL is not a base64 data URL")}} else { dropInstance(instance_id) } }})
        .catch((error) => console.log(error))
  }

  const startUploadImageFromBase64URL = (instance_id, contentURLBase64) => {
    console.log(contentURLBase64)
    const fileType = getMimeType(contentURLBase64);
    const imageFile = new File([dataURItoBlob(contentURLBase64)], 'image.'+fileType.split("/")[1], { type: fileType });
    const data = new FormData();
    data.append('file', imageFile);
    if (imageFile.name.match(/\.(jpg|jpeg|png|gif)$/)) {
      fetch(SERVER_LINK + '/get_image_upload_link', {
        method: 'POST',
        headers: {
          'SimpTokAuth': props.tokenPass,
          'InstID': instance_id,
          'ImageFileType': fileType.split("/")[1]
        },
        body: data
      }).then((response) => response.json())
        .then((json) => {uploadImageToCloud(json, imageFile, fileType, instance_id)})
        .catch((error) => {console.log(error)})
    }
  }

  const uploadImageToCloud = (upload_url, image_file, file_type, instance_id) => {
    setUploadingResourceToServer(true)
    const putCloudConfig = {
      onUploadProgress: progressEvent => setUploadingProgress((progressEvent.loaded/image_file.size)*100),
      headers: {
        'Content-Type': file_type
      }
    }
    axios.put(upload_url, image_file, putCloudConfig)
    .then((response) => {response.status==200 ? setSuccessfullImageUploadOnServer(file_type, instance_id) : alert('something went wrong with the upload')})
    .catch((error) => {console.log('error ... ' + error)})
    .finally(() => {setUploadingResourceToServer(false)})
  }

  const setSuccessfullImageUploadOnServer = (file_type, instanceid) => {
    fetch(SERVER_LINK + '/set_instance_image', {
      method: 'POST',
      headers: {
        'SimpTokAuth': props.tokenPass,
        'InstID': instanceid,
        'ImageFileType': file_type.split("/")[1]
      },
      body: JSON.stringify({'empty': 'object'})
    }).then((response) => response.json())
      .then((data) => {closeAndResetBox()})
      .catch((error) => {console.log(error)})
  }

  const dropInstance = (instanceid) => {
    if (props.mapid) {
      console.log('dropping ' + instanceid.toString() + ' in map ' + props.mapid)
      props.dropInMap(instanceid)
      return 
    }
    closeAndResetBox()
  }

  const renderAddingState = () => {
    return <Button onClick={() => {closeAndResetBox()}}>Done</Button>
  }

  const renderBox = (encodingType) => {
    switch (encodingType) {
      case 'text':
        return renderTextBox()
      case 'image':
        return renderImageUploadBox()
      case 'video':
        return renderVideoUploadBox()
      case 'pdf':
        return <PDFParserAndUploader tokenPass={props.tokenPass} dropInstance={(instance) => {dropInstance(instance)}}/>
      case 'url':
        return renderURLBox()
      case 'recent':
        return renderRecentBox()
      default:
        return (
              <Grid container spacing={2} justifyContent="center" className={classes.gridRoot}>
                {allContentEncodingTypes.map((encodingType, idx) => (
                  <Grid item key={encodingType || idx}>
                    <Card className={classes.card} elevation={0}>
                      <CardActionArea
                        className={classes.action}
                        onClick={() => setContentEncoding(encodingType)}
                      >
                        <img
                          src={allContentEncodingTypesImages[idx]}
                          alt={encodingType}
                          className={classes.img}
                        />
                      </CardActionArea>

                      <Box className={classes.label}>
                        <Typography className={classes.labelText} variant="body2">
                          {encodingType}
                        </Typography>
                      </Box>
                    </Card>
                  </Grid>
                ))}
              </Grid>
            );
    }
  }

  const renderBoxParent = () => {
    if (props.mapid) {
      return <p>Map</p>
    }
    if (props.taskid) {
      return <p>Task</p>
    }
    if (props.moodid) {
      return <p>Mood</p>
    }
    return <p>Unknown</p>
  }


  return (<div className="infoi"> 
              <div className="centeredBox"> 
                  <Button style={{'float': 'left'}}
                          onClick={() => {setContentEncoding(''); }}>
                    <KeyboardBackspaceIcon/>
                  </Button>
                  <Button style={{'float': 'right'}}
                          onClick={props.closeAddBox}>
                    <CloseIcon/>
                  </Button>
                  <div style={{'display': 'flex', 'align-items': 'center', 'justify-content': 'center'}}>
                <h4>Adding Content {contentEncoding != "" ? (" - " + contentEncoding.toUpperCase()) : ""}</h4>
                </div>
                {renderBox(contentEncoding)}
                
              </div>
            </div>);
}


function AddingTopicWindow(props) {
  const [topicQuery, setTopicQuery] = useState('');
  const [loadingTopicResults, setLoadingTopicResults] = useState(false);
  const [topicResults, setTopicResults] = useState([]);

  const queryUserTopics = () => {
    setLoadingTopicResults(true)
    fetch(SERVER_LINK + '/query_topics', {
      method: 'GET',
        headers: {
          Accept:'application/json',
          'Content-Type': 'application/json',
          'SimpTokAuth': props.tokenPass,
          'InputSearchText': topicQuery
        }
      }).then((response) => response.json())
        .then((data) => { if (Array.isArray(data)) {setTopicResults(data); setLoadingTopicResults(false); console.log(data)} else {console.log(data) } })
        .catch((error) => console.log(error))
    }

  return (<div className="infoi"> 
              <div className="centeredBox"> 
                <Button style={{'float': 'right'}}
                        onClick={props.closeWindow}>
                  <CloseIcon/>
                </Button>

                <h4>Adding Topic</h4>
                <TextField value={topicQuery}
                            onChange={(e) => {setTopicQuery(e.target.value)}}
                            placeholder="Search for topic"
                            style={{'width': '100%'}}
                            />
                <Button onClick={queryUserTopics}>Search</Button>
                {loadingTopicResults ? <p>Loading...</p> : 
                                      <div className="grid-container-small">
                                        {topicResults.map((topic, idx) => {
                                          return <Card style={{'width':'100px', 'height':'100px', 'margin':'auto'}}>
                                                    <CardActionArea onClick={() => {props.addTopic(topic.instid); setTopicResults([])}} style={{width: '100%', height: '80%', padding: '5px'}}>
                                                        <Typography variant="body1" align="center">{topic.insttext}</Typography>
                                                    </CardActionArea>
                                                </Card>})}
                                      </div>}
                
              </div>
            </div>);
}






//Objects
function ObjectsScreen(props) {
  const [instances, setInstances] = useState([]);
  const [selectedInstance, setSelectedInstance] = useState(null);

  useEffect(() => {
    fetchInstances();
  }, []);

  const handleAddInstance = () => {
    const newInstanceId = instances.length + 1;
    setInstances([...instances, newInstanceId]);
  };

  const handleInstanceClick = (instance) => {
    setSelectedInstance(instance);
  };


  const fetchInstances = () => {
    // fetch instances in short term memory from server

    // setInstances(instances)
  };




  return (
    <div>
    <div className="instances-container">
      <div className="instances-scroll">
        {instances.map((instance) => (
          <div
          key={instance}
          className={`instance ${selectedInstance === instance ? 'selected' : ''}`}
          onClick={() => handleInstanceClick(instance)}
        >
          Instance {instance}
        </div>
        ))}
        <button className="add-button" onClick={handleAddInstance}>
          Add
        </button>
      </div>
      </div>
      <div className="content-container">
        {selectedInstance && (
          <ObjectInstance instance={selectedInstance} />
        )}
      </div>
    </div>
      
  );
}

const ObjectInstance = () => {
  const [selectedOption, setSelectedOption] = useState(null);

  const handleOptionSelect = (option) => {
    setSelectedOption(option);
  };

  return (
  <div className="instance-component">
          <div className="options-column">
            <h2>Rep Options</h2>
            <ul>
              <li
                  className={selectedOption === 'type' ? 'selected' : ''}
                  onClick={() => handleOptionSelect('type')}
                >
                Type
              </li>
              <li
                className={selectedOption === 'text' ? 'selected' : ''}
                onClick={() => handleOptionSelect('text')}
              >
                Text
              </li>
              <li
                className={selectedOption === 'image' ? 'selected' : ''}
                onClick={() => handleOptionSelect('image')}
              >
                Image
              </li>
              <li
                className={selectedOption === 'video' ? 'selected' : ''}
                onClick={() => handleOptionSelect('video')}
              >
                Video
              </li>
              <li
                className={selectedOption === 'pdf' ? 'selected' : ''}
                onClick={() => handleOptionSelect('pdf')}
              >
                PDF
              </li>
              <li
                className={selectedOption === 'url' ? 'selected' : ''}
                onClick={() => handleOptionSelect('url')}
              >
                URL
              </li>
              
            </ul>
          </div>
          <div className="option-content">
            {selectedOption === 'text' && <TextOption />}
            {selectedOption === 'image' && <ImageOption />}
            {selectedOption === 'video' && <VideoOption />}
            {selectedOption === 'pdf' && <PdfOption />}
            {selectedOption === 'url' && <UrlOption />}
          </div>
        </div>)
};

const TextOption = () => {
  const [text, setText] = useState('');

  const handleTextChange = (event) => {
    setText(event.target.value);
  };

  return (
    <div>
      <h3>Text Option</h3>
      <textarea value={text} onChange={handleTextChange} rows={4} cols={30} />
      <p>Entered text: {text}</p>
    </div>
  );
};

const ImageOption = () => {
  const [imageUrl, setImageUrl] = useState('');

  const handleImageUrlChange = (event) => {
    setImageUrl(event.target.value);
  };

  return (
    <div>
      <h3>Image Option</h3>
      <input
        type="text"
        placeholder="Enter image URL"
        value={imageUrl}
        onChange={handleImageUrlChange}
      />
      {imageUrl && <img src={imageUrl} alt="Selected" style={{ width: '100%' }} />}
    </div>
  );
};

const VideoOption = () => {
  const [videoUrl, setVideoUrl] = useState('');

  const handleVideoUrlChange = (event) => {
    setVideoUrl(event.target.value);
  };

  return (
    <div>
      <h3>Video Option</h3>
      <input
        type="text"
        placeholder="Enter video URL"
        value={videoUrl}
        onChange={handleVideoUrlChange}
      />
      {videoUrl && (
        <video controls style={{ width: '100%' }}>
          <source src={videoUrl} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      )}
    </div>
  );
};

const PdfOption = () => {
  const [pdfUrl, setPdfUrl] = useState('');

  const handlePdfUrlChange = (event) => {
    setPdfUrl(event.target.value);
  };

  return (
    <div>
      <h3>PDF Option</h3>
      <input
        type="text"
        placeholder="Enter PDF URL"
        value={pdfUrl}
        onChange={handlePdfUrlChange}
      />
      {pdfUrl && <embed src={pdfUrl} type="application/pdf" width="100%" height="500px" />}
    </div>
  );
};

const UrlOption = () => {
  const [externalUrl, setExternalUrl] = useState('');

  const handleExternalUrlChange = (event) => {
    setExternalUrl(event.target.value);
  };

  return (
    <div>
      <h3>URL Option</h3>
      <input
        type="text"
        placeholder="Enter external URL"
        value={externalUrl}
        onChange={handleExternalUrlChange}
      />
      {externalUrl && (
        <p>
          Visit the URL: <a href={externalUrl} target="_blank" rel="noopener noreferrer">{externalUrl}</a>
        </p>
      )}
    </div>
  );
};


const normalize = (s = "") =>
  s
    .toLowerCase()
    .normalize("NFKD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[^\w\s]/g, " ")
    .replace(/\s+/g, " ")
    .trim();

const trigrams = (s) => {
  const t = `  ${s}  `;
  const out = new Set();
  for (let i = 0; i < t.length - 2; i++) out.add(t.slice(i, i + 3));
  return out;
};

const jaccard = (aSet, bSet) => {
  let inter = 0;
  for (const x of aSet) if (bSet.has(x)) inter++;
  const union = aSet.size + bSet.size - inter;
  return union ? inter / union : 0;
};

const similarity01 = (a, b) => {
  if (!a && !b) return 1;
  if (!a || !b) return 0;

  const A = normalize(a);
  const B = normalize(b);

  const base = jaccard(trigrams(A), trigrams(B));
  const containsBoost = B.includes(A) || A.includes(B) ? 0.12 : 0;

  return Math.min(1, base + containsBoost);
};

//Maps
function MapsScreen(props) {
  const classes = useStyles();

  const [maps, setMaps] = useState([])
  const [showingMaps, setShowingMaps] = useState(true)
  const [fetchingMaps, setFetchingMaps] = useState(true)
  const [currentSelectedMapId, setCurrentSelectedMapId] = useState('')
  const [currentSelectedMapName, setCurrentSelectedMapName] = useState('')
  const [addingMap, setAddingMap] = useState(false)
  const [newMapName, setNewMapName] = useState('')

  const [editingMapName, setEditingMapName] = useState(false)
  const [newEditedMapName, setNewEditedMapName] = useState('')


  const [fetchingMap, setFetchingMap] = useState(false)
  const [graphData, setGraphData] = useState({nodes:[], links:[]})

  const [savingMap, setSavingMap] = useState(false)
  const [errorSaving, setErrorSaving] = useState(false)

  const [addingNode, setAddingNode] = useState(false)
  const [addingNodeEvent, setAddingNodeEvent] = useState()
  const [nodeOpened, setNodeOpened] = useState(false)
  const [openedNode, setOpenedNode] = useState({})
  const [openedNodeTextSize, setOpenedNodeTextSize] = useState('')
  const [crtlKeyDown, setCrtlKeyDown] = useState(false)
  const [searchPlatform, setSearchPlatform] = useState('')

  const [addingLink, setAddingLink] = useState(false);
  const [firstNodeSelected, setFirstNodeSelected] = useState(false)
  const [firstNode, setFirstNode] = useState(null);
  const [secondNodeArray, setSecondNodeArray] = useState([]);

  const [removingLink, setRemovingLink] = useState(false);
  const [linkToBeRemovedSource, setLinkToBeRemovedSource] = useState(null);
  const [linkToBeRemovedTarget, setLinkToBeRemovedTarget] = useState(null);

  const [searchingNode, setSearchingNode] = useState(false)
  const [searchingNodeInput, setSearchingNodeInput] = useState('')
  const [searchingNodeResults, setSearchingNodeResults] = useState([])

  
  const [dimensions, setDimensions] = useState({ 
    height: window.innerHeight,
    width: window.innerWidth
  })

  const handleResize = () => {
    setDimensions({
      height: window.innerHeight,
      width: window.innerWidth
    }) 
  }

  useEffect(() => {
    window.addEventListener('resize', handleResize)
    window.onkeyup = function(e) { if (e.keyCode == 16) {setCrtlKeyDown(false)} }
    window.onkeydown = function(e) { if (e.keyCode == 16) {setCrtlKeyDown(true)} }
    getMaps()
  }, [])

  useEffect(() => {
    document.title = "DIL Maps (" + currentSelectedMapName + ")";
  }, [currentSelectedMapName])

  const setCurrentFocusedResultIndex = (new_index) => {
    setGraphData((old_data) => {
      var new_nodes = old_data.nodes
      var new_links = old_data.links
      return {nodes: new_nodes, links: new_links, focusedNodeId: new_index}
    })
  }

  const getMaps = () => {
    fetch(SERVER_LINK + '/get_maps', {
      method: 'GET',
        headers: {
          Accept:'application/json',
          'Content-Type': 'application/json',
          'SimpTokAuth': props.tokenPass
        }
      }).then((response) => response.json())
        .then((data) => {if (Array.isArray(data)) {setMaps(data); if (props.currentMap) {openCurrentMap(data);} } else {alert('error fetching data, please reload page')}})
        .catch((error) => console.log(error))
        .finally(() => setFetchingMaps(false))
  }

  const openCurrentMap = (data) => {
    const map = data.find(m => m.id == props.currentMap)
    if (map) {
      setCurrentSelectedMapId(map.id)
      setCurrentSelectedMapName(map.name)
      fetchMap(map.id, -1)
      setShowingMaps(false)
    }
  }

  const addMap = () => {
    fetch(SERVER_LINK + '/add_map', {
      method: 'POST',
        headers: {
          Accept:'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          'idtoken': props.tokenPass,
          'name': newMapName,
        })
      }).then((response) => response.json())
        .then((data) => {if (data == 'SUCCESS') {getMaps()}})
        .catch((error) => console.log(error))
        .finally(() => {setAddingMap(false)})
  }

  const setMapName = () => {
    fetch(SERVER_LINK + '/set_map_name', {
      method: 'POST',
        headers: {
          Accept:'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          'idtoken': props.tokenPass,
          'map_id': currentSelectedMapId,
          'name': newEditedMapName,
        })
      }).then((response) => response.json())
        .then((data) => {if (data == 'SUCCESS') {getMaps(); setEditingMapName(false); setCurrentSelectedMapName(newEditedMapName)}})
        .catch((error) => console.log(error))
        .finally(() => {setAddingMap(false)})
  }

  const onClickGraph = function(event) {
    if (nodeOpened) {
      closeNodeInfoBox()
    }
    else {
      if (currentSelectedMapId == '') {
        alert('please select a map to add nodes')
      }
      else {
        event.persist()
        setAddingNode(true)
        setAddingNodeEvent(event)
        var screen_x = event.nativeEvent.layerX;
        var screen_y = event.nativeEvent.layerY;
        var trans_x = 0
        var trans_y = 0
        var trans_scale = 1
        if (event.target.childNodes[1].transform.baseVal.length > 0) {
          trans_x = event.target.childNodes[1].transform.baseVal[0].matrix.e + 100;
          trans_y = event.target.childNodes[1].transform.baseVal[0].matrix.f + 850;
          trans_scale = event.target.childNodes[1].transform.baseVal[1].matrix.a;
        }
        var canvas_x = (screen_x - trans_x)/trans_scale;
        var canvas_y = (screen_y - trans_y)/trans_scale;
        console.log(canvas_x)
        console.log(canvas_y)
        console.log(event)
      }
    }
  }

  const centerGraph = () => {
    setFetchingMap(true)
    fetchMap(currentSelectedMapId, -1)
  }

  const addNode = (instanceid) => {
      var screen_x = addingNodeEvent.nativeEvent.layerX;
      var screen_y = addingNodeEvent.nativeEvent.layerY;
      var trans_x = 0
      var trans_y = 0
      var trans_scale = 1
      if (addingNodeEvent.target.childNodes[1].transform.baseVal.length > 0) {
        trans_x = addingNodeEvent.target.childNodes[1].transform.baseVal[0].matrix.e + 40;
        trans_y = addingNodeEvent.target.childNodes[1].transform.baseVal[0].matrix.f + 140;
        trans_scale = addingNodeEvent.target.childNodes[1].transform.baseVal[1].matrix.a;
      }
      var canvas_x = (screen_x - trans_x)/trans_scale;
      var canvas_y = (screen_y - trans_y)/trans_scale;
      console.log(canvas_x)
      console.log(canvas_y)

    fetch(SERVER_LINK + '/add_node', {
      method: 'POST',
        headers: {
          Accept:'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          'idtoken': props.tokenPass,
          'mapid': currentSelectedMapId,
          'instid': instanceid,
          'x': canvas_x,
          'y': canvas_y
        })
      }).then((response) => response.json())
        .then((data) => {if (Number.isInteger(data)) {addNodeToCurrentMapObject(data)}})
        .catch((error) => console.log(error))
        .finally(closeAddNodeBox)
  }

  const addNodeToCurrentMapObject = (new_node_id, callback) => {
    fetch(SERVER_LINK + '/get_node_info', {
      method: 'GET',
        headers: {
          Accept:'application/json',
          'Content-Type': 'application/json',
          'SimpTokAuth': props.tokenPass,
          'InstNodeID': new_node_id
        }
      }).then((response) => response.json())
        .then((data) => {setGraphData((old_data) => {
                                          var new_nodes = old_data.nodes
                                          var new_links = old_data.links
                                          new_nodes.push(data)
                                          return {nodes: new_nodes, links: new_links}
                                        })})
        .then(() => {if (callback) {callback()}})
        .catch((error) => console.log(error))
    
  }

  const getClickedCoords = () => {
    var screen_x = addingNodeEvent.nativeEvent.layerX;
    var screen_y = addingNodeEvent.nativeEvent.layerY;
    var trans_x = 0
    var trans_y = 0
    var trans_scale = 1
    if (addingNodeEvent.target.childNodes[1].transform.baseVal.length > 0) {
      trans_x = addingNodeEvent.target.childNodes[1].transform.baseVal[0].matrix.e;
      trans_y = addingNodeEvent.target.childNodes[1].transform.baseVal[0].matrix.f;
      trans_scale = addingNodeEvent.target.childNodes[1].transform.baseVal[1].matrix.a;
    }
    var canvas_x = (screen_x - trans_x)/trans_scale;
    var canvas_y = (screen_y - trans_y)/trans_scale;
    console.log(canvas_x)
    console.log(canvas_y)
    return [canvas_x, canvas_y]
  }

  const addChildNodeInSurroundings = (node_parent, instanceid_of_soontobechild) => {
    console.log('receiving node in map ...')
    console.log(node_parent)
    console.log(instanceid_of_soontobechild)

    const x_relative_coord = (Math.random()*2) - 1
    const y_relative_coord = Math.cos(x_relative_coord)
    const x_absolute_coord = node_parent.x + (x_relative_coord*100)
    const y_absolute_coord = node_parent.y + (y_relative_coord*100)

    fetch(SERVER_LINK + '/add_node', {
      method: 'POST',
        headers: {
          Accept:'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          'idtoken': props.tokenPass,
          'mapid': currentSelectedMapId,
          'instid': instanceid_of_soontobechild,
          'x': x_absolute_coord,
          'y': y_absolute_coord
        })
      }).then((response) => response.json())
        .then((data) => {if (Number.isInteger(data)) {setLinkFromAddingChildToSurrondings(node_parent.id, data)}})
        .catch((error) => console.log(error))

  }

  const setLinkFromAddingChildToSurrondings = (parentid, childid) => {
    fetch(SERVER_LINK + '/set_node_parent', {
      method: 'POST',
      headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
      },
      body: JSON.stringify({
          idtoken: props.tokenPass,
          mapid: currentSelectedMapId,
          nodeid: childid,
          newparentid: parentid
      })
    }).then((response) => response.json())
      .then((data) => {
                      if (data == 'SUCCESS') {
                          addNodeToCurrentMapObject(childid, () => {
                            setGraphData((state, props) => {
                              var new_links = state.links;
                              new_links.push({source: parentid, target: childid});
                              return {
                                nodes : state.nodes,
                                links : new_links
                              }
                            })
                          })
                      } else {
                          alert('ERROR INSERTING LINK TO HIGHLIGHT')
                      }
                    })
      .catch((error) => console.log(error))

  }

  const deleteNode = () => {
    fetch(SERVER_LINK + '/delete_node', {
      method: 'POST',
        headers: {
          Accept:'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          'idtoken': props.tokenPass,
          'mapid': currentSelectedMapId,
          'nodeid': openedNode.id,
        })
      }).then((response) => response.json())
        .then((data) => {if (data=='SUCCESS') {closeNodeInfoBox(); setGraphData((old_data) => {
          let selectedNodeIndex = old_data['nodes'].findIndex(x => x.id === openedNode.id)
          let newArr = [...old_data['nodes']];
          newArr.splice(selectedNodeIndex, 1)
          let newGraphData = { 'nodes': newArr, 'links': old_data['links']}
          return newGraphData
        })}})
        .catch((error) => console.log(error))
  }

  const nodeMoved = (instanceId, newX, newY) => {
    console.log(graphData['nodes'].find(x => x.id === instanceId).x)
    if (crtlKeyDown) {
      moveNodesInServer(instanceId, newX, newY)
    } else {
      setNewNodePosition(instanceId, newX, newY)
    }
  }

  const moveNodesInServer = (instanceId, newX, newY) => {
    let childrenNodes = graphData['links'].filter(x => x.source === instanceId)
    let selectedNode = graphData['nodes'].find(x => x.id === instanceId)
    let deltaX = (selectedNode.fx-newX)
    let deltaY = (selectedNode.fy-newY)
    console.log('moved by ' + (deltaX) + ' ... ' + (deltaY))
    setNewNodePosition(instanceId, newX, newY)
    for(var i = 0; i < childrenNodes.length; i++) {
      let childNode = graphData['nodes'].find(x => x.id === childrenNodes[i].target)
      let newChildX = childNode.fx - deltaX
      let newChildY = childNode.fy - deltaY
      moveNodesInServer(childNode.id, newChildX, newChildY)
    }
  }

  const setNewNodePosition = (nodeid, newX, newY) => {
    setGraphData((old_data) => {
      let selectedNodeIndex = old_data['nodes'].findIndex(x => x.id === nodeid)
      let newArr = [...old_data['nodes']];
      newArr[selectedNodeIndex].fx = newX
      newArr[selectedNodeIndex].fy = newY
      let newGraphData = { 'nodes': newArr, 'links': old_data['links']}
      return newGraphData
    })
    setSavingMap(true)
    fetch(SERVER_LINK + '/set_node_position', {
      method: 'POST',
        headers: {
          Accept:'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          'idtoken': props.tokenPass,
          'mapid': currentSelectedMapId,
          'nodeid': nodeid,
          'x': newX,
          'y': newY
        })
      }).then((response) => response.json())
        .then((data) => {if (data=='SUCCESS') {
                          setSavingMap(false)
                        } else {
                          setSavingMap(false)
                          setErrorSaving(true)
                          alert('ERROR UPDATING POSITION')
                        }})
        .catch((error) => console.log(error))
  }

  const onMouseOverNode = function(nodeId, node) {
    console.log('mouse over node ' + nodeId)
    //paint all parents and self
  };

  const onMouseOutNode = function(nodeId, node) {
    console.log('mouse out of node ' + nodeId)
  };

  const resetAddLink = () => {
    setAddingLink(false); 
    setFirstNodeSelected(false); 
    setFirstNode(null);
    setSecondNodeArray([]);
  }

  const startAddingLink = () => {
    setAddingLink(true);
    setFirstNodeSelected(false); 
    setFirstNode(null);
    setSecondNodeArray([]);
  }

  const addLink = () => {
    for (let secondedNodeId in secondNodeArray) {
              fetch(SERVER_LINK + '/set_node_parent', {
                method: 'POST',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    idtoken: props.tokenPass,
                    mapid: currentSelectedMapId,
                    nodeid: secondNodeArray[secondedNodeId].toString(),
                    newparentid: firstNode.id.toString()
                })
              }).then((response) => response.json())
                .then((data) => {
                                if (data == 'SUCCESS') {
                                    setGraphData((state, props) => {
                                      var new_links = state.links;
                                      new_links.push({source: firstNode.id, target: parseInt(secondNodeArray[secondedNodeId])});
                                      return {
                                        nodes : state.nodes,
                                        links : new_links
                                      }
                                    })
                                    setAddingLink(false);
                                } else {
                                    setAddingLink(false);
                                    alert('ERROR INSERTING ALL LINKS')
                                }
                              })
                .catch((error) => console.log(error))
    }
  };

  const onClickLink = (source, target) => {
    console.log('clicked link between ' + source + ' and ' + target)
    setLinkToBeRemovedSource(source)
    setLinkToBeRemovedTarget(target)
    startRemovingLink()
  };

  const startRemovingLink = () => {
    setRemovingLink(true);
  }

  const removeLink = () => {
    fetch(SERVER_LINK + '/remove_node_parent', {
      method: 'POST',
        headers: {
          Accept:'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          'idtoken': props.tokenPass,
          'mapid': currentSelectedMapId,
          'nodeid': linkToBeRemovedTarget
          })
      }).then((response) => response.json())
        .then((data) => {if (data=='SUCCESS') {
              setGraphData((old_data) => {
                var newLinks = old_data.links
                newLinks = newLinks.filter((link) => {
                  return !((link.source == linkToBeRemovedSource && link.target == linkToBeRemovedTarget))})
                return { nodes: old_data.nodes, links: newLinks };
              });
              closeRemoveLinkBox();} else { alert('ERROR REMOVING LINK') }})
        .catch((error) => console.log(error))
  }

  const closeRemoveLinkBox = () => {
    setRemovingLink(false);
    setLinkToBeRemovedTarget(null);
  }

  const closeAddNodeBox = () => {
    setAddingNode(false); 
  }

  const closeNodeInfoBox = () => {
    if (nodeOpened) {
      setNodeOpened(false)
      setOpenedNodeTextSize('')
      let openedNodeInfo = { ...openedNode}
      setGraphData((old_data) => {
        let selectedNodeIndex = old_data['nodes'].findIndex(x => x.id == openedNodeInfo.id)
        let newArr = [...old_data['nodes']];
        newArr[selectedNodeIndex].color = "white"
        let newGraphData = { 'nodes': newArr, 'links': old_data['links']}
        return newGraphData
      })
    }
  }

  const onClickNode = (nodeId, node) => {
    console.log(node.x)
    console.log(node.y)
    if (addingLink) {
      if (!firstNodeSelected) {
        setFirstNode(node)
        setFirstNodeSelected(true)
      }
      else {
        setSecondNodeArray((old_array) => [...old_array, nodeId])
      }
    }
    else if (nodeOpened) {
      closeNodeInfoBox()
    }
    else {
      setOpenedNode(node)
      setOpenedNodeTextSize(node.textsize)
      setGraphData((old_data) => {
        let selectedNodeIndex = old_data['nodes'].findIndex(x => x.id == node.id)
        let newArr = [...old_data['nodes']];
        newArr[selectedNodeIndex].color = 'gray'
        let newGraphData = { 'nodes': newArr, 'links': old_data['links']}
        return newGraphData
      })
      setNodeOpened(true)
    }
  };

  const handleSearchPlatformChange = (event) => {
    setSearchPlatform(event.target.value);
  };

  const fetchMap = (mapid, instid) => {
    setFetchingMap(true)
    closeNodeInfoBox()
    closeAddNodeBox()
    fetch(SERVER_LINK + '/get_nodes', {
      method: 'GET',
        headers: {
          Accept:'application/json',
          'Content-Type': 'application/json',
          'SimpTokAuth': props.tokenPass,
          'MapID': mapid
        }
      }).then((response) => response.json())
        .then((data) => {console.log(data); {instid>=0 ? setGraphData({nodes: data.nodes, links: data.links, focusedNodeId: instid}) : setGraphData(data)}})
        .catch((error) => console.log(error))
        .finally(() => {setFetchingMap(false); setCurrentSelectedMapId(mapid);})
  }

  const openMap = (mapid) => {
    if (nodeOpened) {
      closeNodeInfoBox()
    }
    setFetchingMap(true)
    fetchMap(mapid, -1)
    setShowingMaps(false)
    window.history.pushState(null, '', '/maps/' + mapid)
  }

  const handleOpenedNodeTextSizeChange = (event) => {
    fetch(SERVER_LINK + '/set_node_text_size', {
      method: 'POST',
        headers: {
          Accept:'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          'idtoken': props.tokenPass,
          'mapid': currentSelectedMapId,
          'nodeid': openedNode.id,
          'tsize': event.target.value
        })
      }).then((response) => response.json())
        .then((data) => {if (data=='SUCCESS') {
          setOpenedNodeTextSize(event.target.value);
          changeCurrentNodeTextSizeInMap(openedNode.id)
          } else { alert('ERROR CHANGING TEXT SIZE')}})
        .catch((error) => console.log(error))
  }

  const changeCurrentNodeTextSizeInMap = (node_id) => {
    fetch(SERVER_LINK + '/get_node_info', {
      method: 'GET',
        headers: {
          Accept:'application/json',
          'Content-Type': 'application/json',
          'SimpTokAuth': props.tokenPass,
          'InstNodeID': node_id
        }
      }).then((response) => response.json())
        .then((data) => {
          setGraphData((old_data) => {
            let selectedNodeIndex = old_data['nodes'].findIndex(x => x.id === node_id)
            let newArr = [...old_data['nodes']];
            newArr[selectedNodeIndex].textsize = data.textsize
            newArr[selectedNodeIndex].size = data.size
            let newGraphData = { 'nodes': newArr, 'links': old_data['links']}
            return newGraphData
          })
        })
        .catch((error) => console.log(error))
    
  }

  const changeCurrentInstNodesTextInMap = (instid) => {
    //get all nodes with that inst id
    //for each node, get the text and size
    //set the text and size in the graph data
    let list_nodes_id = graphData['nodes'].filter(x => x.instid === instid).map(x => x.id)
    console.log('list of nodes with instid ' + instid)
    console.log(list_nodes_id)
    for (let i = 0; i < list_nodes_id.length; i++) {
      let node_id = list_nodes_id[i]
      fetch(SERVER_LINK + '/get_node_info', {
        method: 'GET',
          headers: {
            Accept:'application/json',
            'Content-Type': 'application/json',
            'SimpTokAuth': props.tokenPass,
            'InstNodeID': node_id
          }
        }).then((response) => response.json())
          .then((data) => {
            setGraphData((old_data) => {
              let selectedNodeIndex = old_data['nodes'].findIndex(x => x.id === node_id)
              let newArr = [...old_data['nodes']];
              newArr[selectedNodeIndex].text = data.text
              newArr[selectedNodeIndex].size = data.size
              newArr[selectedNodeIndex].typename = data.typename
              let newGraphData = { 'nodes': newArr, 'links': old_data['links']}
              return newGraphData
            })
          })
          .catch((error) => console.log(error))
        }
    
  }

  const onDragMove = (event, index, nodes, dx, dy) => {
    console.log(event)
    console.log(index)
    console.log(dx)
    console.log(dy)
  }
  /** 
  const searchForTextInMap = () => {
    console.log(graphData['nodes'])
    var results = []
    for (let node in graphData['nodes']) {
      if (graphData['nodes'][node]['text'].toLowerCase().includes(searchingNodeInput.toLowerCase())) {
        //console.log('found card with text ... ' + graphData['nodes'][node]['text'])
        results.push(graphData['nodes'][node])
      }
    }
    setSearchingNodeResults(results)
    setSearchingNode(true)
  }
    */

  const searchForTextInMap = () => {
    const q = searchingNodeInput ?? "";
    const nodesObj = graphData?.nodes ?? {};
    const nodes = Array.isArray(nodesObj) ? nodesObj : Object.values(nodesObj);
    console.log('searching for ' + q + ' in nodes:')
    console.log(nodes)

    const scored = nodes
      .map((n) => {
        const text = n['text'] ?? "";
        const score = similarity01(q, text);
        return { ...n, _similarity: score };
      })
      // If query is tiny, don’t filter too aggressively
      .sort((a, b) => b._similarity - a._similarity)
      .slice(0, 20);

    setSearchingNodeResults(scored);
    console.log('search results:')
    console.log(scored)
    setSearchingNode(true);
    console.log(similarity01("helo wrld", "hello world"));  
  };

  const dropHandler = (ev) => {
    console.log('File(s) dropped');
  
    // Prevent default behavior (Prevent file from being opened)
    ev.preventDefault();
  
    if (ev.dataTransfer.items) {
      // Use DataTransferItemList interface to access the file(s)
      for (var i = 0; i < ev.dataTransfer.items.length; i++) {
        // If dropped items aren't files, reject them
        if (ev.dataTransfer.items[i].kind === 'file') {
          var file = ev.dataTransfer.items[i].getAsFile();
          console.log('... file[' + i + '].name = ' + file.name);
        }
      }
    } else {
      // Use DataTransfer interface to access the file(s)
      for (var i = 0; i < ev.dataTransfer.files.length; i++) {
        console.log('... file[' + i + '].name = ' + ev.dataTransfer.files[i].name);
      }
    }
  }
  
  // the graph configuration, just override the ones you need
  const myConfig1 = {
    nodeHighlightBehavior: true,
    height: dimensions.height - 124,
    width: showingMaps ? dimensions.width - 301 : dimensions.width - 74,
    minZoom: 0.01,
    node: {
      color: "lightgreen",
      highlightStrokeColor: "blue",
      //size: {width:2750, height:3500},
      labelProperty: () => {return ''},
      viewGenerator: (node) => {
        return <SimpleInstanceCard tokenPass={props.tokenPass}
                                   text={node.text} 
                                   typename={node.typename} 
                                   instanceid={node.id} 
                                   typeid={node.typeid}
                                   tsize={node.textsize}
                                   imageurl={node.instanceimage}
                                   color={node.color}
                                   size={node.size} />
      }
    },
    directed: true,
    link: {
      highlightColor: "lightblue",
      strokeWidth: 15,
      color: 'black',
      markerHeight: 0,
      markerWidth: 0,
    },
    d3: {
      disableLinkForce: true,
      gravity: -400,
      linkLength: 180,
    },
  };
  

  
  return (<div style={{'overflow': 'hidden'}}>
            {showingMaps ? (
                    <div
                      className="side-bar-graph-goals"
                      style={{
                        height: dimensions.height - 98,
                        overflowY: "auto",
                        overflowX: "hidden",
                        padding: 0,
                        background: "#f7f8fa",
                        position: "relative",
                      }}
                    >
                      {/* Sticky header that hides scrolled content behind it */}
                      <div
                        style={{
                          position: "sticky",
                          top: 0,
                          zIndex: 20,
                          background: "#f7f8fa",
                          paddingLeft: 12,
                          paddingRight: 12,
                          padding: 10,
                          borderBottom: "1px solid rgba(0,0,0,0.08)",
                          boxShadow: "0 6px 12px rgba(0,0,0,0.04)",
                        }}
                      >
                        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                          <Typography style={{ fontWeight: 900, fontSize: 14, color: "#111" }}>
                            Maps
                          </Typography>

                          <div style={{ flex: 1 }} />

                          {!addingMap ? (
                            <Button
                              variant="contained"
                              size="small"
                              onClick={() => setAddingMap(true)}
                              style={{
                                borderRadius: 999,
                                textTransform: "none",
                                fontWeight: 700,
                                boxShadow: "none",
                              }}
                            >
                              Add Map
                            </Button>
                          ) : (
                            <Button
                              size="small"
                              onClick={() => setAddingMap(false)}
                              style={{
                                borderRadius: 999,
                                textTransform: "none",
                                fontWeight: 700,
                              }}
                            >
                              Cancel
                            </Button>
                          )}

                          {/* Collapse button */}
                          <Button
                            size="small"
                            onClick={() => setShowingMaps(false)}
                            style={{ minWidth: 36, borderRadius: 10 }}
                            title="Collapse"
                          >
                            <KeyboardBackspaceIcon />
                          </Button>
                        </div>

                        {/* Inline add form (compact + modern) */}
                        {addingMap && (
                          <div style={{ marginTop: 10, display: "flex", gap: 10 }}>
                            <TextField
                              id="newname"
                              type="text"
                              variant="outlined"
                              label="New map"
                              fullWidth
                              onChange={(event) => setNewMapName(event.target.value)}
                              value={newMapName}
                              size="small"
                            />
                            <Button
                              variant="contained"
                              disableElevation
                              onClick={addMap}
                              disabled={!newMapName.trim()}
                              style={{
                                borderRadius: 12,
                                textTransform: "none",
                                fontWeight: 800,
                                whiteSpace: "nowrap",
                              }}
                            >
                              Add
                            </Button>
                          </div>
                        )}
                      </div>

                      {fetchingMaps ? (
                        <div style={{ display: "flex", justifyContent: "center", padding: 20 }}>
                          <CircularProgress size={24} />
                        </div>
                      ) : (
                        <List disablePadding style={{ paddingTop: 12 }}>
                          {maps.map((map) => (
                            <SimpleMapCard
                              key={map.id}
                              map={map}
                              onSelection={() => {
                                openMap(map.id);
                                setCurrentSelectedMapId(map.id);
                                setCurrentSelectedMapName(map.name);
                              }}
                            />
                          ))}
                        </List>
                      )}
                    </div>
                  ) : (
                    // Collapsed rail (icon-only)
                    <div
                      className="side-bar-graph-goals"
                      style={{
                        height: dimensions.height - 98,
                        width: 56,
                        overflow: "hidden",
                        padding: 8,
                        background: "#f7f8fa",
                        borderRight: "1px solid rgba(0,0,0,0.08)",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        gap: 8,
                      }}
                    >
                      <Button
                        variant="contained"
                        onClick={() => setShowingMaps(true)}
                        style={{
                          minWidth: 40,
                          width: 40,
                          height: 40,
                          borderRadius: 12,
                          boxShadow: "none",
                        }}
                        title="Open Maps"
                      >
                        <KeyboardBackspaceIcon style={{ transform: "rotate(180deg)" }} />
                      </Button>
                    </div>
                  )}
            <div style={{ backgroundColor: "#E3F6AC", overflow: 'overlay'}}>
              <div
                      style={{
                        backgroundColor: "#FFF",
                        width: showingMaps ? dimensions.width - 301 : dimensions.width - 74,
                        height: "57px",
                        borderBottom: "1px solid rgba(0,0,0,0.12)",
                        boxShadow: "0 1px 0 rgba(0,0,0,0.04)",
                        padding: "0 12px",
                        boxSizing: "border-box",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        gap: 12,
                        overflow: "hidden",
                      }}
                    >
                      {currentSelectedMapId === "" ? (
                        <Typography style={{ opacity: 0.75, fontWeight: 700 }}>Select map</Typography>
                      ) : (
                        <>
                          {/* LEFT: status + map name */}
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: 10,
                              minWidth: 0,
                              flex: "0 0 auto",
                            }}
                          >
                            <div style={{ width: 22, height: 22, display: "grid", placeItems: "center" }}>
                              {savingMap ? (
                                <PendingIcon fontSize="small" />
                              ) : errorSaving ? (
                                <ErrorIcon fontSize="small" />
                              ) : (
                                <CheckCircleIcon fontSize="small" />
                              )}
                            </div>

                            {/* Map name (truncate, never grows bar) */}
                            <Typography
                              variant="subtitle1"
                              style={{
                                fontWeight: 900,
                                letterSpacing: "-0.2px",
                                maxWidth: 260,
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                              }}
                              title={currentSelectedMapName}
                            >
                              {currentSelectedMapName}
                            </Typography>
                          </div>

                          {/* MIDDLE: edit name OR add link OR search */}
                          <div style={{ flex: "1 1 auto", minWidth: 0, display: "flex", alignItems: "center", gap: 10 }}>
                            {editingMapName ? (
                              <>
                                <TextField
                                  type="text"
                                  variant="outlined"
                                  label="Map name"
                                  size="small"
                                  onChange={(event) => setNewEditedMapName(event.target.value)}
                                  value={newEditedMapName}
                                  style={{ maxWidth: 340, width: "100%" }}
                                />
                                <Button
                                  variant="contained"
                                  color="primary"
                                  onClick={setMapName}
                                  style={{ borderRadius: 999, textTransform: "none", fontWeight: 900, height: 36 }}
                                >
                                  Save
                                </Button>
                                <Button
                                  variant="outlined"
                                  onClick={() => setEditingMapName(false)}
                                  style={{ borderRadius: 999, textTransform: "none", fontWeight: 800, height: 36 }}
                                >
                                  Back
                                </Button>
                              </>
                            ) : addingLink ? (
                              <>
                                <div style={{ minWidth: 0 }}>
                                  <Typography variant="caption" style={{ opacity: 0.7 }}>
                                    From
                                  </Typography>
                                  <Typography
                                    variant="body2"
                                    style={{ fontWeight: 800, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}
                                  >
                                    {firstNode == null ? ".." : firstNode.id}
                                  </Typography>
                                </div>

                                <div style={{ minWidth: 0 }}>
                                  <Typography variant="caption" style={{ opacity: 0.7 }}>
                                    To
                                  </Typography>
                                  <Typography
                                    variant="body2"
                                    style={{ fontWeight: 800, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}
                                  >
                                    {secondNodeArray.map((nodeid) => nodeid).join(", ")}
                                  </Typography>
                                </div>

                                <Button
                                  variant="contained"
                                  color="primary"
                                  onClick={addLink}
                                  style={{ borderRadius: 999, textTransform: "none", fontWeight: 900, height: 36 }}
                                >
                                  Add link
                                </Button>
                                <Button
                                  variant="outlined"
                                  onClick={resetAddLink}
                                  style={{ borderRadius: 999, textTransform: "none", fontWeight: 800, height: 36 }}
                                >
                                  Cancel
                                </Button>
                              </>
                            ) : (
                              <>
                                <TextField
                                  id="searchmap"
                                  type="text"
                                  variant="outlined"
                                  label="Search in map…"
                                  size="small"
                                  onChange={(event) => setSearchingNodeInput(event.target.value)}
                                  value={searchingNodeInput}
                                  style={{ maxWidth: 340, width: "100%" }}
                                />
                                <Button
                                  variant="contained"
                                  color="primary"
                                  onClick={searchForTextInMap}
                                  style={{ borderRadius: 999, textTransform: "none", fontWeight: 900, height: 36 }}
                                >
                                  Search
                                </Button>
                              </>
                            )}
                          </div>

                          {/* RIGHT: actions */}
                          {!editingMapName && (
                            <div style={{ display: "flex", alignItems: "center", gap: 8, flex: "0 0 auto" }}>
                              {!addingLink && (
                                <Button
                                  variant="outlined"
                                  onClick={() => centerGraph()}
                                  style={{ borderRadius: 999, textTransform: "none", fontWeight: 800, height: 36 }}
                                >
                                  Center
                                </Button>
                              )}

                              {!addingLink && (
                                <Button
                                  variant="outlined"
                                  onClick={() => {
                                    setEditingMapName(true);
                                    setNewEditedMapName(currentSelectedMapName);
                                  }}
                                  style={{ borderRadius: 999, textTransform: "none", fontWeight: 800, height: 36 }}
                                >
                                  Edit name
                                </Button>
                              )}

                              
                            </div>
                          )}
                        </>
                      )}
                    </div>
            {fetchingMap? <CircularProgress /> :
              <div className="droppable" onDragOver={(e)=>this.onDragOver(e)} >
                <Graph
                  id="map-graph" // id is mandatory
                  data={graphData}
                  config={myConfig1}
                  onClickGraph={onClickGraph}
                  onNodePositionChange={nodeMoved}
                  onClickNode={onClickNode}
                  onDragMoveCallBack={onDragMove}
                  onClickLink={onClickLink}
                />
              </div>}
              {searchingNode ?
                <div style={{position: 'absolute', top: '150px', left: '70px', width: dimensions.width - 90, height: dimensions.height - 190, backgroundColor: 'white', borderRadius: 10.0, overflow:'scroll'}}>  
                    <div>
                      <Button onClick={() => {setSearchingNode(false)}}> <Close /> </Button>
                    </div>
                    <br />
                    <div class={'grid-container'} style={{width: dimensions.width - 90, height: dimensions.height - 170}}>
                    {searchingNodeResults.map((result, index) => {
                                    return <div class='grid_element_search'>
                                      <ClickableInstanceCard tokenPass={props.tokenPass}
                                                              text={result.text} 
                                                              typename={result.typename} 
                                                              instanceid={result.id} 
                                                              typeid={result.typeid}
                                                              tsize={result.textsize}
                                                              imageurl={result.instanceimage}
                                                              handleClick={(instid) => {setSearchingNode(false); setCurrentFocusedResultIndex(instid); setSearchingNodeInput('')}} />
                                            </div>
                                })}
                    </div>
                </div> : <div></div>}                  
            </div>
            {addingNode? <AddingContentWindow tokenPass={props.tokenPass} 
                                              mapid={currentSelectedMapId}
                                              dropInMap={addNode}
                                              closeAddBox={closeAddNodeBox} /> : <div></div>}
            {removingLink? <div className="infoi"> 
                              <div className="centeredBox"> 
                                <Button style={{'float': 'right'}}
                                        onClick={closeRemoveLinkBox}>
                                  <CloseIcon/>
                                </Button>
                                <h4>Removing Link</h4>
                                <p>Are you sure you want to remove the link from {linkToBeRemovedSource} to {linkToBeRemovedTarget}</p>
                                <Button onClick={removeLink}>Yes</Button>
                                <Button onClick={closeRemoveLinkBox}>No</Button>
                              </div>
                            </div>: <div></div>}
            {nodeOpened ? 
                <div style={{backgroundColor:'gray', 'padding-left': '20px', paddingTop:10, height: window.innerHeight-130, width: '480px', float: 'right', zIndex: '5', position: 'absolute', top: '120px', right: '10px', 'overflow': 'scroll'}}>
                    <Button style={{'float': 'right'}}
                            onClick={closeNodeInfoBox}>
                      <CloseIcon/>
                    </Button>
                    <InputLabel>Text Size</InputLabel>
                    <Select
                      value={openedNodeTextSize}
                      onChange={handleOpenedNodeTextSizeChange}
                    >
                      <MenuItem value={'headline'}>Super Big Title</MenuItem>
                      <MenuItem value={'h1'}>Big Title</MenuItem>
                      <MenuItem value={'h3'}>Small Title</MenuItem>
                      <MenuItem value={'body2'}>Normal Text</MenuItem>
                    </Select>
                    <Button onClick={deleteNode}>
                      Delete from map
                    </Button>
                    <InstanceCard tokenPass={props.tokenPass}
                                  text={openedNode.text} 
                                  typename={openedNode.typename} 
                                  instanceid={openedNode.instid} 
                                  typeid={openedNode.typeid}
                                  handleDelete={() => {closeNodeInfoBox(); setGraphData((old_data) => {
                                                              let selectedNodeIndex = old_data['nodes'].findIndex(x => x.id === openedNode.id)
                                                              let newArr = [...old_data['nodes']];
                                                              newArr.splice(selectedNodeIndex, 1)
                                                              let newGraphData = { 'nodes': newArr, 'links': old_data['links']}
                                                              return newGraphData
                                                            })}}
                                  updateParent={() => {changeCurrentInstNodesTextInMap(openedNode.instid)}}
                                  pdfPath={openedNode.instancepdf}
                                  someURL={openedNode.instanceurl}
                                  imagePath={openedNode.instanceimage}
                                  sendToMap={(instid) => {addChildNodeInSurroundings(openedNode, instid)}} 
                                   />


                </div> :
                <div></div>
            }
            
          </div>);
}


//Streams
function StreamScreen(props) {
  const classes = useStyles();

  const [fetchingStreams, setFetchingStreams] = useState(true)
  const [streams, setStreams] = useState([]);

  const [currentlySelectedStream, setCurrentlySelectedStream] = useState(null)
  const [currentStreamModel, setCurrentStreamModel] = useState(null)

  const [addingNewStream, setAddingNewStream] = useState(false);
  const [newStreamName, setNewStreamName] = useState('');

  const [annotatingImage, setAnnotatingImage] = useState(false);

  const [events, setEvents] = useState([])
  const [selectedEvent, setSelectedEvent] = useState(null)

  const [dimensions, setDimensions] = useState({ 
    height: window.innerHeight,
    width: window.innerWidth
  });

  const scrollEventsDisplay = useRef(null);

  useEffect(() => {
    window.addEventListener('resize', handleResize)
    getStreams()
  },[])

  useEffect(() => {
    console.log(dimensions.width*events.length)
    if (scrollEventsDisplay.current != null) {
      scrollEventsDisplay.current.scrollLeft = dimensions.width*events.length + dimensions.width
    }
    
  }, [events])

  const handleResize = () => {
    setDimensions({
      height: window.innerHeight,
      width: window.innerWidth
    }) 
  }

  const getStreams = () => {
    setFetchingStreams(true)
    fetch(SERVER_LINK + '/get_streams', {
      method: 'GET',
        headers: {
          Accept:'application/json',
          'Content-Type': 'application/json',
          'SimpTokAuth': props.tokenPass
        }
      }).then((response) => response.json())
        .then((data) => {Array.isArray(data) ? setStreams(data) : alert('error fetching data, please reload page')})
        .catch((error) => console.log(error))
        .finally(() => setFetchingStreams(false))
  }

  const addStream = () => {
    fetch(SERVER_LINK + '/add_stream', {
      method: 'POST',
        headers: {
          Accept:'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          'idtoken': props.tokenPass,
          'stream_name': newStreamName,
          'stream_source': 'SCREEN'
        })
      }).then((response) => response.json())
        .then((data) => {console.log(data)})
        .catch((error) => console.log(error))
        .finally(() => {setAddingNewStream(false); getStreams();})
  }


  const startStream = () => {
    navigator.mediaDevices.getDisplayMedia({video: true})
          .then((stream) => {const video = document.querySelector('video');
                              video.srcObject = stream;
                              // demonstrates how to detect that the user has stopped
                              // sharing the screen via the browser UI.
                              stream.getVideoTracks()[0].addEventListener('ended', () => {
                                saveCurrentChain()
                                setCurrentlySelectedStream(null);
                                alert('The user has ended sharing the screen');})
                              }, (error) => {
                                alert(`getDisplayMedia error: ${error.name}`, error);
                              } )
  }


  const captureFrame = () => {
    const video = document.querySelector("video");
    const canvas = document.createElement("canvas");
    canvas.height = video.videoHeight;
    canvas.width = video.videoWidth;
    const context = canvas.getContext("2d");
    context.drawImage(video, 0, 0, canvas.width, canvas.height);


    const frame = canvas.toDataURL("image/jpg");

    var imageData = context.getImageData(0, 0, canvas.width, canvas.height);
    setEvents((oldArray) => {
      if (oldArray.length == 0) {
        const new_event = {frameSrc: frame, frameData: imageData.data, description: [], first: true}
        return [...oldArray, new_event]
      }
      else {
        const previous_event = oldArray[oldArray.length-1]
        const new_event = {frameSrc: frame, frameData: imageData.data, description: [], changes: [], first: false}
        if (previous_event.frameData.length != new_event.frameData.length) {
          alert('stream dimesnions have changed, this cannot happen')
        }

        //compute the map
        const bitChangeMap = []
        for(var i = 0; i < previous_event.frameData.length; i += 4) {
          var red = previous_event.frameData[i] == new_event.frameData[i];
          var green = previous_event.frameData[i+1] == new_event.frameData[i+1];
          var blue = previous_event.frameData[i+2] == new_event.frameData[i+2];
          var alpha = previous_event.frameData[i+3] == new_event.frameData[i+3];
          if (red && green && blue && alpha) {
            bitChangeMap.push([0,0,0,255])
          }
          else {
            bitChangeMap.push([255,255,255,255])
          }
        }

        //console.log('num_diffs ' + bitChangeMap.reduce((a, b) => a + b, 0))
        const bitChangeRGBAValues = bitChangeMap.reduce((xs, ys) => xs.concat(ys));
        const imgData = new ImageData(Uint8ClampedArray.from(bitChangeRGBAValues), canvas.width, canvas.height);
        const canvas1 = document.createElement("canvas");
        canvas1.height = video.videoHeight;
        canvas1.width = video.videoWidth;
        const context1 = canvas1.getContext("2d");
        context1.putImageData(imgData, 0, 0);
        const bitChangeMapImageURL = canvas1.toDataURL("image/png");
        console.log(bitChangeMapImageURL)

        return [...oldArray, new_event]
      }
    })
  }

  const extractRawCropProperties = () => {
    //extract properties values from current frame by cropping according to model
    
    //compute values (i.e map each cropped image to a value in the type set)

    //compute the transformations of the properties from the previous state

  }

  const saveCurrentChain = () => {
    //transform the array of events into a json file

    //upload to 
  }



  return (
    <div style={{height:dimensions.height-64, 'overflow':'scroll'}}>
      {currentlySelectedStream == null ? 
        (fetchingStreams ? <CircularProgress /> :
          <div class="grid-container">
            {streams.map((stream) => {
              return <Card style={{'width':'200px', 'height':'200px', 'margin':'auto'}}>
                        <CardActionArea onClick={() => {setCurrentlySelectedStream(stream, startStream());}} style={{width: '100%', height: '100%'}}>
                            <Typography variant='h6' align="center" style={{width: '200px', height: '200px'}}>{stream.name}</Typography>
                        </CardActionArea>
                    </Card> 
            })}
            <Card style={{'width':'200px', 'height':'200px', 'margin':'auto'}}>
              <CardActionArea onClick={() => {setAddingNewStream(true)}} style={{width: '100%', height: '100%'}}>
                <Typography variant='h4' align="center" style={{width: '200px', height: '200px'}}>ADD NEW STREM</Typography>
              </CardActionArea>
            </Card> 
          </div>) :
          <div>
            <Button style={{'float':'left'}} onClick={() => {setCurrentlySelectedStream(null)}}><KeyboardBackspaceIcon/></Button>
            <Typography variant='h2' align='center'>{currentlySelectedStream.name}</Typography>
            <Typography variant='body2' align='center'> # {currentlySelectedStream.id}</Typography>
            <video id="gum-local" autoplay='' playsinline='' muted='' style={{'width':dimensions.width/2, 'height':dimensions.height-200, 'float':'left'}}></video>
            <div style={{'width':dimensions.width/2, 'height':dimensions.height-200, 'float':'right'}}>
              <div class="scrollmenu" ref={scrollEventsDisplay}>
                {events.map((event) => {return <div>
                                                    <div style={{height:'100px'}}>
                                                      {event.first ? 
                                                        <div>Start</div> :
                                                        <div style={{display:'inline'}}>
                                                          <RemoveIcon/>
                                                          <ArrowForwardIcon/>
                                                        </div>}
                                                    </div>
                                                    <Card style={{}}>
                                                      <CardActionArea onClick={() => setSelectedEvent(event)}>
                                                        <img src={event.frameSrc} height={dimensions.height - 220}/>
                                                        <div>
                                                          {event.description.map((object) => 
                                                          <div>
                                                            
                                                          </div>)}
                                                        </div>
                                                      </CardActionArea>
                                                    </Card>
                                                  </div>})}
              </div>
            </div>
            <Button onClick={startStream}>Start Stream</Button>
            <Button onClick={captureFrame}>Take Snapshot</Button>
          </div>}
      {addingNewStream ? 
      <div className="infoi"> 
        <div className="centeredBox"> 
          <Button style={{'float': 'right'}}
                  onClick={() => {setAddingNewStream(false)}}>
            <CloseIcon/>
          </Button>
          <h4>New Stream</h4>
          <p>To add a new stream, first register the physical sensor with your dil node</p>

          <p>Then, input the registration number and the password</p>
          <TextField variant="outlined"
                     fullWidth={true}
                     onChange={(event) => {setNewStreamName(event.target.value)}}
                     value={newStreamName} />
          <Button onClick={addStream}>Add</Button>
        
        </div>
      </div>  : <div></div>}

      {selectedEvent == null ? <div></div> :
        <div className="infoi"> 
          <Button style={{'float': 'right'}}
                  onClick={() => {setSelectedEvent(null)}}>
            <CloseIcon/>
          </Button>
          <div style={{'margin': 'auto', 'width': '80%', 'height': '100%', 'background-color': 'grey'}}>
            <ImageAnnotator urlImage={selectedEvent.frame} tokenPass={props.tokenPass} instanceid={''}/>
          </div>
        </div> }
    </div>
  );
}


//////////////////////
//Agents////
//////////////////////
function AgentsScreen(props) {
  const classes = useStyles();

  const [loadingAgents, setLoadingAgents] = useState(true)
  const [agents, setAgents] = useState([])
  const [addingAgent, setAddingAgent] = useState(false)

  const [dimensions, setDimensions] = useState({
    height: window.innerHeight,
    width: window.innerWidth
  });

  useEffect(() => {
    window.addEventListener('resize', handleResize)
    fetchAgents()
  },[])

  const handleResize = () => {
    setDimensions({
      height: window.innerHeight,
      width: window.innerWidth
    })
  }

  const fetchAgents = () => {
    setLoadingAgents(true)
    fetch('https://api.eyevinn.technology/agent/v1/agents', {})
  }

  const addAgent = () => {
  }

  const removeAgent = (agent) => {
  }

  return (
    <div>
      {loadingAgents ? <div>Loading Agents</div> :
        <div>
          <div style={{'width':dimensions.width, 'height':dimensions.height-200, 'float':'left'}}>
            <div class="scrollmenu">
              {agents.map((agent) => {return <div>
                                                  <div style={{height:'100px'}}>

                                                  </div>
                                                  </div>})}
            </div>
          </div>
        </div>}
      </div>
  );
}



//////////////////////
/////Calender////
//////////////////////
function CalendarScreen(props) {
  const classes = useStyles();

  const [loadingCalender, setLoadingCalender] = useState(true)
  const [selectedIntervals, setSelectedIntervals] = React.useState([]);
  const [lastUid, setLastUid] = React.useState(0);
  const [relativeWeek, setRelativeWeek] = React.useState(0);

  const [addingTask, setAddingTask] = React.useState(false);
  const [newTaskObject, setNewTaskObject] = React.useState({});
  const [taskName, setTaskName] = React.useState('');
  const [removingTask, setRemovingTask] = React.useState(false);

  const [fetchingPrototypeTasks, setFetchingPrototypeTasks] = useState(false);
  const [prototypeTasks, setPrototypeTasks] = useState([]);


  const [dimensions, setDimensions] = useState({ 
    height: window.innerHeight,
    width: window.innerWidth
  });

  useEffect(() => {
    window.addEventListener('resize', handleResize)
    fetchIntervals()
  }, [])
  

  const handleEventRemove = (event) => {
    //TODO: remove task instance in server and on positive callback remove it in the calender
    console.log('removed interval')
    const index = selectedIntervals.findIndex((interval) => interval.uid === event.uid);
    const newIntervals = [...selectedIntervals];
    if (index > -1) {
      newIntervals.splice(index, 1);
      setSelectedIntervals(newIntervals);
    }
    saveIntervals(newIntervals)
  }

  const handleEventUpdate = (event) => {
    //TODO: update task instance in server and on positive callback update it in the calender

    console.log('updated interval')
    const index = selectedIntervals.findIndex((interval) => interval.uid === event.uid);
    const newIntervals = [...selectedIntervals];
    if (index > -1) {
      newIntervals[index] = event;
      setSelectedIntervals(newIntervals);
    }
    saveIntervals(newIntervals)
    console.log(newIntervals)
  }

  const handleSelect = (newIntervals) => {
    console.log('selected interval')
    console.log(newIntervals)
    setAddingTask(true)
    setNewTaskObject(newIntervals)
  }


  const getPrototypeTasks = () => {
    setFetchingPrototypeTasks(true);
    fetch(SERVER_LINK + '/query_task_prototypes', {
      method: 'GET',
        headers: {
          Accept:'application/json',
          'Content-Type': 'application/json',
          'SimpTokAuth': props.tokenPass,
          'InputSearchText': taskName
        }
      }).then((response) => response.json())
        .then((data) => {Array.isArray(data) ? setPrototypeTasks(data) : console.log(data)})
        .catch((error) => console.log(error))
        .finally(() => {setFetchingPrototypeTasks(false)})
  }

  const addNewPrototypeTask = () => {
    fetch(SERVER_LINK + '/add_task_prototype', {
      method: 'POST',
        headers: { 
          Accept:'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          'idtoken': props.tokenPass,
          'taskname': taskName
        })
      }).then((response) => response.json())
        .then((data) => {if ((data!='NO_AUTH') && (data!='ERROR')) {addNewTaskInServer(data)} else {console.log(data)}})
        .catch((error) => console.log(error))
  }

  const addNewTaskInServer = (prototypeid) => {
    fetch(SERVER_LINK + '/schedule_task_instance', {
        method: 'POST',
          headers: {
            Accept:'application/json',
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            'idtoken': props.tokenPass,
            'taskname': taskName,
            'prototypeid': prototypeid,
            'start': newTaskObject[0].start.format('YYYY-MM-DD HH:mm:ss'),
            'end': newTaskObject[0].end.format('YYYY-MM-DD HH:mm:ss')
          })
        }).then((response) => response.json())
          .then((data) => {if ((data!='NO_AUTH') && (data!='ERROR') && Number.isInteger(data)) { addNewTaskInstanceToCalender(data) } else {console.log(data)}})
          .catch((error) => console.log(error))
  }

  const addNewTaskInstanceToCalender = (task_inst_id) => {


    const intervals = newTaskObject.map( (interval, index) => {

      return {
        ...interval,
        value: taskName,
        uid: task_inst_id
      }
    });


    setSelectedIntervals(selectedIntervals.concat(intervals));
    saveIntervals()
    setAddingTask(false)
  }

  const customEvent = (props) => {
    const currentDate = moment()
    if (currentDate.isBetween(props.start, props.end)) {
      return <div style={{'backgroundColor': 'gray', color: 'blue', height:'90%', width:'90%', overflow:'hidden'}}>{props.value}</div>
    } else {
      return <div style={{'backgroundColor': 'gray', color: 'black', height:'90%', width:'90%', overflow:'hidden'}}>{props.value}</div>
    }
  };

  const fetchIntervals = () => {
    setLoadingCalender(true)
    fetch(SERVER_LINK + '/load_calendar', {
      method: 'GET',
        headers: {
          Accept:'application/json',
          'Content-Type': 'application/json',
          'SimpTokAuth': props.tokenPass
        }
      }).then((response) => response.json())
        .then((data) => {data=='NO_CALENDAR'? console.log(data) : setIntervalsFromJSON((JSON.parse(data))) })
        .catch((error) => console.log(error))
        .finally(() => setLoadingCalender(false))
  }

  const setIntervalsFromJSON = (json) => {
    console.log('setting interval')
    console.log(json)
    const loaded_intervals = []
    for (let i = 0; i < json.length; i++) {
      const new_interval = {
        uid: json[i].uid,
        value: json[i].value,
        start: moment(json[i].start),
        end: moment(json[i].end) 
      }
      loaded_intervals.push(new_interval)
    }
    console.log(loaded_intervals)
    setSelectedIntervals(loaded_intervals)
    setLastUid(Math.max.apply(Math, loaded_intervals.map(function(o) { return o.uid+1; })))
    setLoadingCalender(false)
  }

  const saveIntervals = () => {
    fetch(SERVER_LINK + '/save_calender', {
      method: 'POST',
      headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
      },
      body: JSON.stringify({
          idtoken: props.tokenPass,
          calender_intervals: JSON.stringify(selectedIntervals)
      })
    }).then((response) => response.json())
      .then((data) => {if (data=='SUCCESS') {console.log('Calendar saved successfully! ')} else {console.log(data)}} )
      .catch((error) => console.log(error))
  }

  const handleResize = () => {
    setDimensions({
      height: window.innerHeight,
      width: window.innerWidth
    })
  }

  const handleEventClick = (event) => {
    console.log(event)
  }

  return (
    <div>
        <div style={{'height': 0.8*(dimensions.height-84), 'width': 0.8*dimensions.width}}>
          <Typography variant="caption">{relativeWeek}</Typography>
          <Button onClick={() => {setRelativeWeek(relativeWeek-1)}}>
            Last Week
          </Button>
          <Button onClick={() => {setRelativeWeek(relativeWeek+1)}}>
            Next Week
          </Button>
          <Button onClick={() => {setRelativeWeek(0)}}>
            This Week
          </Button>
          <Button onClick={() => {saveIntervals()}}>
            Save
          </Button>
          {loadingCalender ? 
          <div className="centeredBox">
            <CircularProgress/>
          </div> :
          <div>
          
          <WeekCalendar
                    firstDay={moment().startOf('week').subtract(-1*relativeWeek, 'week')}
                    startTime = {moment({h: 6, m: 0})}
                    endTime = {moment({h: 23, m: 30})}
                    numberOfDays= {7}
                    scaleUnit = {30}
                    selectedIntervals = {selectedIntervals}
                    headerCellComponent={CustomHeaderCell}
                    eventComponent={customEvent}
                    onEventClick={handleEventClick}
                    onIntervalSelect = {handleSelect}
                    onIntervalUpdate = {handleEventUpdate}
                    onIntervalRemove = {handleEventRemove}
                    useModal = {false}
            /> 
        
          </div>}
           <div>
            {/*
            <WeekCalender  beginningWeek={"2022-03-06"} 
                          
                          height={200} />
                          */}
          </div> 
            <div style={{height: 0.1*(dimensions.height-84)}}>
              <Button onClick={() => {saveIntervals(selectedIntervals)}}>Save</Button>
              <Button onClick={fetchIntervals}>Fetch</Button>
            </div>
        </div>
    
          
    <div>
      {addingTask ? <div className="infoi"> 
                      <div className="centeredBox"> 
                        <Button style={{'float': 'right'}}
                                onClick={() => {setAddingTask(false)}}>
                          <CloseIcon/>
                        </Button>
                        <h4>Type a task to schedule</h4>
                        <TextField id="outlined-basic" label="Task" variant="outlined" onChange={(e) => {setTaskName(e.target.value)}}/>
                        <Button onClick={getPrototypeTasks} >Search</Button>
                        <div>
                        <div style={{'height': '500px', 'overflow': 'scroll'}}>
                          <Button onClick={addNewPrototypeTask}> Crete new prototype </Button>
                          <p>or instantiate directly from the knowledge base..</p>
                          <Grid container
                                direction="column"
                                alignItems="stretch">
                                {prototypeTasks.map((prototype) => {
                                  return <SimpleTaskCard task={prototype}
                                                        clickCallback={() => {}} />
                                })}
                          </Grid>
                        </div>
                        

                        </div>
                        </div>
                        </div>: <div></div>}
      {removingTask ? <div className="infoi">
                        <div className="centeredBox">
                          <Button style={{'float': 'right'}}
                                  onClick={() => {setRemovingTask(false)}}>
                            <CloseIcon/>
                          </Button>
                          <h4>Are you sure you want to remove this task?</h4>
                          <Button onClick={() => {}}>Yes</Button>
                          <Button onClick={() => {}}>No</Button>
                        </div>
                      </div> : <div></div>}
    </div>
    </div>);
}



function AddTask(props) {
  const classes = useStyles();
  const [taskName, setTaskName] = useState('')
  const [taskStart, setTaskStart] = useState(new Date())
  const [taskEnd, setTaskEnd] = useState(new Date())
  const [taskRecurrent, setTaskRecurrent] = useState(false)



}








//Task base, prototypes, and past specifications
function TaskbaseScreen(props) {
  const classes = useStyles();

  const [dimensions, setDimensions] = useState({
    height: window.innerHeight,
    width: window.innerWidth
  });

  useEffect(() => {
    window.addEventListener('resize', handleResize)
  },[])

  const handleResize = () => {
    setDimensions({
      height: window.innerHeight,
      width: window.innerWidth
    })
  }

  return <div>
          <p>Here we show all task prototypes and their past specifications </p>
          <p>Search box for prototype</p>
          
          <p>Show tasks</p>
        </div>
}


//MOOD_KEYS = ["chill", "programming", "exercise", "cooking", "cleaning",
//    "reading", "meditation", "socializing", "working", "exploring", "writing",
//    "shopping", "capricious", "hungry", "thirsty", "fatigued", "sore", "ill",
//    "sad", "anxious", "tired", "stressed", "happy", "creative", "adventurous",
//    "studying", "researching", "planning", "organizing", "stretching", "outdoor",
//    "baking", "gardening", "family_time", "journaling", "storytelling", "music",
//    "gaming", "money", "bureaucracies", "maintenance", "teaching", "mentoring",
//    "volunteering", "self_care", "entertainment", "building", "tinkering",
//    "celebrating", "spiritual", "crafting", "errands", "admin", "paperwork", "chores"}
function TaskInfoBox(props) {
  const classes = useStyles();

  const [isMonday, setIsMonday] = useState(props.taskInfo.isMonday)
  const [isTuesday, setIsTuesday] = useState(props.taskInfo.isTuesday)
  const [isWednesday, setIsWednesday] = useState(props.taskInfo.isWednesday)
  const [isThursday, setIsThursday] = useState(props.taskInfo.isThursday)
  const [isFriday, setIsFriday] = useState(props.taskInfo.isFriday)
  const [isSaturday, setIsSaturday] = useState(props.taskInfo.isSaturday)
  const [isSunday, setIsSunday] = useState(props.taskInfo.isSunday)
  const [isHoliday, setIsHoliday] = useState(props.taskInfo.isHoliday)
  const [isEarlyMorning, setIsEarlyMorning] = useState(props.taskInfo.isEarlyMorning)
  const [isMorning, setIsMorning] = useState(props.taskInfo.isMorning)
  const [isLunch, setIsLunch] = useState(props.taskInfo.isLunch)
  const [isAfternoon, setIsAfternoon] = useState(props.taskInfo.isAfternoon)
  const [isDinner, setIsDinner] = useState(props.taskInfo.isDinner)
  const [isEvening, setIsEvening] = useState(props.taskInfo.isEvening)
  const [isNight, setIsNight] = useState(props.taskInfo.isNight)
  const [isSunny, setIsSunny] = useState(props.taskInfo.isSunny)
  const [isRainy, setIsRainy] = useState(props.taskInfo.isRainy)
  const [isCloudy, setIsCloudy] = useState(props.taskInfo.isCloudy)
  const [isSnowy, setIsSnowy] = useState(props.taskInfo.isSnowy)
  const [isWindy, setIsWindy] = useState(props.taskInfo.isWindy)
  const [isStormy, setIsStormy] = useState(props.taskInfo.isStormy)
  const [isFoggy, setIsFoggy] = useState(props.taskInfo.isFoggy)
  const [chill, setIsChill] = useState(props.taskInfo.chill)
  const [programming, setIsProgramming] = useState(props.taskInfo.programming)
  const [exercise, setIsExercise] = useState(props.taskInfo.exercise)
  const [cooking, setIsCooking] = useState(props.taskInfo.cooking)
  const [cleaning, setIsCleaning] = useState(props.taskInfo.cleaning)
  const [reading, setIsReading] = useState(props.taskInfo.reading)
  const [meditation, setIsMeditation] = useState(props.taskInfo.meditation)
  const [socializing, setIsSocializing] = useState(props.taskInfo.socializing)
  const [working, setIsWorking] = useState(props.taskInfo.working)
  const [exploring, setIsExploring] = useState(props.taskInfo.exploring)
  const [writing, setIsWriting] = useState(props.taskInfo.writing)
  const [shopping, setIsShopping] = useState(props.taskInfo.shopping)
  const [capricious, setIsCapricious] = useState(props.taskInfo.capricious)
  const [hungry, setIsHungry] = useState(props.taskInfo.hungry)
  const [thirsty, setIsThirsty] = useState(props.taskInfo.thirsty)
  const [fatigued, setIsFatigued] = useState(props.taskInfo.fatigued)
  const [sore, setIsSore] = useState(props.taskInfo.sore)
  const [ill, setIsIll] = useState(props.taskInfo.ill)
  const [sad, setIsSad] = useState(props.taskInfo.sad)
  const [anxious, setIsAnxious] = useState(props.taskInfo.anxious)
  const [tired, setIsTired] = useState(props.taskInfo.tired)
  const [stressed, setIsStressed] = useState(props.taskInfo.stressed)
  const [happy, setIsHappy] = useState(props.taskInfo.happy)
  const [creative, setIsCreative] = useState(props.taskInfo.creative)
  const [adventurous, setIsAdventurous] = useState(props.taskInfo.adventurous)
  const [studying, setIsStudying] = useState(props.taskInfo.studying)
  const [researching, setIsResearching] = useState(props.taskInfo.researching)
  const [planning, setIsPlanning] = useState(props.taskInfo.planning)
  const [organizing, setIsOrganizing] = useState(props.taskInfo.organizing)
  const [stretching, setIsStretching] = useState(props.taskInfo.stretching)
  const [outdoor, setIsOutdoor] = useState(props.taskInfo.outdoor)
  const [baking, setIsBaking] = useState(props.taskInfo.baking)
  const [gardening, setIsGardening] = useState(props.taskInfo.gardening)
  const [family_time, setIsFamilyTime] = useState(props.taskInfo.family_time)
  const [journaling, setIsJournaling] = useState(props.taskInfo.journaling)
  const [storytelling, setIsStorytelling] = useState(props.taskInfo.storytelling)
  const [music, setIsMusic] = useState(props.taskInfo.music)
  const [gaming, setIsGaming] = useState(props.taskInfo.gaming)
  const [money, setIsMoney] = useState(props.taskInfo.money)
  const [bureaucracies, setIsBureaucracies] = useState(props.taskInfo.bureaucracies)
  const [maintenance, setIsMaintenance] = useState(props.taskInfo.maintenance)
  const [teaching, setIsTeaching] = useState(props.taskInfo.teaching)
  const [mentoring, setIsMentoring] = useState(props.taskInfo.mentoring)
  const [volunteering, setIsVolunteering] = useState(props.taskInfo.volunteering)
  const [self_care, setIsSelfCare] = useState(props.taskInfo.self_care)
  const [entertainment, setIsEntertainment] = useState(props.taskInfo.entertainment)
  const [building, setIsBuilding] = useState(props.taskInfo.building)
  const [tinkering, setIsTinkering] = useState(props.taskInfo.tinkering)
  const [celebrating, setIsCelebrating] = useState(props.taskInfo.celebrating)
  const [spiritual, setIsSpiritual] = useState(props.taskInfo.spiritual)
  const [crafting, setIsCrafting] = useState(props.taskInfo.crafting)
  const [errands, setIsErrands] = useState(props.taskInfo.errands)
  const [admin, setIsAdmin] = useState(props.taskInfo.admin)
  const [paperwork, setIsPaperwork] = useState(props.taskInfo.paperwork)
  const [chores, setIsChores] = useState(props.taskInfo.chores)

  const saveIdealState = () => {
    const ideal_state = {
      isMonday: isMonday,
      isTuesday: isTuesday,
      isWednesday: isWednesday,
      isThursday: isThursday,
      isFriday: isFriday,
      isSaturday: isSaturday,
      isSunday: isSunday,
      isHoliday: isHoliday,
      isEarlyMorning: isEarlyMorning,
      isMorning: isMorning,
      isLunch: isLunch,
      isAfternoon: isAfternoon,
      isDinner: isDinner,
      isEvening: isEvening,
      isNight: isNight,
      isSunny: isSunny,
      isRainy: isRainy,
      isCloudy: isCloudy,
      isSnowy: isSnowy,
      isWindy: isWindy,
      isStormy: isStormy,
      isFoggy: isFoggy,
      chill: chill,
      programming: programming,
      exercise: exercise,
      cooking: cooking,
      cleaning: cleaning,
      reading: reading,
      meditation: meditation,
      socializing: socializing,
      working: working,
      exploring: exploring,
      writing: writing,
      shopping: shopping,
      capricious: capricious,
      hungry: hungry,
      thirsty: thirsty,
      fatigued: fatigued,
      sore: sore,
      ill: ill,
      sad: sad,
      anxious: anxious,
      tired: tired,
      stressed: stressed,
      happy: happy,
      creative: creative,
      adventurous: adventurous,
      studying: studying,
      researching: researching,
      planning: planning,
      organizing: organizing,
      stretching: stretching,
      outdoor: outdoor,
      baking: baking,
      gardening: gardening,
      family_time: family_time,
      journaling: journaling,
      storytelling: storytelling,
      music: music,
      gaming: gaming,
      money: money,
      bureaucracies: bureaucracies,
      maintenance: maintenance,
      teaching: teaching,
      mentoring: mentoring,
      volunteering: volunteering,
      self_care: self_care,
      entertainment: entertainment,
      building: building,
      tinkering: tinkering,
      celebrating: celebrating,
      spiritual: spiritual,
      crafting: crafting,
      errands: errands,
      admin: admin,
      paperwork: paperwork,
      chores: chores
    }
    props.onSave(ideal_state)
  }

  return (
    props.fetchingTaskInfo ? <CircularProgress /> :
    <div>
      <Button style={{'float': 'right'}}
              onClick={props.onClose}>
        <CloseIcon/>
      </Button>
      <Button onClick={props.onDelete}>
        Delete Task
      </Button>
      <h3>Task Info</h3>
      <p>Task Name: {props.taskInfo.name}</p>
      <p>Task Description: {props.taskInfo.description}</p>
      <p>Task Duration: {props.taskInfo.duration} mins</p>
      <p>Task Frequency: {props.taskInfo.frequency} hours</p>
      <p>Task Search Text: {props.taskInfo.task_search_text}</p>
      <h5>Task Ideal State: </h5>
      <p>Monday: <Checkbox checked={isMonday} onChange={(e) => setIsMonday(e.target.checked)} /></p>
      <p>Tuesday: <Checkbox checked={isTuesday} onChange={(e) => setIsTuesday(e.target.checked)} /></p>
      <p>Wednesday: <Checkbox checked={isWednesday} onChange={(e) => setIsWednesday(e.target.checked)} /></p>
      <p>Thursday: <Checkbox checked={isThursday} onChange={(e) => setIsThursday(e.target.checked)} /></p>
      <p>Friday: <Checkbox checked={isFriday} onChange={(e) => setIsFriday(e.target.checked)} /></p>
      <p>Saturday: <Checkbox checked={isSaturday} onChange={(e) => setIsSaturday(e.target.checked)} /></p>
      <p>Sunday: <Checkbox checked={isSunday} onChange={(e) => setIsSunday(e.target.checked)} /></p>
      <p>holiday: <Checkbox checked={isHoliday} onChange={(e) => setIsHoliday(e.target.checked)} /></p>
      <p>early_morning: <Checkbox checked={isEarlyMorning} onChange={(e) => setIsEarlyMorning(e.target.checked)} /></p>
      <p>morning: <Checkbox checked={isMorning} onChange={(e) => setIsMorning(e.target.checked)} /></p>
      <p>lunchtime: <Checkbox checked={isLunch} onChange={(e) => setIsLunch(e.target.checked)} /></p>
      <p>afternoon: <Checkbox checked={isAfternoon} onChange={(e) => setIsAfternoon(e.target.checked)} /></p>
      <p>dinner: <Checkbox checked={isDinner} onChange={(e) => setIsDinner(e.target.checked)} /></p>
      <p>evening: <Checkbox checked={isEvening} onChange={(e) => setIsEvening(e.target.checked)} /></p>
      <p>night: <Checkbox checked={isNight} onChange={(e) => setIsNight(e.target.checked)} /></p>
      <p>sunny: <Checkbox checked={isSunny} onChange={(e) => setIsSunny(e.target.checked)} /></p>
      <p>rainy: <Checkbox checked={isRainy} onChange={(e) => setIsRainy(e.target.checked)} /></p>
      <p>cloudy: <Checkbox checked={isCloudy} onChange={(e) => setIsCloudy(e.target.checked)} /></p>
      <p>snowy: <Checkbox checked={isSnowy} onChange={(e) => setIsSnowy(e.target.checked)} /></p>
      <p>windy: <Checkbox checked={isWindy} onChange={(e) => setIsWindy(e.target.checked)} /></p>
      <p>stormy: <Checkbox checked={isStormy} onChange={(e) => setIsStormy(e.target.checked)} /></p>
      <p>foggy: <Checkbox checked={isFoggy} onChange={(e) => setIsFoggy(e.target.checked)} /></p>
      <p>chill: <Checkbox checked={chill} onChange={(e) => setIsChill(e.target.checked)} /></p>
      <p>programming: <Checkbox checked={programming} onChange={(e) => setIsProgramming(e.target.checked)} /></p>
      <p>exercise: <Checkbox checked={exercise} onChange={(e) => setIsExercise(e.target.checked)} /></p>
      <p>cooking: <Checkbox checked={cooking} onChange={(e) => setIsCooking(e.target.checked)} /></p>
      <p>cleaning: <Checkbox checked={cleaning} onChange={(e) => setIsCleaning(e.target.checked)} /></p>
      <p>reading: <Checkbox checked={reading} onChange={(e) => setIsReading(e.target.checked)} /></p>
      <p>meditation: <Checkbox checked={meditation} onChange={(e) => setIsMeditation(e.target.checked)} /></p>
      <p>socializing: <Checkbox checked={socializing} onChange={(e) => setIsSocializing(e.target.checked)} /></p>
      <p>working: <Checkbox checked={working} onChange={(e) => setIsWorking(e.target.checked)} /></p>
      <p>exploring: <Checkbox checked={exploring} onChange={(e) => setIsExploring(e.target.checked)} /></p>
      <p>writing: <Checkbox checked={writing} onChange={(e) => setIsWriting(e.target.checked)} /></p>
      <p>shopping: <Checkbox checked={shopping} onChange={(e) => setIsShopping(e.target.checked)} /></p>  
      <p>capricious: <Checkbox checked={capricious} onChange={(e) => setIsCapricious(e.target.checked)} /></p>
      <p>hungry: <Checkbox checked={hungry} onChange={(e) => setIsHungry(e.target.checked)} /></p>
      <p>thirsty: <Checkbox checked={thirsty} onChange={(e) => setIsThirsty(e.target.checked)} /></p>
      <p>fatigued: <Checkbox checked={fatigued} onChange={(e) => setIsFatigued(e.target.checked)} /></p>
      <p>sore: <Checkbox checked={sore} onChange={(e) => setIsSore(e.target.checked)} /></p>
      <p>ill: <Checkbox checked={ill} onChange={(e) => setIsIll(e.target.checked)} /></p>
      <p>sad: <Checkbox checked={sad} onChange={(e) => setIsSad(e.target.checked)} /></p>
      <p>anxious: <Checkbox checked={anxious} onChange={(e) => setIsAnxious(e.target.checked)} /></p>
      <p>tired: <Checkbox checked={tired} onChange={(e) => setIsTired(e.target.checked)} /></p>
      <p>stressed: <Checkbox checked={stressed} onChange={(e) => setIsStressed(e.target.checked)} /></p>
      <p>happy: <Checkbox checked={happy} onChange={(e) => setIsHappy(e.target.checked)} /></p>
      <p>creative: <Checkbox checked={creative} onChange={(e) => setIsCreative(e.target.checked)} /></p>
      <p>adventurous: <Checkbox checked={adventurous} onChange={(e) => setIsAdventurous(e.target.checked)} /></p>
      <p>studying: <Checkbox checked={studying} onChange={(e) => setIsStudying(e.target.checked)} /></p>
      <p>researching: <Checkbox checked={researching} onChange={(e) => setIsResearching(e.target.checked)} /></p>
      <p>planning: <Checkbox checked={planning} onChange={(e) => setIsPlanning(e.target.checked)} /></p>
      <p>organizing: <Checkbox checked={organizing} onChange={(e) => setIsOrganizing(e.target.checked)} /></p>
      <p>stretching: <Checkbox checked={stretching} onChange={(e) => setIsStretching(e.target.checked)} /></p>
      <p>outdoor: <Checkbox checked={outdoor} onChange={(e) => setIsOutdoor(e.target.checked)} /></p>
      <p>baking: <Checkbox checked={baking} onChange={(e) => setIsBaking(e.target.checked)} /></p>
      <p>gardening: <Checkbox checked={gardening} onChange={(e) => setIsGardening(e.target.checked)} /></p>
      <p>family_time: <Checkbox checked={family_time} onChange={(e) => setIsFamilyTime(e.target.checked)} /></p>
      <p>journaling: <Checkbox checked={journaling} onChange={(e) => setIsJournaling(e.target.checked)} /></p>
      <p>storytelling: <Checkbox checked={storytelling} onChange={(e) => setIsStorytelling(e.target.checked)} /></p>
      <p>music: <Checkbox checked={music} onChange={(e) => setIsMusic(e.target.checked)} /></p>
      <p>gaming: <Checkbox checked={gaming} onChange={(e) => setIsGaming(e.target.checked)} /></p>
      <p>money: <Checkbox checked={money} onChange={(e) => setIsMoney(e.target.checked)} /></p>
      <p>bureaucracies: <Checkbox checked={bureaucracies} onChange={(e) => setIsBureaucracies(e.target.checked)} /></p>
      <p>maintenance: <Checkbox checked={maintenance} onChange={(e) => setIsMaintenance(e.target.checked)} /></p>
      <p>teaching: <Checkbox checked={teaching} onChange={(e) => setIsTeaching(e.target.checked)} /></p>
      <p>mentoring: <Checkbox checked={mentoring} onChange={(e) => setIsMentoring(e.target.checked)} /></p>
      <p>volunteering: <Checkbox checked={volunteering} onChange={(e) => setIsVolunteering(e.target.checked)} /></p>
      <p>self_care: <Checkbox checked={self_care} onChange={(e) => setIsSelfCare(e.target.checked)} /></p>
      <p>entertainment: <Checkbox checked={entertainment} onChange={(e) => setIsEntertainment(e.target.checked)} /></p>
      <p>building: <Checkbox checked={building} onChange={(e) => setIsBuilding(e.target.checked)} /></p>
      <p>tinkering: <Checkbox checked={tinkering} onChange={(e) => setIsTinkering(e.target.checked)} /></p>
      <p>celebrating: <Checkbox checked={celebrating} onChange={(e) => setIsCelebrating(e.target.checked)} /></p>
      <p>spiritual: <Checkbox checked={spiritual} onChange={(e) => setIsSpiritual(e.target.checked)} /></p>
      <p>crafting: <Checkbox checked={crafting} onChange={(e) => setIsCrafting(e.target.checked)} /></p>
      <p>errands: <Checkbox checked={errands} onChange={(e) => setIsErrands(e.target.checked)} /></p>
      <p>admin: <Checkbox checked={admin} onChange={(e) => setIsAdmin(e.target.checked)} /></p>
      <p>paperwork: <Checkbox checked={paperwork} onChange={(e) => setIsPaperwork(e.target.checked)} /></p>
      <p>chores: <Checkbox checked={chores} onChange={(e) => setIsChores(e.target.checked)} /></p>
      <Button onClick={saveIdealState}>
        Save Changes
      </Button>

    </div>
  );
}




function PlannerScreen(props) {

  const [goals, setGoals] = useState([])
  const [fetchingGoals, setFetchingGoals] = useState(true)
  const [currentSelectedGoalId, setCurrentSelectedGoalId] = useState('')
  const [currentSelectedGoalName, setCurrentSelectedGoalName] = useState('')
  const [currentSelectedGoalDescription, setCurrentSelectedGoalDescription] = useState('')
  const [currentSelectedGoalUserPrompt, setCurrentSelectedGoalUserPrompt] = useState('')
  
  const [addingGoal, setAddingGoal] = useState(false)
  const [newGoalDescription, setNewGoalDescription] = useState('')
  const [goalDescriptionSubmitted, setGoalDescriptionSubmitted] = useState(false)
  const [fetchingQuestions, setFetchingQuestions] = useState(false)
  const [questions, setQuestions] = useState([])
  const [addingGoalServer, setAddingGoalServer] = useState(false)
  const [numberMetricsToReccommend, setNumberMetricsToReccommend] = useState(3) //num of tasks = *3

  const [editingGoal, setEditingGoal] = useState(false)
  const [editingGoalName, setEditingGoalName] = useState('')
  const [editingGoalServer, setEditingGoalServer] = useState(false)

  const [fetchingTasks, setFetchingTasks] = useState(false)
  const [tasks, setTasks] = useState([])
  const [selectedTasks, setSelectedTasks] = useState([])
  const [taskInfoBoxOpen, setTaskInfoBoxOpen] = useState(false)
  const [currentlySelectedTask, setCurrentlySelectedTask] = useState(null)
  const [fetchingTaskInfo, setFetchingTaskInfo] = useState(true)
  const [taskInfo, setTaskInfo] = useState(null)
  const [addingTask, setAddingTask] = useState(false)
  const [newTaskDescription, setNewTaskDescription] = useState('')
  const [addingTaskServer, setAddingTaskServer] = useState(false)

  const [fetchingMetrics, setFetchingMetrics] = useState(false)
  const [metrics, setMetrics] = useState([])
  const [currentlySelectedMetric, setCurrentlySelectedMetric] = useState(null)
  const [addingNewMetric, setAddingNewMetric] = useState(false)
  const [newMetricDescription, setNewMetricDescription] = useState('')
  const [addingMetricServer, setAddingMetricServer] = useState(false)

  const [dimensions, setDimensions] = useState({ 
    height: window.innerHeight,
    width: window.innerWidth
  })


  const handleResize = () => {
    setDimensions({
      height: window.innerHeight,
      width: window.innerWidth
    }) 
  }

  useEffect(() => {
    window.addEventListener('resize', handleResize)
    getGoals()
  }, [])

  const getGoals = () => {
    setFetchingGoals(true)
    fetch(SERVER_LINK + '/get_goals', {
      method: 'GET',
        headers: {
          Accept:'application/json',
          'Content-Type': 'application/json',
          'SimpTokAuth': props.tokenPass
        }
      }).then((response) => response.json())
        .then((data) => {Array.isArray(data) ? setGoals(data) : console.log(data)})
        .catch((error) => console.log(error))
        .finally(() => setFetchingGoals(false))
  }

  const getGoalsAndSelect = (goalid) => {
    setFetchingGoals(true)
    fetch(SERVER_LINK + '/get_goals', {
      method: 'GET',
        headers: {
          Accept:'application/json',
          'Content-Type': 'application/json',
          'SimpTokAuth': props.tokenPass
        }
      }).then((response) => response.json())
        .then((data) => { if (Array.isArray(data)) {setGoals(data); const goalToSelect = data.find(g => g.id === goalid); selectGoal(goalToSelect)} else {console.log(data)}})
        .catch((error) => console.log(error))
        .finally(() => setFetchingGoals(false))
  }

  const submitGoalDescription = () => {
    setGoalDescriptionSubmitted(true)
    setFetchingQuestions(true)
    fetch(SERVER_LINK + '/get_goal_questions', {
      method: 'POST',
        headers: {
          Accept:'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          'idtoken': props.tokenPass,
          'goal_text': newGoalDescription,
        })
      }).then((response) => response.json())
        .then((data) => {Array.isArray(data) ? setQuestions(data) : console.log(data)})
        .catch((error) => console.log(error))
        .finally(() => setFetchingQuestions(false))
  }

  const addGoal = () => {
    setAddingGoalServer(true)
    fetch(SERVER_LINK + '/add_goal', {
      method: 'POST',
        headers: {
          Accept:'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          'idtoken': props.tokenPass,
          'goal_text': newGoalDescription,
          'num_metrics': numberMetricsToReccommend
        })
      }).then((response) => response.json())
        .then((data) => {if (parseInt(data)) {getGoals(); }})
        .catch((error) => console.log(error))
        .finally(() => {closeAddGoalBox();})
  }

  const saveEditedGoal = () => {
    setEditingGoalServer(true)
    fetch(SERVER_LINK + '/edit_goal', {
      method: 'POST',
        headers: {
          Accept:'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          'idtoken': props.tokenPass,
          'goalid': currentSelectedGoalId,
          'new_goal_text': editingGoalName,
          'num_metrics': numberMetricsToReccommend
        })
      }).then((response) => response.json())
        .then((data) => {if (data=='SUCCESS') {getGoalsAndSelect(currentSelectedGoalId); } else {alert('Error editing goal. Please try again with a different goal description or number of metrics'); console.log(data)}})
        .catch((error) => console.log(error))
        .finally(() => {setEditingGoal(false); setEditingGoalName(''); setEditingGoalServer(false);})
  }

  const addMetric = () => {
    setAddingMetricServer(true)
    fetch(SERVER_LINK + '/add_metric', {
      method: 'POST',
        headers: {
          Accept:'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          'idtoken': props.tokenPass,
          'goal': currentSelectedGoalName,
          'goalid': currentSelectedGoalId,
          'metric_text': newMetricDescription,
        })
      }).then((response) => response.json())
        .then((data) => {if (data=='SUCCESS') {fetchMetricsForGoal(currentSelectedGoalId); setAddingMetricServer(false);} else {alert('Error adding metric. Please try again with a different metric description'); console.log(data)}})
        .catch((error) => console.log(error))
        .finally(() => {closeAddMetricBox();})
  }

  const addTask = () => {
    setAddingTaskServer(true)
    fetch(SERVER_LINK + '/add_state_task', {
      method: 'POST',
        headers: {
          Accept:'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          'idtoken': props.tokenPass,
          'goal': currentSelectedGoalName,
          'goalid': currentSelectedGoalId,
          'task_text': newTaskDescription,
        })
      }).then((response) => response.json())
        .then((data) => {if (parseInt(data)) {fetchTasksForGoal(currentSelectedGoalId); openTaskInfoBox(data)} else {alert('Error adding task. Please try again with a different task description'); console.log(data)}})
        .catch((error) => console.log(error))
        .finally(() => {closeAddTaskBox();} )
  }

  const deleteTask = (taskid) => {
  fetch(SERVER_LINK + '/delete_state_task', {
    method: 'POST',
      headers: {
        Accept:'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        'idtoken': props.tokenPass,
        'goalid': currentSelectedGoalId,
        'taskid': taskid
      })
    }).then((response) => response.json())
      .then((data) => {if (data=='SUCCESS') {fetchTasksForGoal(currentSelectedGoalId); }})
      .catch((error) => console.log(error))
      .finally(() => {setTaskInfoBoxOpen(false); setCurrentlySelectedTask(null); setTaskInfo(null);} )
  }


  const deleteGoal = () => {
  setCurrentSelectedGoalId('')
  setCurrentSelectedGoalName('')
  setFetchingGoals(true)
  fetch(SERVER_LINK + '/delete_goal', {
    method: 'POST',
      headers: {
        Accept:'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        'idtoken': props.tokenPass,
        'goalid': currentSelectedGoalId,
      })
    }).then((response) => response.json())
      .then((data) => {if (data=='SUCCESS') {setCurrentSelectedGoalId(''); setCurrentSelectedGoalName(''); setTasks([]); setMetrics([]); getGoals()}})
      .catch((error) => console.log(error))
  }


  const closeAddGoalBox = () => {
    setAddingGoal(false); 
    setNewGoalDescription('');
    setGoalDescriptionSubmitted(false);
    setQuestions([]);
    setAddingGoalServer(false);
    setFetchingQuestions(false);
  }

  const closeAddMetricBox = () => {
    setAddingNewMetric(false);
    setNewMetricDescription('');
    setAddingMetricServer(false);
  }

  const closeAddTaskBox = () => {
    setAddingTask(false);
    setNewTaskDescription('');
    setAddingTaskServer(false);
  }



  const selectGoal = (goal) => {
    fetchTasksForGoal(goal.id); 
    fetchMetricsForGoal(goal.id);
    setCurrentSelectedGoalId(goal.id); 
    setCurrentSelectedGoalName(goal.name);
    setCurrentSelectedGoalDescription(goal.description);
    setCurrentSelectedGoalUserPrompt(goal.user_prompt);
    setCurrentlySelectedTask(null);
    setTaskInfoBoxOpen(false);
    setTaskInfo(null);

  }
  


  const fetchTasksForGoal = (goalid) => {
    setFetchingTasks(true)
    fetch(SERVER_LINK + '/get_tasks_for_goal', {
      method: 'GET',
        headers: {
          Accept:'application/json',
          'Content-Type': 'application/json',
          'SimpTokAuth': props.tokenPass,
          'GoalID': goalid
        }
      }).then((response) => response.json())
        .then((data) => {console.log(data); setTasks(data)})
        .catch((error) => console.log(error))
        .finally(() => {setFetchingTasks(false); setSelectedTasks([])})

  }

  const fetchMetricsForGoal = (goalid) => {
    setFetchingMetrics(true)
    fetch(SERVER_LINK + '/get_metrics_for_goal', {
      method: 'GET',
        headers: {
          Accept:'application/json',
          'Content-Type': 'application/json',
          'SimpTokAuth': props.tokenPass,
          'GoalID': goalid
        }
      }).then((response) => response.json())
        .then((data) => {if (Array.isArray(data)) { setMetrics(data); if (currentlySelectedMetric) { setCurrentlySelectedMetric(data.find((metric) => metric.id === currentlySelectedMetric.id)) }} else {console.log(data)}})
        .catch((error) => console.log(error))
        .finally(() => {setFetchingMetrics(false);})
    }

  const fetchTaskInfo = (taskid) => {
    setFetchingTaskInfo(true)
    fetch(SERVER_LINK + '/get_task_info', {
      method: 'GET',
        headers: {
          Accept:'application/json',
          'Content-Type': 'application/json',
          'SimpTokAuth': props.tokenPass,
          'TaskID': JSON.stringify(taskid)
        }
      }).then((response) => response.json())
        .then((data) => { setTaskInfo(data); } )
        .catch((error) => console.log(error))
        .finally(() => {setFetchingTaskInfo(false);})
  }

  const saveTaskInfo = (ideal_state) => {
    fetch(SERVER_LINK + '/set_task_ideal_state', {
      method: 'POST',
        headers: {
          Accept:'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          'idtoken': props.tokenPass,
          'taskid': currentlySelectedTask,
          'ideal_state': ideal_state
        })
      }).then((response) => response.json())
        .then((data) => {if (data=='SUCCESS') {fetchTaskInfo(currentlySelectedTask); }})
        .catch((error) => console.log(error))
  }

  const openTaskInfoBox = (state_task_id) => {
    setCurrentlySelectedTask(state_task_id)
    fetchTaskInfo(state_task_id)
    setTaskInfoBoxOpen(true)
  }
    

  

  
  
  return (<div style={{'overflow': 'hidden'}}>
            <div
                className="side-bar-graph-goals"
                style={{
                  height: dimensions.height - 88,
                  overflowY: "auto",
                  overflowX: "hidden",
                  paddingTop: 0,
                  paddingBottom: 12,
                  paddingLeft: 12,
                  paddingRight: 12,
                  background: "#f7f8fa",
                }}
              >
                {/* Header */}
                <div
                      style={{
                        position: "sticky",
                        top: 0,
                        zIndex: 20,

                        // IMPORTANT: must be opaque to hide content behind it
                        background: "#f7f8fa",

                        // give it a little "surface" feel
                        paddingTop: 8,
                        paddingBottom: 10,
                        marginLeft: -12,   // extend to container edges (since container has padding)
                        marginRight: -12,
                        paddingLeft: 12,
                        paddingRight: 12,

                        borderBottom: "1px solid rgba(0,0,0,0.08)",
                        boxShadow: "0 6px 12px rgba(0,0,0,0.04)",
                      }}
                    >
                  <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                    <Typography
                      style={{
                        fontWeight: 800,
                        fontSize: 14,
                        color: "#111",
                      }}
                    >
                      Goals
                    </Typography>

                    <div style={{ flex: 1 }} />

                    <Button
                      variant="contained"
                      size="small"
                      onClick={() => setAddingGoal(true)}
                      style={{
                        borderRadius: 999,
                        textTransform: "none",
                        fontWeight: 700,
                        boxShadow: "none",
                      }}
                    >
                      Add Goal
                    </Button>
                  </div>
                </div>

                {fetchingGoals ? (
                  <div style={{ display: "flex", justifyContent: "center", padding: 20 }}>
                    <CircularProgress size={24} />
                  </div>
                ) : (
                  <List style={{ paddingTop: 10 }}>
                    {goals.map((goal) => (
                      <SimpleGoalCard
                        key={goal.id}
                        goal={goal}
                        onSelection={() => selectGoal(goal)}
                        selected={goal.id === currentSelectedGoalId}
                      />
                    ))}
                  </List>
                )}
              </div>
            {currentSelectedGoalId == '' ? <div>
              <Typography variant='h4' align='center' style={{'marginTop': '200px'}}> Select or add a goal </Typography>
            </div> :
              <div >

                {currentlySelectedMetric == null ?
                <div>
                <div
                    style={{
                      position: "absolute",
                      left: 325,
                      height: 100,
                      width: dimensions.width - 357,
                      backgroundColor: "#fff",
                      borderBottom: "1px solid rgba(0,0,0,0.12)",
                      display: "flex",
                      justifyContent: "center",
                      paddingLeft: 16,
                      paddingRight: 16,
                      boxShadow: "0 1px 0 rgba(0,0,0,0.04)",
                      zIndex: 10,
                    }}
                  >
                    {/* Title */}
                    <Typography
                      variant="h5"
                      style={{
                        fontWeight: 900,
                        letterSpacing: "-0.2px",
                        maxWidth: "70%",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        paddingTop: 8,
                      }}
                    >
                      {currentSelectedGoalName}
                    </Typography>

                    {/* Description */}
                    <Typography
                      variant="body2"
                      align="center"
                      color="textSecondary"
                      style={{
                        position: "absolute",
                        top: 44,
                        left: 200,
                        right: 200,
                        fontStyle: "italic",
                        maxHeight: 40,
                        overflow: "hidden",
                        display: "-webkit-box",
                        WebkitBoxOrient: "vertical",
                        WebkitLineClamp: 3,   // ✅ TWO lines
                        wordBreak: "break-word",
                        overflowWrap: "anywhere",
                      }}
                    >
                      {currentSelectedGoalDescription}
                    </Typography>

                    {/* Left action */}
                    <div
                      style={{
                        position: "absolute",
                        left: 16,
                        bottom: 16,
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <Button
                        variant="outlined"
                        color="primary"
                        style={{
                          borderRadius: 999,
                          textTransform: "none",
                          fontWeight: 800,
                          paddingLeft: 16,
                          paddingRight: 16,
                        }}
                        onClick={() => {setEditingGoal(true); setEditingGoalName(currentSelectedGoalUserPrompt);}}
                      >
                        Edit goal
                      </Button>
                    </div>

                    {/* Right action */}
                    <div
                      style={{
                        position: "absolute",
                        right: 16,
                        bottom: 16,
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <Button
                        variant="contained"
                        color="secondary"
                        style={{
                          borderRadius: 999,
                          textTransform: "none",
                          fontWeight: 900,
                          paddingLeft: 18,
                          paddingRight: 18,
                        }}
                        onClick={() => {
                          if (
                            window.confirm(
                              "Are you sure you want to delete this goal? This action cannot be reversed."
                            )
                          ) {
                            deleteGoal();
                          }
                        }}
                      >
                        Delete goal
                      </Button>
                    </div>

                    

                  </div>
                  <div style={{'height': dimensions.height - 84 - 100, 'width': '350px', 'position': 'absolute', 'left': '325px', 'top': '184px', 'overflow': 'scroll'}}>
                      <Typography variant='h5' align='center'> Tasks </Typography>
                      {fetchingTasks ? <CircularProgress /> :
                         (taskInfoBoxOpen ? 
                            (fetchingTaskInfo ? <CircularProgress /> :
                                      <TaskInfoBox 
                                              taskId={currentlySelectedTask}
                                              taskInfo={taskInfo}
                                              onClose={() => {setTaskInfoBoxOpen(false); setCurrentlySelectedTask(null);
                                              setTaskInfo(null);}}
                                              onDelete={() => {if (window.confirm('Are you sure you want to delete this task?')) { deleteTask(currentlySelectedTask); }}} 
                                              onSave={saveTaskInfo} /> ) 

                                  :

                      <div style={{display: 'grid', gap: 16, padding: 16}}>
                            {tasks.map((task) => (<StateTaskCard task={task} onClick={() => {openTaskInfoBox(task.id)}} /> ))}
                            <Card    sx={{
                                      mb: 1,
                                      borderRadius: 2,
                                      transition: '0.2s',
                                      '&:hover': {
                                        boxShadow: 6,
                                        transform: 'translateY(-1px)',
                                      },
                                    }}
                                  >
                                    <CardActionArea onClick={() => {setAddingTask(true)}}>
                                      <CardContent sx={{ pb: 1 }}>
                                        <Typography
                                            variant="body2"
                                            color="text.secondary"
                                            sx={{
                                              mt: 1,
                                              whiteSpace: 'pre-line',
                                            }}
                                          >
                                            ADD TASK
                                          </Typography>
                                      </CardContent>
                                    </CardActionArea>
                                  </Card></div>)}
                  </div>
                  <div style={{'width': dimensions.width - 700, 'height': dimensions.height - 84 - 100, 'position': 'absolute', 'left': '700px', 'top': '184px', 'overflow': 'scroll'}}>
                      <Typography variant='h5' align='center'> Metrics </Typography>
                      {fetchingMetrics ? <CircularProgress /> :
                                <div class="grid-container-small">
                                  {metrics.map((metric) => {
                                    return <MetricCard metric={metric} onSelect={(m) => {setCurrentlySelectedMetric(m)}} />
                                  })}
                                  <Card style={{'width':'200px', 'height':'200px', 'margin':'auto'}}>
                                    <CardActionArea onClick={() => {setAddingNewMetric(true)}} style={{width: '100%', height: '100%'}}>
                                      <Typography variant='h4' align="center" style={{width: '200px', height: '200px'}}>ADD NEW METRIC</Typography>
                                    </CardActionArea>
                                  </Card> 
                                </div>}
                  </div> 
                  </div>
                : <SelectedMetricScreen metric={currentlySelectedMetric} setCurrentlySelectedMetric={setCurrentlySelectedMetric} reloadMetrics={() => {getGoals(); fetchMetricsForGoal(currentSelectedGoalId)}} tokenPass={props.tokenPass}/> }
                  </div>}
            
            {addingGoal ? <div className="infoi"> 
                              <div className="centeredBox"> 
                                {addingGoalServer ? 
                                    <><CircularProgress /> <p> Creating plan ... This might take a while ...</p> <p>Please do not refresh or close the page / window</p></> : 
                                    
                                    
                                    <div>
                                      <Button style={{'float': 'right'}}
                                              onClick={closeAddGoalBox}>
                                        <CloseIcon/>
                                      </Button>
                                      <h4>Adding new Goal - Please provide description of what you are trying to accomplish or maintain</h4>
                                      <TextField id="time" 
                                                type="text" 
                                                variant="outlined" 
                                                label="Goal description" 
                                                multiline={true} 
                                                rows={4} 
                                                fullWidth={true} 
                                                onChange={(event) => {setNewGoalDescription(event.target.value)}}
                                                value={newGoalDescription}
                                                />
                                      <h5>Please select the complexity of the goal</h5>
                                      <Box sx={{ flexDirection: 'row', display: 'flex', gap: 2}}>
                                        <Box sx={{width: '120px'}}>
                                      <Select
                                        labelId="demo-simple-select-label"
                                        id="demo-simple-select"
                                        value={numberMetricsToReccommend}
                                        label="Number of tasks to recommend"
                                        onChange={(event) => {setNumberMetricsToReccommend(event.target.value)}}
                                        
                                      >
                                        <MenuItem value={3}>Very Small</MenuItem>
                                        <MenuItem value={8}>Small</MenuItem>
                                        <MenuItem value={14}>Medium</MenuItem>
                                        <MenuItem value={18}>Large</MenuItem>
                                        <MenuItem value={21}>Very Large</MenuItem>
                                        <MenuItem value={25}>Huge</MenuItem>
                                      </Select>
                                      </Box>
                                      <Box sx={{width:"380px"}}>
                                        <Typography variant='body2'>Tip: You can specify the goal as well as the times of day and days of week in which you prefer to work on them. Choose a complexity level that best matches your goal's scope. Example: A "Small" goal might be 'write a scientific paper' or 'lose 5 pounds', while a "Large" goal could be 'create a startup' or 'become a professor'.</Typography>
                                      </Box>
                                      </Box>
                                      <Button onClick={addGoal}>Add</Button>
                                    </div>
                                }
                                
                                
                              </div>
                            </div>: <div></div>}
            {editingGoal ?  <div className="infoi"> 
                              <div className="centeredBox"> 
                                {editingGoalServer ? 
                                    <><CircularProgress /> <p> Editing goal ... This might take a while .. </p> <p> Please do not close the browser window or refresh the page. </p></> : 
                                    <div>
                                      <Button style={{'float': 'right'}}
                                              onClick={() => {setEditingGoal(false); setEditingGoalName('');}}>
                                        <CloseIcon/>
                                      </Button>
                                      <h4>Editing goal {selectGoal.name}. Please clarify the description of the goal. </h4>
                                      <TextField id="time" 
                                                type="text" 
                                                variant="outlined" 
                                                label="Goal description" 
                                                multiline={true} 
                                                rows={4} 
                                                fullWidth={true} 
                                                onChange={(event) => {setEditingGoalName(event.target.value)}}
                                                value={editingGoalName}
                                                />
                                      <h5>Please select the complexity of the goal</h5>
                                      <Box sx={{ flexDirection: 'row', display: 'flex', gap: 2}}>
                                        <Box sx={{width: '120px'}}>
                                      <Select
                                        labelId="demo-simple-select-label"
                                        id="demo-simple-select"
                                        value={numberMetricsToReccommend}
                                        label="Number of tasks to recommend"
                                        onChange={(event) => {setNumberMetricsToReccommend(event.target.value)}}
                                        
                                      >
                                        <MenuItem value={3}>Very Small</MenuItem>
                                        <MenuItem value={8}>Small</MenuItem>
                                        <MenuItem value={14}>Medium</MenuItem>
                                        <MenuItem value={18}>Large</MenuItem>
                                        <MenuItem value={21}>Very Large</MenuItem>
                                        <MenuItem value={25}>Huge</MenuItem>
                                      </Select>
                                      </Box>
                                       <Box sx={{width:"380px"}}>
                                        <Typography variant='body2'>Tip: You can specify the goal as well as the times of day and days of week in which you prefer to work on them. Choose a complexity level that best matches your goal's scope. Example: A "Small" goal might be 'write a scientific paper' or 'lose 5 pounds', while a "Large" goal could be 'create a startup' or 'become a professor'.</Typography>
                                      </Box>
                                      </Box>
                                      <Button onClick={saveEditedGoal}>Save</Button>
                                    </div>
                                }
                              </div>
                            </div> : <div></div>}
            {addingNewMetric ? <div className="infoi"> 
                              <div className="centeredBox"> 
                                {addingMetricServer ? 
                                    <><CircularProgress /> <p> Add metric ...</p></> : 
                                    
                                    <div>
                                      <Button style={{'float': 'right'}}
                                              onClick={closeAddMetricBox}>
                                        <CloseIcon/>
                                      </Button>
                                      <h4>Adding new new metric to goal {selectGoal.name} - Please provide a high level description of what you are trying to track</h4>
                                      <TextField id="time" 
                                                type="text" 
                                                variant="outlined" 
                                                label="Text" 
                                                multiline={true} 
                                                rows={4} 
                                                fullWidth={true} 
                                                onChange={(event) => {setNewMetricDescription(event.target.value)}}
                                                value={newMetricDescription}
                                                />
                                      <Button onClick={addMetric}>Add</Button>
                                    </div>
                                }
                                
                                
                              </div>
                            </div>: <div></div>}
            {addingTask ? <div className="infoi"> 
                              <div className="centeredBox"> 
                                {addingTaskServer ? 
                                    <><CircularProgress /> <p> Add task ...</p></> : 
                                    
                                    <div>
                                      <Button style={{'float': 'right'}}
                                              onClick={closeAddTaskBox}>
                                        <CloseIcon/>
                                      </Button>
                                      <h4>Adding new new task to goal {selectGoal.name} - Please provide a description of the task you are trying to add</h4>
                                      <TextField id="time" 
                                                type="text" 
                                                variant="outlined" 
                                                label="Text" 
                                                multiline={true} 
                                                rows={4} 
                                                fullWidth={true} 
                                                onChange={(event) => {setNewTaskDescription(event.target.value)}}
                                                value={newTaskDescription}
                                                />
                                      <Button onClick={addTask}>Add</Button>
                                    </div>
                                }
                                
                                
                              </div>
                            </div>: <div></div>}
                            
            
          </div>);

}

function normalizeOptions(options) {
  // Ensure "Other" exists and is last (optional)
  const hasOther = options.some((o) => o.toLowerCase() === "other");
  const filtered = options.filter((o) => o.toLowerCase() !== "other");
  return hasOther ? [...filtered, "Other"] : [...filtered, "Other"];
}

function answersToSummaryString(questions, answers, { skipUnknown = true } = {}) {
  if (!Array.isArray(questions) || !answers || typeof answers !== "object") return "";

  const parts = [];

  for (const q of questions) {
    const a = answers[q.id];
    const value = (a?.value ?? "").toString().trim();
    if (!value) continue;

    if (skipUnknown && value.toLowerCase() === "unknown") continue;

    parts.push(`${q.label} is ${value}.`);
  }

  return parts.join(" ");
}

function MultiChoiceWizard({ questions, initialAnswers, onComplete, onChange, allowSkip = false, }) {
  const styles = {
  card: {
    maxWidth: 640,
    margin: "0 auto",
    padding: 16,
    border: "1px solid #ddd",
    borderRadius: 12,
    fontFamily: "system-ui, -apple-system, Segoe UI, Roboto, sans-serif",
  },
  headerRow: { display: "flex", justifyContent: "space-between", gap: 12 },
  title: { fontSize: 18, fontWeight: 700 },
  progress: { fontSize: 12, opacity: 0.7, alignSelf: "center" },
  optionsWrap: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: 10,
    marginTop: 14,
  },
  optionBtn: {
    textAlign: "left",
    padding: "10px 12px",
    borderRadius: 10,
    border: "1px solid #ccc",
    background: "white",
    cursor: "pointer",
  },
  optionBtnSelected: {
    border: "2px solid #111",
  },
  otherWrap: { marginTop: 14 },
  otherLabel: { display: "block", fontSize: 12, marginBottom: 6, opacity: 0.8 },
  otherInput: {
    width: "100%",
    padding: "10px 12px",
    borderRadius: 10,
    border: "1px solid #ccc",
  },
  navRow: { display: "flex", justifyContent: "space-between", marginTop: 16 },
  navBtn: {
    padding: "10px 14px",
    borderRadius: 10,
    border: "1px solid #ccc",
    background: "white",
    cursor: "pointer",
    minWidth: 110,
  },
  primaryBtn: {
    border: "1px solid #111",
  },
  navBtnDisabled: {
    opacity: 0.4,
    cursor: "not-allowed",
  },
};

  const normalizedQuestions = React.useMemo(() => {
    return (questions || []).map((q) => ({
      ...q,
      options: normalizeOptions(q.options || []),
    }));
  }, [questions]);

  const [step, setStep] = useState(0);

  // answers[qid] = { type: "option"|"other", value: string }
  const [answers, setAnswers] = useState(() => initialAnswers || {});
  const current = normalizedQuestions[step];

  const currentAnswer = current ? answers[current.id] : undefined;
  const selectedValue = currentAnswer?.value ?? "";
  const selectedType = currentAnswer?.type ?? "";

  const setAnswer = (qid, next) => {
    setAnswers((prev) => {
      const updated = { ...prev, [qid]: next };
      onChange?.(updated);
      return updated;
    });
  };

  const isOtherSelected =
    selectedType === "other" ||
    (selectedType === "option" && selectedValue === "Other");

  const canGoNext = React.useMemo(() => {
    if (!current) return false;
    if (allowSkip) return true;

    const a = answers[current.id];
    if (!a) return false;

    if (a.type === "option") {
      // If "Other" chosen as an option, require text (we store as type: "other" anyway)
      return a.value && a.value !== "Other";
    }
    if (a.type === "other") {
      return Boolean(a.value?.trim());
    }
    return false;
  }, [answers, current, allowSkip]);

  const goNext = () => {
    if (step < normalizedQuestions.length - 1) {
      setStep((s) => s + 1);
    } else {
      onComplete?.(answersToSummaryString(questions, answers));
    }
  };

  const goBack = () => setStep((s) => Math.max(0, s - 1));

  if (!normalizedQuestions.length) {
    return <div>No questions provided.</div>;
  }

  const handleOptionClick = (opt) => {
    if (!current) return;

    if (opt === "Other") {
      // Switch to "other" answer; preserve any previously typed value if present
      const prev = answers[current.id];
      const prevOtherValue = prev?.type === "other" ? prev.value : "";
      setAnswer(current.id, { type: "other", value: prevOtherValue });
    } else {
      setAnswer(current.id, { type: "option", value: opt });
    }
  };

  const handleOtherTextChange = (e) => {
    if (!current) return;
    setAnswer(current.id, { type: "other", value: e.target.value });
  };

  const progressText = `${step + 1} / ${normalizedQuestions.length}`;

  return (
    <div style={styles.card}>
      <div style={styles.headerRow}>
        <div style={styles.title}>{current.label}</div>
        <div style={styles.progress}>{progressText}</div>
      </div>

      <div style={styles.optionsWrap}>
        {current.options.map((opt) => {
          const selected =
            (selectedType === "option" && selectedValue === opt) ||
            (opt === "Other" && selectedType === "other");

          return (
            <button
              key={opt}
              type="button"
              onClick={() => handleOptionClick(opt)}
              style={{
                ...styles.optionBtn,
                ...(selected ? styles.optionBtnSelected : null),
              }}
            >
              {opt}
            </button>
          );
        })}
      </div>

      {isOtherSelected && (
        <div style={styles.otherWrap}>
          <label style={styles.otherLabel}>Please specify</label>
          <input
            type="text"
            value={selectedType === "other" ? selectedValue : ""}
            onChange={handleOtherTextChange}
            placeholder="Type your answer…"
            style={styles.otherInput}
          />
        </div>
      )}

      <div style={styles.navRow}>
        <button
          type="button"
          onClick={goBack}
          disabled={step === 0}
          style={{
            ...styles.navBtn,
            ...(step === 0 ? styles.navBtnDisabled : null),
          }}
        >
          Back
        </button>

        <button
          type="button"
          onClick={goNext}
          disabled={!canGoNext}
          style={{
            ...styles.navBtn,
            ...styles.primaryBtn,
            ...(!canGoNext ? styles.navBtnDisabled : null),
          }}
        >
          {step < normalizedQuestions.length - 1 ? "Next" : "Finish"}
        </button>
      </div>
    </div>
  );
}



function clamp01(x) {
  return Math.max(0, Math.min(1, x));
}

function hasMeasuredValue(v) {
  if (v === null || v === undefined) return false;
  if (typeof v === "string") {
    const s = v.trim().toLowerCase();
    if (s === "" || s === "null" || s === "nan" || s === "undefined") return false;
  }
  const n = Number(v);
  return Number.isFinite(n);
}

function normalizedDistance(metric) {
  const v = metric.value;
  const mean = metric.ideal_mean;
  const variance = metric.ideal_variance;

  if (v == null || mean == null) return null;

  let varAbs = Math.abs(Number(variance));
  if (!isFinite(varAbs) || varAbs <= 0) {
    // can’t normalize; treat as some distance but not extreme
    varAbs = 1e-6;
  }

  const dist = Math.abs(Number(v) - Number(mean)) / varAbs; // 1.0 == "one variance away"
  // Map distance to 0..1 (cap at 2 variances)
  return clamp01(dist / 2);
}

function gradientFor(metric) {
  const z = normalizedDistance(metric);

  // Unknown current value => neutral grey
  if (z == null) {
    return "linear-gradient(135deg, rgba(120,120,120,0.25), rgba(120,120,120,0.08))";
  }

  // Interpolate hue from green(140) -> red(8)
  const hue = 140 - z * (140 - 8);
  const c1 = `hsla(${hue}, 80%, 45%, 0.35)`;
  const c2 = `hsla(${hue}, 90%, 55%, 0.12)`;

  return `linear-gradient(135deg, ${c1}, ${c2})`;
}

function formatValue(metric) {
  const v = metric.value;
  if (v == null) return null;

  // You can tune decimal display here:
  const n = Number(v);
  if (!isFinite(n)) return String(v);
  return n.toLocaleString(undefined, { maximumFractionDigits: 2 });
}

function formatNumber(value) {
  const num = Number(value);
  if (Number.isNaN(num)) return value;

  // Remove unnecessary trailing zeros
  return num % 1 === 0 ? num.toString() : num.toString();
}


function MetricCard({ metric, onSelect, updateParent, tokenPass }) {
  const isKnown = hasMeasuredValue(metric.value);
  const bg = gradientFor(metric);
  const [hover, setHover] = useState(false);

  const name = metric.name;
  const units = metric.units ?? "";

  return (<Card
                  onMouseEnter={() => setHover(true)}
                  onMouseLeave={() => setHover(false)}
                  elevation={0}
                  style={{
                  width: 200,
                  height: 200,
                  margin: "auto",
                  borderRadius: 14,
                  overflow: "hidden",
                  border: "1px solid rgba(0,0,0,0.10)",
                  transform: hover ? "translateY(-2px)" : "translateY(0)",
                  boxShadow: hover ? "0 10px 26px rgba(0,0,0,0.12)" : "none",
                  borderColor: hover ? "rgba(0,0,0,0.25)" : "rgba(0,0,0,0.10)",
                  transition: "transform 160ms ease, box-shadow 160ms ease, border-color 160ms ease",
                  transition: "transform 160ms ease, box-shadow 160ms ease, border-color 160ms ease",

                }}
              >
                <CardActionArea
                  onClick={() => onSelect(metric)}
                  style={{
                    width: "100%",
                    height: "100%",
                    background: bg,
                  }}
                >
                  <Box
                    style={{
                      width: "100%",
                      height: "100%",
                      display: "grid",
                      gridTemplateRows: "44px 1fr 26px", // ✅ more space for content, still fixed height overall
                      padding: 14,
                      boxSizing: "border-box",
                    }}
                  >
                    {/* Row 1: Title */}
                    <Typography
                      variant="subtitle2"
                      style={{
                        fontWeight: 900,
                        letterSpacing: 0.2,
                        lineHeight: "18px",
                        minWidth: 0,
                        opacity: 0.95,
                        display: "-webkit-box",
                        WebkitBoxOrient: "vertical",
                        WebkitLineClamp: 2,   // ✅ TWO lines
                        wordBreak: "break-word",
                        overflowWrap: "anywhere",
                      }}
                      title={name}
                    >
                      {name}
                    </Typography>

                    {/* Row 2: Value */}
                    <Box
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                        textAlign: "center",
                        minHeight: 0,
                      }}
                    >
                      {isKnown ? (
                        <>
                          <Typography
                            variant="h4"
                            style={{
                              fontWeight: 900,
                              lineHeight: 1.05,
                              letterSpacing: -0.5,
                            }}
                          >
                            {formatNumber(metric.value)}
                          </Typography>

                          <Typography
                            variant="body2"
                            style={{
                              marginTop: 8,
                              opacity: 0.85,
                            }}
                          >
                            {units}
                          </Typography>
                        </>
                      ) : (
                        <>
                          <Typography
                            variant="h5"
                            style={{
                              fontWeight: 900,
                              opacity: 0.6,
                              lineHeight: 1.1,
                            }}
                          >
                            —
                          </Typography>

                          <Typography
                            variant="body2"
                            style={{
                              marginTop: 8,
                              opacity: 0.8,
                            }}
                          >
                            {units || "Units not set"}
                          </Typography>
                        </>
                      )}
                    </Box>

                    {/* Row 3: Footer */}
                    <Typography
                      variant="caption"
                      style={{
                        textAlign: "center",
                        lineHeight: "26px",
                        opacity: 0.75,
                        borderTop: "1px solid rgba(0,0,0,0.08)",
                      }}
                    >
                      {metric.last_measured
                        ? `Last: ${new Date(metric.last_measured).toLocaleDateString()}`
                        : "No data yet"}
                    </Typography>
                  </Box>
                </CardActionArea>
              </Card>
                );
}

//Metrics
function MetricScreen(props) {
  // Show all current state variables and allow for them to be changed
  const classes = useStyles();

  const [fetchingMetrics, setFetchingMetrics] = useState(true)
  const [metrics, setMetrics] = useState([]);

  const [currentlySelectedMetric, setCurrentlySelectedMetric] = useState(null)

  const [addingNewMetric, setAddingNewMetric] = useState(false);
  const [newMetricName, setNewMetricName] = useState('');
  const [newMetricType, setNewMetricType] = useState('float1D'); // [float1D*&category, float2D*&category, float3D*&category, category*&only]
  const [newMetricFloatValue, setNewMetricFloatValue] = useState(0.0); // current metric value
  const [newMetricFloatGradient, setNewMetricFloatGradient] = useState(0.0); // gradient without intervention
  const [newMetricFloatGradientLens, setNewMetricFloatGradientLens] = useState(0.0); // minute, hour, day, week
  const [newMetricFloatCategories, setNewMetricFloatCategories] = useState([]); // category {name, value, sign(><=), noise, color}
  const [searchingSymbols, setSearchingSymbols] = useState(false); 
  const [symbolsResults, setSymbolsResults] = useState([]);
  const [newMetricSymbolLink, setNewMetricSymbolLink] = useState('');

  const [dimensions, setDimensions] = useState({ 
    height: window.innerHeight,
    width: window.innerWidth
  });

  const scrollEventsDisplay = useRef(null);


  useEffect(() => {
    window.addEventListener('resize', handleResize)
    getMetrics()
  },[])

  const handleResize = () => {
    setDimensions({
      height: window.innerHeight,
      width: window.innerWidth
    }) 
  }


  const getMetrics = () => {
    setFetchingMetrics(true)
    fetch(SERVER_LINK + '/get_metrics', {
      method: 'GET',
        headers: {
          Accept:'application/json',
          'Content-Type': 'application/json',
          'SimpTokAuth': props.tokenPass
        }
      }).then((response) => response.json())
        .then((data) => {if (Array.isArray(data)) { setMetrics(data); if (currentlySelectedMetric) { setCurrentlySelectedMetric(data.find((metric) => metric.id === currentlySelectedMetric.id)) } } else { alert('error fetching data, please reload page') }})
        .catch((error) => console.log(error))
        .finally(() => setFetchingMetrics(false))
  }


  const addMetric = () => {
    fetch(SERVER_LINK + '/add_metric', {
      method: 'POST',
        headers: {
          Accept:'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          'idtoken': props.tokenPass,
          'name': newMetricName,
          'symbol': '',
          'type': newMetricType
        })
      }).then((response) => response.json())
        .then((data) => {console.log(data)})
        .catch((error) => console.log(error))
        .finally(() => {setAddingNewMetric(false); getMetrics();})
  }


  const searchForSymbols = () => {
    if (newMetricName == '') return;
    setSearchingSymbols(true);
    fetch(SERVER_LINK + '/search_symbols', {
      method: 'POST',
      headers: {
        Accept:'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        idtoken: props.tokenPass,
        search_string: newMetricName
      })
    }).then((response) => response.json())
      .then((data) => {console.log(data); setSymbolsResults(data);})
      .finally(() => {setSearchingSymbols(false);})
  }


  return (
    <div style={{height:dimensions.height-64, 'overflow':'scroll'}}>
      {fetchingMetrics ? <CircularProgress /> :
        (currentlySelectedMetric == null ? 
          <div class="grid-container">
            {metrics.map((metric) => {
              return <MetricCard  key={metric.id}
                                  metric={metric}
                                  onSelect={(m) => setCurrentlySelectedMetric(m)}
                                  updateParent={() => getMetrics()}
                                  tokenPass={props.tokenPass}
                                />
            })}
          </div> :
          <SelectedMetricScreen metric={currentlySelectedMetric} setCurrentlySelectedMetric={setCurrentlySelectedMetric} reloadMetrics={getMetrics} tokenPass={props.tokenPass} />
          )
      }
      {addingNewMetric ? 
        <div className="infoi"> 
          <div className="centeredBox"> 
            <Button style={{'float': 'right'}}
                    onClick={() => {setAddingNewMetric(false)}}>
              <CloseIcon/>
            </Button>
            <h4>New Metric</h4>
            <TextField variant="outlined"
                      fullWidth={true}
                      onChange={(event) => {setNewMetricName(event.target.value)}}
                      value={newMetricName} />
            <Button onClick={() => {searchForSymbols()}}>Search Symbols</Button>
            <div style={{'height':'200px', 'overflow':'scroll'}}>
              {symbolsResults.map((symbol) => {
                return <div>
                  <Button onClick={() => {setNewMetricSymbolLink(symbol)}}>{symbol}</Button>
                </div>
              })}
            </div>
            <Button onClick={addMetric}>Add</Button>
          
          </div>
        </div>  : <div></div>}
    </div>
  );
}

function Sparkline({
  data,                 // [{ value: number, measured_at: string|Date }]
  idealMean,            // number
  idealVariance,        // number (treated as +/- band)
  height = 120,
  width = 560,
  padding = 12,
  ticks = 3,
}) {
  const points = (Array.isArray(data) ? data : [])
    .map((d) => ({
      v: Number(d?.value),
      t: new Date(d?.measured_at).getTime(),
    }))
    .filter((d) => Number.isFinite(d.v) && Number.isFinite(d.t))
    .sort((a, b) => a.t - b.t);

  const plotH = height - padding * 2 - 18; // reserve for x labels
  const plotW = width - padding * 2;

  if (points.length < 2) {
    return (
      <div style={{ height, display: "flex", alignItems: "center", justifyContent: "center", opacity: 0.7, fontSize: 12 }}>
        Not enough data to graph yet
      </div>
    );
  }

  const values = points.map((p) => p.v);
  let minV = Math.min(...values);
  let maxV = Math.max(...values);

  const hasIdeal =
    Number.isFinite(Number(idealMean)) && Number.isFinite(Number(idealVariance));

  const mean = Number(idealMean);
  const band = Math.abs(Number(idealVariance));
  const lower = mean - band;
  const upper = mean + band;

  // Expand y-domain a bit so the ideal band is visible even if points are tight
  if (hasIdeal) {
    minV = Math.min(minV, lower);
    maxV = Math.max(maxV, upper);
  }

  const spanV = maxV - minV || 1;

  const minT = points[0].t;
  const maxT = points[points.length - 1].t;
  const spanT = maxT - minT || 1;

  const xScale = (t) => padding + ((t - minT) / spanT) * plotW;
  const yScale = (v) => padding + (1 - (v - minV) / spanV) * plotH;

  const xy = points.map((p) => ({
    x: xScale(p.t),
    y: yScale(p.v),
    v: p.v,
    t: p.t,
  }));

  const line = xy.map((p) => `${p.x.toFixed(1)},${p.y.toFixed(1)}`).join(" ");
  const last = xy[xy.length - 1];

  const safeTicks = Math.max(2, Math.min(5, ticks));
  const tickTimes = Array.from({ length: safeTicks }, (_, i) => {
    const f = i / (safeTicks - 1);
    return minT + f * spanT;
  });

  const fmt = (ms) => {
    const d = new Date(ms);
    return d.toLocaleDateString(undefined, { month: "short", day: "numeric" });
  };

  // --- Ideal zone Y positions (clamped into plot)
  const clamp = (v, lo, hi) => Math.max(lo, Math.min(hi, v));
  const yTop = padding;
  const yBottom = padding + plotH;

  const yUpper = hasIdeal ? clamp(yScale(upper), yTop, yBottom) : null;
  const yLower = hasIdeal ? clamp(yScale(lower), yTop, yBottom) : null;
  const yMean = hasIdeal ? clamp(yScale(mean), yTop, yBottom) : null;

  // NOTE: because y increases downward in SVG:
  // - "above upper" zone is from yTop -> yUpper (if upper is in range)
  // - "ideal band" zone is from yUpper -> yLower (if lower below upper)
  // - "below lower" zone is from yLower -> yBottom

  const zoneAboveH = hasIdeal ? Math.max(0, yUpper - yTop) : 0;
  const zoneBandH = hasIdeal ? Math.max(0, yLower - yUpper) : 0;
  const zoneBelowH = hasIdeal ? Math.max(0, yBottom - yLower) : 0;

  return (
    <svg width="100%" height={height} viewBox={`0 0 ${width} ${height}`}>
      {/* plot area */}
      <rect
        x={padding}
        y={padding}
        width={plotW}
        height={plotH}
        rx="10"
        fill="rgba(0,0,0,0.02)"
      />

      {/* Ideal zones */}
      {hasIdeal && (
        <>
          {/* Above ideal band */}
          <rect
            x={padding}
            y={yTop}
            width={plotW}
            height={zoneAboveH}
            fill="rgba(244, 67, 54, 0.08)"
          />
          {/* Ideal band */}
          <rect
            x={padding}
            y={yUpper}
            width={plotW}
            height={zoneBandH}
            fill="rgba(76, 175, 80, 0.10)"
          />
          {/* Below ideal band */}
          <rect
            x={padding}
            y={yLower}
            width={plotW}
            height={zoneBelowH}
            fill="rgba(244, 67, 54, 0.08)"
          />

          {/* Mean + band lines */}
          <line x1={padding} y1={yMean} x2={padding + plotW} y2={yMean} stroke="rgba(76,175,80,0.55)" strokeWidth="1.5" />
          <line x1={padding} y1={yUpper} x2={padding + plotW} y2={yUpper} stroke="rgba(76,175,80,0.35)" strokeWidth="1" />
          <line x1={padding} y1={yLower} x2={padding + plotW} y2={yLower} stroke="rgba(76,175,80,0.35)" strokeWidth="1" />
        </>
      )}

      {/* area under line */}
      <polyline
        points={`${line} ${padding + plotW},${padding + plotH} ${padding},${padding + plotH}`}
        fill="rgba(63,81,181,0.10)"
        stroke="none"
      />

      {/* line */}
      <polyline
        points={line}
        fill="none"
        stroke="rgba(63,81,181,0.95)"
        strokeWidth="2.5"
        strokeLinejoin="round"
        strokeLinecap="round"
      />

      {/* last point */}
      <circle cx={last.x} cy={last.y} r="4.2" fill="rgba(0,0,0,0.65)" />

      {/* y labels */}
      <text x={padding + 8} y={padding + 14} fontSize="11" fill="rgba(0,0,0,0.55)">
        max {maxV}
      </text>
      <text x={padding + 8} y={padding + plotH - 6} fontSize="11" fill="rgba(0,0,0,0.55)">
        min {minV}
      </text>

      {/* x-axis */}
      <line
        x1={padding}
        y1={padding + plotH}
        x2={padding + plotW}
        y2={padding + plotH}
        stroke="rgba(0,0,0,0.10)"
        strokeWidth="1"
      />

      {tickTimes.map((t, i) => {
        const x = xScale(t);
        const y0 = padding + plotH;
        return (
          <g key={i}>
            <line x1={x} y1={y0} x2={x} y2={y0 + 5} stroke="rgba(0,0,0,0.18)" strokeWidth="1" />
            <text
              x={x}
              y={y0 + 16}
              fontSize="11"
              fill="rgba(0,0,0,0.60)"
              textAnchor={i === 0 ? "start" : i === tickTimes.length - 1 ? "end" : "middle"}
            >
              {fmt(t)}
            </text>
          </g>
        );
      })}

      {/* tiny legend */}
      {hasIdeal && (
        <text x={padding + plotW} y={padding + 14} fontSize="11" fill="rgba(0,0,0,0.55)" textAnchor="end">
          ideal: {lower} – {upper}
        </text>
      )}
    </svg>
  );
}

//
function SelectedMetricScreen(props) {
  const [metric, setMetric] = useState(null);
  const [metricName, setMetricName] = useState(null);

  const [editingMetricIdealValue, setEditingMetricIdealValue] = useState(false);
  const [newIdealMean, setNewIdealMean] = useState('');
  const [newIdealVariance, setNewIdealVariance] = useState('');

  const [newMeasurementValue, setNewMeasurementValue] = useState('');

  const [fetchingMetricHistory, setFetchingMetricHistory] = useState(true);
  const [metricHistory, setMetricHistory] = useState([]);


  const [dimensions, setDimensions] = useState({ 
    height: window.innerHeight,
    width: window.innerWidth
  });

  const handleResize = () => {
    setDimensions({
      height: window.innerHeight,
      width: window.innerWidth
    })
  }

  useEffect(() => {
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);


  useEffect(() => {
    if (props.metric != null) {
      setMetric(props.metric);
      setNewIdealMean(props.metric.ideal_mean);
      setNewIdealVariance(props.metric.ideal_variance);
      fetchMetricHistory();
    }
  }
  , [props.metric])


  const setIdealValue = () => {
    fetch(SERVER_LINK + '/set_ideal_value', {
      method: 'POST',
        headers: {
          Accept:'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          'idtoken': props.tokenPass,
          'metricid': metric.id,
          'ideal_mean': newIdealMean,
          'ideal_variance': newIdealVariance
        })
      }).then((response) => response.json())
        .then((data) => {if (data == 'SUCCESS') {props.reloadMetrics(); setEditingMetricIdealValue(false);} else {alert('Failed to update ideal value, please try again.')}})
        .catch((error) => console.log(error))
  }

  const submitMetricMeasurement = (metric, value) => {
    //submit metric measurement to backend
    fetch(SERVER_LINK + '/submit_metric_measurement', {
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'SimpTokAuth': props.tokenPass
        },
        body: JSON.stringify({
            metric_id: metric.id,
            value: value
        })
      }).then((response) => response.json())
        .then((data) => {if (data === "SUCCESS") {alert("Measurement submitted successfully."); props.reloadMetrics();} else {alert("Failed to submit metric value.");}} )
        .catch((error) => console.log(error));
  }

  const deleteMetric = () => {
    fetch(SERVER_LINK + '/delete_metric', {
      method: 'POST',
        headers: {
          Accept:'application/json',
          'Content-Type': 'application/json',
        },  
        body: JSON.stringify({
          'idtoken': props.tokenPass,
          'metricid': metric.id,
        })
      }).then((response) => response.json())
        .then((data) => {if (data=='SUCCESS') {props.setCurrentlySelectedMetric(null); props.reloadMetrics();} else {alert('Failed to delete metric, please try again.')}})
        .catch((error) => console.log(error))
  }

  const fetchMetricHistory = () => {
    setFetchingMetricHistory(true);
    fetch(SERVER_LINK + '/get_metric_history', {
      method: 'GET',
        headers: {
          Accept:'application/json',
          'Content-Type': 'application/json',
          'SimpTokAuth': props.tokenPass,
          'MetricID': props.metric.id
        }
      }).then((response) => response.json())
        .then((data) => {if (Array.isArray(data)) { setMetricHistory(data); } else { alert('error fetching metric history, please try again') }})
        .catch((error) => console.log(error))
        .finally(() => setFetchingMetricHistory(false))
  }



  return (
    <div
  style={{
    height: dimensions.height - 84,
    overflowY: "auto",
    padding: 20,
    boxSizing: "border-box",
    background: "rgba(0,0,0,0.02)",
  }}
>
  {/* Header */}
  <div
    style={{
      position: "sticky",
      top: 0,
      zIndex: 5,
      background: "rgba(255,255,255,0.95)",
      backdropFilter: "blur(8px)",
      borderBottom: "1px solid rgba(0,0,0,0.10)",
      borderRadius: 12,
      padding: "14px 16px",
      marginBottom: 16,
      display: "grid",
      gridTemplateColumns: "40px minmax(0, 1fr) 160px",
      alignItems: "center",
      columnGap: 12,
    }}
  >
    <Button
      onClick={() => props.setCurrentlySelectedMetric(null)}
      style={{
        minWidth: 40,
        width: 40,
        height: 40,
        borderRadius: 999,
        padding: 0,
      }}
    >
      <KeyboardBackspaceIcon />
    </Button>

    <div style={{ minWidth: 0 }}>
      <Typography
        variant="h5"
        style={{
          fontWeight: 900,
          lineHeight: 1.15,
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
        }}
        title={props.metric.name}
      >
        {props.metric.name}
      </Typography>

      <Typography variant="body2" style={{ opacity: 0.75 }}>
        #{props.metric.id}
      </Typography>
    </div>

    <div style={{ textAlign: "right" }}>
      <Typography variant="body2" style={{ opacity: 0.7 }}>
        Current
      </Typography>
      <Typography style={{ fontWeight: 900, lineHeight: 1.1 }}>
        {props.metric.value} {props.metric.units}
      </Typography>
    </div>
  </div>

  {/* Main content: left info + right actions (responsive-ish) */}
  <div
    style={{
      display: "grid",
      gridTemplateColumns: "minmax(0, 1fr) 320px",
      gap: 16,
      alignItems: "start",
    }}
  >
    {/* LEFT: Info + forms */}
    <div style={{ minWidth: 0 }}>
      {/* Info card */}
      <div
        style={{
          background: "#fff",
          border: "1px solid rgba(0,0,0,0.10)",
          borderRadius: 14,
          padding: 16,
          boxShadow: "0 1px 0 rgba(0,0,0,0.04)",
          marginBottom: 16,
        }}
      >
        <Typography variant="subtitle1" style={{ fontWeight: 900, marginBottom: 10 }}>
          Details
        </Typography>

        <div style={{ display: "grid", gap: 10 }}>
          <div>
            <Typography variant="caption" style={{ opacity: 0.65 }}>
              Last measured
            </Typography>
            <Typography variant="body1" style={{ fontWeight: 700 }}>
              {props.metric.last_measured || "—"}
            </Typography>
          </div>

          <div>
            <Typography variant="caption" style={{ opacity: 0.65 }}>
              Measurement frequency
            </Typography>
            <Typography variant="body1" style={{ fontWeight: 700 }}>
              {props.metric.measurement_frequency || "—"} h
            </Typography>
          </div>

          <div>
            <Typography variant="caption" style={{ opacity: 0.65 }}>
              Instructions
            </Typography>
            <Typography
              variant="body2"
              style={{
                lineHeight: 1.6,
                whiteSpace: "pre-line",
                opacity: 0.9,
              }}
            >
              {props.metric.measurement_method || "—"}
            </Typography>
          </div>
        </div>
      </div>

      {/* Metric history card */}
      {fetchingMetricHistory ?
            <CircularProgress />
         : 
      <div
          style={{
            background: "#fff",
            border: "1px solid rgba(0,0,0,0.10)",
            borderRadius: 14,
            padding: 16,
            boxShadow: "0 1px 0 rgba(0,0,0,0.04)",
            marginBottom: 16,
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "baseline",
              justifyContent: "space-between",
              gap: 12,
              marginBottom: 8,
            }}
          >
            <Typography variant="subtitle1" style={{ fontWeight: 900 }}>
              Trend
            </Typography>
            <Typography variant="caption" style={{ opacity: 0.7 }}>
              last {metricHistory.length} points
            </Typography>
          </div>

          <div style={{ width: "100%" }}>
            <Sparkline data={metricHistory} idealMean={props.metric.ideal_mean} idealVariance={props.metric.ideal_variance} height={120} />
          </div>

        </div>
}

      {/* Ideal values card */}
      <div
        style={{
          background: "#fff",
          border: "1px solid rgba(0,0,0,0.10)",
          borderRadius: 14,
          padding: 16,
          boxShadow: "0 1px 0 rgba(0,0,0,0.04)",
          marginBottom: 16,
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: 12,
            marginBottom: 10,
          }}
        >
          <Typography variant="subtitle1" style={{ fontWeight: 900 }}>
            Ideal Range
          </Typography>

          {!editingMetricIdealValue && (
            <Button
              variant="outlined"
              color="primary"
              onClick={() => setEditingMetricIdealValue(true)}
              style={{
                borderRadius: 999,
                textTransform: "none",
                fontWeight: 800,
              }}
            >
              Edit
            </Button>
          )}
        </div>

        {editingMetricIdealValue ? (
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr auto", gap: 10 }}>
            <TextField
              label="Ideal Mean"
              variant="outlined"
              value={newIdealMean}
              onChange={(e) => setNewIdealMean(e.target.value)}
              size="small"
            />
            <TextField
              label="Ideal Variance"
              variant="outlined"
              value={newIdealVariance}
              onChange={(e) => setNewIdealVariance(e.target.value)}
              size="small"
            />
            <Button
              variant="contained"
              color="primary"
              onClick={() => setIdealValue()}
              style={{
                borderRadius: 999,
                textTransform: "none",
                fontWeight: 900,
                paddingLeft: 18,
                paddingRight: 18,
              }}
            >
              Save
            </Button>
          </div>
        ) : (
          <Typography variant="body2" style={{ lineHeight: 1.6, opacity: 0.9 }}>
            Ideal Mean: <strong>{props.metric.ideal_mean ?? "—"}</strong> {props.metric.units}{" "}
            {" • "}
            Ideal Variance: <strong>{props.metric.ideal_variance ?? "—"}</strong> {props.metric.units}
          </Typography>
        )}
      </div>

      {/* Submit measurement card */}
      <div
        style={{
          background: "#fff",
          border: "1px solid rgba(0,0,0,0.10)",
          borderRadius: 14,
          padding: 16,
          boxShadow: "0 1px 0 rgba(0,0,0,0.04)",
          marginBottom: 16,
        }}
      >
        <Typography variant="subtitle1" style={{ fontWeight: 900, marginBottom: 10 }}>
          Submit Measurement
        </Typography>

        <div style={{ display: "grid", gridTemplateColumns: "1fr auto", gap: 10 }}>
          <TextField
            label="New value"
            variant="outlined"
            onChange={(e) => setNewMeasurementValue(e.target.value)}
            size="small"
          />
          <Button
            variant="contained"
            color="primary"
            onClick={() => submitMetricMeasurement(props.metric, newMeasurementValue)}
            style={{
              borderRadius: 999,
              textTransform: "none",
              fontWeight: 900,
              paddingLeft: 18,
              paddingRight: 18,
            }}
          >
            Submit
          </Button>
        </div>
      </div>

      
    </div>



    {/* RIGHT: Danger zone / actions */}
    <div style={{ minWidth: 0 }}>
      <div
        style={{
          background: "#fff",
          border: "1px solid rgba(255,0,0,0.25)",
          borderRadius: 14,
          padding: 16,
          boxShadow: "0 1px 0 rgba(0,0,0,0.04)",
        }}
      >
        <Typography variant="subtitle1" style={{ fontWeight: 900, marginBottom: 8 }}>
          Danger zone
        </Typography>

        <Typography variant="body2" style={{ opacity: 0.75, lineHeight: 1.5, marginBottom: 12 }}>
          Deleting a metric removes it permanently, including its measurement history.
        </Typography>

        <Button
          variant="contained"
          color="secondary"
          onClick={deleteMetric}
          style={{
            width: "100%",
            borderRadius: 12,
            textTransform: "none",
            fontWeight: 900,
            paddingTop: 10,
            paddingBottom: 10,
          }}
        >
          Delete metric
        </Button>
      </div>
    </div>
  </div>
</div>
  )
}





//Settings
function SettingsScreen(props) {
  const [selectedTask, setSelectedTask] = useState(null);

  const [tasks, setTasks] = useState([
    {
      id: 1,
      taskName: 'Object Search',
      hyperparameters: {
        text_encoder: '', // for the search string
        parameter2: '',
        parameter3: '',
        // Add more hyperparameters as needed
      }
    },
    {
      id: 2,
      taskName: 'Mood Inference',
      hyperparameters: {
        text_encoder: '', // for the task name
        parameter2: '',
        parameter3: '',
        // Add more hyperparameters as needed
      }
    },
    {
      id: 3,
      taskName: 'Task Splitting',
      hyperparameters: {
        parameter1: '',
        parameter2: '',
        parameter3: '',
        // Add more hyperparameters as needed
      }
    },
    {
      id: 4,
      taskName: 'Type Inference',
      hyperparameters: {
        parameter1: '',
        parameter2: '',
        parameter3: '',
        // Add more hyperparameters as needed
      }
    },

    // Add more tasks as needed
  ]);

  const models = [
    {
      function: "Image Classification",
      preTrainedModel: "ResNet-50",
      headModel: "Fully Connected",
      open: "Link"
    },
    {
      function: "Object Detection",
      preTrainedModel: "YOLOv3",
      headModel: "Faster R-CNN",
      open: "Link"
    },
    {
      function: "Text Generation",
      preTrainedModel: "GPT-2",
      headModel: "LSTM",
      open: "Link"
    },
    // Add more models as needed
  ];

  const renderModelsTable = () => {
    return (
      <table className="models-table">
        <thead>
          <tr>
            <th>Function</th>
            <th>Pre-Trained Model</th>
            <th>Head Model</th>
            <th>Open</th>
          </tr>
        </thead>
        <tbody>
          {models.map((model, index) => (
            <tr key={index}>
              <td>{model.function}</td>
              <td>{model.preTrainedModel}</td>
              <td>{model.headModel}</td>
              <td>{model.open}</td>
            </tr>
          ))}
        </tbody>
      </table>
    );
  };

  const handleTaskClick = (taskId) => {
    setSelectedTask(taskId);
  };

  const handleParameterChange = (taskId, paramName, value) => {
    setTasks(prevTasks => prevTasks.map(task => {
      if (task.id === taskId) {
        return {
          ...task,
          hyperparameters: {
            ...task.hyperparameters,
            [paramName]: value
          }
        };
      }
      return task;
    }));
  };

  const renderTaskIndex = () => {
    return tasks.map(task => (
      <div
        key={task.id}
        className={`task-index-item ${selectedTask === task.id ? 'active' : ''}`}
        onClick={() => handleTaskClick(task.id)}
      >
        {task.taskName}
      </div>
    ));
  };

  const renderTaskDetails = () => {
    const task = tasks.find(task => task.id === selectedTask);
    if (!task) return null;

    return (
      <div className="task-details">
        <h3 className="task-title">{task.taskName}</h3>
        <div>
          <label className="parameter-label">Parameter 1:</label>
          <input
            type="text"
            className="parameter-input"
            value={task.hyperparameters.parameter1}
            onChange={e => handleParameterChange(task.id, 'parameter1', e.target.value)}
          />
        </div>
        <div>
          <label className="parameter-label">Parameter 2:</label>
          <select
            className="parameter-select"
            value={task.hyperparameters.parameter2}
            onChange={e => handleParameterChange(task.id, 'parameter2', e.target.value)}
          >
            <option value="">Select an option</option>
            <option value="option1">Option 1</option>
            <option value="option2">Option 2</option>
            {/* Add more options as needed */}
          </select>
        </div>
        <div>
          <label className="parameter-label">Parameter 3:</label>
          <div>
            <input
              type="radio"
              className="parameter-radio"
              name={`parameter3-${task.id}`}
              value="value1"
              checked={task.hyperparameters.parameter3 === 'value1'}
              onChange={e => handleParameterChange(task.id, 'parameter3', e.target.value)}
            />
            <span>Value 1</span>
          </div>
          <div>
            <input
              type="radio"
              className="parameter-radio"
              name={`parameter3-${task.id}`}
              value="value2"
              checked={task.hyperparameters.parameter3 === 'value2'}
              onChange={e => handleParameterChange(task.id, 'parameter3', e.target.value)}
            />
            <span>Value 2</span>
          </div>
          {/* Add more radio options as needed */}
        </div>
        {/* Add more hyperparameters as needed */}
      </div>
    );
  };

  return (
    <div className="settings-container">
      <div className="task-index">
        <h2>Models</h2>
        <p>Table </p>
        {renderModelsTable()}

        


      </div>
      <div className="task-index">
        <h2>Parsing Parameters</h2>
        <p>PDF difference y size</p>

        {renderTaskIndex()}
      </div>
      <div>
        {renderTaskDetails()}
      </div>
    </div>
  );
};



function TestsScreen(props) {
  const classes = useStyles();

  const fecthingTests = useState(true);
  const [tests, setTests] = useState([]);

  const [dimensions, setDimensions] = useState({
    height: window.innerHeight,
    width: window.innerWidth
  });



  return (<div>
            <h2> Test Screen </h2>
          </div>);

}



//Home
function HomeScreen(props) {
  const classes = useStyles();


  const [fetchingTasks, setFetchingTasks] = useState(true);
  const [tasks, setTasks] = useState([]); // array of task instances

  const [binBackground, setBinBackground] = useState('');

  //Searching Task and creating task
  const [addingNewTask, setAddingNewTask] = useState(false);
  const [newTaskObjectives, setNewTaskObjectives] = useState([]); //Array of goals with the specification of how much it alters each goal
  const [newTaskObjectivesSearchField, setNewTaskObjectivesSearchField] = useState('')
  const [newTaskObjectiveInfluence, setNewTaskObjectiveInfluence] = useState(0)
  
  //Selected Task Instance (when the task is selected the user is actively working on it)
  const [selectedTaskID, setSelectedTaskID] = useState('');
  const [fetchingCurrentTaskInfo, setFetchingCurrentTaskInfo] = useState(true);
  const [selectedTaskInstance, setSelectedTaskInstance] = useState(null);
  const [settingTaskMood, setSettingTaskMood] = useState(false);
  const [moodList, setMoodList] = useState([]);
  const [currentMood, setCurrentMood] = useState(-1);
  const [editingMood, setEditingMood] = useState(false);
  const [currentTimeElapsed, setCurrentTimeElapsed] = useState(0.0);
  
  const [focusedTaskProtId, setFocusedTaskProtId] = useState('')

  const [linkingInstanceToTask, setLinkingInstanceToTask] = useState(false)

  const [loadingReccomendedContent, setLoadingReccomendedContent] = useState(false)
  
  const [taskBackgroundColor, setTaskBackgroundColor] = useState('white')

  const [postponingTask, setPostponingTask] = useState(false)
  const [postponedTaskId, setPostponedTaskId] = useState('')
  const [postponingReason, setPostponingReason] = useState('')
   
  const [deletingTask, setDeletingTask] = useState(false)

  const [dimensions, setDimensions] = useState({ 
    height: window.innerHeight,
    width: window.innerWidth
  })

  useEffect(() => {
    window.addEventListener('resize', handleResize)
    
  }, [])

  useEffect(() => {
    getTasks()
  }, [props.refresh])

  useEffect(() => {
    if (selectedTaskID != '') {
      fetchInfoForCurrentTask()
    }
    else {
      setSelectedTaskInstance(null)
    }
  }, [selectedTaskID])

  useEffect(() => {
    console.log('fetching for .... ' + currentMood)
    if (currentMood == -1) {
      getTasks()
    }
    else {
      getTasksForMood(currentMood)
    }
    setFocusedTaskProtId('')
  }, [currentMood])


  const handleResize = () => {
    setDimensions({
      height: window.innerHeight,
      width: window.innerWidth
    }) 
  }


  const getTasks = () => {
    setFetchingTasks(true)
    if (currentMood == -1) {
      fetch(SERVER_LINK + '/get_goals', {
        method: 'GET',
          headers: {
            Accept:'application/json',
            'Content-Type': 'application/json',
            'SimpTokAuth': props.tokenPass,
          }
        }).then((response) => response.json())
          .then((data) => {Array.isArray(data) ? setTasks(data) : console.log(data)})
          .catch((error) => console.log(error))
          .finally(() => {setFetchingTasks(false)})
    }
    else {
      getTasksForMood(currentMood)
    }
  };


  const getTasksForMood = (moodId) => {
    setFetchingTasks(true);
    fetch(SERVER_LINK + '/get_active_task_instances_with_mood', {
      method: 'GET',
        headers: {
          Accept:'application/json',
          'Content-Type': 'application/json',
          'SimpTokAuth': props.tokenPass,
          'TaskMoodID': moodId
        }
      }).then((response) => response.json())
        .then((data) => {Array.isArray(data) ? setTasks(data) : console.log(data)})
        .catch((error) => console.log(error))
        .finally(() => {setFetchingTasks(false); setLoadingReccomendedContent(false)})
  };


  const getMoodsFromServer = () => {
    fetch(SERVER_LINK + '/get_moods', {
      method: 'GET',
        headers: {
          Accept:'application/json',
          'Content-Type': 'application/json',
          'SimpTokAuth': props.tokenPass
        }
      }).then((response) => response.json())
        .then((data) => {console.log(data); setMoodList(data);})
        .catch((error) => console.log(error))
        .finally(() => setSettingTaskMood(true))
  };


  const delete_task = () => {
    fetch(SERVER_LINK + '/delete_task', {
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            idtoken: props.tokenPass,
            taskid: selectedTaskID
        })
      }).then((response) => response.json())
        .then((data) => {if (data=='SUCCESS') {setSelectedTaskID(''); setSelectedTaskInstance(null)} else {alert('Task couldnt be deleted')}} )
        .catch((error) => console.log(error))
        .finally(() => getTasks())
  };


  const setTaskDone = (taskId) => {
    fetch(SERVER_LINK + '/set_task_status', {
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            idtoken: props.tokenPass,
            taskid: taskId,
            new_status: 'DONE'
        })
      }).then((response) => response.json())
        .then((data) => {if (data=='SUCCESS') {} else {alert('Status couldnt be set')}} )
        .catch((error) => console.log(error))
        .finally(() => getTasks())
  };


  const setTaskInProgress = (taskId) => {
    fetch(SERVER_LINK + '/set_task_status', {
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            idtoken: props.tokenPass,
            taskid: taskId,
            new_status: 'INPROGRESS'
        })
      }).then((response) => response.json())
        .then((data) => {if (data=='SUCCESS') {} else {alert('Status couldnt be set')}} )
        .catch((error) => console.log(error))
        .finally(() => getTasks())
  };


  const setTaskMood = (taskPrototypeId, moodId) => {
    fetch(SERVER_LINK + '/set_task_mood', {
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            idtoken: props.tokenPass,
            task_prototype_id: taskPrototypeId,
            new_moodid: moodId
        })
      }).then((response) => response.json())
        .then((data) => {if (data=='SUCCESS') {} else {alert('Status couldnt be set')}} )
        .catch((error) => console.log(error))
        .finally(() => {setSettingTaskMood(false)})
  };


  const startPostponingTask = (taskid, taskdeadline) => {
    setPostponedTaskId(taskid)
    setPostponingTask(true)
  };
  

  const fetchInfoForCurrentTask = () => {
    console.log(' fetching info for task ' + selectedTaskID.toString() + ' dd ')
    setFetchingCurrentTaskInfo(true)
    fetch(SERVER_LINK + '/get_task_info', {
      method: 'GET',
        headers: {
          Accept:'application/json',
          'Content-Type': 'application/json',
          'SimpTokAuth': props.tokenPass,
          'TaskID': selectedTaskID
        }
      }).then((response) => response.json())
        .then((data) => {if (Array.isArray(data)) { setSelectedTaskInstance(data[0]); setFocusedTaskProtId(data[0].prototype.id)} else { console.log('ERRORR!!')}})
        .catch((error) => console.log(error))
        .finally(() => {setFetchingCurrentTaskInfo(false)})
  };

  const draggingOverTaskList = (ev) => {
    console.log('dragging over ' + props.task.id); 
    let event = ev;
    event.stopPropagation();
    event.preventDefault();
    setTaskBackgroundColor('#408000')
  };

  const draggingOverBin = (ev) => {
    console.log('dragging over bin'); 
    let event = ev;
    event.stopPropagation();
    event.preventDefault();
    setBinBackground('#F71300')
  };

  const dragExitBin = (ev) => {
    console.log('exiting bin'); 
    setBinBackground('')
  };

  const droppedOnBin = (ev) => {
    let event = ev;
    let task_instance_id = ev.dataTransfer.getData("task_instance_id")
    fetch(SERVER_LINK + '/delete_task_instance', {
      method: 'POST',
        headers: {
          Accept:'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            idtoken: props.tokenPass,
            taskid: task_instance_id
        })
      }).then((response) => response.json())
        .then((data) => {if (data=='SUCCESS') {console.log('task ' + task_instance_id.toString() + ' deleted')} else {alert('Task couldnt be deleted')}} )
        .catch((error) => console.log(error))
        .finally(() => {setBinBackground(''); getTasks();})


    setBinBackground('#a6a6a6')
  };

  const goBackInTaskHandler = () => {
    setSelectedTaskID('');
    setFocusedTaskProtId('');
  };

  
  return (
      <div>
        <div className="screen">
            <MoodChooser 
                tokenPass={props.tokenPass} 
                selectedMood={currentMood} 
                editingSelectedMood={editingMood}
                setSelectedMood={(newMood) => {
                  if (newMood != currentMood) {
                    setCurrentMood(newMood)
                    setSelectedTaskID('')
                    console.log('setting new moooood')
                  }
                }}
                setEditing={setEditingMood}/>
            {fetchingTasks ?
              <p>Loading tasks... </p> :
              <div >
                  <div style={{'height': dimensions.height - 84 - 100, 'width': '352px', 'position': 'absolute'}}>
                      {selectedTaskID == '' ?
                        <div style={{'width': '352px'}}>
                          
                              <Button onClick={() => {setEditingMood(true)}}>
                                EDIT MOOD
                              </Button>
                              <Button onClick={() => {setAddingNewTask(true)}}>
                                ADD
                              </Button>
                              <div onDragOver={draggingOverBin}
                                onDragLeave={dragExitBin}
                                onDrop={droppedOnBin}
                                style={{'background' : binBackground, 'float': 'right', 'margin': '5px'}}>
                              <DeleteForeverIcon />
                            </div>
                        </div> : <div style={{'height': '10px', 'width': '352px'}}></div>}
                    <div style={{'width': '352px', 'height': selectedTaskID == '' ? dimensions.height - 84 - 138 : dimensions.height - 64 - 138, 'position': 'absolute', 'overflow': 'scroll'}}>
                        {selectedTaskID == '' ?

                          <div>
                          {addingNewTask ? 
                            <div>
                                <AddTaskCard tokenPass={props.tokenPass}
                                              cardHeight={300}
                                              parentid={'-1'}
                                              cancelAddTask={() => {setAddingNewTask(false)}}
                                              taskAddedCallback={() => {setAddingNewTask(false); getTasks();}}
                                              mood={currentMood} /> 
                            </div> 
                                  :  
                                  <div></div>}
                                    
                            <Grid container
                                direction="column"
                                justify="flex-start"
                                alignItems="stretch"
                                onDraggingOver={draggingOverTaskList} 
                                style={{width: '345px'}}
                                >
                                {tasks.map((task, index) => 
                                    <DraggableTaskCard task={task}
                                                        tokenPass={props.tokenPass}
                                                        setSelectedTaskID={(selected_task_id) => {setSelectedTaskID(selected_task_id);}}
                                                        setTaskInProgress={setTaskInProgress}
                                                        setTaskDone={setTaskDone}
                                                        setPostponingTask={() => {}}
                                                        updateParent={getTasks} />
                                )}
                            </Grid> 
                            </div> :
                          (fetchingCurrentTaskInfo ? 
                            <div><CircularProgress /> <p>Loading Task...</p> </div> :
                              (selectedTaskInstance == null ? 
                                  <div><p>Error: Couldnt retrieve task info... </p></div> :
                    
                                <ExpandedTaskCard task={selectedTaskInstance}
                                                  parentid={null}
                                                  tokenPass={props.tokenPass}
                                                  goBackFunction={goBackInTaskHandler}
                                                  fetchLinksForTask={(newFocusedTaskID) => {setFocusedTaskProtId(newFocusedTaskID)}}
                                                  depthIndex={0}
                                                  updateParent={() => {(currentMood != -1) ? getTasksForMood(currentMood) : getTasks()}}
                                                  currentMood={currentMood}/>)
                          )
                        }
                    </div>
                  </div>
              </div>
            }
                    <div style={{'width': dimensions.width - 380, 'height': dimensions.height - 84 - 100, 'position': 'absolute', 'left': '380px', 'overflow': 'scroll'}}>
                      {loadingReccomendedContent ? 
                        <p>Loading content...</p> :
                        (focusedTaskProtId == '' ? (currentMood == -1 ? <NewsFeedHome tokenPass={props.tokenPass} /> :
                                                    <TopicVisualizer tokenPass={props.tokenPass}
                                                                    currentPinTypeSelected={"MOOD"}
                                                                    currentPinID={currentMood}
                                                                    currentScreenWidth={dimensions.width} />)
                                                  : <TopicVisualizer tokenPass={props.tokenPass}
                                                                    currentPinTypeSelected={"TASK"}
                                                                    currentPinID={focusedTaskProtId} 
                                                                    currentScreenWidth={dimensions.width}/>)
                        }

                    </div>
              
          </div>

      {deletingTask ? <div className="infoi"> 
            <div className="centeredBox"> 
              <Button style={{'float': 'right'}}
                      onClick={() => {setDeletingTask(false)}}>
                <CloseIcon/>
              </Button>
              <h4>Deleting selected task permenantly, are you sure?</h4>
              <Grid container
                    direction="column"
                    justify="flex-start"
                    alignItems="stretch">
                <Button onClick={() => {delete_task(); setDeletingTask(false);}}>Yes</Button>
                <Button onClick={() => {setDeletingTask(false)}}>No</Button>
              </Grid>

        </div>
      </div>: <div></div>}
      {postponingTask ? <div className="infoi"> 
            <div className="centeredBox"> 
              <Button style={{'float': 'right'}}
                      onClick={() => {setPostponingTask(false)}}>
                <CloseIcon/>
              </Button>
              <Typography variant="h4"> Postpone Task </Typography>
              <p> Add the ideal circunstances for performing the task </p>
              <Typography variant="h6" style={{float:'right'}}> Hours </Typography>
              <br></br>
              <br></br>
              <Button onClick={() => {}} style={{float:'right'}}>Save</Button>


        </div>
      </div>: <div></div>}
      {postponingTask ? <div className="infoi"> 
            <div className="centeredBox"> 
              <Button style={{'float': 'right'}}
                      onClick={() => {setPostponingTask(false)}}>
                <CloseIcon/>
              </Button>
              <Typography variant="h4"> Postpone Task </Typography>
              <p> Add the ideal circunstances for performing the task </p>
              <Typography variant="h6" style={{float:'right'}}> Hours </Typography>
              <br></br>
              <br></br>
              <Button onClick={() => {}} style={{float:'right'}}>Save</Button>


        </div>
      </div>: <div></div>}
    </div>)
};

function useUserState() {
  const [now, setNow] = React.useState(new Date());
  const [geo, setGeo] = React.useState({
    status: "idle", // idle | requesting | granted | denied | error
    lat: null,
    lon: null,
    accuracy: null,
    error: null,
  });

  const [weather, setWeather] = React.useState({
    status: "idle", // idle | loading | ok | error
    data: null,
    error: null,
  });

  // 1) Keep current time updated
  React.useEffect(() => {
    const t = setInterval(() => setNow(new Date()), 1000);
    return () => clearInterval(t);
  }, []);

  // 2) Ask for location
  const requestLocation = React.useCallback(() => {
    if (!("geolocation" in navigator)) {
      setGeo({ status: "error", lat: null, lon: null, accuracy: null, error: "Geolocation not supported." });
      return;
    }

    setGeo((g) => ({ ...g, status: "requesting", error: null }));

    navigator.geolocation.getCurrentPosition(
      (pos) => {
        setGeo({
          status: "granted",
          lat: pos.coords.latitude,
          lon: pos.coords.longitude,
          accuracy: pos.coords.accuracy,
          error: null,
        });
      },
      (err) => {
        const msg =
          err.code === 1 ? "Permission denied." :
          err.code === 2 ? "Position unavailable." :
          err.code === 3 ? "Location request timed out." :
          "Geolocation error.";
        setGeo({ status: "denied", lat: null, lon: null, accuracy: null, error: msg });
      },
      {
        enableHighAccuracy: false,
        timeout: 10000,
        maximumAge: 5 * 60 * 1000,
      }
    );
  }, []);

  // 3) Fetch current weather once we have location
  React.useEffect(() => {
    async function fetchWeather(lat, lon) {
      try {
        setWeather({ status: "loading", data: null, error: null });

        // Open-Meteo: no key required
        const url =
          `https://api.open-meteo.com/v1/forecast` +
          `?latitude=${encodeURIComponent(lat)}` +
          `&longitude=${encodeURIComponent(lon)}` +
          `&current=temperature_2m,relative_humidity_2m,apparent_temperature,wind_speed_10m,weather_code` +
          `&temperature_unit=fahrenheit` +
          `&wind_speed_unit=mph`;

        const res = await fetch(url);
        if (!res.ok) throw new Error(`Weather request failed: ${res.status}`);
        const json = await res.json();

        setWeather({ status: "ok", data: json.current, error: null });
      } catch (e) {
        setWeather({ status: "error", data: null, error: e.message || "Weather fetch error." });
      }
    }

    if (geo.status === "granted" && geo.lat != null && geo.lon != null) {
      fetchWeather(geo.lat, geo.lon);
    }
  }, [geo.status, geo.lat, geo.lon]);

  return { now, geo, weather, requestLocation };
}

function formatPrettyDate(dateInput) {
  const date = new Date(dateInput);

  const day = date.getDate();
  const year = date.getFullYear();

  const month = date.toLocaleString("en-US", { month: "short" });

  const suffix =
    day % 10 === 1 && day !== 11 ? "st" :
    day % 10 === 2 && day !== 12 ? "nd" :
    day % 10 === 3 && day !== 13 ? "rd" :
    "th";

  return `${day}${suffix} ${month} ${year.toString()[2]}${year.toString()[3]}`;
}

function Section({ title, children }) {
  return (
    <Paper
      elevation={2}
      sx={{
        height: "100%",
        borderRadius: 2,
        overflow: "hidden",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Box sx={{ px: 2, py: 1.5, borderBottom: "1px solid", borderColor: "divider" }}>
        <Typography variant="subtitle1" fontWeight={800}>
          {title}
        </Typography>
      </Box>

      <Box sx={{ p: 2, flex: 1, overflow: "hidden" }}>{children}</Box>
    </Paper>
  );
}



function StateTile({ image, label, value, binaryValue, onClick }) {
  const [hover, setHover] = useState(false);

  const border = binaryValue ? "rgba(63,81,181,0.55)" : "rgba(0,0,0,0.12)";
  const shadow = hover ? "0 10px 22px rgba(0,0,0,0.14)" : "0 1px 0 rgba(0,0,0,0.04)";
  const lift = hover ? "translateY(-2px)" : "translateY(0)";

  return (
    <Box
      role="button"
      tabIndex={0}
      onClick={onClick}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          onClick?.();
        }
      }}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      style={{
        width: 114,
        height: 180,
        borderRadius: 14,
        overflow: "hidden",
        cursor: "pointer",
        userSelect: "none",
        border: `1px solid ${border}`,
        backgroundColor: "#fff",
        boxShadow: shadow,
        transform: lift,
        transition: "transform 140ms ease, box-shadow 140ms ease, border-color 140ms ease",
      }}
    >
      {/* IMAGE AREA */}
      <div
        style={{
          position: "relative",
          width: "100%",
          height: 134, // 180 - header(46)
          backgroundImage: image ? `url(${image})` : "none",
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundColor: "rgba(0,0,0,0.06)",
        }}
      >
        {/* soft overlay for readability */}
        <div
          style={{
            position: "absolute",
            inset: 0,
            background:
              "linear-gradient(to top, rgba(0,0,0,0.62), rgba(0,0,0,0.10) 55%, rgba(0,0,0,0.00))",
          }}
        />

        {/* selected pill */}
        {binaryValue ? (
          <div
            style={{
              position: "absolute",
              top: 8,
              left: 8,
              padding: "4px 8px",
              borderRadius: 999,
              background: "rgba(63,81,181,0.92)",
              color: "#fff",
              fontSize: 10,
              fontWeight: 900,
              letterSpacing: 0.6,
              textTransform: "uppercase",
            }}
          >
            On
          </div>
        ) : null}

        {/* value */}
        {value != null && value !== "" ? (
          <div
            style={{
              position: "absolute",
              left: 10,
              right: 10,
              bottom: 10,
              color: "#fff",
              textShadow: "0 2px 6px rgba(0,0,0,0.65)",
            }}
          >
            <Typography
              style={{
                fontWeight: 900,
                fontSize: 16,
                lineHeight: 1.05,
                textAlign: "center",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              }}
              title={String(value)}
            >
              {value}
            </Typography>
          </div>
        ) : null}
      </div>

      {/* FOOTER LABEL */}
      <div
        style={{
          height: 46,
          padding: "8px 10px",
          boxSizing: "border-box",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          borderTop: "1px solid rgba(0,0,0,0.10)",
          background: binaryValue ? "rgba(63,81,181,0.06)" : "rgba(0,0,0,0.02)",
        }}
      >
        <Typography
          variant="caption"
          style={{
            fontWeight: 900,
            letterSpacing: 0.6,
            textTransform: "uppercase",
            textAlign: "center",
            lineHeight: 1.15,
            overflow: "hidden",
            display: "-webkit-box",
            WebkitLineClamp: 2,
            WebkitBoxOrient: "vertical",
          }}
          title={label}
        >
          {label}
        </Typography>
      </div>
    </Box>
  );
}

function toMinutes(hhmm) {
  const [h, m] = hhmm.split(":").map(Number);
  return h * 60 + m;
}

function fromMysqlTime(mysqlTime) {
  // "HH:MM:SS" -> "HH:MM"
  if (!mysqlTime) return "00:00";

  const [h, m] = mysqlTime.split(":").map(Number);

  const hh = String(h).padStart(2, "0");
  const mm = String(m ?? 0).padStart(2, "0");

  return `${hh}:${mm}`;
}

function toMysqlTime(hhmm) {
  // "HH:MM:SS" -> "HH:MM:00"
  return `${hhmm}:00`;
}

function isAscending(values) {
  for (let i = 1; i < values.length; i++) {
    if (toMinutes(values[i]) <= toMinutes(values[i - 1])) return false;
  }
  return true;
}


function TimeOfDaySettings({
  initialTimes,
  onSave, // async (newTimesMysql) => void
  handleCloseParent, // () => void
}) {
  const [open, setOpen] = useState(false);

  // Keep editable form values as "HH:MM" for <input type="time">
  const [form, setForm] = useState(() => ({
    earlyMorning: fromMysqlTime(initialTimes.earlyMorning),
    morning: fromMysqlTime(initialTimes.morning),
    lunch: fromMysqlTime(initialTimes.lunch),
    afternoon: fromMysqlTime(initialTimes.afternoon),
    dinner: fromMysqlTime(initialTimes.dinner),
    evening: fromMysqlTime(initialTimes.evening),
    night: fromMysqlTime(initialTimes.night),
  }));

  const order = ["earlyMorning", "morning", "lunch", "afternoon", "dinner", "evening", "night"];

  const validation = useMemo(() => {
    const vals = order.map((k) => form[k]);
    if (!isAscending(vals)) {
      return "Times must be strictly increasing (e.g. 05:00 < 09:00 < 12:00 ...).";
    }
    return null;
  }, [form]);

  function update(key, value) {
    setForm((prev) => ({ ...prev, [key]: value }));
  }

  function handleSave() {
    if (validation) return;

    const mysqlPayload = Object.fromEntries(
      Object.entries(form).map(([k, v]) => [k, toMysqlTime(v)])
    );

    // Example payload:
    // { earlyMorning: "05:00:00", morning: "09:00:00", ... }
    if (onSave) onSave(mysqlPayload);

    setOpen(false);
  }

  function handleClose() {
    setOpen(false);
    handleCloseParent();
  }

  return (
    <div>
      <button
        type="button"
        onClick={() => setOpen(true)}
        style={{
          padding: "8px 12px",
          borderRadius: 8,
          border: "1px solid #ccc",
          background: "white",
          cursor: "pointer",
        }}
      >
        Edit times of day
      </button>

      {open && (
        <div
          role="dialog"
          aria-modal="true"
          onClick={handleClose}
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(0,0,0,0.4)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: 16,
            zIndex: 9999,
          }}
        >
          <div
            onClick={(e) => e.stopPropagation()}
            style={{
              width: "min(520px, 100%)",
              background: "white",
              borderRadius: 12,
              padding: 16,
              boxShadow: "0 10px 30px rgba(0,0,0,0.2)",
            }}
          >
            <div style={{ display: "flex", justifyContent: "space-between", gap: 12 }}>
              <h3 style={{ margin: 0 }}>Time of day settings</h3>
              <button
                type="button"
                onClick={handleClose}
                style={{ border: "none", background: "transparent", cursor: "pointer", fontSize: 18 }}
                aria-label="Close"
              >
                ✕
              </button>
            </div>

            <p style={{ marginTop: 8, color: "#555" }}>
              Set the start time for each period. (Night is the “everything else” bucket.)
            </p>

            <div style={{ display: "grid", gap: 10, marginTop: 12 }}>
              {order.map((key) => (
                <label
                  key={key}
                  style={{
                    display: "grid",
                    gridTemplateColumns: "1fr 140px",
                    alignItems: "center",
                    gap: 12,
                  }}
                >
                  <span style={{ textTransform: "capitalize" }}>
                    {key.replace(/([A-Z])/g, " $1").toLowerCase()}
                  </span>
                  <input
                    type="time"
                    value={form[key]}
                    onChange={(e) => update(key, e.target.value)}
                    step={60} // minute steps
                    style={{ padding: 6, borderRadius: 8, border: "1px solid #ccc" }}
                  />
                </label>
              ))}
            </div>

            {validation && (
              <div
                style={{
                  marginTop: 12,
                  padding: 10,
                  borderRadius: 10,
                  background: "#fff3f3",
                  border: "1px solid #ffd0d0",
                  color: "#8a1f1f",
                }}
              >
                {validation}
              </div>
            )}

            <div style={{ display: "flex", justifyContent: "flex-end", gap: 10, marginTop: 16 }}>
              <button
                type="button"
                onClick={handleClose}
                style={{
                  padding: "8px 12px",
                  borderRadius: 8,
                  border: "1px solid #ccc",
                  background: "white",
                  cursor: "pointer",
                }}
              >
                Cancel
              </button>
              <button
                type="button"
                onClick={handleSave}
                disabled={!!validation}
                style={{
                  padding: "8px 12px",
                  borderRadius: 8,
                  border: "1px solid #222",
                  background: validation ? "#eee" : "#222",
                  color: validation ? "#888" : "white",
                  cursor: validation ? "not-allowed" : "pointer",
                }}
              >
                Save
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}



function timeToMinutes(timeStr) {
  const [h, m, s] = timeStr.split(':').map(Number);
  return h * 60 + m + (s || 0) / 60;
}


function StateSection(props) {
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedState, setSelectedState] = useState(null);


  /* All states in raw form and respective binary representation */
  const emptyKindOfDay = () => ({
    monday: false,
    tuesday: false,
    wednesday: false,
    thursday: false,
    friday: false,
    saturday: false,
    sunday: false,
    holiday: false,
  });

  
  const emptyTimeOfDay = () => ({
    early_morning: false,
    morning: false,
    lunch: false,
    afternoon: false,
    dinner: false,
    evening: false,
    night: false,
  });

  const emptyWeather = () => ({
    sunny: false,
    rainy: false,
    cloudy: false,
    snowy: false,
    windy: false,
    stormy: false,
    foggy: false,
  });
  const fullWeatherBinary = () => ({
    sunny: true,
    rainy: true,
    cloudy: true,
    snowy: true,
    windy: true,
    stormy: true,
    foggy: true,
  })

  //DateTime
  const [datetime, setDateTime] = useState(new Date()); //returns object with properties for year, month, day, hours, minutes, seconds
  const [kindOfDay, setKindOfDay] = useState(emptyKindOfDay());
  const [timeOfDay, setTimeOfDay] = useState(emptyTimeOfDay());
  const [timeOfDayEarlyMorning, setTimeOfDayEarlyMorning] = useState(props.timeOfDayEarlyMorning);
  const [timeOfDayMorning, setTimeOfDayMorning] = useState(props.timeOfDayMorning);
  const [timeOfDayLunch, setTimeOfDayLunch] = useState(props.timeOfDayLunch);
  const [timeOfDayAfternoon, setTimeOfDayAfternoon] = useState(props.timeOfDayAfternoon);
  const [timeOfDayDinner, setTimeOfDayDinner] = useState(props.timeOfDayDinner);
  const [timeOfDayEvening, setTimeOfDayEvening] = useState(props.timeOfDayEvening);
  const [timeOfDayNight, setTimeOfDayNight] = useState(props.timeOfDayNight);

  
  //Location
  const [geo, setGeo] = useState({
    status: "idle", // idle | requesting | granted | denied | error
    lat: null,
    lon: null,
    accuracy: null,
    error: null,
  });
  const [geoInfo, setGeoInfo] = useState({
    status: "idle", // idle | loading | ok | error
    city: null,
    region: null,
    country: null,
    postcode: null,
    kindOfPlace: null,
    raw: null,
    error: null,
  });
  const [geoPlace, setGeoPlace] = useState('');
  const [regionPhotoSrc, setRegionPhotoSrc] = useState('');

  //Weather
  const [weather, setWeather] = useState({
    status: "idle", // idle | loading | ok | error
    current: null,
    error: null,
  });
  const [weatherBinary, setWeatherBinary] = useState(emptyWeather());

  // every time state changes, fetch tasks
  useEffect(() => {
    props.onStateChange?.({ kindOfDay: kindOfDay, timeOfDay: timeOfDay, weather: weatherBinary });
  }, [kindOfDay, timeOfDay, weatherBinary]);

  // every time geo updates get photo
  useEffect(() => {
    let cancelled = false;

    (async () => {
      const url = await getRegionImage();
      if (!cancelled) setRegionPhotoSrc(url);
    })();

    return () => { cancelled = true; };
  }, [geoInfo]);

  // keep time updated
  useEffect(() => {
    const t = setInterval(() => setDateTime(new Date()), 1000);
    return () => clearInterval(t);
  }, []);

  useEffect(() => {
    const a = getKindOfDay(datetime);
    const b = kindOfDay;
    if (Object.keys(a).every(key => a[key] === b[key]) === false) {
      encodeKindOfDay(datetime);
    }
    const c = getTimeOfDay(datetime);
    const d = timeOfDay;
    if (Object.keys(c).every(key => c[key] === d[key]) === false) {
      encodeTimeOfDay(datetime);
    }
  }, [datetime]);




  function getKindOfDay(date) {
    const k = emptyKindOfDay();
    const dayMap = [
      "sunday",
      "monday",
      "tuesday",
      "wednesday",
      "thursday",
      "friday",
      "saturday",
    ];
    k[dayMap[date.getDay()]] = true;
    return k;
  }
  function encodeKindOfDay(date) {
    const k = getKindOfDay(date);

    setKindOfDay(k);

    // holiday remains false unless you integrate a holiday API

    return k;
  }
  function getKindOfDayImage() {
    if (kindOfDay.monday) return "/monday.png";
    else if (kindOfDay.tuesday) return "/tuesday.png";
    else if (kindOfDay.wednesday) return "/wednesday.png";
    else if (kindOfDay.thursday) return "/thursday.png";
    else if (kindOfDay.friday) return "/friday.png";
    else if (kindOfDay.saturday) return "/saturday.png";
    else if (kindOfDay.sunday) return "/sunday.png";
    else return "/day.png";
  }


  function getTimeOfDay(date) {
    const t = emptyTimeOfDay();
    const h = date.getHours() * 60 + date.getMinutes();
    const timeOfDayEarlyMorningMins = timeToMinutes(timeOfDayEarlyMorning);
    const timeOfDayMorningMins = timeToMinutes(timeOfDayMorning);
    const timeOfDayLunchMins = timeToMinutes(timeOfDayLunch);
    const timeOfDayAfternoonMins = timeToMinutes(timeOfDayAfternoon);
    const timeOfDayDinnerMins = timeToMinutes(timeOfDayDinner);
    const timeOfDayEveningMins = timeToMinutes(timeOfDayEvening);
    const timeOfDayNightMins = timeToMinutes(timeOfDayNight);

    if (h >= timeOfDayEarlyMorningMins && h < timeOfDayMorningMins) t.early_morning = true;
    else if (h >= timeOfDayMorningMins && h < timeOfDayLunchMins) t.morning = true;
    else if (h >= timeOfDayLunchMins && h < timeOfDayAfternoonMins) t.lunch = true;
    else if (h >= timeOfDayAfternoonMins && h < timeOfDayDinnerMins) t.afternoon = true;
    else if (h >= timeOfDayDinnerMins && h < timeOfDayEveningMins) t.dinner = true;
    else if (h >= timeOfDayEveningMins && h < timeOfDayNightMins) t.evening = true;
    else t.night = true;
    return t;
  }
  function encodeTimeOfDay(date) {
    const t = getTimeOfDay(date);

    setTimeOfDay(t);
    return t;
  }
  function getTimeOfDayImage() {
    if (timeOfDay.early_morning) return "/early_morning.png";
    else if (timeOfDay.morning) return "/morning.png";
    else if (timeOfDay.lunch) return "/lunch.png";
    else if (timeOfDay.afternoon) return "/afternoon.png";
    else if (timeOfDay.dinner) return "/dinner.png";
    else if (timeOfDay.evening) return "/evening.png";
    else if (timeOfDay.night) return "/night.png";
    else return "/time.png";
  }
  function getTimeOfDayLabel() {
    if (timeOfDay.early_morning) return "Sunrise";
    else if (timeOfDay.morning) return "Morning";
    else if (timeOfDay.lunch) return "Lunch";
    else if (timeOfDay.afternoon) return "Afternoon";
    else if (timeOfDay.dinner) return "Dinner";
    else if (timeOfDay.evening) return "Evening";
    else if (timeOfDay.night) return "Night";
    else return "Unknown";
  }


  // For Open-Meteo current weather fields
  function encodeWeather(current) {
    const w = emptyWeather();
    if (!current) return w;

    const code = current.weather_code;

    if ([0].includes(code)) w.sunny = true;
    else if ([1, 2, 3].includes(code)) w.cloudy = true;
    else if ([45, 48].includes(code)) w.foggy = true;
    else if ([51, 53, 55, 61, 63, 65].includes(code)) w.rainy = true;
    else if ([71, 73, 75, 77].includes(code)) w.snowy = true;
    else if ([95, 96, 99].includes(code)) w.stormy = true;

    if (Number(current.wind_speed_10m) >= 20) w.windy = true;

    setWeatherBinary(w);
    return w;
  }
  function getWeatherImage() {
    if (weatherBinary.sunny) return "/sunny.png";
    else if (weatherBinary.rainy) return "/rainy.png";
    else if (weatherBinary.cloudy) return "/cloudy.png";
    else if (weatherBinary.snowy) return "/snowy.png";
    else if (weatherBinary.windy) return "/windy.png";
    else if (weatherBinary.stormy) return "/stormy.png";
    else if (weatherBinary.foggy) return "/foggy.png";
    else return "/weather.png";
  }

 


  const getRegionImage = async () => {
    if (!geoInfo.region) return "/location.png";

    const query = `${geoInfo.region}`;

    try {
      const res = await fetch(
        "https://commons.wikimedia.org/w/api.php?" +
          new URLSearchParams({
            action: "query",
            format: "json",
            origin: "*",          // CORS
            generator: "search",
            gsrsearch: query,
            gsrnamespace: "6",    // File namespace
            gsrlimit: "1",
            prop: "imageinfo",
            iiprop: "url",
          })
      );

      const data = await res.json();
      const pages = data?.query?.pages;
      console.log(pages);

      if (!pages) return "/location.png";

      const image = Object.values(pages)[0]?.imageinfo?.[0]?.url;
      return image || "/location.png";
    } catch {
      return "/location.png";
    }
  };
  

  const setUserTimes = (times) => {
    fetch(SERVER_LINK + '/set_times_of_day', {
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'SimpTokAuth': props.tokenPass
        },
        body: JSON.stringify(times)
      }).then((response) => response.json())
        .then((data) => {if (data=='SUCCESS') { handleClose();} else {console.log('Times couldnt be set: ' + data)}} )
        .catch((error) => console.log(error))
  }
  
  

  const requestLocation = React.useCallback(async () => {
    if (!("geolocation" in navigator)) {
      setGeo({
        status: "error",
        lat: null,
        lon: null,
        accuracy: null,
        error: "Geolocation not supported.",
      });
      setGeoInfo({
        status: "error",
        city: null,
        region: null,
        country: null,
        postcode: null,
        kindOfPlace: null,
        raw: null,
        error: "Geolocation not supported.",
      });
      return;
    }

    setGeo((g) => ({ ...g, status: "requesting", error: null }));
    setGeoInfo((x) => ({ ...x, status: "loading", error: null }));

    // Wrap getCurrentPosition in a Promise so we can await it
    const getPos = () =>
      new Promise((resolve, reject) => {
        navigator.geolocation.getCurrentPosition(resolve, reject, {
          enableHighAccuracy: true,
          timeout: 10000,
          maximumAge: 5 * 60 * 1000,
        });
      });

    try {
      const pos = await getPos();

      const lat = pos.coords.latitude;
      const lon = pos.coords.longitude;
      const accuracy = pos.coords.accuracy;

      setGeo({
        status: "granted",
        lat,
        lon,
        accuracy,
        error: null,
      });

      // Reverse geocode using OpenStreetMap Nominatim
      // Note: be mindful of rate limits. This is great for prototyping.
      const url =
        `https://nominatim.openstreetmap.org/reverse` +
        `?format=jsonv2&lat=${encodeURIComponent(lat)}&lon=${encodeURIComponent(lon)}` +
        `&zoom=18&addressdetails=1`;

      const res = await fetch(url, {
        headers: {
          // Nominatim asks for an identifiable UA/Referer; browser controls UA.
          // This header may be ignored by browsers; it's still okay for basic usage.
          Accept: "application/json",
        },
      });

      if (!res.ok) throw new Error(`Reverse geocode failed: ${res.status}`);
      const data = await res.json();

      const addr = data.address || {};
      const city =
        addr.city || addr.town || addr.village || addr.hamlet || addr.suburb || null;

      // "kind of place" (rough): Nominatim provides `class` + `type`
      const kindOfPlace =
        data?.type || null;

      setGeoInfo({
        status: "ok",
        city: city,
        region: addr.state || addr.region || null,
        country: addr.country || null,
        postcode: addr.postcode || null,
        kindOfPlace: kindOfPlace,
        raw: data, // keep raw if you want deeper mapping later
        error: null,
      });
    } catch (err) {
      // Handle permission denied / timeout nicely
      const msg =
        err?.code === 1
          ? "Permission denied."
          : err?.code === 2
          ? "Position unavailable."
          : err?.code === 3
          ? "Location request timed out."
          : err?.message || "Location error.";

      setGeo({
        status: "denied",
        lat: null,
        lon: null,
        accuracy: null,
        error: msg,
      });

      setGeoInfo({
        status: "error",
        city: null,
        region: null,
        country: null,
        postcode: null,
        kindOfPlace: null,
        raw: null,
        error: msg,
      });
    }
  }, []);

  useEffect(() => {
    requestLocation();
  }, [requestLocation]);

  // fetch current weather after location granted
  useEffect(() => {
    async function fetchWeather(lat, lon) {
      try {
        setWeather({ status: "loading", current: null, error: null });

        const url =
          `https://api.open-meteo.com/v1/forecast` +
          `?latitude=${encodeURIComponent(lat)}` +
          `&longitude=${encodeURIComponent(lon)}` +
          `&current=temperature_2m,relative_humidity_2m,apparent_temperature,wind_speed_10m,weather_code` +
          `&temperature_unit=fahrenheit` +
          `&wind_speed_unit=mph`;

        const res = await fetch(url);
        if (!res.ok) throw new Error(`Weather request failed: ${res.status}`);
        const json = await res.json();

        setWeather({ status: "ok", current: json.current, error: null });
        encodeWeather(json.current);
      } catch (e) {
        setWeather({
          status: "error",
          current: null,
          error: e.message || "Weather fetch error.",
        });
      }
    }

    if (geo.status === "granted" && geo.lat != null && geo.lon != null) {
      fetchWeather(geo.lat, geo.lon);
    }
  }, [geo.status, geo.lat, geo.lon]);



  const handleOpen = (event, item) => {
    setAnchorEl(event.currentTarget);
    setSelectedState(item);
  };

  const handleClose = () => {
    setAnchorEl(null);
    setSelectedState(null);
  };

  

  return (
    
    <Box
      sx={{
        height: "100%",          // fill the STATE section
        display: "flex",
        flexDirection: "column",
        minHeight: 0,            // IMPORTANT for scroll to work
      }}
    >
      {/* SCROLL CONTAINER */}
      <Box
        sx={{
          flex: 1,               // take remaining space
          overflowY: "auto",
          minHeight: 0,          // IMPORTANT
          pb: 2,               // space for scrollbar
          pt:1
        }}
      >
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fill, 114px)",
            gap: 6.5,
          }}
        >
          <StateTile
              key={'0'}
              image={getKindOfDayImage()}
              label={'DAY'}
              value={datetime.toLocaleDateString()}
              binaryValue={JSON.stringify(kindOfDay)}
              onClick={(event) => handleOpen(event, '0')}
            />
          <StateTile
              key={'1'}
              image={getTimeOfDayImage()}
              label={'TIME'}
              value={getTimeOfDayLabel()}
              binaryValue={JSON.stringify(timeOfDay)}
              onClick={(event) => handleOpen(event, '1')}
            />
          <StateTile
              key={'2'}
              image={getWeatherImage()}
              label={'WEATHER'}
              value={weather.status === "ok" ? JSON.stringify(weather.current.temperature_2m) + "°F" : "N/A"}
              binaryValue={JSON.stringify(weatherBinary)}
              onClick={(event) => handleOpen(event, '2')}
            />


        </Box>
      </Box>
      {/* 🔥 SMALL MODAL (Popover) */}
      <Popover
          open={Boolean(anchorEl)}
          anchorEl={anchorEl}
          onClose={handleClose}
          anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
          transformOrigin={{ vertical: "top", horizontal: "left" }}
          PaperProps={{
            style: { width: 280, padding: 16, borderRadius: 8 },
          }}
        >
          {selectedState && (
            selectedState === '0' ?
            <div>
              <Typography variant="h6" gutterBottom>Kind of Day</Typography>
              <pre></pre>
            </div> :
            selectedState === '1' ?
            <div>
              <Typography variant="h6" gutterBottom>Time of Day</Typography>
              
              <TimeOfDaySettings
                  initialTimes={{earlyMorning: timeOfDayEarlyMorning, morning: timeOfDayMorning, lunch: timeOfDayLunch, afternoon: timeOfDayAfternoon, dinner: timeOfDayDinner, evening: timeOfDayEvening, night: timeOfDayNight}} // MySQL format "HH:MM:SS"
                  onSave={(newTimesMysql) => {
                    console.log("New times (MySQL format):", newTimesMysql);
                    setTimeOfDayEarlyMorning(newTimesMysql.earlyMorning);
                    setTimeOfDayMorning(newTimesMysql.morning);
                    setTimeOfDayLunch(newTimesMysql.lunch);
                    setTimeOfDayAfternoon(newTimesMysql.afternoon);
                    setTimeOfDayDinner(newTimesMysql.dinner);
                    setTimeOfDayEvening(newTimesMysql.evening);
                    setTimeOfDayNight(newTimesMysql.night);
                    setUserTimes(newTimesMysql);
                    handleClose();
                  }}
                  handleCloseParent={() => handleClose()}
                />
            </div> :
            selectedState === '2' ?
            <div>
              <Typography variant="h6" gutterBottom>Weather</Typography>
              <pre></pre>
            </div> :
            <div></div>

          )}
        </Popover>
    </Box>
  );
}

function MetricRow({ metric, expanded, onToggle, onSubmit }) {
  const [value, setValue] = useState("");
  const [hover, setHover] = useState(false);

  const overdueLabel = useMemo(() => {
    const h = Number(metric.hours_overdue);
    if (!Number.isFinite(h)) return "—";
    if (h <= 0) return "On time";
    return `${h}h overdue`;
  }, [metric.hours_overdue]);

  const overdue = Number(metric.hours_overdue);
  const isOverdue = Number.isFinite(overdue) && overdue > 0;

  const canSubmit = value.toString().trim().length > 0;

  const borderColor = expanded
    ? "rgba(0,0,0,0.22)"
    : hover
    ? "rgba(0,0,0,0.18)"
    : "rgba(0,0,0,0.10)";

  const shadow = expanded
    ? "0 10px 26px rgba(0,0,0,0.12)"
    : hover
    ? "0 8px 22px rgba(0,0,0,0.10)"
    : "0 1px 0 rgba(0,0,0,0.04)";

  const transform = expanded ? "scale(1.01)" : hover ? "translateY(-2px)" : "none";

  return (
    <Paper
      elevation={0}
      role="button"
      tabIndex={0}
      onClick={onToggle}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          onToggle?.();
        }
      }}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      style={{
        width: "100%",
        minWidth: 0,
        borderRadius: 14,
        overflow: "hidden",
        border: `1px solid ${borderColor}`,
        background: expanded ? "rgba(0,0,0,0.02)" : "#fff",
        boxShadow: shadow,
        transform,
        transition:
          "transform 160ms ease, box-shadow 160ms ease, border-color 160ms ease, background-color 160ms ease",
        cursor: "pointer",
        userSelect: "none",
      }}
    >
      {/* Header */}
      <div
        style={{
          padding: "14px 14px 12px",
          minHeight: 64,
          display: "grid",
          gridTemplateColumns: "minmax(0, 1fr) auto 28px", // ✅ name can shrink, chip stays visible
          alignItems: "center",
          gap: 10,
          boxSizing: "border-box",
        }}
      >
        {/* Name + units (never overlaps chip) */}
        <div style={{ minWidth: 0 }}>
          <Typography
            variant="caption"
            style={{
              fontWeight: 900,
              letterSpacing: 0.9,
              textTransform: "uppercase",
              opacity: 0.7,
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap", // ✅ keep header clean
              display: "block",     // ✅ ensures ellipsis works
            }}
            title={(metric.name ?? "UNNAMED METRIC").toString()}
          >
            {(metric.name ?? "UNNAMED METRIC").toString()}
          </Typography>

          <Typography
            variant="body2"
            style={{
              marginTop: 6,
              fontWeight: 900,
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              display: "block",
              opacity: 0.9,

            }}
            title={metric.units ?? ""}
          >
            {metric.units ?? " "}
          </Typography>
        </div>

        {/* Overdue pill (always visible) */}
        <div
          style={{
            padding: "6px 10px",
            borderRadius: 999,
            border: `1px solid ${isOverdue ? "rgba(244,67,54,0.35)" : "rgba(0,0,0,0.10)"}`,
            background: isOverdue ? "rgba(244,67,54,0.08)" : "rgba(0,0,0,0.02)",
            color: isOverdue ? "rgba(244,67,54,0.95)" : "rgba(0,0,0,0.60)",
            fontWeight: 900,
            fontSize: 12,
            whiteSpace: "nowrap",
            flex: "0 0 auto",
          }}
        >
          {overdueLabel}
        </div>

        {/* Expand icon */}
        <div
          style={{
            width: 28,
            height: 28,
            borderRadius: 999,
            display: "grid",
            placeItems: "center",
            background: "rgba(0,0,0,0.04)",
            border: "1px solid rgba(0,0,0,0.08)",
            transform: expanded ? "rotate(180deg)" : "rotate(0deg)",
            transition: "transform 160ms ease",
          }}
        >
          <ExpandMoreIcon fontSize="small" />
        </div>
      </div>

      {/* Expanded */}
      <Collapse in={expanded} timeout={200} unmountOnExit>
        <div style={{ padding: "0 14px 14px", boxSizing: "border-box" }}>
          <div
            style={{
              borderTop: "1px solid rgba(0,0,0,0.08)",
              paddingTop: 12,
              display: "grid",
              gap: 12,
            }}
          >
            <Typography variant="body2" style={{ lineHeight: 1.6, opacity: 0.82 }}>
              {metric.instructions || metric.intructions || "No instructions provided."}
            </Typography>

            <div
              onClick={(e) => e.stopPropagation()}
              style={{
                display: "grid",
                gridTemplateColumns: "minmax(0, 1fr) auto",
                gap: 10,
                alignItems: "center",
              }}
            >
              <TextField
                value={value}
                onChange={(e) => setValue(e.target.value)}
                label="Measured value"
                variant="outlined"
                fullWidth
                inputProps={{ inputMode: "decimal" }}
              />

              <div
                style={{
                  padding: "10px 12px",
                  borderRadius: 12,
                  border: "1px solid rgba(0,0,0,0.10)",
                  background: "rgba(0,0,0,0.02)",
                  fontWeight: 900,
                  whiteSpace: "nowrap",
                  width: "100px",
                  textAlign: "center",
                  textOverflow: "ellipsis",
                  overflow: "hidden",
                }}
                title={metric.units ?? ""}
              >
                {metric.units ?? "—"}
              </div>
            </div>

            <div
              onClick={(e) => e.stopPropagation()}
              style={{ display: "flex", justifyContent: "flex-end" }}
            >
              <Button
                variant="contained"
                disabled={!canSubmit}
                onClick={() => onSubmit?.(metric, value)}
                style={{
                  borderRadius: 999,
                  textTransform: "none",
                  fontWeight: 900,
                  padding: "10px 18px",
                  backgroundImage: "linear-gradient(135deg, #ff6a00, #ff00a8)",
                  boxShadow: "0 8px 22px rgba(255, 0, 168, 0.22)",
                  opacity: canSubmit ? 1 : 0.6,
                }}
              >
                Submit
              </Button>
            </div>
          </div>
        </div>
      </Collapse>
    </Paper>
  );
}



function MetricsSection(props) {
  const [expandedKey, setExpandedKey] = useState(null);

  const [fetchingMetrics, setFetchingMetrics] = useState(false);
  const [metrics, setMetrics] = useState([]);

  useEffect(() => {
    fetchMetrics();
  }, []);

  const fetchMetrics = () => {
    //fetch tasks from backend
    //dummy data for now
    setFetchingMetrics(true);
    fetch(SERVER_LINK + '/get_metrics_to_measure', {
        method: 'GET',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'SimpTokAuth': props.tokenPass
        }
      }).then((response) => response.json())
        .then((data) => {if (Array.isArray(data)) {setMetrics(data); console.log(data)} else {console.log('Status couldnt be set: ' + data)}} )
        .catch((error) => console.log(error))
        .finally(() => setFetchingMetrics(false));
  }

  const submitMetricMeasurement = (metric, value) => {
    //submit metric measurement to backend
    fetch(SERVER_LINK + '/submit_metric_measurement', {
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'SimpTokAuth': props.tokenPass
        },
        body: JSON.stringify({
            metric_id: metric.id,
            value: value
        })
      }).then((response) => response.json())
        .then((data) => {if (data === "SUCCESS") {alert("Metric submitted successfully!"); fetchMetrics();} else {alert("Failed to submit metric.");}} )
        .catch((error) => console.log(error));
  }

  return fetchingMetrics ? (
              <CircularProgress />
            ) : (
              <Box
                style={{
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                  minHeight: 0,
                  boxSizing: "border-box",
                  marginLeft: -5,
                }}
              >
                {/* Header */}
                <Typography
                  variant="subtitle1"
                  style={{
                    fontWeight: 900,
                    marginBottom: 0,   // ✅ was mb: 1 (ignored)
                    letterSpacing: 0.6,
                    opacity: 0.85,
                    marginLeft: 5,

                  }}
                >
                  TRACKING METRICS
                </Typography>

                {/* Scrollable list */}
                <Box
                  style={{
                    flex: "1 1 auto",      // ✅ was sx={{ flex: 1 }} (ignored)
                    overflowY: "auto",     // ✅ was sx (ignored)
                    minHeight: 0,
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  {metrics.map((metric, index) => {
                    const key = metric.id ?? metric.metric_id ?? index;
                    const expanded = expandedKey === key;

                    return (
                      <div key={key} style={{ marginBottom: 5, marginLeft:5, marginRight:5, marginTop: 5 }}>
                        <MetricRow
                          metric={metric}
                          expanded={expanded}
                          onToggle={() => setExpandedKey(expanded ? null : key)}
                          onSubmit={(m, val) => submitMetricMeasurement(m, val)}
                        />
                      </div>
                    );
                  })}

                  {metrics.length === 0 && (
                    <Typography
                      variant="body2"
                      color="textSecondary"
                      style={{ textAlign: "center", marginTop: 16 }}
                    >
                      No metrics to measure right now.
                    </Typography>
                  )}
                </Box>
              </Box>
            );
}


function TaskWindow(props) {

  const durationMin = props.task.task_duration || props.task.task_durantion || 0;
  const [seconds, setSeconds] = useState(props.initialTimeElapsed || 0);
  const [isActive, setIsActive] = useState(true);

  const [findingContent, setFindingContent] = useState(false);

  useEffect(() => {
    let interval = null;
    if (isActive) {
      interval = setInterval(() => {
        setSeconds((s) => s + 1);
      }, 1000);
    } else {
      clearInterval(interval);
    }
    return () => clearInterval(interval);
  }, [seconds]);

  const [dimensions, setDimensions] = useState({ 
    height: window.innerHeight,
    width: window.innerWidth
  })

  useEffect(() => {
    window.addEventListener('resize', handleResize)
    
  }, [])

  const handleResize = () => {
    setDimensions({
      height: window.innerHeight,
      width: window.innerWidth
    }) 
  }

  const formatTime = (totalSeconds) => {
    const mins = Math.floor(totalSeconds / 60);
    const secs = totalSeconds % 60;
    return `${mins}:${secs.toString().padStart(2, "0")}`;
  };

  return (
    <div>
    <Box
      sx={{
        height: "100%",
        width: dimensions.width - 96, // account for sidebar
        display: "flex",
        flexDirection: "column",
        p: 6,
        paddingTop: 14,
        paddingBottom: 8,
        bgcolor: "background.paper",
        overflow: "hidden",

      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "flex-start",
          mb: 2,
          overflow: "scroll",
          height: 80,
        }}
      >
        <Box>
          <Typography
            variant="caption"
            style={{ fontWeight: 900, color: "primary.main", mb: 1, display: "block" }}
          >
            {(props.task.goal_name || "TASK").toUpperCase()}
          </Typography>
          <Typography variant="h3" fontWeight={900}>
            {props.task.task_name}
          </Typography>
        </Box>
      </Box>
      
      <Box sx={{ color: "text.secondary", mb: 2, height: 60, overflow: "scroll", textOverflow: "ellipsis" }}>
        {props.task.task_description || "No description provided for this task."}
      </Box>
      
      <Box style={{
              height: dimensions.height - 407, // adjust based on header/footer size
              overflow: "scroll", // <-- scroll within this region
              mb: 2,            // optional spacing
            }}>
        <EmbeddingsFeedHome embeddingText={props.task.task_search_text} tokenPass={props.tokenPass} />
      </Box>
      
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          marginTop: 10
        }}
      >
        <Typography
          style={{
            fontSize: "2rem",
            fontWeight: 950,
            lineHeight: 1,
            letterSpacing: "-0.02em",
            mb: 2,
          }}
        >
          {formatTime(seconds)}
        </Typography>

        <Typography variant="h5" color="text.secondary" style={{ fontWeight: 700, mb: 4 }}>
          / {durationMin}:00
        </Typography>

        <Box style={{ width: "100%", maxWidth: 800, mb: 2 }}>
          <LinearProgress
            variant="determinate"
            value={Math.min(100, (seconds / (durationMin * 60 || 1)) * 100)}
            color={seconds > (durationMin * 60) ? "error" : "primary"}
            style={{ height: 14, borderRadius: 12, backgroundColor: seconds > (durationMin * 60) ? "#ff0000" : "grey.200" }}
          />
        </Box>

        <Box style={{ display: "flex", gap: 10, marginTop: 10 }}>
          <Button 
            variant="contained"
            size="large"
            onClick={props.pauseTask}
            style={{
              height: 50,
              px: 6,
              borderRadius: 40,
              fontSize: "1.5rem",
              fontWeight: 900,
              boxShadow: 10,
              
            }}
          >
            PAUSE
          </Button>
          <Button
            variant="contained"
            size="large"
            onClick={props.taskSkipped}
            style={{
              height: 50,
              px: 6,
              borderRadius: 40,
              fontSize: "1.5rem",
              fontWeight: 900,
              boxShadow: 10,
            }}
          >
            SKIP
          </Button>
          <Button
            variant="contained"
            size="large"
            onClick={props.taskDone}
            style={{
              height: 50,
              px: 6,
              borderRadius: 40,
              fontSize: "1.5rem",
              fontWeight: 900,
              boxShadow: 10,
              marginRight: 20,
              background: "linear-gradient(135deg, #5af95a, #5c745b)",
              "&:hover": {
                background: "linear-gradient(135deg, #4ae44a, #4c634b)",
              },
              "&:active": {
                background: "linear-gradient(135deg, #3ae03a, #3c523b)",
              },
            }}
          >
            DONE
          </Button>
          {/** Yellowish button */}
          <Button 
            variant="contained"
            size="large"
            onClick={() => {setFindingContent(true);}}
            style={{
              height: 50,
              px: 6,
              borderRadius: 40,
              fontSize: "1.5rem",
              fontWeight: 900,
              boxShadow: 10,
              background: "linear-gradient(135deg, #f9f95a, #746f5c)",
              "&:hover": {
                background: "linear-gradient(135deg, #f0f04a, #645e4c)",
              },
              "&:active": {
                background: "linear-gradient(135deg, #e5eb3a, #544e3c)",
              },
            }}
          >
            HELP
          </Button>
        </Box>
      </Box>
    </Box>
    {findingContent ?  <div className="infoi"> 
                              <div className="centeredBox"> 
                                    <div>
                                      <Button style={{'float': 'right'}}
                                              onClick={() => {setFindingContent(false)}}>
                                        <CloseIcon/>
                                      </Button>
                                      <h4>Search for content related to this task in the popular platforms</h4>
                                        <Button onClick={() => {window.open('https://www.youtube.com/results?search_query=' + props.task.task_search_text); setFindingContent(false)}}>
                                          YouTube
                                        </Button>
                                        <Button onClick={() => {window.open('https://www.reddit.com/search/?q=' + props.task.task_search_text); setFindingContent(false)}}>
                                          Reddit
                                        </Button>
                                        <Button onClick={() => {window.open('https://twitter.com/search?q=' + props.task.task_search_text); setFindingContent(false)}}>
                                          Twitter / X
                                        </Button>
                                         <Button onClick={() => {window.open('https://www.google.com/search?q=' + props.task.task_search_text); setFindingContent(false)}}>
                                          Google
                                          </Button>
                                          <Button onClick={() => {window.open('https://www.linkedin.com/search/results/content/?keywords=' + props.task.task_search_text); setFindingContent(false)}}>
                                          Linkedin
                                          </Button>
                                    </div>
                              </div>
                            </div>: <div></div>}
                            </div>
  );
      
}



function TaskRow({ task, onTaskStart, onTaskNotRelevant }) {
  const classes = useStylesTaskRow();
  const [expanded, setExpanded] = useState(false);

  const goal = useMemo(
    () => (task?.goal_name ?? "").toString().trim().toUpperCase(),
    [task]
  );

  const duration = task?.task_duration ?? task?.task_durantion; // keep your fallback

  const toggle = useCallback(() => setExpanded((v) => !v), []);

  const onKeyDown = (e) => {
    // accessible: Enter / Space toggles
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      toggle();
    }
  };

  const stop = (e) => e.stopPropagation();

  return (
    <Paper
      role="button"
      tabIndex={0}
      elevation={0}
      onClick={toggle}
      onKeyDown={onKeyDown}
      className={`${classes.root} ${expanded ? classes.expanded : ""}`}
      aria-expanded={expanded}
    >
      {/* Header row */}
      <Box className={classes.header}>
          <Chip
            size="small"
            label={goal || "NO GOAL"}
            className={classes.goalChip}
            color={goal ? "default" : "secondary"}
            variant="outlined"
            onClick={stop} // prevents toggling if you want chip interactions later
          />

          <Typography variant="body2" className={classes.duration}>
            {typeof duration === "number" ? `${duration} min` : "—"}
          </Typography>
      </Box>

      {/* Title */}
      <Typography variant="h5" align="center" className={classes.title}>
        {task?.task_name}
      </Typography>

      {/* Expandable */}
      <Collapse in={expanded} timeout={200} unmountOnExit>
        <Box className={classes.details}>
          <Typography variant="body2" color="textSecondary">
            {task?.task_description ? task.task_description : "No description."}
          </Typography>

          <Box className={classes.actionsRow}>
            <Button
              variant="outlined"
              className={classes.ghostBtn}
              startIcon={<NotInterestedIcon />}
              onClick={(e) => {
                stop(e);
                onTaskNotRelevant?.(task);
              }}
            >
              Not relevant
            </Button>

            <Button
              variant="contained"
              className={classes.primaryBtn}
              startIcon={<PlayArrowIcon />}
              onClick={(e) => {
                stop(e);
                onTaskStart?.(task);
              }}
            >
              Start
            </Button>
          </Box>
        </Box>
      </Collapse>
    </Paper>
  );
}


function PausedTaskRow({ task, onTaskResume }) {
  const classes = useStylesTaskRow();
  const [expanded, setExpanded] = useState(false);

  const goal = useMemo(
    () => (task?.goal_name ?? "").toString().trim().toUpperCase(),
    [task]
  );
  const totalDuration =
    task.task_duration ?? task.task_durantion;

  const elapsedMinutes = secondsToMinutes(task.time_elapsed || 0);

  const durationText = useMemo(() => {
    if (elapsedMinutes != null && typeof totalDuration === "number") {
      return `${elapsedMinutes} / ${totalDuration} min`;
    }
    if (elapsedMinutes != null) {
      return `${elapsedMinutes} min elapsed`;
    }
    if (typeof totalDuration === "number") {
      return `${totalDuration} min`;
    }
    return "—";
  }, [elapsedMinutes, totalDuration]);

  const toggle = useCallback(() => setExpanded((v) => !v), []);

  const onKeyDown = (e) => {
    // accessible: Enter / Space toggles
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      toggle();
    }
  };

  const stop = (e) => e.stopPropagation();

  return (
    <Paper
      role="button"
      tabIndex={0}
      elevation={0}
      onClick={toggle}
      onKeyDown={onKeyDown}
      className={`${classes.root} ${expanded ? classes.expanded : ""}`}
      aria-expanded={expanded}
    >
      {/* 🔴 PAUSED BANNER */}
      <Box
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          height: 28,
          borderTopLeftRadius: 3,
          borderTopRightRadius: 3,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          background:
            "linear-gradient(135deg, #fff587, #ffe134)",
        }}
      >
        <Typography
          variant="caption"
          style={{
            fontWeight: 900,
            letterSpacing: 1.2,
            color: "white",
          }}
        >
          PAUSED TASK
        </Typography>
      </Box>

      {/* Header row */}
      <Box className={classes.header_paused}
      >
          <Chip
            size="small"
            label={goal || "NO GOAL"}
            className={classes.goalChip}
            color={goal ? "default" : "secondary"}
            variant="outlined"
            onClick={stop} // prevents toggling if you want chip interactions later
          />

          <Typography variant="body2" className={classes.durationPaused}>
            {durationText}
          </Typography>
      </Box>

      {/* Title */}
      <Typography variant="h5" align="center" className={classes.title}>
        {task?.task_name}
      </Typography>

      {/* Expandable */}
      <Collapse in={expanded} timeout={200} unmountOnExit>
        <Box className={classes.details}>
          <Typography variant="body2" color="textSecondary">
            {task?.task_description ? task.task_description : "No description."}
          </Typography>

          <Box className={classes.actionsRow}>
                <Button
                variant="contained"
                onClick={(e) => {
                  e.stopPropagation();
                  onTaskResume?.(task);
                }}
                className={classes.resumeBtn}
                startIcon={<PlayArrowIcon />}
              >
                RESUME
              </Button>
          </Box>
        </Box>
      </Collapse>
    </Paper>
  );
}



function TaskSection({ tasks = [], pausedTasks = [], onTaskStart, onTaskResume, onTaskNotRelevant }) {


  const onTaskClick = (task) => {
    console.log("Task clicked:", task);
    // Implement task click behavior here
  };

  


  return (
    <div>
      {pausedTasks.map((task, index) => (
        <PausedTaskRow
          key={task.instance_id ?? `${task.task_name}-${index}`}
          task={task}
          onClick={onTaskClick}
          onTaskResume={() => onTaskResume(task)}
          color="secondary"
        />
      ))}
      {tasks.map((task, index) => (
        <Box style={{ minWidth: 0 }}>
        <TaskRow
          key={task.id ?? `${task.task_name}-${index}`}
          task={task}
          onClick={onTaskClick}
          onTaskStart={() => onTaskStart(task)}
          onTaskNotRelevant={() => onTaskNotRelevant(task)}
          color="primary"
        />
        </Box>
      ))}
      

      {((tasks.length === 0) && (pausedTasks.length === 0))  && (
        <Typography
          variant="body2"
          color="text.secondary"
          style={{ textAlign: "center", mt: 2 }}
        >
          No tasks yet. Go to planner and try to add a goal!
        </Typography>
      )}
      </div>
  );
}


function MoodPickerCard({
  currentMood,
  moods,
  onSelectMood,
  onAddMood,
  onRemoveMood,
}) {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const [hover, setHover] = useState(false);

  const safeMood = currentMood || { name: "neutral", imageUrl: "" };

  const moodList = useMemo(() => Array.isArray(moods) ? moods : [], [moods]);

  return (
    <>
      <Card
        elevation={0}
        role="button"
        tabIndex={0}
        style={{
          width: 357,
          height: 140,
          borderRadius: 14,
          overflow: "hidden",
          /* --- modern interaction --- */
          border: `1px solid ${
            (hover || open) ? "rgba(0,0,0,0.18)" : "rgba(0,0,0,0.10)"
          }`,
          boxShadow: (hover || open)
            ? "0 10px 26px rgba(3, 3, 3, 0.14)"
            : "0 1px 0 rgba(0,0,0,0.04)",
          transform: (hover || open) ? "translateY(-2px)" : "translateY(0)",
          transition:
            "transform 160ms ease, box-shadow 160ms ease, border-color 160ms ease",

          backgroundColor: "#fff",
          cursor: "pointer",
          userSelect: "none",
          display: "flex",
          alignItems: "center",
          padding: 14,
          boxSizing: "border-box",
          gap: 14,
        }}
        onClick={(e) => setAnchorEl(e.currentTarget)}
        onMouseEnter={() => setHover(true)}
        onMouseLeave={() => setHover(false)}
      >
        {/* Left: square image */}
        <div
          style={{
            width: 118,
            height: 118,
            borderRadius: 12,
            overflow: "hidden",
            background: "rgba(0,0,0,0.04)",
            border: "1px solid rgba(0,0,0,0.08)",
            flex: "0 0 auto",
            display: "grid",
            placeItems: "center",
          }}
        >
          {safeMood.imageUrl ? (
            <img
              src={safeMood.imageUrl}
              alt={safeMood.name.replace(/_/g, ' ').toUpperCase()}
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
                display: "block",
              }}
              onError={(e) => {
                e.currentTarget.style.display = "none";
              }}
            />
          ) : (
            <div style={{ opacity: 0.6, fontSize: 12 }}>No image</div>
          )}
        </div>

        {/* Right: text */}
        <div style={{ minWidth: 0, flex: "1 1 auto" }}>
          <Typography
            variant="caption"
            style={{
              fontWeight: 1900,
              letterSpacing: 0.8,
              textTransform: "uppercase",
              opacity: 0.7,
            }}
          >
            Current mood
          </Typography>

          <Typography
            variant="h5"
            style={{
              marginTop: 6,
              fontWeight: 900,
              letterSpacing: "-0.2px",
              lineHeight: 1.15,
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
            title={safeMood.name.replace(/_/g, ' ').toUpperCase()}
          >
            {safeMood.name.replace(/_/g, ' ').toUpperCase()}
          </Typography>
        </div>
      </Card>

      {/* Dropdown */}
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={() => setAnchorEl(null)}
        getContentAnchorEl={null}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        transformOrigin={{ vertical: "top", horizontal: "left" }}
        PaperProps={{
          style: {
            width: 337,
            borderRadius: 12,
            border: "1px solid rgba(0,0,0,0.10)",
            overflow: "scroll",
          },
        }}
      >
        {moodList.length === 0 ? (
          <MenuItem disabled>No moods yet</MenuItem>
        ) : (
          moodList.map((m) => (
            <MenuItem
              key={m.name}
              onClick={() => {
                onSelectMood?.(m);
                setAnchorEl(null);
              }}
              style={{
                display: "flex",
                alignItems: "center",
                gap: 10,
                paddingTop: 10,
                paddingBottom: 10,
                backgroundColor: currentMood?.name === m.name ? "rgba(0,0,0,0.04)" : undefined,
              }}
            >
              <div
                style={{
                  width: 28,
                  height: 28,
                  borderRadius: 8,
                  overflow: "hidden",
                  background: "rgba(0,0,0,0.04)",
                  border: "1px solid rgba(0,0,0,0.08)",
                  flex: "0 0 auto",
                }}
              >
                {m.imageUrl ? (
                  <img
                    src={m.imageUrl}
                    alt={m.name}
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                      display: "block",
                    }}
                    onError={(e) => {
                      e.currentTarget.style.display = "none";
                    }}
                  />
                ) : null}
              </div>

              <Typography
                variant="body2"
                style={{
                  fontWeight: 800,
                  minWidth: 0,
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                  flex: "1 1 auto",
                }}
              >
                {m.name.replace(/_/g, ' ').toUpperCase()}
              </Typography>

              {currentMood?.name === m.name ? (
                <Typography variant="caption" style={{ opacity: 0.7, fontWeight: 800 }}>
                  Selected
                </Typography>
              ) : null}

              {/* Delete Button: Hidden if Neutral */}
              {!(m.name === 'neutral') && (
                <IconButton
                  size="small"
                  onClick={(e) => {
                    e.stopPropagation(); // Prevents selecting the mood when deleting
                    onRemoveMood?.(m.name);
                  }}
                  style={{ padding: 4, opacity: 0.4 }}
                >
                  <CloseIcon style={{ fontSize: 16 }} />
                </IconButton>
              )}
            </MenuItem>
          ))
        )}

        <Divider />

        <div style={{ padding: 10 }}>
          <Button
            fullWidth
            variant="outlined"
            color="primary"
            startIcon={<AddIcon />}
            onClick={() => {
              setAnchorEl(null);
              onAddMood?.();
            }}
            style={{
              borderRadius: 12,
              textTransform: "none",
              fontWeight: 900,
              paddingTop: 10,
              paddingBottom: 10,
            }}
          >
            Add new mood
          </Button>
        </div>
      </Menu>
    </>
  );
}

function AddMoodModal({ open, onClose, library, activeMoods, onAdd }) {
  const [search, setSearch] = useState("");

  // Filter out moods the user already has active
  const availableToAdd = library.filter(libMood => 
    !activeMoods.some(active => active.name === libMood.name) &&
    libMood.name.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <Dialog 
      open={open} 
      onClose={onClose}
      PaperProps={{ style: { borderRadius: 20, padding: 8, width: 400 } }}
    >
      <div style={{ padding: '16px 20px' }}>
        <Typography variant="h6" style={{ fontWeight: 900, marginBottom: 16 }}>
          ADD NEW MOOD
        </Typography>
        
        <TextField
          fullWidth
          placeholder="Search for a mood..."
          variant="outlined"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          InputProps={{
            style: { borderRadius: 12, fontWeight: 700, backgroundColor: 'rgba(0,0,0,0.02)' },
            startAdornment: <SearchIcon style={{ marginRight: 8, opacity: 0.4 }} />
          }}
        />
      </div>

      <List style={{ maxHeight: 300, overflow: 'auto', padding: '0 8px 16px' }}>
        {availableToAdd.map((mood) => (
          <MenuItem 
            key={mood.id}
            onClick={() => onAdd(mood)}
            style={{ borderRadius: 12, marginBottom: 4, padding: 12, gap: 12 }}
          >
            <Avatar 
              src={mood.imageUrl} 
              variant="rounded" 
              style={{ width: 70, height: 70, borderRadius: 10, border: '1px solid rgba(0,0,0,0.05)' }} 
            />
            <Typography style={{ fontWeight: 800, flex: 1 }}>
              {mood.name.toUpperCase().replace(/_/g, ' ')}
            </Typography>
            <AddIcon style={{ opacity: 0.3 }} />
          </MenuItem>
        ))}
        {availableToAdd.length === 0 && (
          <Typography align="center" style={{ padding: 20, opacity: 0.5, fontWeight: 700 }}>
            No new moods found
          </Typography>
        )}
      </List>
    </Dialog>
  );
}

// New Home
function NewHomeScreen(props) {
  const classes = useStyles();

  const [fetchingTasks, setFetchingTasks] = useState(false);
  const [tasks, setTasks] = useState([]);
  const [pausedTasks, setPausedTasks] = useState([]);
  const [currentTask, setCurrentTask] = useState(null);
  const [currentActiveTaskInstanceID, setCurrentActiveTaskInstanceID] = useState(null);
  const [currentActiveTaskInstanceTimeElapsed, setCurrentActiveTaskInstanceTimeElapsed] = useState(0);
  const [checkingForActiveTaskInstance, setCheckingForActiveTaskInstance] = useState(true);

  const [loadingContent, setLoadingContent] = useState(false);
  const [reccomendedContent, setReccomendedContent] = useState([]);

  const abortRef = useRef(null);
  const abortRefTasks = useRef(null);

  const [addingTask, setAddingTask] = useState(false);
  const [newTaskName, setNewTaskName] = useState("");
  const [newTaskGoal, setNewTaskGoal] = useState("");
  const [goals, setGoals] = useState([]);
  const [fetchingGoals, setFetchingGoals] = useState(false);
  const [addingTaskInServer, setAddingTaskInServer] = useState(false);

  const [fetchingMoods, setFetchingMoods] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [allLibraryMoods] = useState([
    "neutral", "chill", "programming", "exercise", "cooking", "cleaning",
    "reading", "meditation", "socializing", "working", "exploring", "writing",
    "shopping", "capricious", "hungry", "thirsty", "fatigued", "sore", "ill",
    "sad", "anxious", "tired", "stressed", "happy", "creative", "adventurous",
    "studying", "researching", "planning", "organizing", "stretching", "outdoor",
    "baking", "gardening", "family_time", "journaling", "storytelling", "music",
    "gaming", "money", "bureaucracies", "maintenance", "teaching", "mentoring",
    "volunteering", "self_care", "entertainment", "building", "tinkering",
    "celebrating", "spiritual", "crafting", "errands", "admin", "paperwork", "chores"
  ].map(name => ({ name, imageUrl: `${name}.png` })));
  const [moods, setMoods] = useState([]);
  const [mood, setMood] = useState({'name': 'neutral', 'imageUrl': 'neutral.png'});
  const [moodBinary, setMoodBinary] = useState(null);
  const [kindOfDayBinary, setKindOfDayBinary] = useState(null);
  const [timeOfDayBinary, setTimeOfDayBinary] = useState(null);
  const [weatherBinary, setWeatherBinary] = useState(null);


  const [timeOfDayEarlyMorning, setTimeOfDayEarlyMorning] = useState(null);
  const [timeOfDayMorning, setTimeOfDayMorning] = useState(null);
  const [timeOfDayLunch, setTimeOfDayLunch] = useState(null);
  const [timeOfDayAfternoon, setTimeOfDayAfternoon] = useState(null);
  const [timeOfDayDinner, setTimeOfDayDinner] = useState(null);
  const [timeOfDayEvening, setTimeOfDayEvening] = useState(null);
  const [timeOfDayNight, setTimeOfDayNight] = useState(null);

  const [notRelevantPromptOpen, setNotRelevantPromptOpen] = useState(false);
  const [taskBeingMarkedNotRelevant, setTaskBeingMarkedNotRelevant] = useState(null);
  const [notRelevantReason, setNotRelevantReason] = useState("");
  const [markingNotRelevantInServer, setMarkingNotRelevantInServer] = useState(false);


  const [dimensions, setDimensions] = useState({ 
    height: window.innerHeight,
    width: window.innerWidth
  })

  useEffect(() => {
    window.addEventListener('resize', handleResize)
    fetchCurrentlyActiveTaskInstance();
    fetchPausedTasks();
    fetchUserState();
    fetchMoods();
  }, [])

  useEffect(() => {
    fetchRecentContent(mood);
  }, [mood])


  const handleResize = () => {
    setDimensions({
      height: window.innerHeight,
      width: window.innerWidth
    }) 
  }

  const setUserState = (kindOfDay, timeOfDay, weather, currentMood) => {
    fetch(SERVER_LINK + '/set_user_state', {
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'SimpTokAuth': props.tokenPass
        },
        body: JSON.stringify({
                kindOfDay: kindOfDay,
                timeOfDay: timeOfDay,
                weather: weather,
                mood: currentMood.name
              })
      }).then((response) => response.json())
        .then((data) => {if (data=='SUCCESS') {fetchTasks();} else {console.log('Status couldnt be set: ' + data)}} )
        .catch((error) => console.log(error))
  }

  const fetchUserState = () => {
    fetch(SERVER_LINK + '/get_user_state', {
        method: 'GET',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'SimpTokAuth': props.tokenPass
        },
      }).then((response) => response.json())
        .then((data) => {
          // set all states from data
          setKindOfDayBinary(data.kind_of_day);
          setTimeOfDayBinary(data.time_of_day);
          setWeatherBinary(data.weather_conditions);
          setMoodBinary(data.moods);
          const activeMood = Object.entries(data.moods).find(([key, value]) => value === true)?.[0];
          if (!activeMood) {
            setMood({"name": "neutral", "imageUrl": "neutral.png"});
          }
          else {
            setMood({"name": activeMood, "imageUrl": activeMood + ".png"});
          }
          setTimeOfDayEarlyMorning(data.times.early_morning);
          setTimeOfDayMorning(data.times.morning);
          setTimeOfDayLunch(data.times.lunch);
          setTimeOfDayAfternoon(data.times.afternoon);
          setTimeOfDayDinner(data.times.dinner);
          setTimeOfDayEvening(data.times.evening);
          setTimeOfDayNight(data.times.night);
        })
        .catch((error) => console.log(error))
  }

  const fetchMoods = () => {
    setFetchingMoods(true);
    fetch(SERVER_LINK + '/get_user_moods', {
        method: 'GET',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'SimpTokAuth': props.tokenPass
        },
      }).then((response) => response.json())
        .then((data) => {if (Array.isArray(data)) {setMoods(data);} else {console.log('Status couldnt be set: ' + data)}} )
        .catch((error) => console.log(error))
        .finally(() => setFetchingMoods(false));
  }

  const handleAddMood = (newMood) => {
    // 1. Add to the list
    const updated = [...moods, newMood];
    
    fetch(SERVER_LINK + '/set_user_moods', {
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({idtoken: props.tokenPass, moods: updated.map(m => m.name)})
      }).then((response) => response.json())
        .then((data) => {if (data === "SUCCESS") {setMoods(updated);} else {console.log('Failed to update moods:', data)}} )
        .catch((error) => console.log(error))
        .finally(() => {setIsModalOpen(false)});
  };

  const handleRemoveMood = async (mood_name) => {
    if (mood_name.toLowerCase() === 'neutral') {
      return; 
    }

    // 3. Filter the list, make a list of names only
    const updatedMoods = moods.filter(m => m.name !== mood_name);
    const updatedMoodNames = updatedMoods.map(m => m.name);

    
    fetch(SERVER_LINK + '/set_user_moods', {
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({idtoken: props.tokenPass, moods: updatedMoodNames})
      }).then((response) => response.json())
        .then((data) => {if (data === "SUCCESS") {setMoods(updatedMoods);} else {console.log('Failed to update moods:', data)}} )
        .catch((error) => console.log(error))
  };


  const fetchRecentContent = () => {
    if (abortRef.current) abortRef.current.abort();
    const controller = new AbortController();
    abortRef.current = controller;
    setLoadingContent(true)
    console.log("Fetching content for mood:", mood);
    fetch(SERVER_LINK + '/get_instances_for_feed', {
      method: 'POST',
        headers: {
          Accept:'application/json',
          'Content-Type': 'application/json',
          'SimpTokAuth': props.tokenPass
        },
        body: JSON.stringify({mood: mood.name})
      }).then((response) => response.json())
        .then((data) => {if (!controller.signal.aborted) {
          if (Array.isArray(data)) setReccomendedContent(data);
          else console.log(data);
        }} )
        .catch((err) => {
        // ignore abort errors; they’re expected
        if (err.name !== "AbortError") console.log(err);
      })
      .finally(() => {
        if (!controller.signal.aborted) setLoadingContent(false);
      });
      
      return () => controller.abort(); // cleanup on next call or unmount
  }
  
  const fetchCurrentlyActiveTaskInstance = () => {
    setCheckingForActiveTaskInstance(true);
    fetch(SERVER_LINK + '/get_active_task', {
        method: 'GET',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'SimpTokAuth': props.tokenPass
        }
      }).then((response) => response.json())
        .then((data) => {if (Array.isArray(data) && data.length > 0) {setCurrentTask(data[0]); setCurrentActiveTaskInstanceID(data[0].instance_id); setCurrentActiveTaskInstanceTimeElapsed(data[0].time_elapsed);} else {console.log('No active task instance: ' + data)}} )
        .catch((error) => console.log(error))
        .finally(() => setCheckingForActiveTaskInstance(false));
  }


  const fetchPausedTasks = () => {
    //fetch paused tasks from backend
    fetch(SERVER_LINK + '/get_paused_tasks', {
        method: 'GET',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'SimpTokAuth': props.tokenPass
        }
      }).then((response) => response.json())
        .then((data) => {if (Array.isArray(data)) {setPausedTasks(data); console.log(data)} else {console.log('Status couldnt be set: ' + data)}} )
        .catch((error) => console.log(error));
  }

  const fetchTasks = () => {
    //fetch tasks from backend
    //dummy data for now
    if (abortRefTasks.current) abortRefTasks.current.abort();
    const controller = new AbortController();
    abortRefTasks.current = controller;
    setFetchingTasks(true);
    fetch(SERVER_LINK + '/get_task_ideal_states', {
        method: 'GET',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'SimpTokAuth': props.tokenPass
        }
      }).then((response) => response.json())
        .then((data) => {if (!controller.signal.aborted && Array.isArray(data)) {setTasks(data);} else {console.log('Status couldnt be set: ' + data)}} )
        .catch((error) => {
        // ignore abort errors; they’re expected
        if (error.name !== "AbortError") console.log(error);
      })
        .finally(() => {
          if (!controller.signal.aborted) setFetchingTasks(false);
        });
  }

  const fetchGoals = () => {
    //fetch goals from backend
    setFetchingGoals(true);
    fetch(SERVER_LINK + '/get_goals', {
        method: 'GET',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'SimpTokAuth': props.tokenPass
        }
      }).then((response) => response.json())
        .then((data) => {if (Array.isArray(data)) {setGoals(data);} else {console.log('Status couldnt be set: ' + data)}} )
        .catch((error) => console.log(error))
        .finally(() => setFetchingGoals(false));
  }

  const addTask = () => {
    setAddingTaskInServer(true);
    fetch(SERVER_LINK + '/add_state_task', {
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            task_text: newTaskName,
            goalid: newTaskGoal,
            goal: goals.find(g => g.id == newTaskGoal)?.goal_name ?? "",
            idtoken: props.tokenPass
        })
      }).then((response) => response.json())
        .then((data) => {if (parseInt(data)) {setAddingTask(false); setNewTaskName(""); setNewTaskGoal(""); getTask(data);} else {alert("Failed to add task.");}} )
        .catch((error) => console.log(error))
        .finally(() => {setAddingTaskInServer(false);});
  }

  const getTask = (taskid) => {
    fetch(SERVER_LINK + '/get_task', {
        method: 'GET',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'TaskID': taskid,
            'SimpTokAuth': props.tokenPass
        }
      }).then((response) => response.json())
        .then((data) => {if (data && data.task_name) {startTask(data)} else {console.log('Failed to get task: ' + data);}} )
        .catch((error) => {console.log(error); return null;});
  }

  const closeAddTaskBox = () => {
    setAddingTask(false);
    setNewTaskName("");
    setNewTaskGoal("");
  }

  const startTask = (task) => {
    console.log("Starting task:", task);
    fetch(SERVER_LINK + '/set_state_task_started', {
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            taskid: task.id,
            idtoken: props.tokenPass
        })
      }).then((response) => response.json())
        .then((data) => {if (parseInt(data)) {setCurrentTask(task); setCurrentActiveTaskInstanceID(data);} else {alert("Failed to start task.");}} )
        .catch((error) => console.log(error));
  }

  const pauseTask = () => {
    fetch(SERVER_LINK + '/set_state_task_paused', {
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            taskinstanceid: currentActiveTaskInstanceID,
            idtoken: props.tokenPass
        })
      }).then((response) => response.json())
        .then((data) => {if (data === "SUCCESS") {setCurrentTask(null); setCurrentActiveTaskInstanceID(null); setCurrentActiveTaskInstanceTimeElapsed(0); fetchPausedTasks(); fetchTasks();} else {alert("Failed to pause task.");}} )
        .catch((error) => console.log(error));
  }

  const resumeTask = (task) => {
    fetch(SERVER_LINK + '/set_state_task_resumed', {
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            taskinstanceid: task.instance_id,
            idtoken: props.tokenPass
        })
      }).then((response) => response.json())
        .then((data) => {if (data === "SUCCESS") {fetchCurrentlyActiveTaskInstance();} else {alert("Failed to resume task.");}} )
        .catch((error) => console.log(error));
  }

  const skipTask = () => {
    fetch(SERVER_LINK + '/set_state_task_skipped', {
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            taskinstanceid: currentActiveTaskInstanceID,
            idtoken: props.tokenPass
        })
      }).then((response) => response.json())
        .then((data) => {if (data === "SUCCESS") {setCurrentTask(null); setCurrentActiveTaskInstanceID(null); setCurrentActiveTaskInstanceTimeElapsed(0); fetchPausedTasks(); fetchTasks();} else {alert("Failed to skip task.");}} )
        .catch((error) => console.log(error));
  }

  const doneTask = () => {
    fetch(SERVER_LINK + '/set_state_task_done', {
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            taskid: currentTask.id,
            taskinstanceid: currentActiveTaskInstanceID,
            idtoken: props.tokenPass
        })
      }).then((response) => response.json())
        .then((data) => {if (data === "SUCCESS") {setCurrentTask(null); setCurrentActiveTaskInstanceID(null); setCurrentActiveTaskInstanceTimeElapsed(0); fetchPausedTasks(); fetchTasks();} else {alert("Failed to mark task as done.");}} )
        .catch((error) => console.log(error));
  }

  const setTaskNotRelevant = (task) => {
    fetch(SERVER_LINK + '/set_task_mood_not_relevant', {
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            taskid: task.id,
            mood: mood.name,
            idtoken: props.tokenPass
        })
      }).then((response) => response.json())
        .then((data) => {if (data === "SUCCESS") {fetchTasks();} else {alert("All tasks are relevant in neutral mood");}} )
        .catch((error) => console.log(error))
        .finally(() => {setMarkingNotRelevantInServer(false); setNotRelevantPromptOpen(false);});
  }


  return (
    <div>
    {checkingForActiveTaskInstance ? <CircularProgress /> :
    currentTask ?
    (currentActiveTaskInstanceID ?
      <TaskWindow task={currentTask} pauseTask={pauseTask} taskDone={doneTask} taskSkipped={skipTask} tokenPass={props.tokenPass} initialTimeElapsed={currentActiveTaskInstanceTimeElapsed}/> :
      <CircularProgress /> ) 
      :
    <Box
      sx={{
        height: dimensions.height - 64,
        p: 1,
        paddingBottom: 0,
        boxSizing: "border-box",
        display: "grid",
        gap: 2,
        // 3 columns across
        gridTemplateColumns: "365px minmax(0, 1fr) minmax(0, 1fr)",
      }}
    >

      {/* Column 1: two half-height sections */}
      <Box
        style={{
          display: "grid",
          gap: 2,
          height: "100%",
          gridTemplateRows: "140px 210px 1fr", // fixed height, then take remaining space
          minHeight: 0,
        }}
      >
        {((mood === null) || fetchingMoods) ? <CircularProgress /> :
        <MoodPickerCard currentMood={mood} moods={moods} onSelectMood={(new_mood) => {setMood(new_mood); setUserState(kindOfDayBinary, timeOfDayBinary, weatherBinary, new_mood);}} onAddMood={() => setIsModalOpen(true)} onRemoveMood={handleRemoveMood}/>}
        {(kindOfDayBinary === null || timeOfDayBinary === null || weatherBinary === null || timeOfDayEarlyMorning === null || timeOfDayMorning === null || timeOfDayLunch === null || timeOfDayAfternoon === null || timeOfDayDinner === null || timeOfDayEvening === null || timeOfDayNight === null) ? <CircularProgress /> :
        <StateSection onStateChange={(state) => {setKindOfDayBinary(state.kindOfDay); setTimeOfDayBinary(state.timeOfDay); setWeatherBinary(state.weather); setUserState(state.kindOfDay, state.timeOfDay, state.weather, mood); }} tokenPass={props.tokenPass} timeOfDayEarlyMorning={timeOfDayEarlyMorning} timeOfDayMorning={timeOfDayMorning} timeOfDayLunch={timeOfDayLunch} timeOfDayAfternoon={timeOfDayAfternoon} timeOfDayDinner={timeOfDayDinner} timeOfDayEvening={timeOfDayEvening} timeOfDayNight={timeOfDayNight}/>}
        <MetricsSection tokenPass={props.tokenPass} />
      </Box>

      {/* Column 2: full-height section */}
      
      <Box sx={{
              height: "100%",          
              display: "flex",
              flexDirection: "column",
              minHeight: 0,            
            }} >

            <Box
                style={{
                  margin: "5px 5px 5px 5px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}>
                {/* Title */}
                <Typography
                  variant="subtitle1"
                  style={{
                    fontWeight: 900,
                    marginBottom: 0,   // ✅ was mb: 1 (ignored)
                    letterSpacing: 0.6,
                    opacity: 0.85,
                    marginLeft: 5,

                  }}
                >
                  RECOMMENDED TASKS
                </Typography>

                {/* Action */}
                <Button
                  onClick={() => {
                    setAddingTask(true);
                    fetchGoals();
                  }}
                  style={{
                    borderRadius: 999,
                    textTransform: "none",
                    fontWeight: 900,
                    fontSize: 14,
                    padding: "6px 14px",
                    minWidth: 0,
                    background: "rgba(0,0,0,0.05)",
                    border: "1px solid rgba(0,0,0,0.12)",
                    transition: "all 140ms ease",
                  }}
                >
                  + ADD TASK
                </Button>
              </Box>
      <Box
        sx={{
          flex: 1,               // take remaining space
          overflowY: "auto",
          minHeight: 0,          // IMPORTANT
          p: 0.5,               
        }}
      >

      {fetchingTasks ?
        <CircularProgress /> :
        <TaskSection tasks={tasks} pausedTasks={pausedTasks} onTaskStart={startTask} onTaskResume={resumeTask} onTaskNotRelevant={(task) => {setTaskNotRelevant(task); setNotRelevantPromptOpen(true);}} />}
    </Box></Box>
      {/* Column 3: full-height section */}
      <Box
        sx={{
          height: '100%',
          overflowY: "auto",
          pr: 1,
        }}
      >
        {loadingContent ? <CircularProgress /> :
      <NewsFeedHome content={reccomendedContent} updateParent={fetchRecentContent} tokenPass={props.tokenPass}/>}
      </Box>
    </Box>}
    <AddMoodModal
        open={isModalOpen}
        activeMoods={moods}
        onClose={() => setIsModalOpen(false)}
        onAdd={handleAddMood}
        library={allLibraryMoods} // Your master list of all possible moods
      />
    {addingTask ? <div className="infoi"> 
                    <div className="centeredBox"> 
                      {addingTaskInServer ? 
                          <><CircularProgress /> <p> Add task ...</p></> : 
                          
                          <div>
                            <Button style={{'float': 'right'}}
                                    onClick={closeAddTaskBox}>
                              <CloseIcon/>
                            </Button>
                            <h4>Adding Task</h4>
                            <TextField id="time" 
                                      type="text" 
                                      variant="outlined" 
                                      label="Text" 
                                      multiline={true} 
                                      rows={4} 
                                      fullWidth={true} 
                                      onChange={(event) => {setNewTaskName(event.target.value)}}
                                      value={newTaskName}
                                      />
                            <div>
                              {fetchingGoals ? <CircularProgress /> :
                                <TextField
                                  select
                                  label="Select Goal"
                                  value={newTaskGoal}
                                  onChange={(event) => setNewTaskGoal(event.target.value)}
                                  fullWidth
                                  margin="normal"
                                >
                                  {goals.map((goal) => (
                                    <MenuItem key={goal.id} value={goal.id}>
                                      {goal.name}
                                    </MenuItem>
                                  ))}
                                </TextField>
                                  }
                            <Button onClick={addTask}>Add</Button>
                          </div>
                          </div>
                      }
                      
                      
                    </div>
                  </div>: <div></div>}
    {notRelevantPromptOpen ? <div className="infoi">
                    <div className="centeredBox">
                      <CircularProgress /> <p> Marking task as not relevant ...</p>
                       </div>
                    </div> : <div>  </div>}


    </div>
  );
}


const useJarvisSession = () => {
  // 1. Wrap the refresh logic in useCallback to keep it stable
  const refreshSession = useCallback(async () => {
    try {
      console.log("Refreshing JarvisToken...");
      const res = await fetch(SERVER_LINK + '/refresh', {
        method: 'POST',
        credentials: 'include' // MANDATORY to send the refresh cookie
      });

      if (res.ok) {
        const { accessToken } = await res.json();
        localStorage.setItem('access_token', accessToken);
      } else {
        console.warn("Session invalid or expired");
      }
    } catch (err) {
      console.error("Refresh network error:", err);
    }
  }, []);

  useEffect(() => {
    // 2. Timer: Refresh every 10 minutes
    const timer = setInterval(refreshSession, 10 * 60 * 1000);

    // 3. Tab Sync: Refresh when the tab becomes visible
    const handleVisibilityChange = () => {
      if (document.visibilityState === 'visible') {
        console.log("Tab focused: syncing session...");
        refreshSession();
      }
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);

    // Initial check on mount
    refreshSession();

    // 4. Cleanup
    return () => {
      clearInterval(timer);
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, [refreshSession]);
};

//Main app
function MainApp() {
  const classes = useStyles();

  const [username, setUsername] = useState('')
  const [password, setPassword] = useState('')

  const [signingIn, setSigningIn] = useState(true);
  const [token, setToken] = useState('');
  const [currentPage, setCurrentPage] = useState('Home');
  const [drawerState, setDrawerState] = useState(false)
  const [googleResponseToken, setGoogleResponseToken] = useState({})
  const [searching, setSearching] = useState(false)
  const [searchingValue, setSearchingValue] = useState('')

  const [uploadingResource, setUploadingResource] = useState(false)

  const [contentData, setContentData] = useState({url: '', title: '', image: '', pdf: '', video: ''})

  const [updatingHomeScreenRefreshVar, setUpdatingHomeScreenRefreshVar] = useState(true)
  // Track last token refresh time
  const lastTokenRefresh = useRef(Date.now());

  
  const [checkingNotifications, setCheckingNotifications] = useState(false)

  const [anchorEl, setAnchorEl] = React.useState(null);
  const [mobileMoreAnchorEl, setMobileMoreAnchorEl] = React.useState(null);

  const [tokenIsValid, setTokenIsValid] = useState(false);
  const [accountIconColor, setAccountIconColor] = useState('warning')

  const isMenuOpen = Boolean(anchorEl);
  const isMobileMenuOpen = Boolean(mobileMoreAnchorEl);

  const [currentMap, setCurrentMap] = useState(null)
  const [currentStream, setCurrentStream] = useState(null)
  const [currentGoal, setCurrentGoal] = useState(null)
  const [currentMetric, setCurrentMetric] = useState(null)

  const [dimensions, setDimensions] = useState({ 
    height: window.innerHeight,
    width: window.innerWidth
  })

  useEffect(() => {
    window.addEventListener('resize', handleResize)
    window.addEventListener('message', function(event) {
      console.log("SOME MESSAGE RECEIVED")
      console.log(event.data)
      if (event.data.type == 'link') {
        setContentData({url: event.data.url, title: event.data.title, image: event.data.image, pdf: event.data.pdf, video: event.data.video})
      }
    });
    document.title = currentPage;
  }, [])

  const refreshSession = useCallback(async () => {
    try {
      console.log("Refreshing JarvisToken...");
      const res = await fetch(SERVER_LINK + '/refresh', {
        method: 'POST',
        credentials: 'include' // MANDATORY to send the refresh cookie
      });

      if (res.ok) {
        const { accessToken } = await res.json();
        setToken(accessToken);
        lastTokenRefresh.current = Date.now(); // <-- Track when it was refreshed
        return accessToken;  
      } else {
        console.warn("Session invalid or expired");
        setSigningIn(false);
        return null;
      }
    } catch (err) {
      console.error("Refresh network error:", err);
      return null;
    }
  }, []);

  useEffect(() => {
    const handler = async (event) => {
        if (event.data.type === 'GET_TOKEN') {
          let tokenToSend = token;
        
          // If it's been more than 9 minutes (540,000 ms), force a refresh first
          const timeSinceLastRefresh = Date.now() - lastTokenRefresh.current;
          if (timeSinceLastRefresh > 9 * 60 * 1000) {
            console.log("Token might be stale. Refreshing for extension...");
            const freshToken = await refreshSession();
            if (freshToken) {
                tokenToSend = freshToken;
            }
          }
          window.postMessage({ type: 'token_response', token: token }, '*');
        }
      };

      window.addEventListener('message', handler);
      return () => window.removeEventListener('message', handler);
  }, [token, refreshSession])

  useEffect(() => {
    const path = window.location.pathname;
    const pages = path.split('/'); // split the path and get the page name
    if (pages[1] == 'home') {
      setCurrentPage('Home')
    }
    else if (pages[1] == 'planner') {
      setCurrentPage('Planner')
      setCurrentGoal(pages[2] ? pages[2] : null)
    }
    else if (pages[1] == 'metrics') {
      setCurrentPage('Metrics')
      setCurrentMetric(pages[2] ? pages[2] : null)
    }
    else if (pages[1] == 'streams') {
      setCurrentPage('Streams')
      setCurrentStream(pages[2] ? pages[2] : null)
    }
    else if (pages[1] == 'maps') {
      setCurrentPage('Maps')
      setCurrentMap(pages[2] ? pages[2] : null)
    }
    else if (pages[1] == 'calendar') {
      setCurrentPage('Calendar')
    }
    else if (pages[1] == 'settings') {
      setCurrentPage('Settings')
    }
    else {
      setCurrentPage('Home')
      window.history.replaceState(null, '', '/home');
    }
  }, [])


  useEffect(() => {
    document.title = currentPage;
  }, [currentPage])

  useEffect(() => {
    if (contentData.url != '') {
      setUploadingResource(true)
    }
  }, [contentData])



  const handleResize = () => {
    setDimensions({
      height: window.innerHeight,
      width: window.innerWidth
    }) 
  }

  const notifWrapperBox = useRef(null);
  useOutsideAlerter(notifWrapperBox, ()=> {setCheckingNotifications(false)});

  const handleProfileMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMobileMenuClose = () => {
    setMobileMoreAnchorEl(null);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    handleMobileMenuClose();
  };

  const handleMobileMenuOpen = (event) => {
    setMobileMoreAnchorEl(event.currentTarget);
  };

  

  useEffect(() => {
    // 2. Timer: Refresh every 10 minutes
    const timer = setInterval(refreshSession, 10 * 60 * 1000);

    // 3. Tab Sync: Refresh when the tab becomes visible
    const handleVisibilityChange = () => {
      if (document.visibilityState === 'visible') {
        console.log("Tab focused: syncing session...");
        refreshSession();
      }
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);

    // Initial check on mount
    refreshSession();

    // 4. Cleanup
    return () => {
      clearInterval(timer);
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };

  }, [refreshSession]);

  const handleLoginWithGoogle = (token) => {
    //window.addEventListener("focus", () => {userEnteringPage(window)});
    setSigningIn(true);
    //setGoogleResponseToken(google_response);
    backendSignin(token);
  };

  const handleLoginWithDIL = () => {
    //with the credentials we obtain a token


  };

  const backendSignin = (token) => {
    fetch(SERVER_LINK + '/sign_in', {
      method: 'POST',
      credentials: 'include',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        credential: token
      })
    }).then((response) => response.json())
      .then((data) => {data.status == "SUCCESS" ? setToken(data.accessToken) : setToken('', () => console.log(data))})
      .then(() => {setSigningIn(false)});
  };

  const userEnteringPage = (doc) => {
    console.log('focused')
  };

  const handleSearchChange = (event) => {
    if (event.target.value == '') {
      setSearching(false)
    }
    else {
      if (!searching) {
        setSearching(true)
      }
    }
    setSearchingValue(event.target.value)

  };

  const trainAllModels = () => {
  fetch(SERVER_LINK + '/nl_train_query_models', {
    method: 'POST',
    headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
    },
    body: JSON.stringify({
        idtoken: token,
        batch_size: 32,
    })
  }).then((response) => response.json())
    .then((data) => {if (data=='SUCCESS') {alert('Models trained successfully');}} )
    .catch((error) => console.log(error))}

  // side menu  
  const list = () => (
    <div
      className={clsx(classes.list, {[classes.fullList]: false})}
      role="presentation"
      onClick={() => {setDrawerState(false)}}
    >
      <List>
        <ListItem button key={'Home'} onClick={() => {setCurrentPage('Home'); window.history.replaceState(null, '', '/home');}}>
          <ListItemIcon><HomeIcon/></ListItemIcon>
          <ListItemText primary={'Home'} />
        </ListItem>
        <ListItem button key={'Planner'} onClick={() => {setCurrentPage('Planner'); window.history.replaceState(null, '', '/planner');}}>
          <ListItemIcon><AccountTreeIcon/></ListItemIcon>
          <ListItemText primary={'Planner'} />
        </ListItem>
        <ListItem button key={'Metrics'} onClick={() => {setCurrentPage('Metrics'); window.history.replaceState(null, '', '/metrics');}}>
          <ListItemIcon><EqualizerIcon/></ListItemIcon>
          <ListItemText primary={'Metrics'} />
        </ListItem>
        <ListItem button key={'Agents'} onClick={() => {setCurrentPage('Agents'); window.history.replaceState(null, '', '/agents');}}>
          <ListItemIcon><AdbIcon/></ListItemIcon>
          <ListItemText primary={'Agents'} />
        </ListItem>
        <ListItem button key={'Maps'} onClick={() => {setCurrentPage('Maps'); window.history.replaceState(null, '', '/maps');}}>
          <ListItemIcon><GridOnIcon/></ListItemIcon>
          <ListItemText primary={'Maps'} />
        </ListItem>
        <ListItem button key={'Calendar'} onClick={() => {setCurrentPage('Calendar'); window.history.replaceState(null, '', '/calendar');}}>
          <ListItemIcon><CalendarTodayIcon/></ListItemIcon>
          <ListItemText primary={'Calendar'} />
        </ListItem>
      </List>
      <Divider />
      <List>
        <ListItem button key={'Settings'} onClick={() => {setCurrentPage('Settings'); window.history.replaceState(null, '', '/settings');}}>
          <ListItemIcon><SettingsIcon/></ListItemIcon>
          <ListItemText primary={'Settings'} />
        </ListItem>
      </List>
    </div>
  );

  const renderMainScreen = (pageScreen) => {
    switch (pageScreen) {
      case 'Home':
        return <NewHomeScreen tokenPass={token}/>
      case 'Planner':
        return <PlannerScreen tokenPass={token} currentGoal={currentGoal} />
      case 'Metrics':
        return <MetricScreen tokenPass={token} currentMetric={currentMetric} />
      case 'Agents':
        return <StreamScreen tokenPass={token} currentStream={currentStream} />
      case 'Maps':
        return <MapsScreen tokenPass={token} currentMap={currentMap}/>
      case 'Calendar':
        return <CalendarScreen tokenPass={token} />
      case 'Settings':
        return <SettingsScreen tokenPass={token}/>
      default:
        return <NewHomeScreen tokenPass={token}/>
    }
  }

  const menuId = 'primary-search-account-menu';
  const renderMenu = (
    <Menu
      anchorEl={anchorEl}
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      id={menuId}
      keepMounted
      transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      open={isMenuOpen}
      onClose={handleMenuClose}
    >
      <MenuItem onClick={handleMenuClose}>My account</MenuItem>
    </Menu>
  );

  const mobileMenuId = 'primary-search-account-menu-mobile';
  const renderMobileMenu = (
    <Menu
      anchorEl={mobileMoreAnchorEl}
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      id={mobileMenuId}
      keepMounted
      transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      open={isMobileMenuOpen}
      onClose={handleMobileMenuClose}
    >
      <MenuItem onClick={handleProfileMenuOpen}>
        <IconButton
          aria-label="account of current user"
          aria-controls="primary-search-account-menu"
          aria-haspopup="true"
        >
          <AccountCircle />
        </IconButton>
        <p>Profile</p>
      </MenuItem>
    </Menu>
  );


  const renderDesktop = (
      <div className={classes.sectionDesktop}>
                  <IconButton color="inherit" onClick={() => setUploadingResource(true)}>
                    <Badge badgeContent={0} color="secondary">
                      <CloudUploadIcon />
                    </Badge>
                  </IconButton>
                  <IconButton
                    edge="end"
                    aria-label="account of current user"
                    aria-controls={menuId}
                    aria-haspopup="true"
                    onClick={handleProfileMenuOpen}>
                    <AccountCircle />
                  </IconButton>
          </div>)


  if ((dimensions.height < 420) || (dimensions.width < 800)) {
    return (
      <div style={{height: '100vh', width: '100vw', backgroundColor: 'rosybrown', position: 'absolute'}}>
        <h2>Please use a bigger screen!</h2>
      </div>)
  }
  else {
    if (token == '') {
      if (signingIn) {
        return (<div style={{'width': '100%', 'height': '100%'}}>
                  <div className='login_button'>
                    <CircularProgress />
                  </div>
                </div>);

      }
      else {
        return (<div style={{'width': '100%', 'height': '100%'}}>
                  <div className='login_button'>
                    <div>
                      <h3>Login with DIL credentials</h3>
                          <TextField variant="outlined"
                                      onChange={(event) => {setUsername(event.target.value)}}
                                      value={username}
                                      placeholder={'Email'} />
                          <br />
                          <TextField variant="outlined"
                                     onChange={(event) => {setPassword(event.target.value)}}
                                     value={password}
                                     placeholder={'Password'} />
                          <br />
                          <Button onClick={handleLoginWithDIL} > Login </Button>
                    </div>
                      <h3>Or via the standard platforms</h3>
                      {/** 
                    <GoogleLogin
                          clientId="907410170158-e21r8l61cgl84lqi52mmql1q7kb30t3s.apps.googleusercontent.com"
                          buttonText="Login"
                          onSuccess={handleLoginWithGoogle}
                          onFailure={(problem) => {alert('google couldnt log you in because: ' + problem.details)}}
                          cookiePolicy={'single_host_origin'}
                          isSignedIn={true}
                          style={{'margin': 'auto'}}
                    /> */}
                    <GoogleLogin
                                  onSuccess={credentialResponse => {
                                    // This 'credentialResponse.credential' is a JWT (ID Token)
                                    // Send this to your backendSignin function
                                    handleLoginWithGoogle(credentialResponse.credential);
                                  }}
                                  onError={() => {
                                    alert('Google login failed');
                                  }}
                                  useOneTap // Optional: shows a tiny prompt if the user is already logged in
                                  use_fedcm_for_prompt={false}
                                  auto_select
                                />
                  </div>
                </div>);
      }
    }
    else {
      return (<div className={classes.root1} >
                <AppBar position="static">
                  <Toolbar>
                    <IconButton edge="start" className={classes.menuButton} color="inherit" aria-label="menu" onClick={() => {setDrawerState(true)}}>
                      <MenuIcon />
                    </IconButton>
                    <Typography variant="h6" className={classes.title}>
                      {currentPage}
                    </Typography>
                    <div className={classes.search}>
                      <div className={classes.searchIcon}>
                        <SearchIcon />
                      </div>
                      <InputBase
                        placeholder="Search..."
                        classes={{
                          root: classes.inputRoot,
                          input: classes.inputInput,
                        }}
                        inputProps={{ 'aria-label': 'search' }}
                        value={searchingValue}
                        onChange={handleSearchChange}
                        onClick={() => {searchingValue == '' ? setSearching(false) : setSearching(true)}}
                      />
                    </div>
                    <div className={classes.grow}/>
                    {renderDesktop}
                    <div className={classes.sectionMobile}>
                      <IconButton
                        aria-label="show more"
                        aria-controls={mobileMenuId}
                        aria-haspopup="true"
                        onClick={handleMobileMenuOpen}
                        color="inherit"
                      >
                        <MoreIcon />
                      </IconButton>
                    </div>
                            
                  </Toolbar>
                </AppBar>
                <Drawer anchor={'left'} open={drawerState} onClose={() => {setDrawerState(false)}}>
                  {list()}
                </Drawer>
                
                {renderMobileMenu}
                {renderMenu}
                
                {searching ? <SearchBar tokenPass={token}
                                        searchingText={searchingValue}
                                        hideSearchBox={() => {setSearching(false)}} />
                  : 
                  <div></div>
                }
                {checkingNotifications ? 
                            <NotificationsBox tokenPass={token}
                                              hideNotificationsBox={() => {setCheckingNotifications(false)}}
                                              refWrapper={notifWrapperBox} />
                  : 
                  <div></div>
                }

                {uploadingResource? <AddingContentWindow tokenPass={token} 
                                                         closeAddBox={() => {setUploadingResource(false); setContentData({url: '', title: '', image: '', pdf: '', video: ''}); setUpdatingHomeScreenRefreshVar((old_val) => {return !old_val})}}
                                                         contentData={contentData} /> : <div></div>
                }

                {renderMainScreen(currentPage)}
              </div>
      );
    }
  }
};



export default function App() {
  
  return <GoogleOAuthProvider clientId="907410170158-e21r8l61cgl84lqi52mmql1q7kb30t3s.apps.googleusercontent.com">
    <MainApp />
  </GoogleOAuthProvider>

}


